import React, { useState, useMemo, useCallback } from 'react';
import {
  unGroup,
  dateToString,
  toDatePickerDate,
  indexBy,
  objectParValueToString,
  calculateDate,
} from 'utils/utils2';
import {
  Collapse,
  Input,
  Button,
  Card,
  Col,
  DatePicker,
  Divider,
  Form,
  Row,
  message,
  notification,
  Tabs,
  InputNumber,
  Popconfirm,
  Switch,
  Tag,
  Space,
  Modal,
  List,
  Spin,
  Image,
  Popover,
} from 'antd';
import { useFormList } from 'hooks/useFormList';
import { shouldUpdateCompare } from 'utils/utils2';
import DataGrid, { DataGridColDef } from 'components/DataGrid/DataGrid';
import { assetCatalogToAsset } from './assetCatalogToAsset';
import Text from 'antd/lib/typography/Text';
import { FormInstance } from 'antd/lib/form';
import { CalculatorTwoTone } from '@ant-design/icons';
import * as finEngine from 'services/finEngine';
import { getRounding, toCurrency, toRate } from 'utils/utils';
import { useModalState } from 'hooks/useModalState';
import OfferInput from './OfferInput';
import AssetsTable from './AssetsTable';
import PricingInput from './PricingInput';
import ProductInput from './ProductInput';
import Title from 'components/Title';
import Value from 'components/Value';
import FormInput from 'components/FormInput';
import InputRate from 'components/InputRate';
import InputCurrency from 'components/InputCurrency';
import ParListSelect from 'components/ParListSelect';
import ScheduleButton from 'components/ScheduleButton';
import SliderWithInput from 'components/SliderWithInput';
import ThirdPartyInput from 'components/ThirdPartyInput';
import AssetCatalogModal from 'components/AssetCatalogModal';
import SimpleAssetModal from './SimpleAssetModal';
import FinancialScheduleModal from 'components/FinancialScheduleModal';
import { AssetCatalogModalProps } from 'components/AssetCatalogModal/AssetCatalogModal';
import AssetCatalogPackModal, {
  AssetCatalogPackModalProps,
} from 'components/AssetCatalogPackModal/AssetCatalogPackModal';
import SliderWithInputAndPercentage from 'components/SliderWithInputAndPercentage';
import {
  getPricingDetail,
  getPricingPackDetail,
  getprOfferDetailByOfferId,
  prFilteringCriteria,
  AssetUseCriteria,
  FilteringCriteria,
  MUserJobAuthorizationCheckResponse,
  AssetRVCriteria,
  getApplicablePricingCommissionList,
  ParCommissionResponse,
  getServiceByServcode,
} from 'services/pricing';
import {
  getAssetCatalogRvAmountList,
  ParAssetCatalogOptionResponse,
} from 'services/assetconfig';

import { getAssetRvAmountList } from 'services/assetconfig';

import {
  CloseOutlined,
  CheckOutlined,
  PlusOutlined,
  CalendarTwoTone,
  LockTwoTone,
  UnlockTwoTone,
  ExclamationCircleOutlined,
} from '@ant-design/icons';
import { SimpleAssetModalProps } from './SimpleAssetModal';
import moment from 'moment';
import GetLabel from 'DisplayFramework/components/GetLabel';
import { offerToElement } from './offerToElement';
import { pricingToElement } from './pricingToElement';
import { commissionToElement } from './commissionToElement';
import {
  PropElemAttributeResponse,
  PropElementRequest,
  PropElementResponse,
  PropElemStepRequest,
  PropElemStepResponse,
  PropThirdPartyRequest,
  Syndicationlist,
} from '../../../services/proposal';

import {
  AssetRequest,
  AssetResponse,
  getAssetUseByAssetID,
} from 'services/assets';
import ElementsTable from './ElementsTable';
import _, { debounce, groupBy, isEmpty, isNil, sumBy } from 'lodash';
import TaxSelect from 'components/TaxSelect';
import DeleteButton from 'components/DeleteButton';
import NewButtonSmall from 'components/NewButtonSmall';
import SimpleServElementModal from './SimpleServElementModal';
import IAdd from 'icons/IAdd';
import AssetListModalV from 'pages/Asset/AssetListModalV2';
import FormItem from 'antd/lib/form/FormItem';
import SimpleCommissionModal from './simpleCommissionModal';
import PropList from '../PropList';
import NewButton from 'components/NewButtonSmall';
import ProposalModal from '../ProposalModal';
import RateFormulaSelect from 'components/RateFormulaSelect';
import SimpleFinElementModal from './SimpleFinElementModal';
import ElementsFinTable from './ElementsFinTable';
import ModalControllerNV from 'components/ModalControllerNV';
//import AssetDetails from 'pages/Asset/AssetDetail';
import { getThirdPartyRoleListByTpid } from 'services/thirdParty';
import { TpRoleToTp } from './TpRoleToTp';
import { useTranslation } from 'react-i18next';
import { assetSearchToAsset } from './assetSearchToAsset';
import { useDisplayFrameworkContext } from 'DisplayFramework/hooks/useDisplayFrameworkContext';
import StatusHistoryPopover from 'components/StatusHistoryPopover';
import BankAccountListSelect from 'pages/ThirdParty/ThirdPartyDetail/Components/BankAccListSelect';
import AddresseListSelect from 'pages/ThirdParty/ThirdPartyDetail/Components/AddressesListSelect';
import TextArea from 'antd/lib/input/TextArea';
import { getParAssetUseByFilters, ParAssetUseRequest } from 'services/pricing';
import getEnvValue from 'utils/getEnvValue';
import UtinaCard from 'components/UtinaCard';
import ElementAttributesTable from './ElementAttributesTable';
import AttributeModal from './AttributeModal';
import ButtonAction from 'components/ButtonAction';
import ICalculator from 'icons/ICalculator';
import MoreButton from 'components/MoreButton';
import UtinaPanel from 'components/UtinaPanel/UtinaPanel';
import PayementModal from 'pages/Payment/PayementModal';
import { useQuery } from 'react-query';
import { getMgParValueByParCode } from 'services/parametersService';
import ButtonOperation from 'components/ButtonOperation';
import ConElemPrefinStepModal from './components/ConElemPrefinStepModal';
import PopoverController from 'components/PopoverController';
import { ServiceResponceToElement } from './ServiceResponceToElement';
import { ServiceToElement } from './ServiceToElement';
import ParCalendarSelect from 'pages/Configuration/ParCalendar/ParCalendarSelect';
import AssetsCardTable from './AssetsCardTable';
import LoanRedemption from './LoanRedemption';
import ProposalSelect from 'components/ProposalSelect';

const { confirm } = Modal;

export type QuickSimulationProps = {
  form: FormInstance;
  phase: 'PROD' | 'PROPOSAL';
  isProposalCreate: boolean;
  firstAssetid: number;
  ctrid?: number;
  reftechProp?: () => void;
  loadTPDetail: (
    tpid: any,
    tpname: string,
    tpreference: string,
    tprolecode: any
  ) => any;
  showAsModal: boolean;
  ctstatus?: string;
  setLoadingBtn?: any;
};

const { Panel } = Collapse;
const { TabPane } = Tabs;

const QuickSimulation = ({
  form,
  phase,
  ctrid,
  isProposalCreate,
  firstAssetid,
  loadTPDetail,
  reftechProp,
  showAsModal,
  ctstatus,
  setLoadingBtn,
}: QuickSimulationProps) => {
  const { data: nbreAsset } = useQuery(['getMgParValueByParCode'], () =>
    getMgParValueByParCode({ parcode: 'NBREASSET' }).then((resp) => resp.data)
  );

  const { getComponentLabel } = useDisplayFrameworkContext();

  const catalogModal = useModalState();
  const catalogPackModal = useModalState();
  const simpleAssetModal = useModalState();

  const [assetModalVisible, setAssetModalVisible] = useState(false);

  const assetMultiCompModal = useModalState();

  const { t } = useTranslation();

  const { add: addsyn, remove: removesyn } = useFormList(form, 'syndication', {
    idKey: 'syndid',
    addAsFirst: true,
  });
  const { add: addtp, remove: removetp } = useFormList(form, 'thirdparties', {
    idKey: 'tpid',
    addAsFirst: true,
  });

  const [isLoading, setIsLoading] = useState(false);

  const [elementID, setElementID] = useState(1);

  const [loading, setLoading] = useState(false);

  const [loadingCalculateStep, setLoadingCalculateStep] = useState(false);

  const [displayTerm, setDisplayTerm] = useState(false);

  const [unlockCalculator, setunlockCalculator] = useState(false);
  const [vatDefferal, setVatDefferal] = useState(false);

  const [calculatorStatusColor, setCalculatorStatusColor] = useState('#722ED1');

  // eslint-disable-next-line no-unused-vars
  const dateTimeToDate = (dateTime: any) => {
    if (typeof dateTime === 'string') {
      return toDatePickerDate(dateTime);
    } else {
      return dateToString(dateTime);
    }
  };

  let [alreadyanswered, setAlreadyanswered] = useState(false);

  const getNameBenef = useCallback(
    (name: string) => (record: any) => {
      const Benef = form.getFieldValue('thirdparties');
      const index = indexBy(Benef, 'tproleid')[record.tproleid];
      return ['thirdparties', index, name];
    },
    [form]
  );
  const addRowsyn = () => {
    let totalcoef =
      sumBy(form.getFieldValue('syndication'), 'partcoef') +
      form.getFieldValue('ctsyndmgcoef');
    let investamount = isNaN(
      form.getFieldValue(getName('cteinvestamount', elementID))
    )
      ? 0
      : form.getFieldValue(getName('cteinvestamount', elementID));
    addsyn(
      newsynd(
        form.getFieldValue('cttype') === 'LEAD' ? 'PARTNER' : 'LEAD',
        100 - totalcoef,
        investamount * (Number(100 - totalcoef) / 100)
      )
    );
  };

  const handleSyndTPChange = async (
    tpid: number,
    syndid: number,
    tprole: string
  ) => {
    await getThirdPartyRoleListByTpid({ tpid: tpid }).then((response) => {
      if (response.code === '200') {
        const data = response.list.find((tp: any) => tp.tprolecode === tprole);
        form.setFieldsValue({
          syndication: form.getFieldValue('syndication').map((synd: any) => {
            if (synd.syndid === syndid)
              return {
                ...synd,
                tpadrid: data?.tpadrid,
                tpbkidout: data?.tpbkidout,
                tpbkidin: data?.tpbkidin,
                payoutmode: data?.tppaymodeout,
                payinmode: data?.tppaymodein,
              };
            else return synd;
          }),
        });
      }
    });
  };
  const addRowBen = () => {
    // let totalrequestedamount = sumBy(
    //   form
    //     .getFieldValue('thirdparties')
    //     .filter((elem: any) => elem.tprolecode === 'MFBENEF'),
    //   'mfrequestedamount'
    // );
    // let mfrequestedamount = form.getFieldValue('mfrequestedamount');
    // let newrequested =
    //   totalrequestedamount < Number(mfrequestedamount ?? 0)
    //     ? mfrequestedamount - totalrequestedamount
    //     : 0;
    addtp(newBF(0)); //newrequested
  };
  const getName = (param: string, cteid: any) => {
    let lcteid = form.getFieldValue('selectedElement');

    if (lcteid === 1) {
      return ['elements', 'FIN', 0, param];
    } else {
      if (form.getFieldValue(['elements', 'FIN'])) {
        const index = form
          .getFieldValue(['elements', 'FIN'])
          .findIndex((item: any) => item?.cteid === lcteid);
        return ['elements', 'FIN', index, param];
      } else {
        return ['elements', 'FIN', 0, param];
      }
    }
  };

  const getNameFinOut = (param: string, cteid: any) => {
    return ['elements', 'FINOUT', 0, param];
  };

  const getNameSpv = (param: string, cteid: any) => {
    return ['elements', 'SPV', 0, param];
  };

  const getHelperSpv = (param: string, cteid: any) => {
    return ['elements', 'SPV', 0, 'helpers', param];
  };

  const getHelperFinOut = (param: string, cteid: any) => {
    return ['elements', 'FINOUT', 0, 'helpers', param];
  };

  const getHelper = (param: string, cteid: any) => {
    let lcteid = form.getFieldValue('selectedElement');

    if (lcteid === 1) {
      return ['elements', 'FIN', 0, 'helpers', param];
    } else {
      if (form.getFieldValue(['elements', 'FIN'])) {
        const index = form
          .getFieldValue(['elements', 'FIN'])
          .findIndex((item: any) => item.cteid === lcteid);
        return ['elements', 'FIN', index, 'helpers', param];
      } else {
        return ['elements', 'FIN', 0, param];
      }
    }
  };
  const handleAddBenef = (
    tpid: number,
    tpname: string,
    tpreference: string,
    index: number
  ) => {
    let alltp = form.getFieldValue('thirdparties') ?? [];

    getThirdPartyRoleListByTpid({ tpid: tpid }).then((response) => {
      if (response.code !== '200') {
        notification.error({
          message: response.message,
          description: response.description,
          duration: 0,
        });
      } else {
        if (response.list?.length !== 0 && response.list !== null) {
          let roleData = response.list?.find(
            (e) => e.tprolecode === 'MFBENEF' && e.status === 'VALID'
          );

          if (roleData === null && response?.list) {
            roleData = response?.list[0];
          }
          alltp[index] = {
            ...alltp[index],
            ...TpRoleToTp('MFBENEF', roleData, tpname, tpreference, ctrid),
          };

          form.setFieldsValue({ thirdparties: [] });
          alltp = alltp.slice(); //thats will trigger the form
          form.setFieldsValue({
            thirdparties: alltp,
          });
        }
      }
    });
  };
  const removeStep = (ctesorder: number) => {
    const eleID = isNaN(form.getFieldValue('selectedElement'))
      ? elementID
      : form.getFieldValue('selectedElement');

    const indexElement = form
      .getFieldValue(['elements', 'FIN'])
      .findIndex((item: any) => item.cteid === eleID);

    const FinElements = form.getFieldValue(['elements', 'FIN']);

    var FinElemStep = form.getFieldValue([
      'elements',
      'FIN',
      indexElement,
      'conElemSteps',
    ]) as PropElemStepResponse[];

    FinElemStep = FinElemStep.filter((item) => item.ctesorder !== ctesorder);
    FinElemStep = FinElemStep.map((step) => {
      return { ...step, status: 'ERROR' };
    });

    form.setFieldsValue({
      elements: {
        FIN: FinElements.map((element: any, index: number) =>
          index === indexElement
            ? {
                ...element,
                conElemSteps: FinElemStep,
                conElemSchedules: [],
              }
            : element
        ),
      },
    });
  };
  const clearElementsstep = (cteid: any) => {
    const finelements = form.getFieldValue(['elements', 'FIN']);
    form.setFieldsValue({
      elements: {
        FIN: finelements.map((element: any) =>
          element.cteid === cteid
            ? {
                ...element,
                conElemSteps: [],
              }
            : element
        ),
      },
    });
  };
  const addStep = () => {
    const eleID = isNaN(form.getFieldValue('selectedElement'))
      ? elementID
      : form.getFieldValue('selectedElement');

    const indexElement = form
      .getFieldValue(['elements', 'FIN'])
      .findIndex((item: any) => item.cteid === eleID);

    const FinElements = form.getFieldValue(['elements', 'FIN']);

    var FinElemStep = form.getFieldValue([
      'elements',
      'FIN',
      indexElement,
      'conElemSteps',
    ]);

    if (FinElemStep === undefined || isEmpty(FinElemStep)) {
      FinElemStep = [rowStep(1)];
    } else {
      const ctesorder = FinElemStep?.length + 1;
      FinElemStep.push(rowStep(ctesorder));
    }

    form.setFieldsValue({
      elements: {
        FIN: FinElements.map((element: any, index: number) =>
          index === indexElement
            ? {
                ...element,
                conElemSteps: FinElemStep,
              }
            : element
        ),
      },
    });
  };
  const rowStep = (ctesorder: number): PropElemStepResponse => {
    return {
      ctesid: Math.floor(_.random(10000) * 10000000),
      ctesorder: ctesorder,
      ctesyear: 0,
      ctesyearend: 0,
      ctesperiodicity: '1',
      ctesperiodicityunit: 'M',
      ctesduration: 1,
      ctesamortizedcoef: 0,
      ctesoutstandingamount: 0,
      ctesrentalamount: 0,
      ctesrentalcoef: 0,
      cteid: 0,
      ctesperiodicityunitlabel: '',
      ctrid: 0,
      status: 'ERROR',
    };
  };
  const rowWeighteStep = (ctesorder: number): PropElemStepResponse => {
    return {
      ctesid: Math.floor(_.random(100000) * 10000000),
      ctesorder: ctesorder,
      ctesyear: 0,
      ctesyearend: 0,
      ctesperiodicity: '1',
      ctesperiodicityunit: 'M',
      ctesduration: 1,
      ctesamortizedcoef: 0,
      ctesoutstandingamount: 0,
      ctesrentalamount: 0,
      ctesrentalcoef: 0,
      cteid: 0,
      ctesperiodicityunitlabel: '',
      ctrid: 0,
      status: 'ERROR',
    };
  };

  const recalculateSteps = debounce(
    (index: number, field: string, updatedValues: any) => {
      const eleID = isNaN(form.getFieldValue('selectedElement'))
        ? elementID
        : form.getFieldValue('selectedElement');
      const indexElement = form
        .getFieldValue(['elements', 'FIN'])
        .findIndex((item: any) => item.cteid === eleID);
      const FinElements = form.getFieldValue(['elements', 'FIN']);

      const finAmount =
        form.getFieldValue([
          'elements',
          'FIN',
          indexElement,
          'ctefinancedamount',
        ]) ?? 1;

      var FinElemStep = form.getFieldValue([
        'elements',
        'FIN',
        indexElement,
        'conElemSteps',
      ]) as PropElemStepResponse[];
      // eslint-disable-next-line array-callback-return
      const newValues = FinElemStep.map((item, i) => {
        if (i > index) {
          return { ...item, status: 'ERROR' };
        } else if (i === index) {
          const updatedItem = { ...item, ...{ field: updatedValues } };

          if (field === 'ctesorder') {
            const ctesorder = updatedValues;

            return {
              ...updatedItem,
              ctesorder,
              status: 'ERROR',
            };
          }
          if (field === 'ctesyear') {
            const ctesyear = updatedValues;

            return {
              ...updatedItem,
              ctesyear,
              status: 'ERROR',
            };
          }

          if (field === 'ctesyearend') {
            const ctesyearend = updatedValues;

            return {
              ...updatedItem,
              ctesyearend,
              status: 'ERROR',
            };
          }
          if (field === 'ctesduration') {
            const ctesduration = updatedValues;

            return {
              ...updatedItem,
              ctesduration,
              status: 'ERROR',
            };
          }
          if (field === 'ctesperiodicity') {
            const ctesperiodicity = updatedValues;

            return {
              ...updatedItem,
              ctesperiodicity,
              status: 'ERROR',
            };
          }

          if (field === 'ctesperiodicityunit') {
            const ctesperiodicityunit = updatedValues;

            return {
              ...updatedItem,
              ctesperiodicityunit,
              status: 'ERROR',
            };
          }

          ///

          if (field === 'ctesrentalcoef') {
            const ctesrentalcoef = updatedValues;
            const ctesrentalamount = (finAmount * updatedValues) / 100;

            return {
              ...updatedItem,
              ctesrentalcoef,
              ctesrentalamount,
              status: 'ERROR',
            };
          }

          if (field === 'ctesrentalamount') {
            const ctesrentalamount = updatedValues;
            const ctesrentalcoef = (updatedValues / finAmount) * 100;

            return {
              ...updatedItem,
              ctesrentalcoef,
              ctesrentalamount,
              status: 'ERROR',
            };
          }

          if (field === 'ctesamortizedcoef') {
            const ctesamortizedcoef = updatedValues;
            const ctesoutstandingamount = (finAmount * updatedValues) / 100;

            return {
              ...updatedItem,
              ctesamortizedcoef,
              ctesoutstandingamount,
              status: 'ERRORRENT',
            };
          }

          if (field === 'ctesoutstandingamount') {
            const ctesoutstandingamount = updatedValues;
            const ctesamortizedcoef = (updatedValues / finAmount) * 100;

            return {
              ...updatedItem,
              ctesamortizedcoef,
              ctesoutstandingamount,
              status: 'ERROR',
            };
          }
        } else return item;
      });
      form.setFieldsValue({
        elements: {
          FIN: FinElements.map((element: any, index: number) =>
            index === indexElement
              ? {
                  ...element,
                  conElemSteps: newValues,
                  // conElemSchedules: [],
                }
              : element
          ),
        },
      });
    },
    500
  );

  const calculateAge = (birthDateString: any) => {
    const birthDate = new Date(birthDateString);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    return age;
  };

  const getFilterList = (
    _assets?: any[],
    _offerCriteriaList?: Array<FilteringCriteria>
  ): prFilteringCriteria => {
    let assetList = _assets ?? form?.getFieldValue('assets') ?? [];

    let assetUseCriteriaList: Array<AssetUseCriteria> = [];
    let assetRVCriteriaList: Array<AssetRVCriteria> = [];
    let offerCriteriaList: Array<FilteringCriteria> = _offerCriteriaList ?? [];
    let ret: prFilteringCriteria;

    offerCriteriaList.push({
      critcode: 'PROPORIGIN',
      critvalue: form?.getFieldValue('ctproporigin') ?? '',
    });

    offerCriteriaList.push({
      critcode: 'DEALRATING',
      critvalue: form?.getFieldValue('ctdealerrating') ?? '',
    });

    offerCriteriaList.push({
      critcode: 'OFFER',
      critvalue: form?.getFieldValue('offerid') ?? '0',
    });
    offerCriteriaList.push({
      critcode: 'NASSETS',
      critvalue: form?.getFieldValue('assets')?.length ?? '0',
    });

    const duration = form
      ?.getFieldValue(['elements', 'FIN'])
      ?.filter(
        (e: any) => e?.cteid === form?.getFieldValue('selectedElement')
      )[0]?.cteduration;

    offerCriteriaList.push({
      critcode: 'DURATION',
      critvalue: duration ?? 48,
    });

    const invest = sumBy(form?.getFieldValue('assets'), 'assetnetamount');

    offerCriteriaList.push({
      critcode: 'INVEST',
      critvalue:
        invest && invest > 0
          ? String(invest)
          : String(form?.getFieldValue('ctfinancedamount')),
    });

    //PROPORIGIN

    offerCriteriaList.push({
      critcode: 'PRCODE',
      critvalue: form?.getFieldValue('flagmasterfacility')
        ? form?.getFieldValue('mfprcode')
        : form?.getFieldValue('prcode') ?? '',
    });
    offerCriteriaList.push({
      critcode: 'TPTYPE',
      critvalue: form.getFieldValue('client')?.tptype ?? '',
    });
    offerCriteriaList.push({
      critcode: 'NETWORK',
      critvalue: form.getFieldValue('ctnetworkcode') ?? '',
    });
    offerCriteriaList.push({
      critcode: 'CLIRATING',
      critvalue: form.getFieldValue('client')?.tpsalestatus ?? '',
    });

    offerCriteriaList.push({
      critcode: 'TPAGE',
      critvalue:
        String(calculateAge(form?.getFieldValue('tpbirthdate'))) ?? '0',
      // ?.filter(
      //   (tp: any) =>tp.tprolecode !== 'CLIENT'
      // )?.tpbirthdate)) ?? '',
    });

    assetList?.forEach((a: any) => {
      assetRVCriteriaList.push({
        catalogid: a.catalogid,
        assetid: a.assetid,
        assetsegment: a.assetsegment,
        assetfamily: a.assetfamily,
        assettype: a.assettype,
        assetcategory: a.assetcategory,
        assetmodel: a.assetmodel,
        assetbrand: a.assetbrand,
        assetbrandmodel: a.assetbrandmodel,
        assetnetamount: a.assetnetamount,
        assetfinamount: a.assetfinamount,
        assetvariant: a.assetvariant,
        // assetclass :a.assetclass,
      });

      offerCriteriaList.push({
        critcode: 'ASSETFAM',
        critvalue: a.assetfamily,
      });
      offerCriteriaList.push({ critcode: 'ASSETTYPE', critvalue: a.assettype });
      offerCriteriaList.push({
        critcode: 'ASSETCAT',
        critvalue: a.assetcategory,
      });

      offerCriteriaList.push({
        critcode: 'ASSETMODEL',
        critvalue: a.assetmodel,
      });

      a.assetusereqList?.forEach((u: any) => {
        offerCriteriaList.push({
          critcode: u.attcode,
          critvalue: u.usevalue ?? '',
        });
      });

      offerCriteriaList.push({
        critcode: 'FLAGUSED',
        critvalue: String(a.flagused) ?? '',
      });

      a.power != null ??
        offerCriteriaList.push({ critcode: 'POWER', critvalue: a.power ?? '' });
      // additional attributes :
      a.entityAddAttributList?.forEach((e: any) => {
        e.attstringvalue !== null
          ? offerCriteriaList.push({
              critcode: e.attcode,
              critvalue: e.attstringvalue,
            })
          : e.attnumericvalue !== null ??
            offerCriteriaList.push({
              critcode: e.attcode,
              critvalue: e.attnumericvalue,
            });
      });

      if (getEnvValue('FLAG_APPLY_ASSET_USE')) {
        a.assetusereqList?.forEach((u: any) => {
          assetUseCriteriaList.push({
            assetfamily: a.assetfamily,
            assettype: a.assettype,
            assetcategory: a.assetcategory,
            catalogid: a.catalogid ?? '',
            attcode: u.attcode ?? '',
            attvalue: u.usevalue ?? '',
          });
        });
      }
    });

    ret = {
      prcode: form?.getFieldValue('flagmasterfacility')
        ? form?.getFieldValue('mfprcode')
        : form?.getFieldValue('prcode') ?? '',
      tpid: form.getFieldValue('client')?.tpid ?? 0,
      tpidbroker: form.getFieldValue('broker')?.tpid ?? 0,
      tpidmanufacturer:
        assetList && assetList.length > 0
          ? assetList![0]?.tpidmanufacturer ?? 0
          : 0,
      assetUseCriteria: assetUseCriteriaList,
      assetRVCriteria: assetRVCriteriaList,
      offerCriteria: offerCriteriaList,
      flagApplyAssetUse: getEnvValue('FLAG_APPLY_ASSET_USE'),
      flagApplyAttributesExtendDurationValues: true,
      flagApplyAttributesExtendFirstRentalValues: true,
      flagApplyAttributesExtendRVValues: true,
      flagApplyAttributesExtendRateValues: true,
      flagApplyExtendDurationValues: true,
      flagApplyExtendFirstRentalValues: true,
      flagApplyExtendRVValues: true,
      flagApplyExtendRateValues: true,
    };
    return ret;
  };

  const setAssetRvAmount = (rvamount: any) => {
    const cteid = form.getFieldValue('selectedElement');
    let assets = form.getFieldValue('assets');
    const FinElement = form
      .getFieldValue(['elements', 'FIN'])
      .find((ele: any) => ele.cteid === cteid);
    assets = assets.map((asset: any) => {
      if (asset.cteid === cteid) {
        return {
          ...asset,
          assetrvamount:
            (Number(asset.assetfinamount) / FinElement.cteinvestamount) *
            rvamount,
        };
      } else return asset;
    });
    form.setFieldsValue({
      assets: assets,
    });
  };

  const handlesyncoef = (coef: any) => {
    let investamount = form.getFieldValue('ctfinancedamount') * (coef / 100);
    let syndList = form.getFieldValue('syndication');

    let investamountOfFin = isNaN(
      form.getFieldValue(getName('cteinvestamount', elementID))
    )
      ? 0
      : form.getFieldValue(getName('cteinvestamount', elementID));
    if (syndList.length > 1) {
      syndList = syndList.map((synd: any) => ({
        ...synd,
        partamount: 0,
        partcoef: 0,
      }));
    }
    if (syndList.length === 1)
      syndList = syndList.map((synd: any) => ({
        ...synd,
        partamount:
          investamountOfFin *
          ((100 - form.getFieldValue('ctsyndmgcoef')) / 100),
        partcoef: 100 - form.getFieldValue('ctsyndmgcoef'),
      }));

    form.setFieldsValue({
      ctsyndmgpartamount: investamount,
      syndication: syndList,
    });
  };
  const calculatePaymentSheduleStep = (inCteid: number) => {
    const indexElement = form
      .getFieldValue(['elements', 'FIN'])
      .findIndex((item: any) => item.cteid === inCteid);

    const FinElements = form.getFieldValue(['elements', 'FIN']);
    const finElement = FinElements[indexElement !== -1 ? indexElement : 0];

    let FinElemStep = form.getFieldValue([
      'elements',
      'FIN',
      indexElement !== -1 ? indexElement : 0,
      'conElemSteps',
    ]) as any[];

    // calculate FIN
    var finamount = 0;

    const investamount = finElement.cteinvestamount;
    // const firstPayment = finElement.ctefirstpayment;
    // const rvAmount = finElement.ctervamount;
    const upfront = finElement.cteupfrontamount;

    var part = 0;

    const partmethod = finElement.ctepartmethod;

    if (partmethod === 'PROMO' || partmethod === 'REDUCEFIN') {
      part = isNaN(finElement.ctepartamount) ? 0 : finElement.ctepartamount;
    }

    const extracost =
      finElement.cteextracosttofinance == null
        ? 0
        : finElement.cteextracosttofinance;

    finamount = investamount + extracost - upfront - part;

    if (isNil(FinElemStep) || FinElemStep.length === 0) {
      notification.error({
        message: 'Please add steps before',
        description: '',
        duration: 10,
      });
      return;
    } else {
      FinElemStep.forEach((s: PropElemStepRequest) => {
        s.ctesoutstandingamount = (finamount * s.ctesamortizedcoef) / 100;
      });

      setLoading(true);
      finEngine
        .calculatePaymentSheduleSteps({
          finReq: {
            elementStep: FinElemStep,
            inBillingDate: finElement?.ctebilligdate,
            inCalculationMethod: 'STEP',
            inCountingbasis: finElement?.cteratebasis,
            inDeferredMethod: finElement?.ctedeferredinterestmethod,
            inDeferredRate: finElement?.ctedeferredinterestnominalrate,
            inDepositAmount:
              finElement?.ctedepositamount == null
                ? 0
                : finElement?.ctedepositamount,
            inDepositMethod: finElement?.ctedepositinterestmethod,
            inDepositRate:
              finElement?.ctedepositnominalrate == null
                ? 0
                : finElement?.ctedepositnominalrate,

            inFinancedAmount: finamount,
            inFirstInstallmentDate: '', //dateToString(finElement?.ctestartdate),
            inInterestMethod: finElement?.cteinterestmethod,
            inPartAmount:
              finElement?.ctepartamount == null ? 0 : finElement?.ctepartamount,
            inPartMethod: finElement?.ctepartmethod
              ? finElement?.ctepartmethod
              : 'NONE',
            inPartNbDays:
              finElement?.ctepartdays == null ? 0 : finElement?.ctepartdays,
            inPartRate:
              finElement?.ctepartrate == null ? 0 : finElement?.ctepartrate,
            inPartInvoicingMode: '',
            inRatePeriodicity: finElement?.cterateperiodicity,
            inRateType: finElement?.cteratetype,
            inRateValue:
              finElement?.ctenominalrate == null
                ? 0
                : finElement?.ctenominalrate,
            inRoundingAmount: getRounding(finElement.currcode),
            inRoundingRate: 9,
            inStartDate: dateToString(finElement.ctestartdate),
            inTaxcode: finElement?.taxcode,
            inTaxrate: finElement?.taxrate,
            inTaxtype: finElement?.taxtype,
            inTerm: finElement?.ctepaymentterm,
            inUpfrontAmount: finElement?.cteupfrontamount,
          },
        })
        .then((res) => {
          setLoading(false);
          if (res.success) {
            message.success(t(`finEngine.${res.message}`));
            let ind = res.elementStep.length;
            let rvamount = 0;
            let rvcoef = 0;

            if (ind > 0) {
              rvamount = res.elementStep[ind - 1].ctesoutstandingamount;
              rvcoef = res.elementStep[ind - 1].ctesamortizedcoef;
            }

            let _paymentSchedule = res.paymentSchedule.filter(
              (res) => res.ctstype !== 'RV'
            );

            let maxCteEnddate = _.maxBy(
              _paymentSchedule,
              'ctsenddate'
            )?.ctsenddate;

            setAssetRvAmount(_.last(res.elementStep)?.ctesoutstandingamount);

            let _elements = {
              FIN: FinElements.map((element: any, index: number) =>
                index === indexElement
                  ? {
                      ...element,
                      conElemSchedules: res.paymentSchedule,
                      ctedeferredinterestnominalrate: res.inDeferredRate,
                      ctedeferredinterest: res.deferredInterest,
                      ctedepositnominalrate: res.inDepositRate,
                      ctedepositinterest: res.depositInterest,
                      cteactuarialrate: res.effectiverate,
                      ctervamount: rvamount,
                      ctervcoef: rvcoef,
                      ctefirstpayment: 0,
                      ctefirstpaymentcoef: 0,
                      cteenddate:
                        maxCteEnddate !== ''
                          ? toDatePickerDate(maxCteEnddate)
                          : '',
                      conElemSteps: res.elementStep.map((step) => {
                        return {
                          ...step,
                          ctesid: Math.floor(_.random(100000) * 10000000), //theres no ctesid received
                          ctesamortizedcoef: step.ctesamortizedcoef,
                          ctesperiodicity: step.ctesperiodicity,
                        };
                      }),
                    }
                  : element
              ),
            };

            form.setFieldValue('elements', _elements);

            calculateServAndComm(res, finElement, finamount, inCteid);
          } else {
            message.error(res.message);
          }
        })
        .catch((err) => {
          setLoading(false);
        });

      /// end calculate FIN
    }
  }; // end calculate PaymentShedule Steps :
  const setTargetRentalAmount = debounce(async (e: any) => {
    if (e !== 0) {
      const cteid = form.getFieldValue('selectedElement');

      const finElement = form
        .getFieldValue(['elements', 'FIN'])
        .find((item: any) => item.cteid === cteid);

      const coef = finElement.conElemSteps[0]?.ctesrentalcoef;
      const oldInstallment = finElement.cteinstallmentamount;

      const servElement = form
        .getFieldValue(['elements', 'SERV'])
        .filter((item: any) => item.cteidparent === cteid);

      let oldRental = getFirstGlobalPayment();

      const newRental = oldInstallment * (e / oldRental); //*coef/100;

      finElement.cteinstallmentamount = newRental;

      finElement.conElemSteps.forEach((s: any) => {
        s.ctesrentalamount = (newRental * s.ctesrentalcoef) / 100;
      });

      setLoading(true);

      finEngine
        .calculate({
          finReq: {
            inBillingDate: finElement?.ctebilligdate,
            inCalculationMethod: 'FINANCING', // INST
            inCalculationType: finElement?.ctecalculationtype,
            inCountingbasis: finElement?.cteratebasis,
            inDeferredMethod: finElement?.ctedeferredinterestmethod,
            inDeferredRate: finElement?.ctedeferredinterestnominalrate,
            inDepositAmount:
              finElement?.ctedepositamount == null
                ? 0
                : finElement?.ctedepositamount,
            inDepositMethod: finElement?.ctedepositinterestmethod,
            inDepositRate:
              finElement?.ctedepositinterestmethod === 'NONE'
                ? 0
                : finElement?.ctedepositnominalrate == null
                ? 0
                : finElement?.ctedepositnominalrate,
            inDuration: finElement?.cteduration,
            inFinancedAmount: finElement?.ctefinancedamount ?? 0,
            inFirstInstallmentDate: '', //dateToString(finElement?.ctestartdate),
            inFirstPayment: finElement.ctefirstpayment,
            inGracePeriodDuration:
              finElement?.ctegraceperiodduration == null
                ? 0
                : finElement?.ctegraceperiodduration,
            inGracePeriodMethod: finElement?.ctegraceperiodmethod,
            inInstallmentAmount: finElement?.cteinstallmentamount,
            inInterestMethod: finElement?.cteinterestmethod,
            inPartAmount:
              finElement?.ctepartamount == null ? 0 : finElement?.ctepartamount,
            inPartMethod: finElement?.ctepartmethod
              ? finElement?.ctepartmethod
              : 'NONE',
            inPartNbDays:
              finElement?.ctepartdays == null ? 0 : finElement?.ctepartdays,
            inPartRate:
              finElement?.ctepartrate == null ? 0 : finElement?.ctepartrate,
            inPeriodicity: finElement?.cteperiodicity,
            inPeriodicityUnit: finElement?.cteunit,
            inRatePeriodicity: Number(finElement?.cterateperiodicity),
            inRateType: finElement?.cteratetype,
            inRateValue:
              finElement?.ctenominalrate == null
                ? 0
                : finElement?.ctenominalrate,
            inResidualValue: finElement.ctervamount,
            inRoundingAmount: getRounding(finElement.currcode),
            inRoundingRate: 9,
            inStartDate: dateToString(finElement?.ctestartdate),
            inTaxcode: finElement?.taxcode,
            inTaxrate: finElement?.taxrate,
            inTaxtype: finElement?.taxtype,
            inTerm: finElement?.ctepaymentterm,
            inUpFrontAmount:
              finElement?.cteupfrontamount == null
                ? 0
                : finElement?.cteupfrontamount,
            inFeesAmount: finElement?.ctefeesamount,
            inDealerPartAmount: finElement?.ctepartamount,
            inManufacturerPartAmount: 0,
            inCommissionAmount: finElement?.ctecommissionamount ?? 0,
            inProfitabilityRate: finElement?.cteprofitabilityrate ?? 0,
            inFundingRate: finElement?.ctefundingrate,
            inFundingPeriodicity: finElement?.ctefundingperiodicity,
            inVatAmount: finElement?.ctevatdeferralamount,
            inVatDuration: finElement?.ctevatdeferralduration,
            inVatDaysBasis: finElement?.ctevatdeferraldaysbasis,
            inVatMethod: finElement?.ctevatdeferralmethod,
          },
        })
        .then((res) => {
          setLoading(false);
          if (res.success) {
            const FinElements = form.getFieldValue(['elements', 'FIN']) || [];

            form.setFieldsValue({
              elements: {
                FIN: FinElements.map((element: any, index: number) =>
                  element.cteid === cteid
                    ? {
                        ...element,
                        conElemSteps: finElement.conElemSteps,
                        ctefinancedamount: res.financedamount,
                        cteinstallmentamount: newRental,
                        cteupfrontamount:
                          finElement.cteinvestamount +
                          (finElement.cteextracosttofinance == null
                            ? 0
                            : finElement.cteextracosttofinance) -
                          res.financedamount -
                          res.partAmount,
                      }
                    : element
                ),
              },
            });
            calculateNew(cteid, '', 'INST');
          } // end test success
        })
        .catch((err) => {
          setLoading(false);
        });

      /// end calculate upfront
    }
  }, 1000);

  const getFirstGlobalPayment = () => {
    const cteid = form.getFieldValue('selectedElement');

    const finElement = form
      .getFieldValue(['elements', 'FIN'])
      .filter((item: any) => item.cteid === cteid);

    let rental = 0;
    for (var fin of finElement) {
      rental =
        rental +
          fin?.conElemSchedules.filter((s: any) => s.ctstype === 'RENTAL')[0]
            ?.ctsrentalamount ?? 0;
    }

    const servElement = form
      .getFieldValue(['elements', 'SERV'])
      .filter((item: any) => item.cteidparent === cteid);

    for (var serv of servElement) {
      rental = rental + serv?.conElemSchedules[0]?.ctsrentalamount ?? 0;
    }

    return rental;
  };

  const getParticipationAmount = async (
    cteid: number,
    investAmount: number
  ) => {
    const indexElement = form
      .getFieldValue(['elements', 'FIN'])
      ?.findIndex((item: any) => item.cteid === cteid);
    let elements = form.getFieldValue('elements');
    let finelements = form.getFieldValue(['elements', 'FIN']);

    const finElement = finelements[indexElement];

    const ctepartmethod = finelements[indexElement].ctepartmethod;

    var ctepartamount = isNaN(finelements[indexElement].ctepartamount)
      ? 0
      : finelements[indexElement].ctepartamount;

    //set rvamount for seasonalcalculation

    const attrList = finelements[indexElement]?.conElemAttributes;

    let totalPartAmount = 0;

    switch (ctepartmethod) {
      case 'PROMO':
        return ctepartamount;
      case 'REDUCEFIN':
        return ctepartamount;
      case 'MULTI':
        if (attrList !== null) {
          await Promise.all(
            attrList.map(async (a: PropElemAttributeResponse) => {
              if (a.atttype === 'PART') {
                let nbmonths =
                  a.nbmonthsdefault > finElement.cteduration
                    ? finElement.cteduration
                    : a.nbmonthsdefault;

                a.nbmonthsmax = nbmonths;

                if (a.attmethod === 'PROMO' || a.attmethod === 'REDUCEFIN') {
                  switch (a.attamountmethod) {
                    case 'PERC':
                      ctepartamount = (a.attcoef * investAmount) / 100;

                      break;
                    case 'AMOUNT':
                      ctepartamount = a.attamount;
                      break;
                    case 'PERCCAP':
                      ctepartamount = (a.attcoef * investAmount) / 100;
                      if (ctepartamount > a.attamountmax) {
                        ctepartamount = a.attamountmax;
                      }
                      break;
                    case 'INTCAP':
                      if (a.attstatus === 'INIT') {
                        ctepartamount = await calculateInterest(
                          finElement,
                          investAmount,
                          a.attrate,
                          nbmonths
                        ).then((res) => res?.totalInterest);
                        if (ctepartamount > a.attamountmax) {
                          ctepartamount = a.attamountmax;
                        }
                      } else {
                        ctepartamount = a.attamountrequested;
                      }

                      break;
                  }
                  totalPartAmount = totalPartAmount + ctepartamount;
                }
              }
              a.attamount = ctepartamount;
            })
          );
          // update element :
          finelements[indexElement].conElemAttributes = attrList;

          finelements[indexElement].ctepartamount = totalPartAmount;

          elements = { ...elements, FIN: finelements };

          form.setFieldsValue({ elements: elements });
        } else {
          ctepartamount = 0;
        }

        break;
    }
    return totalPartAmount;
  };

  const getInvestAmount = (invest: any) => {
    // if syndication = LEAD and SEPARATE ==> get MGcoef.
    // if syndication = LEAD and TOTAL ?? ==> get 100%.
    // if syndicaion = PART : get Mgcoef
    // else (synd = NONE or byuback....) get 100%

    let investamount = invest;
    if (
      (form.getFieldValue('cttype') === 'LEAD' &&
        form.getFieldValue('ctsyndinvoicingtype') === 'SEPARATE') ||
      form.getFieldValue('cttype') === 'PART'
    ) {
      let mycoef = form.getFieldValue('ctsyndmgcoef') ?? 100;
      investamount = investamount * (mycoef / 100);
    }
    return investamount;
  };
  const calculateSeasonal = (inCteid: number) => {
    const indexElement = form
      .getFieldValue(['elements', 'FIN'])
      .findIndex((item: any) => item.cteid === inCteid);

    const FinElements = form.getFieldValue(['elements', 'FIN']);
    const finElement = FinElements[indexElement];

    const FinElemStep = form.getFieldValue([
      'elements',
      'FIN',
      indexElement,
      'conElemSteps',
    ]) as any[];

    // calculate FIN

    var finamount = 0;
    const investamount = finElement.cteinvestamount;
    const upfront = finElement.cteupfrontamount;

    var part = 0;

    const partmethod = finElement.ctepartmethod;

    if (partmethod === 'PROMO' || partmethod === 'REDUCEFIN') {
      part = isNaN(finElement.ctepartamount) ? 0 : finElement.ctepartamount;
    }

    const extracost =
      finElement.cteextracosttofinance == null
        ? 0
        : finElement.cteextracosttofinance;

    finamount = investamount + extracost - upfront - part;

    if (FinElemStep === null || isEmpty(FinElemStep)) {
      notification.error({
        message: 'Please add steps before',
        description: '',
        duration: 10,
      });
      return;
    } else {
      setLoading(true);

      finEngine
        .calculateSeasonalSchedule({
          finReq: {
            elementStep: FinElemStep,
            inBillingDate: finElement?.ctebilligdate,
            inCalculationMethod: 'SEASON',
            inCountingbasis: finElement?.cteratebasis,
            inDeferredMethod: finElement?.ctedeferredinterestmethod,
            inDeferredRate: finElement?.ctedeferredinterestnominalrate,
            inDepositAmount:
              finElement?.ctedepositamount == null
                ? 0
                : finElement?.ctedepositamount,
            inDepositMethod: finElement?.ctedepositinterestmethod,
            inDepositRate:
              finElement?.ctedepositnominalrate == null
                ? 0
                : finElement?.ctedepositnominalrate,

            inFinancedAmount: finamount,
            inFirstInstallmentDate: '', //dateToString(finElement?.ctestartdate),
            inInterestMethod: finElement?.cteinterestmethod,
            inPartAmount:
              finElement?.ctepartamount == null ? 0 : finElement?.ctepartamount,
            inPartMethod: finElement?.ctepartmethod
              ? finElement?.ctepartmethod
              : 'NONE',
            inPartNbDays:
              finElement?.ctepartdays == null ? 0 : finElement?.ctepartdays,
            inPartRate:
              finElement?.ctepartrate == null ? 0 : finElement?.ctepartrate,
            inRatePeriodicity: finElement?.cterateperiodicity,
            inRateType: finElement?.cteratetype,
            inRateValue:
              finElement?.ctenominalrate == null
                ? 0
                : finElement?.ctenominalrate,
            inRoundingAmount: getRounding(finElement.currcode),
            inRoundingRate: 9,
            inStartDate: dateToString(finElement.ctestartdate),
            inTaxcode: finElement?.taxcode,
            inTaxrate: finElement?.taxrate,
            inTaxtype: finElement?.taxtype,
            inTerm: finElement?.ctepaymentterm,
            inDuration: finElement?.cteduration,
            inFirstPayment: finElement?.ctefirstpayment,
            inResidualValue:
              finElement?.ctervamount === null ? 0 : finElement?.ctervamount,
            inUpFrontAmount:
              finElement?.cteupfrontamount === null
                ? 0
                : finElement?.cteupfrontamount,
          },
        })
        .then((res) => {
          setLoading(false);

          if (res.success) {
            //  message.success(t(`finEngine.${res.message}`));

            let _paymentSchedule = res.paymentSchedule.filter(
              (res) => res.ctstype !== 'RV'
            );

            let maxCteEnddate = _.maxBy(
              _paymentSchedule,
              'ctsenddate'
            )?.ctsenddate;

            form.setFieldsValue({
              elements: {
                FIN: FinElements.map((element: any, index: number) =>
                  element.cteid === inCteid
                    ? {
                        ...element,
                        conElemSchedules: res.paymentSchedule,
                        conElemSteps: res.elementStep,
                        cteenddate:
                          maxCteEnddate !== ''
                            ? toDatePickerDate(maxCteEnddate)
                            : '',
                      }
                    : element
                ),
              },
            });

            const conelemsteps = form.getFieldValue([
              'elements',
              'FIN',
              0,
              'conElemSteps',
            ]);

            //if (conelemsteps!=null ) {

            const newconelem = conelemsteps.map((element: any) => {
              let rent = res.elementStep.filter(
                (e) => Number(e.ctesorder) === Number(element.ctesorder)
              );

              return {
                ...element,
                ctesrentalamount: rent[0].ctesrentalamount,
                status: 'VALID',
              };
            });

            const FIN = form.getFieldValue(['elements', 'FIN']);
            let elements = form.getFieldValue('elements');
            FIN[0].conElemSteps = newconelem;
            elements = { ...elements, FIN: FIN };

            form.setFieldsValue({ elements: elements });

            message.success(t(`finEngine.${res.message}`));

            calculateServAndComm(res, finElement, finamount, inCteid);

            setVisibleSeasonal(true);
          } // end if success
        })
        .catch((err) => {
          setLoading(false);
        });

      /// end calculate FIN
    }
  }; //end calculation of PaymentShedule Seasonal :

  const calculateStepFinancial = useCallback(
    async (index: number, method: string) => {
      const eleID = isNaN(form.getFieldValue('selectedElement'))
        ? elementID
        : form.getFieldValue('selectedElement');

      const indexElement = form
        .getFieldValue(['elements', 'FIN'])
        .findIndex((item: any) => item.cteid === eleID);

      const FinElements = form.getFieldValue(['elements', 'FIN']);

      const finElement = FinElements[indexElement === -1 ? 0 : indexElement];

      const FinElemStep = form.getFieldValue([
        'elements',
        'FIN',
        indexElement === -1 ? 0 : indexElement,
        'conElemSteps',
      ]) as PropElemStepResponse[];

      const step = FinElemStep[index];

      // calculate FIN

      var finamount = 0;
      const investamount = finElement.cteinvestamount;
      // const firstPayment = finElement.ctefirstpayment;
      // const rvAmount = finElement.ctervamount;
      const upfront = finElement.cteupfrontamount;

      var part = 0;

      const partmethod = finElement.ctepartmethod;

      if (partmethod === 'PROMO' || partmethod === 'REDUCEFIN') {
        part = isNaN(finElement.ctepartamount) ? 0 : finElement.ctepartamount;
      }
      const extracost =
        finElement.cteextracosttofinance == null
          ? 0
          : finElement.cteextracosttofinance;

      finamount = investamount + extracost - upfront - part;
      var startamount = 0;

      if (index === 0) {
        startamount = finamount;
      } else {
        startamount = FinElemStep[index - 1].ctesoutstandingamount;
      }
      setLoadingCalculateStep(true);

      await finEngine
        .calculate({
          finReq: {
            inBillingDate: finElement?.ctebilligdate,
            inCalculationMethod: method === 'INST' ? 'INST' : 'OUTSTAND',
            inCalculationType: finElement?.ctecalculationtype,
            inCountingbasis: finElement?.cteratebasis,
            inDeferredMethod: finElement?.ctedeferredinterestmethod,
            inDeferredRate: finElement?.ctedeferredinterestnominalrate,
            inDepositAmount:
              finElement?.ctedepositamount == null
                ? 0
                : finElement?.ctedepositamount,
            inDepositMethod: finElement?.ctedepositinterestmethod,
            inDepositRate:
              finElement?.ctedepositnominalrate == null
                ? 0
                : finElement?.ctedepositnominalrate,
            inDuration: step.ctesduration,

            inFinancedAmount: startamount,
            inFirstInstallmentDate: '', //dateToString(finElement?.ctestartdate),
            inFirstPayment: 0,
            inGracePeriodDuration: 0,
            inGracePeriodMethod: 'NONE',
            inInstallmentAmount: step.ctesrentalamount,
            inInterestMethod:
              index === 0 ? finElement?.cteinterestmethod : 'BOP',
            inPartAmount:
              finElement?.ctepartamount == null ? 0 : finElement?.ctepartamount,
            inPartMethod: finElement?.ctepartmethod
              ? finElement?.ctepartmethod
              : 'NONE',
            inPartNbDays:
              finElement?.ctepartdays == null ? 0 : finElement?.ctepartdays,
            inPartRate:
              finElement?.ctepartrate == null ? 0 : finElement?.ctepartrate,
            inPeriodicity: step.ctesperiodicity,
            inPeriodicityUnit: step.ctesperiodicityunit,
            inRatePeriodicity: finElement?.cterateperiodicity,
            inRateType: finElement?.cteratetype,
            inRateValue:
              finElement?.ctenominalrate == null
                ? 0
                : finElement?.ctenominalrate,
            inResidualValue: step.ctesoutstandingamount,
            inRoundingAmount: getRounding(finElement.currcode),
            inRoundingRate: 9,
            inStartDate: dateToString(finElement.ctestartdate),
            inTaxcode: finElement?.taxcode,
            inTaxrate: finElement?.taxrate,
            inTaxtype: finElement?.taxtype,
            inTerm: finElement?.ctepaymentterm,
            inUpFrontAmount:
              finElement?.cteupfrontamount == null
                ? 0
                : finElement?.cteupfrontamount,
          },
        })
        .then((res) => {
          setLoadingCalculateStep(false);

          if (res.success) {
            message.success(t(`finEngine.${res.message}`));

            const ctesrentalamount = res.installmentamount;
            const ctesrentalcoef =
              (res.installmentamount / finElement.ctefinancedamount) * 100;
            const ctesoutstandingamount = res.residualvalue;
            const ctesamortizedcoef =
              (res.residualvalue / finElement.ctefinancedamount) * 100;
            const status = 'OK';

            const newValues = FinElemStep.map((item, i) => {
              if (i !== index) {
                return item;
              }
              const updatedItem = { ...item };

              return {
                ...updatedItem,
                ctesrentalcoef,
                ctesrentalamount,
                ctesamortizedcoef,
                ctesoutstandingamount,
                status,
              };
            });

            // call FinEngine with new values :
            setAssetRvAmount(_.last(newValues)?.ctesoutstandingamount); //back

            let _paymentSchedule = res.paymentSchedule.filter(
              (res) => res.ctstype !== 'RV'
            );

            let maxCteEnddate = _.maxBy(
              _paymentSchedule,
              'ctsenddate'
            )?.ctsenddate;

            const finElem: any = FinElements.map(
              (element: any, index: number) =>
                index === indexElement
                  ? {
                      ...element,
                      conElemSteps: [...newValues],
                      conElemSchedules: res.paymentSchedule,
                      cteenddate:
                        maxCteEnddate !== ''
                          ? toDatePickerDate(maxCteEnddate)
                          : '',
                    }
                  : element
            );

            const _elements: any = { FIN: finElem };

            form.setFieldValue('elements', _elements);
          } else {
            message.error(res.message);
          }
        })
        .catch((err) => {
          setLoadingCalculateStep(false);
        });

      await debouncedCalculateNew('', '');

      calculatePaymentSheduleStep(elementID);

      /// end calculate FIN
      //calculatePaymentSheduleStep(form.getFieldValue('selectedElement'));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [form]
  );

  ////////////////// Weighted Steps :

  const removeWeightedStep = (ctesid: number) => {
    const indexElement = form
      .getFieldValue(['elements', 'FIN'])
      .findIndex((item: any) => item.cteid === elementID);

    const FinElements = form.getFieldValue(['elements', 'FIN']);

    var FinElemStep = form.getFieldValue([
      'elements',
      'FIN',
      indexElement,
      'conElemSteps',
    ]) as PropElemStepResponse[];

    FinElemStep = FinElemStep.filter((item) => item.ctesid !== ctesid);

    form.setFieldsValue({
      elements: {
        FIN: FinElements.map((element: any, index: number) =>
          index === indexElement
            ? {
                ...element,
                conElemSteps: FinElemStep,
                conElemSchedules: [],
              }
            : element
        ),
      },
    });
  };

  const addWeightedStep = () => {
    const indexElement = form
      .getFieldValue(['elements', 'FIN'])
      .findIndex((item: any) => item.cteid === elementID);

    const FinElements = form.getFieldValue(['elements', 'FIN']);

    var FinElemStep = form.getFieldValue([
      'elements',
      'FIN',
      indexElement,
      'conElemSteps',
    ]);

    if (FinElemStep === undefined || isEmpty(FinElemStep)) {
      FinElemStep = [rowWeighteStep(1)];
    } else {
      const ctesorder = FinElemStep?.length + 1;
      FinElemStep.push(rowWeighteStep(ctesorder));
    }
    form.setFieldsValue({
      elements: {
        FIN: FinElements.map((element: any, index: number) =>
          index === indexElement
            ? {
                ...element,
                conElemSteps: FinElemStep,
              }
            : element
        ),
      },
    });
  };
  // eslint-disable-next-line no-unused-vars
  const rowWeightedStep = (ctesorder: number): PropElemStepResponse => {
    return {
      ctesid: Math.floor(_.random(10000) * 10000000),
      ctesorder: ctesorder,
      ctesyear: 0,
      ctesyearend: 0,
      ctesperiodicity: '1',
      ctesperiodicityunit: 'M',
      ctesduration: 1,
      ctesamortizedcoef: 0,
      ctesoutstandingamount: 0,
      ctesrentalamount: 0,
      ctesrentalcoef: 0,
      cteid: 0,
      ctesperiodicityunitlabel: '',
      ctrid: 0,
      status: 'ERROR',
    };
  };

  const recalculateWeightedSteps = useCallback(
    (index: number, field: string, updatedValues: any) => {
      const indexElement = form
        .getFieldValue(['elements', 'FIN'])
        .findIndex((item: any) => item.cteid === elementID);

      const FinElements = form.getFieldValue(['elements', 'FIN']);

      const finAmount =
        form.getFieldValue(getName('cteinstallmentamount', elementID)) !== 0 &&
        !isNaN(form.getFieldValue(getName('cteinstallmentamount', elementID)))
          ? form.getFieldValue(getName('cteinstallmentamount', elementID))
          : form.getFieldValue([
              'elements',
              'FIN',
              indexElement,
              'cteinvestamount',
            ]) ?? 1;

      var FinElemStep = form.getFieldValue([
        'elements',
        'FIN',
        indexElement,
        'conElemSteps',
      ]) as PropElemStepResponse[];

      // eslint-disable-next-line array-callback-return
      const newValues = FinElemStep.map((item, i) => {
        if (i !== index) {
          return item;
        }

        const ctesrentalcoef =
          field === 'ctesrentalcoef' ? updatedValues : item.ctesrentalcoef;
        const ctesrentalamount =
          field === 'ctesrentalamount' ? updatedValues : item.ctesrentalamount;
        // const updatedItem = { ...item, ...{ field: updatedValues } };  => we cant assign field as string as object field
        const updatedItem = {
          ...item,
          ctesrentalcoef: ctesrentalcoef,
          ctesrentalamount: ctesrentalamount,
        };

        if (field === 'ctesorder') {
          const ctesorder = updatedValues;

          return {
            ...updatedItem,
            ctesorder,
            status: 'ERROR',
          };
        }
        if (field === 'ctesduration') {
          const ctesduration = updatedValues;

          return {
            ...updatedItem,
            ctesduration,
            status: 'ERROR',
          };
        }
        if (field === 'ctesperiodicity') {
          const ctesperiodicity = updatedValues;

          return {
            ...updatedItem,
            ctesperiodicity,
            status: 'ERROR',
          };
        }

        if (field === 'ctesperiodicityunit') {
          const ctesperiodicityunit = updatedValues;

          return {
            ...updatedItem,
            ctesperiodicityunit,
            status: 'ERROR',
          };
        }

        ///

        if (field === 'ctesrentalcoef') {
          const ctesrentalcoef = updatedValues;
          const ctesrentalamount = (finAmount * updatedValues) / 100;
          return {
            ...updatedItem,
            ctesrentalcoef,
            ctesrentalamount,
            status: 'ERROR',
          };
        }

        if (field === 'ctesrentalamount') {
          const ctesrentalamount = updatedValues;
          const ctesrentalcoef = (updatedValues / finAmount) * 100;

          return {
            ...updatedItem,
            ctesrentalcoef,
            ctesrentalamount,
            status: 'ERROR',
          };
        }

        if (field === 'ctesamortizedcoef') {
          const ctesamortizedcoef = updatedValues;
          const ctesoutstandingamount = (finAmount * updatedValues) / 100;

          return {
            ...updatedItem,
            ctesamortizedcoef,
            ctesoutstandingamount,
            status: 'ERROR',
          };
        }

        if (field === 'ctesoutstandingamount') {
          const ctesoutstandingamount = updatedValues;
          const ctesamortizedcoef = (updatedValues / finAmount) * 100;

          return {
            ...updatedItem,
            ctesamortizedcoef,
            ctesoutstandingamount,
            status: 'ERROR',
          };
        }
      });

      form.setFieldsValue({
        elements: {
          FIN: FinElements.map((element: any, index: number) =>
            index === indexElement
              ? {
                  ...element,

                  conElemSteps: newValues,
                  conElemSchedules: [],
                }
              : element
          ),
        },
      });
      calculateWeightedStepFinancial(index, 'OUTSTAND');
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [form]
  );
  const handleselectformula = (rateval: number, rateof: string, rate: any) => {
    const cteid = form.getFieldValue('selectedElement');

    let FinElements = form.getFieldValue(['elements', 'FIN']);
    let indexEl = FinElements.findIndex((ele: any) => ele.cteid === cteid);

    if (rateof === 'prefin') {
      FinElements[indexEl].prefinrateref = rateval;
      FinElements[indexEl].prefinnominalrate =
        FinElements[indexEl].prefinratespread + rateval;
    }
    if (rateof === 'cte') {
      FinElements[indexEl].cterateref = rateval;
      FinElements[indexEl].ctenominalrate =
        rateval + FinElements[indexEl].cteratespread;
      FinElements[indexEl].ceilingrate = rate.ceilingrate;
      FinElements[indexEl].ceilingdefaultrate = rate.ceilingdefaultrate;
      FinElements[indexEl].floorrate = rate.floorrate;
      FinElements[indexEl].floordefaultrate = rate.floordefaultrate;
      FinElements[indexEl].calid = rate.calid;
    }

    form.setFieldsValue({
      elements: {
        FIN: FinElements,
      },
    });
  };
  const handleratespread = (rateval: any, rateof: string) => {
    let FinElements = form.getFieldValue(['elements', 'FIN']);
    if (rateof === 'prefin')
      FinElements[0].prefinnominalrate =
        FinElements[0].prefinrateref + Number(rateval);
    if (rateof === 'cte')
      FinElements[0].ctenominalrate =
        FinElements[0].cterateref + Number(rateval);
    form.setFieldsValue({
      elements: {
        FIN: FinElements,
      },
    });
  };
  const calculatePaymentSheduleWeightedStep = (
    method: string,
    FinElemStep: any
  ) => {
    const indexElement = form
      .getFieldValue(['elements', 'FIN'])
      .findIndex((item: any) => item.cteid === elementID);

    const FinElements = form.getFieldValue(['elements', 'FIN']);

    const finElement = FinElements[indexElement];

    //var finamount = 0;
    //const investamount = finElement.cteinvestamount;
    // const firstPayment = finElement.ctefirstpayment;
    // const rvAmount = finElement.ctervamount;
    //const upfront = finElement.cteupfrontamount;

    var part = 0;

    const partmethod = finElement.ctepartmethod;

    if (partmethod === 'PROMO' || partmethod === 'REDUCEFIN') {
      part = isNaN(finElement.ctepartamount) ? 0 : finElement.ctepartamount;
    }

    //finamount = investamount - upfront - part;

    if (FinElemStep === null || isEmpty(FinElemStep)) {
      notification.error({
        message: 'Please add steps before',
        description: '',
        duration: 10,
      });
      return;
    } else {
      setLoading(true);

      finEngine
        .calculatePaymentSheduleSteps({
          finReq: {
            elementStep: FinElemStep,
            inBillingDate: finElement?.ctebilligdate,
            inCalculationMethod: method ?? 'STEP',
            inCountingbasis: finElement?.cteratebasis,
            inDeferredMethod: finElement?.ctedeferredinterestmethod,
            inDeferredRate: finElement?.ctedeferredinterestnominalrate,
            inDepositAmount:
              finElement?.ctedepositamount == null
                ? 0
                : finElement?.ctedepositamount,
            inDepositMethod: finElement?.ctedepositinterestmethod,
            inDepositRate:
              finElement?.ctedepositnominalrate == null
                ? 0
                : finElement?.ctedepositnominalrate,

            inFinancedAmount: finElement?.ctefinancedamount,
            inFirstInstallmentDate: '', //dateToString(finElement?.ctestartdate),
            inInterestMethod: finElement?.cteinterestmethod,
            inPartAmount:
              finElement?.ctepartamount == null ? 0 : finElement?.ctepartamount,
            inPartMethod: finElement?.ctepartmethod
              ? finElement?.ctepartmethod
              : 'NONE',
            inPartNbDays:
              finElement?.ctepartdays == null ? 0 : finElement?.ctepartdays,
            inPartRate:
              finElement?.ctepartrate == null ? 0 : finElement?.ctepartrate,
            inPartInvoicingMode: '',
            inRatePeriodicity: finElement?.cterateperiodicity,
            inRateType: finElement?.cteratetype,
            inRateValue:
              finElement?.ctenominalrate == null
                ? 0
                : finElement?.ctenominalrate,
            inRoundingAmount: getRounding(finElement.currcode),
            inRoundingRate: 9,
            inStartDate: dateToString(finElement.ctestartdate),
            inTaxcode: finElement?.taxcode,
            inTaxrate: finElement?.taxrate,
            inTaxtype: finElement?.taxtype,
            inTerm: finElement?.ctepaymentterm,
            inUpfrontAmount: finElement?.cteupfrontamount,
          },
        })
        .then((res) => {
          setLoading(false);

          if (res.success) {
            message.success(t(`finEngine.${res.message}`));
            let ind = res.elementStep.length;
            let rvamount = 0;
            let rvcoef = 0;

            if (ind > 0) {
              // eslint-disable-next-line no-unused-vars
              rvamount = res.elementStep[ind - 1].ctesoutstandingamount;
              // eslint-disable-next-line no-unused-vars
              rvcoef = res.elementStep[ind - 1].ctesamortizedcoef;
            }

            let _paymentSchedule = res.paymentSchedule.filter(
              (res) => res.ctstype !== 'RV'
            );

            let maxCteEnddate = _.maxBy(
              _paymentSchedule,
              'ctsenddate'
            )?.ctsenddate;

            let elements = {
              FIN: FinElements.map((element: any, index: number) =>
                index === indexElement
                  ? {
                      ...element,
                      conElemSchedules: res.paymentSchedule,
                      conElemSteps: res.elementStep,
                      cteenddate:
                        maxCteEnddate !== ''
                          ? toDatePickerDate(maxCteEnddate)
                          : '',
                    }
                  : element
              ),
            };

            form.setFieldValue('elements', elements);
          } else {
            message.error(res.message);
          }
        })
        .catch((err) => {
          setLoading(false);
        });

      /// end calculate FIN
    }
  }; // end calculate PaymentShedule Steps :

  const calculatePaymentShedulePrefinSteps = (inCteid: number) => {
    const eleID = isNaN(form.getFieldValue('selectedElement'))
      ? elementID
      : form.getFieldValue('selectedElement');

    const indexElement = form
      .getFieldValue(['elements', 'FIN'])
      .findIndex((item: any) => item.cteid === eleID);

    const FinElements = form.getFieldValue(['elements', 'FIN']);
    const finElement = FinElements[indexElement !== -1 ? indexElement : 0];

    let FinElemStep = form.getFieldValue([
      'elements',
      'FIN',
      indexElement !== -1 ? indexElement : 0,
      'conElemPrefinSteps',
    ]) as any[];

    // calculate FIN
    var finamount = 0;

    const investamount = finElement.cteinvestamount;
    // const firstPayment = finElement.ctefirstpayment;
    // const rvAmount = finElement.ctervamount;
    const upfront = finElement.cteupfrontamount;

    var part = 0;

    const partmethod = finElement.ctepartmethod;

    if (partmethod === 'PROMO' || partmethod === 'REDUCEFIN') {
      part = isNaN(finElement.ctepartamount) ? 0 : finElement.ctepartamount;
    }

    const extracost =
      finElement.cteextracosttofinance == null
        ? 0
        : finElement.cteextracosttofinance;

    finamount = investamount + extracost - upfront - part;

    let _ctestartdate = finElement.ctestartdate;
    let newprefinStepList = calculateDate(
      FinElemStep,
      moment(_ctestartdate).format('YYYY-MM-DD')
    );

    form.setFieldValue(
      [
        'elements',
        'FIN',
        indexElement !== -1 ? indexElement : 0,
        'conElemPrefinSteps',
      ],
      newprefinStepList
    );

    if (isNil(FinElemStep) || FinElemStep.length === 0) {
      notification.error({
        message: 'Please add steps before',
        description: '',
        duration: 10,
      });
      return;
    } else {
      /*FinElemStep.forEach((s: PropElemStepRequest) => {
        s.ctesoutstandingamount = (finamount * s.ctesamortizedcoef) / 100;
      });*/

      setLoading(true);
      finEngine
        .calculatePaymentShedulePrefinSteps({
          finReq: {
            elementStep: newprefinStepList,
            inBillingDate: finElement?.ctebilligdate,
            inCalculationMethod: 'STEP',
            inCountingbasis: finElement?.cteratebasis,
            inDeferredMethod: finElement?.ctedeferredinterestmethod,
            inDeferredRate: finElement?.ctedeferredinterestnominalrate,
            inDepositAmount:
              finElement?.ctedepositamount == null
                ? 0
                : finElement?.ctedepositamount,
            inDepositMethod: finElement?.ctedepositinterestmethod,
            inDepositRate:
              finElement?.ctedepositnominalrate == null
                ? 0
                : finElement?.ctedepositnominalrate,

            inFinancedAmount: finamount,
            inFirstInstallmentDate: '', //dateToString(finElement?.ctestartdate),
            inInterestMethod: finElement?.cteinterestmethod,
            inPartAmount:
              finElement?.ctepartamount == null ? 0 : finElement?.ctepartamount,
            inPartMethod: finElement?.ctepartmethod
              ? finElement?.ctepartmethod
              : 'NONE',
            inPartNbDays:
              finElement?.ctepartdays == null ? 0 : finElement?.ctepartdays,
            inPartRate:
              finElement?.ctepartrate == null ? 0 : finElement?.ctepartrate,
            inPartInvoicingMode: finElement?.ctepartinvoicingmode,
            inRatePeriodicity: finElement?.cterateperiodicity,
            inRateType: finElement?.cteratetype,
            inRateValue:
              finElement?.ctenominalrate == null
                ? 0
                : finElement?.ctenominalrate,
            inRoundingAmount: getRounding(finElement.currcode),
            inRoundingRate: 9,
            inStartDate: dateToString(finElement.ctestartdate),
            inTaxcode: finElement?.taxcode,
            inTaxrate: finElement?.taxrate,
            inTaxtype: finElement?.taxtype,
            inTerm: finElement?.ctepaymentterm,
            inUpfrontAmount: finElement?.cteupfrontamount,
          },
        })
        .then((res) => {
          setLoading(false);
          if (res.success) {
            message.success(t(`finEngine.${res.message}`));
            let ind = res.elementStep.length;
            let rvamount = 0;
            let rvcoef = 0;

            let _paymentSchedule = res.paymentSchedule.filter(
              (res) => res.ctstype !== 'RV'
            );

            let maxCteEnddate = _.maxBy(
              _paymentSchedule,
              'ctsenddate'
            )?.ctsenddate;

            if (ind > 0) {
              rvamount = res.elementStep[ind - 1].ctesoutstandingamount;
              rvcoef = res.elementStep[ind - 1].ctesamortizedcoef;
            }
            setAssetRvAmount(_.last(res.elementStep)?.ctesoutstandingamount);

            let _elements = {
              FIN: FinElements.map((element: any, index: number) =>
                index === indexElement
                  ? {
                      ...element,
                      conElemSchedules: res.paymentSchedule,
                      ctedeferredinterestnominalrate: res.inDeferredRate,
                      ctedeferredinterest: res.deferredInterest,
                      ctedepositnominalrate: res.inDepositRate,
                      ctedepositinterest: res.depositInterest,
                      cteactuarialrate: res.effectiverate,
                      ctervamount: rvamount,
                      ctervcoef: rvcoef,
                      ctefirstpayment: 0,
                      ctefirstpaymentcoef: 0,
                      conElemSteps: res.elementStep.map((step) => {
                        return {
                          ...step,
                          ctesid: Math.floor(_.random(100000) * 10000000), //theres no ctesid received
                          ctesamortizedcoef: step.ctesamortizedcoef,
                        };
                      }),
                      conElemPrefinSteps: newprefinStepList,
                      cteenddate:
                        maxCteEnddate !== ''
                          ? toDatePickerDate(maxCteEnddate)
                          : '',
                    }
                  : element
              ),
            };

            form.setFieldValue('elements', _elements);

            // calculateServAndComm(res, finElement, finamount, eleID);
          } else {
            message.error(res.message);
          }
        })
        .catch((err) => {
          setLoading(false);
        });

      /// end calculate FIN
    }
  }; // end calculate PaymentShedule Steps :

  const calculateWeightedStepFinancial = useCallback(
    (index: number, method: string) => {
      const indexElement = form
        .getFieldValue(['elements', 'FIN'])
        .findIndex((item: any) => item.cteid === elementID);

      const FinElements = form.getFieldValue(['elements', 'FIN']);

      const finElement = FinElements[indexElement];

      const FinElemStep = form.getFieldValue([
        'elements',
        'FIN',
        indexElement,
        'conElemSteps',
      ]) as PropElemStepResponse[];

      const step = FinElemStep[index];

      // calculate FIN

      var finamount = 0;
      const investamount = finElement.cteinvestamount;
      // eslint-disable-next-line no-unused-vars
      const firstPayment = finElement.ctefirstpayment;
      // eslint-disable-next-line no-unused-vars
      const rvAmount = finElement.ctervamount;
      const upfront = finElement.cteupfrontamount;
      const extracost =
        finElement.cteextracosttofinance == null
          ? 0
          : finElement.cteextracosttofinance;
      var part = 0;

      const partmethod = finElement.ctepartmethod;

      if (partmethod === 'PROMO' || partmethod === 'REDUCEFIN') {
        part = isNaN(finElement.ctepartamount) ? 0 : finElement.ctepartamount;
      }

      finamount = investamount + extracost - upfront - part;
      var startamount = 0;

      if (index === 0) {
        startamount = finamount;
      } else {
        startamount = FinElemStep[index - 1].ctesoutstandingamount;
      }
      setLoading(true);

      finEngine
        .calculate({
          finReq: {
            inBillingDate: finElement?.ctebilligdate,
            inCalculationMethod: method === 'INST' ? 'INST' : 'OUTSTAND',
            inCalculationType: finElement?.ctecalculationtype,
            inCountingbasis: finElement?.cteratebasis,
            inDeferredMethod: finElement?.ctedeferredinterestmethod,
            inDeferredRate: finElement?.ctedeferredinterestnominalrate,
            inDepositAmount:
              finElement?.ctedepositamount == null
                ? 0
                : finElement?.ctedepositamount,
            inDepositMethod: finElement?.ctedepositinterestmethod,
            inDepositRate:
              finElement?.ctedepositnominalrate == null
                ? 0
                : finElement?.ctedepositnominalrate,
            inDuration: step.ctesduration,

            inFinancedAmount: startamount,
            inFirstInstallmentDate: '', //dateToString(finElement?.ctestartdate),
            inFirstPayment: 0,
            inGracePeriodDuration: 0,
            inGracePeriodMethod: 'NONE',
            inInstallmentAmount: step.ctesrentalamount,
            inInterestMethod:
              index === 0 ? finElement?.cteinterestmethod : 'BOP',
            inPartAmount:
              finElement?.ctepartamount == null ? 0 : finElement?.ctepartamount,
            inPartMethod: finElement?.ctepartmethod
              ? finElement?.ctepartmethod
              : 'NONE',
            inPartNbDays:
              finElement?.ctepartdays == null ? 0 : finElement?.ctepartdays,
            inPartRate:
              finElement?.ctepartrate == null ? 0 : finElement?.ctepartrate,
            inPeriodicity: step.ctesperiodicity,
            inPeriodicityUnit: step.ctesperiodicityunit,
            inRatePeriodicity: finElement?.cterateperiodicity,
            inRateType: finElement?.cteratetype,
            inRateValue:
              finElement?.ctenominalrate == null
                ? 0
                : finElement?.ctenominalrate,
            inResidualValue: step.ctesoutstandingamount,
            inRoundingAmount: getRounding(finElement.currcode),
            inRoundingRate: 9,
            inStartDate: dateToString(finElement.ctestartdate),
            inTaxcode: finElement?.taxcode,
            inTaxrate: finElement?.taxrate,
            inTaxtype: finElement?.taxtype,
            inTerm: finElement?.ctepaymentterm,
            inUpFrontAmount:
              finElement?.cteupfrontamount == null
                ? 0
                : finElement?.cteupfrontamount,
          },
        })
        .then((res) => {
          setLoading(false);

          if (res.success) {
            message.success(t(`finEngine.${res.message}`));
            // const ctesrentalamount = res.installmentamount;
            const ctesrentalamount = step.ctesrentalamount;
            const ctesrentalcoef = step.ctesrentalcoef;
            // (res.installmentamount / finElement.cteinvestamount) * 100;
            const ctesoutstandingamount = res.residualvalue;
            const ctesamortizedcoef =
              (res.residualvalue / finElement.cteinvestamount) * 100;
            const status = 'OK';

            const newValues = FinElemStep.map((item, i) => {
              if (i !== index) {
                return item;
              }
              const updatedItem = { ...item };

              return {
                ...updatedItem,
                ctesrentalcoef,
                ctesrentalamount,
                ctesamortizedcoef,
                ctesoutstandingamount,
                status,
              };
            });

            let _paymentSchedule = res.paymentSchedule.filter(
              (res) => res.ctstype !== 'RV'
            );

            let maxCteEnddate = _.maxBy(
              _paymentSchedule,
              'ctsenddate'
            )?.ctsenddate;

            // call FinEngine with new values :

            form.setFieldsValue({
              elements: {
                FIN: FinElements.map((element: any, index: number) =>
                  index === indexElement
                    ? {
                        ...element,
                        conElemSteps: newValues,
                        cteenddate:
                          maxCteEnddate !== ''
                            ? toDatePickerDate(maxCteEnddate)
                            : '',
                      }
                    : element
                ),
              },
            });
          } else {
            message.error(res.message);
          }
        })
        .catch((err) => {
          setLoading(false);
        });

      /// end calculate FIN
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [form]
  );

  ////////////// end Weighted Steps

  const fieldName = getName('conElemSteps', elementID);

  // eslint-disable-next-line no-unused-vars
  const { add, remove } = useFormList(form, fieldName, {
    addAsFirst: true,
    idKey: 'cilid',
  });

  const onDeletePrefinSteps = (ctesid: number) => {
    const listElements = form.getFieldValue('elements') || {};

    let cteid = form.getFieldValue('selectedElement');

    const indexElement = form
      .getFieldValue(['elements', 'FIN'])
      ?.findIndex((item: any) => item.cteid === cteid);

    const finElement = form.getFieldValue([
      'elements',
      'FIN',
      indexElement,
    ]) as any;

    // finElement
    const ConElemPrefinStepsList =
      finElement.conElemPrefinSteps?.filter(
        (conElem: any) => conElem.ctesid === ctesid
      ) ?? [];

    finElement.conElemPrefinSteps = ConElemPrefinStepsList;

    const elements = { ...listElements, FIN: [finElement] };

    form.setFieldValue('elements', elements);
  };

  const columnsPrefinSteps = [
    {
      dataIndex: 'ctesid',
      width: 120,
      render: (val: any, record: any) => (
        <ModalControllerNV
          content={({ setVisible, visible }) => (
            <a
              onClick={() => {
                setVisible(true);
              }}
            >
              {val}
            </a>
          )}
          modal={({ setVisible, visible }) => (
            <ConElemPrefinStepModal
              visible={visible}
              onClose={() => {
                setVisible(false);
              }}
              onSave={(values, action) => {
                onSavePreFinElement(values, 'update');
              }}
              updatePreFinStep
              record={record}
            />
          )}
        ></ModalControllerNV>
      ),
    },
    {
      dataIndex: 'ctesorder',
      width: 120,
    },

    {
      dataIndex: 'ctesduration',
      width: 120,
    },

    {
      dataIndex: 'ctesstartdate',
      width: 120,
    },

    {
      dataIndex: 'enddate',
      width: 120,
    },

    {
      dataIndex: 'ctesperiodicityunit',
      width: 120,
    },
    {
      dataIndex: 'ctesperiodicity',
      width: 120,
    },
    {
      dataIndex: 'calcmethod',
      width: 120,
    },
    {
      dataIndex: 'rateformula',
      width: 120,
    },
    {
      dataIndex: 'ratebasis',
      width: 120,
    },
    {
      dataIndex: 'ratespread',
      width: 120,
      render: (val: number) => toRate(val),
    },
    {
      dataIndex: 'nominalrate',
      width: 120,
      render: (val: number) => toRate(val),
    },
    {
      dataIndex: 'ctesstartamount',
      width: 120,
      render: (val: number) => toCurrency(val),
    },
    {
      dataIndex: 'ctesamortizedcoef',
      width: 120,
      render: (val: number) => toRate(val),
    },
    {
      dataIndex: 'ctesamortizedamount',
      width: 120,
      render: (val: number) => toCurrency(val),
    },
    {
      dataIndex: 'ctesoutstandingcoef',
      width: 120,
      render: (val: number) => toRate(val),
    },
    {
      dataIndex: 'ctesoutstandingamount',
      width: 120,
      render: (val: number) => toCurrency(val),
    },

    {
      dataIndex: 'action',
      width: 120,
      render: (val: number, record: any) => (
        <PopoverController>
          {({ setVisible, visible }) => (
            <Popover
              placement="bottomRight"
              visible={visible}
              trigger="click"
              onVisibleChange={setVisible}
              content={
                <DeleteButton
                  onlyIcon
                  onClick={(e) => {
                    onDeletePrefinSteps(record.ctesid);
                  }}
                />
              }
            ></Popover>
          )}
        </PopoverController>
      ),
    },
  ];

  const columns: any = useMemo<DataGridColDef<PropElemStepResponse>[]>(
    () => [
      {
        dataIndex: 'ctesorder',
        key: 'ctesorder',
        render: (value, record, index) => {
          return (
            <InputNumber
              value={value}
              onChange={(value) => recalculateSteps(index, 'ctesorder', value)}
            />
          );
        },

        fixed: 'left',
        width: 120,
      },
      {
        dataIndex: 'ctesduration',
        key: 'ctesduration',
        render: (value, record, index) => {
          return (
            <InputNumber
              value={value}
              onChange={(value) =>
                recalculateSteps(index, 'ctesduration', value)
              }
            />
          );
        },

        width: 120,
      },

      {
        dataIndex: 'ctesperiodicity',
        key: 'ctesperiodicity',
        render: (value, record, index) => {
          return (
            /*<ParListSelect
              value={String(value)}
              parcode="PERIOD"
              onSelected={(value) =>
                recalculateSteps(index, 'ctesperiodicity', value)
              }
            />*/
            <InputNumber
              min={0}
              max={999}
              step={1}
              value={value}
              onChange={(value) =>
                recalculateSteps(index, 'ctesperiodicity', value)
              }
            />
          );
        },

        width: 120,
      },

      {
        dataIndex: 'ctesperiodicityunit',
        key: 'ctesperiodicityunit',
        render: (value, record, index) => {
          return (
            <ParListSelect
              value={value}
              parcode="UNIT"
              onSelected={(value) =>
                recalculateSteps(index, 'ctesperiodicityunit', value)
              }
            />
          );
        },

        width: 120,
      },

      {
        dataIndex: 'ctesrentalcoef',
        key: 'ctesrentalcoef',
        render: (value, record, index) => {
          return (
            <InputRate
              value={value}
              onChange={(value) =>
                recalculateSteps(index, 'ctesrentalcoef', value)
              }
            />
          );
        },

        width: 120,
      },

      {
        dataIndex: 'ctesrentalamount',
        key: 'ctesrentalamount',
        render: (value, record, index) => {
          return (
            <Row gutter={16}>
              <Col span={4}>
                <Button
                  size="small"
                  icon={
                    <CalculatorTwoTone
                      twoToneColor={
                        record?.status === 'ERROR' ||
                        record?.status === 'ERRORRENT'
                          ? 'red'
                          : 'green'
                      }
                    />
                  }
                  disabled={
                    record?.status !== 'ERROR' && record?.status !== 'ERRORRENT'
                  }
                  onClick={(e) => {
                    calculateStepFinancial(index, 'INST');
                  }}
                ></Button>
              </Col>
              <Col span={20}>
                <InputCurrency
                  noStyle
                  value={value}
                  currcode={form.getFieldValue('currcode')}
                  onChange={(value) =>
                    recalculateSteps(index, 'ctesrentalamount', value)
                  }
                />
              </Col>
            </Row>
          );
        },

        width: 180,
      },

      {
        comcode: 'ctesamortizedcoef',
        dataIndex: 'ctesamortizedcoef',
        key: 'ctesamortizedcoef',
        render: (value, record, index) => {
          return (
            <InputRate
              value={value}
              onChange={(value) =>
                recalculateSteps(index, 'ctesamortizedcoef', value)
              }
            />
          );
        },

        width: 120,
      },

      {
        dataIndex: 'ctesoutstandingamount',
        key: 'ctesoutstandingamount',
        render: (value, record, index) => {
          return (
            <Row gutter={16}>
              <Col span={4}>
                <Button
                  size="small"
                  icon={
                    <CalculatorTwoTone
                      twoToneColor={
                        record?.status === 'ERROR' ||
                        record?.status === 'ERRORROUT'
                          ? 'red'
                          : 'green'
                      }
                    />
                  }
                  disabled={
                    record?.status !== 'ERROR' && record?.status !== 'ERRORROUT'
                  }
                  onClick={(e) => calculateStepFinancial(index, 'OUTSTAND')}
                ></Button>
              </Col>
              <Col span={20}>
                <InputCurrency
                  value={value}
                  currcode={form.getFieldValue('currcode')}
                  onChange={(value) =>
                    recalculateSteps(index, 'ctesoutstandingamount', value)
                  }
                />
              </Col>
            </Row>
          );
        },

        width: 180,
      },
      {
        key: 'actions',
        comcode: 'actions',
        render: (_, record) => (
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => {
              removeStep(record.ctesorder);
            }}
          >
            <DeleteButton
              onlyIcon
              disabled={
                typeof form.getFieldValue('pricing') !== 'object'
                  ? !isNil(form.getFieldValue('pricing'))
                  : !isNil(form.getFieldValue('pricing')?.ofrid)
              }
            />
          </Popconfirm>
        ),
        fixed: 'right',
        width: 80,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [removeStep, recalculateSteps]
  );
  const columnssyndication = useMemo<DataGridColDef<Syndicationlist>[]>(
    () => [
      {
        dataIndex: 'tprole',
        key: 'tprole',
        render: (value, record, index) => {
          return (
            <Form.Item noStyle name={['syndication', index, 'tprole']}>
              <ParListSelect
                parcode="SYNDROLE"
                disabled={form.getFieldValue('cttype') === 'LEAD'}
              />
            </Form.Item>
          );
        },

        fixed: 'left',
        width: 120,
      },
      {
        dataIndex: 'tpid',
        key: 'tpid',
        render: (value, record: any, index) => {
          return (
            <FormInput name={['syndication', index, 'tpid']} noStyle>
              <ThirdPartyInput
                role={record.tprole}
                display={!record.new}
                onChange={(tp) => {
                  handleSyndTPChange(tp.tpid, record.syndid, record.tprole);
                }}
              />
            </FormInput>
          );
        },

        width: 180,
      },

      {
        dataIndex: 'partcoef',
        key: 'partcoef',
        render: (value, record, index) => {
          return (
            <Form.Item noStyle name={['syndication', index, 'partcoef']}>
              <InputRate
                defaultValue={value}
                onChange={(val) => handlepartcoef(val, index)}
                max={100}
                style={{ width: '100%' }}
              />
            </Form.Item>
          );
        },

        width: 150,
      },
      {
        dataIndex: 'partamount',
        key: 'partamount',
        render: (value, record, index) => {
          return (
            <InputCurrency
              currcode={form.getFieldValue('currcode')}
              noStyle
              fieldname={['syndication', index, 'partamount']}
            />
          );
        },

        width: 160,
      },

      {
        dataIndex: 'payinmode',
        key: 'payinmode',
        render: (value, record: any, index) => {
          return (
            <Form.Item noStyle name={['syndication', index, 'payinmode']}>
              <ParListSelect
                value={value}
                parcode="PAYMODEIN"
                disabled={!record.new}
              />
            </Form.Item>
          );
        },

        width: 180,
      },
      {
        dataIndex: 'payoutmode',
        key: 'payoutmode',
        render: (value, record: any, index) => {
          return (
            <Form.Item noStyle name={['syndication', index, 'payoutmode']}>
              <ParListSelect
                value={value}
                parcode="PAYMODEOUT"
                disabled={!record.new}
              />
            </Form.Item>
          );
        },

        width: 180,
      },
      {
        dataIndex: 'tpbkidin',
        key: 'tpibanin',
        render: (value, record: any, index) => {
          return (
            <Form.Item noStyle name={['syndication', index, 'tpbkidin']}>
              <BankAccountListSelect
                params={{
                  tpid: record?.tpid?.tpid,
                  allowedBktype: ['IN', 'INOUT'],
                }}
                disabled={!record.new}
              />
            </Form.Item>
          );
        },

        width: 250,
      },
      {
        dataIndex: 'tpbkidout',
        key: 'tpibanout',
        render: (value, record: any, index) => {
          return (
            <Form.Item noStyle name={['syndication', index, 'tpbkidout']}>
              <BankAccountListSelect
                params={{
                  tpid: record?.tpid?.tpid,
                  allowedBktype: ['OUT', 'INOUT'],
                }}
                disabled={!record.new}
              />
            </Form.Item>
          );
        },

        width: 250,
      },
      {
        dataIndex: 'tpadrid',
        key: 'tpadrid',
        render: (value, record: any, index) => {
          return (
            <Form.Item noStyle name={['syndication', index, 'tpadrid']}>
              <AddresseListSelect
                params={{ tpid: record?.tpid?.tpid ?? 0 }}
                disabled={!record.new}
              />
            </Form.Item>
          );
        },

        width: 250,
      },
      {
        key: 'actions',
        comcode: 'actions',
        render: (_, record) => (
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => {
              removesyn(record.syndid);
            }}
          >
            <DeleteButton onlyIcon />
          </Popconfirm>
        ),
        fixed: 'right',
        width: 80,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  const columnsbeneficary = useMemo<DataGridColDef<PropThirdPartyRequest>[]>(
    () => [
      {
        comcode: 'tprole',
        dataIndex: 'tprolecode',
        key: 'tprolecode',
        render: (value, record, index) => {
          //name={['thirdparties', index, 'tprolecode']}
          return (
            <Form.Item noStyle>
              <ParListSelect parcode="TPMAINROLE" value={value} disabled />
            </Form.Item>
          );
        },

        fixed: 'left',
        width: 150,
      },
      {
        dataIndex: 'tpname',
        key: 'tpname',
        render: (value, record: any, index) => {
          return (
            <FormItem shouldUpdate noStyle>
              {({ getFieldValue }) => (
                <FormInput name={getNameBenef('tpid')(record)} noStyle>
                  <ThirdPartyInput
                    parentid={getFieldValue('client')?.tpid}
                    role="MFBENEF"
                    onChange={(tp) => {
                      handleAddBenef(tp.tpid, tp.tpname, tp.tpreference, index);
                    }}
                  />
                </FormInput>
              )}
            </FormItem>
          );
        },

        width: 260,
      },

      {
        dataIndex: 'startdate',
        key: 'startdate',
        render: (value, record, index) => {
          return (
            <Form.Item noStyle name={getNameBenef('startdate')(record)}>
              <DatePicker />
            </Form.Item>
          );
        },

        width: 140,
      },
      {
        dataIndex: 'enddate',
        key: 'enddate',
        render: (value, record, index) => {
          return (
            <Form.Item noStyle name={getNameBenef('enddate')(record)}>
              <DatePicker />
            </Form.Item>
          );
        },

        width: 140,
      },
      {
        dataIndex: 'status',
        key: 'status',
        render: (value, record, index) => {
          return value === '' || value === 'ACTIVE' ? (
            <Tag color="blue" key="ACTIVE">
              Active
            </Tag>
          ) : (
            <Tag color="volcano" key="TERM">
              Terminate
            </Tag>
          );
        },

        width: 90,
      },
      {
        dataIndex: 'mfrequestedamount',
        key: 'mfrequestedamount',
        render: (value, record, index) => {
          return (
            <InputCurrency
              currcode={form.getFieldValue('currcode')}
              noStyle
              fieldname={getNameBenef('mfrequestedamount')(record)}
              max={form.getFieldValue('mfrequestedamount')}
            />
          );
        },

        width: 160,
      },
      {
        dataIndex: 'mfagreedamount',
        key: 'mfagreedamount',
        render: (val) => toCurrency(val, form.getFieldValue('currcode')),
        width: 120,
      },
      {
        dataIndex: 'mfbookedamount',
        key: 'mfbookedamount',
        render: (val) => toCurrency(val, form.getFieldValue('currcode')),
        width: 120,
      },
      {
        dataIndex: 'mfusedamount',
        key: 'mfusedamount',
        render: (val) => toCurrency(val, form.getFieldValue('currcode')),
        width: 120,
      },
      {
        dataIndex: 'mfavailableamount',
        key: 'mfavailableamount',
        render: (val) => toCurrency(val, form.getFieldValue('currcode')),
        width: 120,
      },

      {
        key: 'actions',
        comcode: 'actions',
        render: (_, record) => (
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => {
              removetp(record.tpid);
            }}
          >
            <DeleteButton onlyIcon />
          </Popconfirm>
        ),
        fixed: 'right',
        width: 80,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [form, removetp]
  );
  const columnsSeasonal = useMemo<DataGridColDef<PropElemStepResponse>[]>(
    () => [
      {
        dataIndex: 'ctesyear',
        key: 'ctesyear',
        render: (value, record, index) => {
          return (
            <InputNumber
              value={value}
              onChange={(value) => recalculateSteps(index, 'ctesyear', value)}
            />
          );
        },
        width: 120,
      },

      {
        dataIndex: 'ctesyearend',
        key: 'ctesyearend',
        render: (value, record, index) => {
          return (
            <InputNumber
              value={value}
              onChange={(value) =>
                recalculateSteps(index, 'ctesyearend', value)
              }
            />
          );
        },

        width: 120,
      },

      {
        dataIndex: 'ctesorder',
        key: 'ctesorder',
        render: (value, record, index) => {
          return (
            <ParListSelect
              value={String(value)}
              parcode="MONTH"
              onSelected={(value) =>
                recalculateSteps(index, 'ctesorder', value)
              }
            />
          );
        },

        fixed: 'left',
        width: 120,
      },

      {
        dataIndex: 'ctesrentalcoef',
        key: 'ctesrentalcoef',
        render: (value, record, index) => {
          return (
            <>
              <InputRate
                value={value}
                onChange={(value) =>
                  recalculateSteps(index, 'ctesrentalcoef', value)
                }
              />
              <Button
                size="small"
                icon={
                  <CalculatorTwoTone
                    twoToneColor={record?.status === 'ERROR' ? 'red' : 'green'}
                  />
                }
                //disabled={record?.status !== 'ERROR'}
                onClick={(e) => debouncedCalculateNew('', '')}
              ></Button>
            </>
          );
        },

        width: 120,
      },

      {
        dataIndex: 'ctesrentalamount',
        key: 'ctesrentalamount',
        render: (val) => toCurrency(val, form.getFieldValue('currcode')),

        width: 120,
      },

      {
        key: 'actions',
        comcode: 'actions',
        render: (_, record) => (
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => {
              removeStep(record.ctesorder);
            }}
          >
            <DeleteButton
              onlyIcon
              /*disabled={
            typeof form.getFieldValue('pricing') !== 'object'
              ? !isNil(form.getFieldValue('pricing'))
              : !isNil(form.getFieldValue('pricing')?.ofrid)
          }*/
            />
          </Popconfirm>
        ),
        fixed: 'right',
        width: 80,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [removeStep, recalculateSteps]
  );

  const columnsWeigthedStep = useMemo<DataGridColDef<PropElemStepResponse>[]>(
    () => [
      {
        dataIndex: 'ctesorder',
        key: 'ctesorder',
        render: (value, record, index) => {
          return (
            <InputNumber
              value={value}
              onChange={(value) =>
                recalculateWeightedSteps(index, 'ctesorder', value)
              }
            />
          );
        },

        fixed: 'left',
        width: 120,
      },
      {
        dataIndex: 'ctesduration',
        key: 'ctesduration',
        render: (value, record, index) => {
          return (
            <InputNumber
              value={value}
              onChange={(value) =>
                recalculateWeightedSteps(index, 'ctesduration', value)
              }
            />
          );
        },

        width: 120,
      },

      {
        dataIndex: 'ctesperiodicity',
        key: 'ctesperiodicity',
        render: (value, record, index) => {
          return (
            <ParListSelect
              value={String(value)}
              parcode="PERIOD"
              onSelected={(value) =>
                recalculateWeightedSteps(index, 'ctesperiodicity', value)
              }
            />
          );
        },

        width: 120,
      },

      {
        dataIndex: 'ctesperiodicityunit',
        key: 'ctesperiodicityunit',
        render: (value, record, index) => {
          return (
            <ParListSelect
              value={value}
              parcode="UNIT"
              onSelected={(value) =>
                recalculateWeightedSteps(index, 'ctesperiodicityunit', value)
              }
            />
          );
        },

        width: 120,
      },

      {
        dataIndex: 'ctesrentalcoef',
        key: 'ctesrentalcoef',
        render: (value, record, index) => {
          return (
            <InputRate
              value={value}
              onChange={(value) =>
                recalculateWeightedSteps(index, 'ctesrentalcoef', value)
              }
            />
          );
        },

        width: 120,
      },

      {
        dataIndex: 'ctesrentalamount',
        key: 'ctesrentalamount',
        render: (value, record, index) => {
          return (
            <Input.Group>
              <InputCurrency
                value={value}
                currcode={form.getFieldValue('currcode')}
                onChange={(value) =>
                  recalculateWeightedSteps(index, 'ctesrentalamount', value)
                }
              />
            </Input.Group>
          );
        },

        width: 120,
      },

      {
        dataIndex: 'ctesamortizedcoef',
        key: 'ctesamortizedcoef',
        render: (value, record, index) => {
          return <InputRate value={record.ctesamortizedcoef} disabled />;
        },

        width: 120,
      },

      {
        dataIndex: 'ctesoutstandingamount',
        key: 'ctesoutstandingamount',
        render: (value, record, index) => {
          return (
            <Input.Group>
              <InputCurrency
                disabled
                currcode={form.getFieldValue('currcode')}
                value={value}
              />
            </Input.Group>
          );
        },

        width: 120,
      },
      {
        key: 'actions',
        comcode: 'actions',
        render: (_, record) => (
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => {
              removeWeightedStep(record.ctesid);
            }}
          >
            <DeleteButton onlyIcon />
          </Popconfirm>
        ),
        fixed: 'right',
        width: 80,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [removeWeightedStep, recalculateWeightedSteps]
  );
  const [assetphase, setassetphase] = useState('');
  const [assetstatus, setassetstatus] = useState('');
  const [visibleSeasonal, setVisibleSeasonal] = useState(false);

  const handleAddFromCatalog = () => {
    catalogModal.open();
  };

  const handleAddFromCatalogPack = () => {
    catalogPackModal.open();
  };

  const handleCreateNewAsset = () => {
    simpleAssetModal.open();
  };
  const handleCreateNewMultiCompAsset = () => {
    assetMultiCompModal.open();
  };

  const handleAddFromStock = () => {
    setassetphase('PROD');
    setassetstatus('STOCK');
    setAssetModalVisible(true);
  };
  const handleAddInitAsset = () => {
    setassetphase('PROPOSAL');
    setassetstatus('INIT');

    // assetListModal.open();
    setAssetModalVisible(true);
  };

  const handleMoveAsset = async (asset: AssetResponse) => {
    const cteid = form.getFieldValue('selectedElement');
    let assets = form.getFieldValue('assets');
    let indexAsset = assets.findIndex(
      (item: any) => item.assetid === asset.assetid
    );

    let elements = form.getFieldValue('elements') || {};
    let finElements = form.getFieldValue(['elements', 'FIN']) || {};
    let finOldElement = finElements.find((e: any) => e.cteid === cteid);

    let indexElement = finElements.findIndex(
      (item: any) => item.cteid === cteid
    );

    finElements[indexElement].cteinvestamount =
      finOldElement.cteinvestamount - asset.assetnetamount;
    finElements[indexElement].ctefinancedamount =
      finOldElement.ctefinancedamount - asset?.assetnetamount;
    finElements[indexElement].ctevatdeferralamount =
      finOldElement.ctevatdeferralamount - asset?.assettaxamount;

    const cteidNew = Math.round(_.random(100000) * 10000000);

    let finNewElement = offerToElement(
      finOldElement.pricing,
      asset.assetnetamount,
      asset.assettaxamount,
      0,
      false,
      'NONE',
      0,
      cteidNew
    );

    finNewElement.ctefinancedamount = asset?.assetnetamount;
    finNewElement.ctevatdeferralamount = asset?.assettaxamount;
    finNewElement.cteinvestamount = asset?.assetnetamount;
    finNewElement.ctedescription = finOldElement.ctedescription;
    finNewElement.ctepartamount = 0;
    finNewElement.cteupfrontamount = 0;
    finNewElement.conElemAttributes = [];

    assets[indexAsset].cteid = cteidNew;

    // add :
    finElements.push(finNewElement);

    elements = { ...elements, FIN: finElements };

    form.setFieldsValue({
      elements: elements,
      assets: assets,
      ctfclevel: 'MULTI',
      //  selectedElement: cteidNew,
    });

    await finElements.forEach((e: any) => {
      form.setFieldsValue({
        selectedElement: e.cteid,
      });

      calculateNew(e.cteid, '', 'INST');
    });
  };

  const handleDeleteAsset = (assetId: number) => {
    const cteid = form.getFieldValue('selectedElement');
    const tpidsupplier = form
      .getFieldValue('assets')
      .find((asset: any) => asset.assetid === assetId).tpidsupplier;
    const newAssets = form
      .getFieldValue('assets')
      .filter((asset: any) => asset.assetid !== assetId);
    const linkedAssets = newAssets.filter(
      (asset: any) => asset.cteid === cteid
    );
    form.setFieldsValue({
      assets: newAssets.map((asset: any) => {
        if (asset.cteid === cteid) return { ...asset, assetrvamount: 0 };
        else return { ...asset };
      }),
      ctfinancedamount: sumBy(newAssets, 'assetfinamount'),
    });

    if (
      (form.getFieldValue('prcode') !== 'LEASEBACK' ||
        newAssets.length === 0) &&
      newAssets.find((asset: any) => asset.tpidsupplier === tpidsupplier) ===
        undefined
    ) {
      const newTP = form
        .getFieldValue('thirdparties')
        .filter(
          (tp: any) =>
            tp.tpid.tpid !== tpidsupplier || tp.tprolecode !== 'SUPPLIER'
        );
      const newSUP = newTP.find((tp: any) => tp.tprolecode === 'SUPPLIER');
      form.setFieldsValue({
        thirdparties: newTP,
        supplier: newSUP === undefined ? null : newSUP,
      });
    }

    let elements = form.getFieldValue('elements');
    if (elements && Object.keys(elements).length > 0) {
      if (linkedAssets.length === 0) {
        handleDeleteElement(
          form.getFieldValue('prcode') === 'SPV'
            ? form
                ?.getFieldValue(['elements', 'SPV'])
                ?.find((ele: any) => ele.cteid === cteid)
            : form
                ?.getFieldValue(['elements', 'FIN'])
                ?.find((ele: any) => ele.cteid === cteid)
        );
      } else if (form?.getFieldValue('ctfclevel') === 'MULTI') {
        let finelements: any[] = form
          .getFieldValue(['elements', 'FIN'])
          .map((ele: any) => {
            if (ele.cteid === cteid) {
              return {
                ...ele,
                cteinvestamount: sumBy(
                  newAssets.filter((asset: any) => asset.cteid === cteid),
                  'assetfinamount'
                ),
                ctevatdeferralamount: sumBy(
                  newAssets.filter((asset: any) => asset.cteid === cteid),
                  'assettaxamount'
                ),
              };
            } else return ele;
          });
        elements = { ...elements, FIN: finelements };

        form.setFieldsValue({ elements: elements });
        let fin = form
          .getFieldValue(['elements', 'FIN'])
          .find((e: any) => e.cteid === cteid);

        if (fin.ofrid !== 0) {
          handlePricingChange(
            {
              ofrid: fin.ofrid,
              ofrtype: fin.ofrtype,
              ofrlabel: fin.ofrlabel,
            },
            '',
            0
          );
        } else {
          handleOfferChange(form.getFieldValue('offerid'));
        }
      }

      form.setFieldsValue({
        ctfinancedamount: sumBy(form.getFieldValue('assets'), 'assetfinamount'),
        // ctefinancedamount: sumBy(form.getFieldValue('assets'), 'assetnetamount'),
      });
      if (form.getFieldValue('ctfclevel') === 'PROPOSAL') {
        form.setFieldsValue({
          offerid: null,
          pricing: null,
          elements: [],
          syndication: [],
          ctsyndinvoicingtype: null,
          ctsyndsuppliermanagementtype: null,
          ctsyndpaymentmanagementtype: null,
          ctsyndmgcoef: 0,
          ctsyndmgpartamount: 0,
        });
      } else debouncedCalculateNew('', '');
    }
  };
  const handlepartcoef = (coef: any, index: number) => {
    let investamount = isNaN(
      form.getFieldValue(getName('cteinvestamount', elementID))
    )
      ? 0
      : form.getFieldValue(getName('cteinvestamount', elementID));
    let listsynd: any[] = form.getFieldValue('syndication');
    let old = listsynd[index];
    listsynd[index] = {
      ...old,
      partamount: investamount * (Number(coef) / 100),
    };
    form.setFieldsValue({ syndication: listsynd });
  };

  const handleSelectedElement = (cteid: number) => {
    form.setFieldsValue({
      selectedElement: cteid,
    });

    setElementID(cteid);

    // debouncedCalculateNew('','');
  };
  const handleAddSimpleAsset: SimpleAssetModalProps['onAdd'] = async (
    simpleasset
  ) => {
    if (form) {
      // const listrv = await getAssetCatalogRvAmountList({
      //   prcode: form?.getFieldValue('flagmasterfacility')
      //     ? form?.getFieldValue('mfprcode')
      //     : form?.getFieldValue('prcode') ?? '',
      //   catalogid: simpleasset.catalogid ?? '',
      //   assetamount: simpleasset.assetnetamount,
      // }).then((res: any) => res.list);

      const listuse = await getParAssetUseByFilters({
        parAssetRequest: [
          {
            assetcategory:
              objectParValueToString(simpleasset.assetcategory) ?? '',
            assetfamily: objectParValueToString(simpleasset.assetfamily) ?? '',
            assetid: '' as any,
            assettype: objectParValueToString(simpleasset?.assettype) ?? '',
            catalogid: simpleasset.catalogid ?? '',
            offerid: '' as any,
            ofrid: '' as any,
            ofrtype: '',
            prcode: form.getFieldValue('prcode'),
          },
        ],
      }).then((res: any) => res.list);

      const listrv = await getAssetRvAmountList({
        assetid: 0,
        prcode: form.getFieldValue('flagmasterfacility')
          ? form.getFieldValue('mfprcode')
          : form.getFieldValue('prcode') ?? '',
        assettype: simpleasset.assettype,
        assetcat: simpleasset.assetcategory,
        assetamount: simpleasset.assetnetamount,
        filters: getFilterList(),
      }).then((res: any) => res.list);

      const cteid = form.getFieldValue('selectedElement');

      let flaguseassetgrossamount = form.getFieldValue(
        'flaguseassetgrossamount'
      );

      const asset = assetCatalogToAsset(
        simpleasset,
        listrv,
        simpleasset.assetqty,
        cteid,
        'free',
        listuse,
        flaguseassetgrossamount
      );

      let client = form.getFieldValue('client');
      if (
        form.getFieldValue('prcode') === 'LEASEBACK' &&
        (client == null || client !== undefined)
      ) {
        form.setFieldsValue({
          client: {
            tpid: simpleasset.tpidsupplier,
            tpname: simpleasset.suppliername,
            tpreference: simpleasset.supplierreference,
          },
        });
      }

      if (!isNil(simpleasset.tpidsupplier) && simpleasset.tpidsupplier !== 0) {
        form.setFieldsValue({
          supplier: {
            tpid: simpleasset.tpidsupplier,
            tpname: simpleasset.suppliername,
            tpreference: simpleasset.supplierreference,
          },
        });
        loadTPDetail(
          simpleasset.tpidsupplier,
          simpleasset.suppliername,
          simpleasset.supplierreference,
          'SUPPLIER'
        );
      }

      // set element.assets :
      if (form.getFieldValue('ctfclevel') === 'PROPOSAL')
        form.setFieldsValue({
          assets: [
            ...(form.getFieldValue('assets').map((asset: any) => {
              return { ...asset, assetrvamount: 0 };
            }) || []),
            asset,
          ],
        });
      else
        form.setFieldsValue({
          assets: [...form.getFieldValue('assets'), asset],
        });

      if (flaguseassetgrossamount) {
        form.setFieldsValue({
          ctfinancedamount: sumBy(
            form.getFieldValue('assets'),
            'assetgrossamount'
          ),
          mfrequestedamount: sumBy(
            form.getFieldValue('assets'),
            'assetgrossamount'
          ),
        });
      } else {
        form.setFieldsValue({
          ctfinancedamount: sumBy(
            form.getFieldValue('assets'),
            'assetnetamount'
          ),
          mfrequestedamount: sumBy(
            form.getFieldValue('assets'),
            'assetnetamount'
          ),
        });
      }

      let elements = form.getFieldValue('elements');

      if (form.getFieldValue('ctfclevel') === 'MULTI') {
        let finelements = form.getFieldValue(['elements', 'FIN']);
        finelements?.forEach((ele: any) => {
          if (ele?.cteid === cteid) {
            ele.cteinvestamount = ele.cteinvestamount + asset.assetnetamount;
            ele.ctevatdeferralamount =
              ele.ctevatdeferralamount + asset.assettaxamount;
          }
        });

        elements = { ...elements, FIN: finelements };

        form.setFieldsValue({ elements: elements });

        let fin = form
          .getFieldValue(['elements', 'FIN'])
          .find((e: any) => e.cteid === cteid);

        if (fin.ofrid !== 0) {
          handlePricingChange(
            {
              ofrid: fin.ofrid,
              ofrtype: fin.ofrtype,
              ofrlabel: fin.ofrlabel,
            },
            '',
            0
          );
        } else {
          handleOfferChange(form.getFieldValue('offerid'));
        }
      } else {
        // (form.getFieldValue('ctfclevel') === 'PROPOSAL') {

        form.setFieldsValue({
          offerid: null,
          pricing: null,
          elements: [],
          syndication: [],
          ctsyndinvoicingtype: null,
          ctsyndsuppliermanagementtype: null,
          ctsyndpaymentmanagementtype: null,
          ctsyndmgcoef: 0,
          ctsyndmgpartamount: 0,
        });
      }
    }
    simpleAssetModal.close();
  };
  const getAssetListId = () => {
    let list: Array<Number> = [];

    form.getFieldValue('assets')?.map((e: any) => list.push(e?.assetid));

    return list;
  };

  const handleSelectAssetFromStockOrInit = async (assetList: any[]) => {
    setIsLoading(true);
    setAssetModalVisible(false);

    await Promise.all(
      assetList.map(async (assetCatalog, index) => {
        let listrv: any[] = [];

        const listuse = await getAssetUseByAssetID({
          assetid: assetCatalog.assetid ?? '',
        }).then((res: any) => res.list);

        const cteid = form.getFieldValue('selectedElement');

        if (form.getFieldValue('prcode') === 'LEASEBACK') {
          let client = form.getFieldValue('client');
          if (client && typeof client == 'object') {
            assetCatalog.suppliername = client?.tpname;
            assetCatalog.supplierreference = client?.reference;
            assetCatalog.tpidsupplier = client?.tpid;
          }
        }
        const asset = assetSearchToAsset(
          assetCatalog,
          listrv,
          assetCatalog.assetqty,
          cteid,
          'free',
          listuse,
          form.getFieldValue('flaguseassetgrossamount')
        );

        form.setFieldsValue({
          supplier: {
            tpid: assetCatalog.tpidsupplier,
            tpname: assetCatalog.suppliername,
            tpreference: assetCatalog.supplierreference,
          },
          ctpower: assetCatalog.kwhpower,
          ctproduction: assetCatalog.kwhproduction,
          ctdegradation: assetCatalog.kwhdegradation,
          ctdeliveryadrzipcode: assetCatalog.deliveryadrzipcode,
          ctdeliveryadrcity: assetCatalog.deliveryadrcity,
        });

        let client = form.getFieldValue('client');
        if (
          form.getFieldValue('prcode') === 'LEASEBACK' &&
          (client == null || client !== undefined)
        ) {
          form.setFieldsValue({
            client: {
              tpid: assetCatalog.tpidsupplier,
              tpname: assetCatalog.suppliername,
              tpreference: assetCatalog.supplierreference,
            },
          });
        }

        if (
          assetCatalog.tpidsupplier !== null &&
          assetCatalog.tpidsupplier !== 0
        ) {
          loadTPDetail(
            assetCatalog.tpidsupplier,
            assetCatalog.suppliername,
            assetCatalog.supplierreference,
            'SUPPLIER'
          );
        }

        if (form.getFieldValue('ctfclevel') === 'PROPOSAL') {
          form.setFieldsValue({
            assets: [
              ...(form.getFieldValue('assets').map((asset: any) => {
                return { ...asset, assetrvamount: 0 };
              }) || []),
              asset,
            ],
            assetpictureurl: asset.assetpictureurl,
          });
        } else {
          form.setFieldsValue({
            assets: [...form.getFieldValue('assets'), asset],
            assetpictureurl: asset.assetpictureurl,
          });
        }

        if (form.getFieldValue('flaguseassetgrossamount')) {
          form.setFieldsValue({
            ctfinancedamount: sumBy(
              form.getFieldValue('assets'),
              'assetgrossamount'
            ),
            mfrequestedamount: sumBy(
              form.getFieldValue('assets'),
              'assetgrossamount'
            ),
          });
        } else {
          form.setFieldsValue({
            ctfinancedamount: sumBy(
              form.getFieldValue('assets'),
              'assetnetamount'
            ),
            mfrequestedamount: sumBy(
              form.getFieldValue('assets'),
              'assetnetamount'
            ),
          });
        }

        let elements = form.getFieldValue('elements');

        if (form.getFieldValue('ctfclevel') === 'MULTI') {
          let finelements = form.getFieldValue(['elements', 'FIN']);
          finelements.forEach((ele: any) => {
            if (ele?.cteid === cteid) {
              ele.cteinvestamount = ele.cteinvestamount + asset.assetfinamount;
              ele.ctevatdeferralamount =
                ele.ctevatdeferralamount + asset.assettaxamount;
            }
          });

          elements = { ...elements, FIN: finelements };

          form.setFieldsValue({ elements: elements });

          let fin = form
            .getFieldValue(['elements', 'FIN'])
            .find((e: any) => e.cteid === cteid);
          if (index === assetList.length - 1)
            if (fin.ofrid !== 0) {
              handlePricingChange(
                {
                  ofrid: fin.ofrid,
                  ofrtype: fin.ofrtype,
                  ofrlabel: fin.ofrlabel,
                },
                '',
                0
              );
            } else {
              handleOfferChange(form.getFieldValue('offerid'));
            }
        } else {
          // (form.getFieldValue('ctfclevel') === 'PROPOSAL') {

          form.setFieldsValue({
            offerid: null,
            pricing: null,
            elements: [],
            syndication: [],
            ctsyndinvoicingtype: null,
            ctsyndsuppliermanagementtype: null,
            ctsyndpaymentmanagementtype: null,
            ctsyndmgcoef: 0,
            ctsyndmgpartamount: 0,
          });
        }
      })
    ).catch(() => {
      setAssetModalVisible(true);
    });

    let assets: any[] = form.getFieldValue('assets');
    let newListAsset: any[] = [];

    await Promise.all(
      assets.map(async (asset) => {
        if (
          assetList.findIndex(
            (assetCatalog) => assetCatalog.assetid === asset.assetid
          ) !== -1
        ) {
          let listrv = [];

          if (!isNil(asset?.catalogid)) {
            listrv = await getAssetCatalogRvAmountList({
              prcode: form.getFieldValue('flagmasterfacility')
                ? form.getFieldValue('mfprcode')
                : form.getFieldValue('prcode') ?? '',
              catalogid: asset.catalogid ?? '',
              assetamount: asset.assetfinamount,
              filters: getFilterList(),
            }).then((res: any) => res.list);
          } else {
            listrv = await getAssetRvAmountList({
              assetid: asset.assetid,
              prcode: form.getFieldValue('flagmasterfacility')
                ? form.getFieldValue('mfprcode')
                : form.getFieldValue('prcode') ?? '',
              assettype: asset.assettype,
              assetcat: asset.assetcategory,
              assetamount: asset.assetfinamount,
              filters: getFilterList(),
            }).then((res: any) => res.list);
          }

          newListAsset.push({
            ...asset,
            listrv: listrv,
          });
        } else {
          newListAsset.push(asset);
        }
      })
    );

    setIsLoading(false);

    form.setFieldValue('assets', newListAsset);

    setassetlist([]);
  };

  const [assetList, setassetlist] = useState<Array<any>>([]);

  const handleSaveAsset = async (asset: any) => {
    if (form) {
      setIsLoading(true);

      const cteid = form.getFieldValue('selectedElement');

      let assetid = Math.floor(_.random(10000) * 10000000);

      let elements = form.getFieldValue('elements');
      if (!isNil(asset.tpidsupplier)) {
        form.setFieldsValue({
          supplier: {
            tpid: asset.tpidsupplier,
            tpname: asset.suppliername,
            tpreference: asset.supplierreference,
          },
        });
        loadTPDetail(
          asset.tpidsupplier,
          asset.suppliername,
          asset.supplierreference,
          'SUPPLIER'
        );
      }
      if (form.getFieldValue('ctfclevel') === 'PROPOSAL') {
        form.setFieldsValue({
          assets: [
            ...(form.getFieldValue('assets').map((asset: any) => {
              return {
                ...asset,
                assetrvamount: 0,
              };
            }) || []),
          ],
        });
      } else if (
        elements?.FIN?.length > 0 &&
        form.getFieldValue('ctfclevel') === 'MULTI'
      ) {
        let finelements = form
          .getFieldValue(['elements', 'FIN'])
          .map((ele: any) => {
            if (ele.cteid === cteid)
              return {
                ...ele,
                cteinvestamount: ele.cteinvestamount + asset.assetfinamount,
              };
            else return ele;
          });
        elements = { ...elements, FIN: finelements };

        form.setFieldsValue({ elements: elements });
        handleOfferChange(form.getFieldValue('offerid')); //to check
        debouncedCalculateNew('', '');
      }
      asset.cteid = cteid;

      let isNew = false;
      if (asset.assetid === 0) {
        // new Asset :
        isNew = true;
        asset.assetid = assetid;
        var listrv = [];

        if (!isNil(asset?.catalogid)) {
          listrv = await getAssetCatalogRvAmountList({
            prcode: form?.getFieldValue('flagmasterfacility')
              ? form?.getFieldValue('mfprcode')
              : form?.getFieldValue('prcode') ?? '',
            catalogid: asset.catalogid,
            assetamount: asset.assetnetamount,
            filters: getFilterList(),
          }).then((res: any) => res.list);
        } else {
          listrv = await getAssetRvAmountList({
            assetid: assetid,
            prcode: form.getFieldValue('flagmasterfacility')
              ? form.getFieldValue('mfprcode')
              : form.getFieldValue('prcode') ?? '',
            assettype: asset.assettype,
            assetcat: asset.assetcategory,
            assetamount: asset.assetfinamount,
            filters: getFilterList(),
          }).then((res: any) => res.list);
        }
        asset.listrv = listrv;
        asset.cteid = cteid;

        form.setFieldsValue({
          assets: [...(form.getFieldValue('assets') || []), asset],
        });
      } else {
        // update existing asset
        asset.assetrvamount = 0;

        form.setFieldsValue({
          assets: form
            .getFieldValue('assets')
            .map((existingAsset: AssetRequest) => {
              return existingAsset.assetid === asset.assetid
                ? asset
                : existingAsset;
            }),
        });
      }

      // then continue :

      if (form.getFieldValue('flaguseassetgrossamount')) {
        form.setFieldsValue({
          ctfinancedamount: sumBy(
            form.getFieldValue('assets'),
            'assetgrossamount'
          ),
          mfrequestedamount: sumBy(
            form.getFieldValue('assets'),
            'assetgrossamount'
          ),
        });
      } else {
        form.setFieldsValue({
          ctfinancedamount: sumBy(
            form.getFieldValue('assets'),
            'assetnetamount'
          ),
          mfrequestedamount: sumBy(
            form.getFieldValue('assets'),
            'assetnetamount'
          ),
        });
      }

      if (form.getFieldValue('ctfclevel') === 'MULTI') {
        let fin = form
          .getFieldValue(['elements', 'FIN'])
          .find((e: any) => e.cteid === cteid);

        if (fin.ofrid !== 0) {
          handlePricingChange(
            {
              ofrid: fin.ofrid,
              ofrtype: fin.ofrtype,
              ofrlabel: fin.ofrlabel,
            },
            '',
            0
          );
        } else {
          handleOfferChange(form.getFieldValue('offerid'));
        }
      } else {
        // Proposal Level :
        form.setFieldsValue({
          offerid: null,
          pricing: null,
          elements: [],
          syndication: [],
          ctsyndinvoicingtype: null,
          ctsyndsuppliermanagementtype: null,
          ctsyndpaymentmanagementtype: null,
          ctsyndmgcoef: 0,
          ctsyndmgpartamount: 0,
        });
      }

      if (!isNew) {
        if (!isNil(asset?.catalogid)) {
          const listrv = await getAssetCatalogRvAmountList({
            prcode: form?.getFieldValue('flagmasterfacility')
              ? form?.getFieldValue('mfprcode')
              : form?.getFieldValue('prcode') ?? '',
            catalogid: asset.catalogid,
            assetamount: asset.assetnetamount,
            filters: getFilterList(),
          }).then((res: any) => res.list);

          asset.listrv = listrv;
        } else {
          const listrv = await getAssetRvAmountList({
            assetid: assetid,
            prcode: form.getFieldValue('flagmasterfacility')
              ? form.getFieldValue('mfprcode')
              : form.getFieldValue('prcode') ?? '',
            assettype: asset.assettype,
            assetcat: asset.assetcategory,
            assetamount: asset.assetfinamount,
            filters: getFilterList(),
          }).then((res: any) => res.list);
          asset.listrv = listrv;
        }

        form.setFieldsValue({
          assets: form
            .getFieldValue('assets')
            .map((existingAsset: AssetRequest) => {
              return existingAsset.assetid === asset.assetid
                ? asset
                : existingAsset;
            }),
        });
      }

      setIsLoading(false);
    }

    assetMultiCompModal.close();
  };

  const handleSaveAssetCard = async (asset: any) => {
    console.log('asset', '______________________________', asset);
    if (form) {
      setIsLoading(true);

      // eslint-disable-next-line no-debugger
      // debugger;

      const cteid = form.getFieldValue('selectedElement');

      let assetid = asset.assetid ?? Math.floor(_.random(10000) * 10000000);

      let elements = form.getFieldValue('elements');
      if (!isNil(asset.tpidsupplier)) {
        form.setFieldsValue({
          supplier: {
            tpid: asset.tpidsupplier,
            tpname: asset.suppliername,
            tpreference: asset.supplierreference,
          },
        });
        loadTPDetail(
          asset.tpidsupplier,
          asset.suppliername,
          asset.supplierreference,
          'SUPPLIER'
        );
      }
      // if (form.getFieldValue('ctfclevel') === 'PROPOSAL') {
      //   form.setFieldsValue({
      //     assets: [
      //       ...(form.getFieldValue('assets').map((asset: any) => {
      //         return {
      //           ...asset,
      //           assetrvamount: 0,
      //         };
      //       }) || []),
      //     ],
      //   });
      // } else if (
      //   elements?.FIN?.length > 0 &&
      //   form.getFieldValue('ctfclevel') === 'MULTI'
      // ) {
      //   let finelements = form
      //     .getFieldValue(['elements', 'FIN'])
      //     .map((ele: any) => {
      //       if (ele.cteid === cteid)
      //         return {
      //           ...ele,
      //           cteinvestamount: ele.cteinvestamount + asset.assetfinamount,
      //         };
      //       else return ele;
      //     });
      //   elements = { ...elements, FIN: finelements };

      //   form.setFieldsValue({ elements: elements });
      // }
      asset.cteid = cteid;

      let isNew = false;

      // update existing asset
      asset.assetrvamount = 0;

      let assets = form
        .getFieldValue('assets')
        .map((existingAsset: AssetRequest) => {
          return existingAsset.assetid === asset.assetid
            ? { ...existingAsset, ...asset }
            : existingAsset;
        });

      form.setFieldValue('assets', assets);

      // then continue :

      if (form.getFieldValue('flaguseassetgrossamount')) {
        form.setFieldsValue({
          ctfinancedamount: sumBy(
            form.getFieldValue('assets'),
            'assetgrossamount'
          ),
          mfrequestedamount: sumBy(
            form.getFieldValue('assets'),
            'assetgrossamount'
          ),
        });
      } else {
        form.setFieldsValue({
          ctfinancedamount: sumBy(
            form.getFieldValue('assets'),
            'assetnetamount'
          ),
          mfrequestedamount: sumBy(
            form.getFieldValue('assets'),
            'assetnetamount'
          ),
        });
      }

      if (form.getFieldValue('ctfclevel') === 'MULTI') {
        let fin = form
          .getFieldValue(['elements', 'FIN'])
          .find((e: any) => e.cteid === cteid);

        if (fin.ofrid !== 0) {
          handlePricingChange(
            {
              ofrid: fin.ofrid,
              ofrtype: fin.ofrtype,
              ofrlabel: fin.ofrlabel,
            },
            '',
            0
          );
        } else {
          handleOfferChange(form.getFieldValue('offerid'));
        }
      }
      if (!isNew) {
        if (!isNil(asset?.catalogid)) {
          const listrv = await getAssetCatalogRvAmountList({
            prcode: form?.getFieldValue('flagmasterfacility')
              ? form?.getFieldValue('mfprcode')
              : form?.getFieldValue('prcode') ?? '',
            catalogid: asset.catalogid,
            assetamount: asset.assetnetamount,
            filters: getFilterList(),
          }).then((res: any) => res.list);

          asset.listrv = listrv;
        } else {
          const listrv = await getAssetRvAmountList({
            assetid: assetid,
            prcode: form.getFieldValue('flagmasterfacility')
              ? form.getFieldValue('mfprcode')
              : form.getFieldValue('prcode') ?? '',
            assettype: asset.assettype,
            assetcat: asset.assetcategory,
            assetamount: asset.assetfinamount,
            filters: getFilterList(),
          }).then((res: any) => res.list);
          asset.listrv = listrv;
        }

        form.setFieldsValue({
          assets: form
            .getFieldValue('assets')
            .map((existingAsset: AssetRequest) => {
              return existingAsset.assetid === asset.assetid
                ? asset
                : existingAsset;
            }),
        });

        form.setFieldValue(getName('tpidsupplier', asset.cteid), {
          tpid: asset.tpidsupplier,
          tpname: asset.suppliername,
          tpreference: asset.supplierreference,
        });
      }

      setIsLoading(false);
    }

    assetMultiCompModal.close();
  };

  const handleSelectAssetFromCatalogPack: AssetCatalogPackModalProps['onSelect'] =
    async (packResponse, nbasset) => {
      // let assetCatalog=packResponse.assets[0];
      const cteid = form.getFieldValue('selectedElement');

      await Promise.all(
        packResponse.assets.map(async (assetCatalog: any) => {
          const listrv = await getAssetCatalogRvAmountList({
            prcode: form?.getFieldValue('flagmasterfacility')
              ? form?.getFieldValue('mfprcode')
              : form?.getFieldValue('prcode') ?? '',
            catalogid: assetCatalog.catalogid,
            assetamount: assetCatalog.assetnetamount * nbasset,
            filters: getFilterList(),
          }).then((res: any) => res.list);

          const listuse = await getParAssetUseByFilters({
            parAssetRequest: [
              {
                assetcategory: assetCatalog.assetcategory ?? '',
                assetfamily: assetCatalog.assetfamily,
                assetid: '' as any,
                assettype: assetCatalog.assettype,
                catalogid: assetCatalog.catalogid ?? '',
                offerid: '' as any,
                ofrid: '' as any,
                ofrtype: '',
                prcode: form?.getFieldValue('flagmasterfacility')
                  ? form?.getFieldValue('mfprcode')
                  : form?.getFieldValue('prcode') ?? '',
              },
            ],
          }).then((res: any) => res.list);

          const asset = assetCatalogToAsset(
            assetCatalog,
            listrv,
            nbasset,
            cteid,
            'catalog',
            listuse,
            form.getFieldValue('flaguseassetgrossamount')
          );
          form?.setFieldsValue({
            supplier: {
              tpid: assetCatalog.tpidsupplier,
              tpname: assetCatalog.suppliername,
              tpreference: assetCatalog.supplierreference,
            },
            ctpower: assetCatalog.kwhpower,
            ctproduction: assetCatalog.kwhproduction,
            ctdegradation: assetCatalog.kwhdegradation,
          });

          // set element.assets :
          if (form?.getFieldValue('ctfclevel') === 'PROPOSAL') {
            form.setFieldsValue({
              assets: [
                ...(form.getFieldValue('assets').map((asset: any) => {
                  return { ...asset, assetrvamount: 0 };
                }) || []),
                asset,
              ],
            });
          } else {
            form.setFieldsValue({
              assets: [...form.getFieldValue('assets'), asset],
            });
          }

          if (form.getFieldValue('flaguseassetgrossamount')) {
            form.setFieldsValue({
              ctfinancedamount: sumBy(
                form.getFieldValue('assets'),
                'assetgrossamount'
              ),
              mfrequestedamount: sumBy(
                form.getFieldValue('assets'),
                'assetgrossamount'
              ),
            });
          } else {
            form.setFieldsValue({
              ctfinancedamount: sumBy(
                form.getFieldValue('assets'),
                'assetnetamount'
              ),
              mfrequestedamount: sumBy(
                form.getFieldValue('assets'),
                'assetnetamount'
              ),
            });
          }

          let elements = form?.getFieldValue('elements');

          if (form.getFieldValue('ctfclevel') === 'MULTI') {
            let finelements = form.getFieldValue(['elements', 'FIN']);
            finelements.forEach((ele: any) => {
              if (ele?.cteid === cteid) {
                ele.cteinvestamount =
                  ele.cteinvestamount + asset.assetfinamount;
                ele.ctepartamount = ele.ctepartamount + asset.partamount;
                ele.ctepartmethod = asset.partmethod;
              }
            });

            elements = { ...elements, FIN: finelements };

            form.setFieldsValue({ elements: elements });
          } else {
            let finelements = form.getFieldValue(['elements', 'FIN']);
            finelements?.forEach((ele: any) => {
              if (ele?.cteid === cteid) {
                ele.cteinvestamount =
                  ele.cteinvestamount + asset.assetfinamount;
                ele.ctepartamount = ele.ctepartamount + asset.partamount;
                ele.ctepartmethod = asset.partmethod;
              }
            });

            elements = { ...elements, FIN: finelements };

            form.setFieldsValue({ elements: elements });
          }

          if (assetCatalog.tpidsupplier != null) {
            await loadTPDetail(
              assetCatalog.tpidsupplier,
              assetCatalog.suppliername,
              assetCatalog.supplierreference,
              'SUPPLIER'
            );
          }
        })
      );

      if (form.getFieldValue('ctfclevel') === 'PROPOSAL') {
        if (packResponse.offerid != null && packResponse.offerid !== 0) {
          form.setFieldsValue({
            offerid: packResponse.offerid,
          });
          handleOfferChange(packResponse.offerid).then(() => {
            if (packResponse.ofrid != null && packResponse.ofrid !== 0) {
              form.setFieldsValue({
                pricing: {
                  ofrid: packResponse.ofrid,
                  ofrtype: packResponse.ofrtype,
                  ofrlabel: packResponse.ofridlabel,
                },
              });
              handlePricingChange(
                {
                  ofrid: packResponse.ofrid,
                  ofrtype: packResponse.ofrtype,
                  ofrlabel: packResponse.ofridlabel,
                },
                '',
                0
              );
            }
          });
        }
      }

      catalogPackModal.close();
    };

  const handleSelectAssetFromCatalog: AssetCatalogModalProps['onSelect'] =
    async (
      assetCatalog,
      nbasset,
      selectedServices,
      selectedOption,
      fromCatalogMulticomponents
    ) => {
      const cteid = form.getFieldValue('selectedElement');
      if (form) {
        setAlreadyanswered(false);

        const listuse = await getParAssetUseByFilters({
          parAssetRequest: [
            {
              assetcategory: assetCatalog.assetcategory ?? '',
              assetfamily: assetCatalog.assetfamily,
              assetid: '' as any,
              assettype: assetCatalog.assettype,
              catalogid: assetCatalog.catalogid ?? '',
              offerid: '' as any,
              ofrid: '' as any,
              ofrtype: '',
              prcode: form?.getFieldValue('flagmasterfacility')
                ? form?.getFieldValue('mfprcode')
                : form?.getFieldValue('prcode') ?? '',
            },
          ],
        })
          .then((res: any) => res.list)
          .catch((er) => []);

        let _offerCriteriaList: Array<FilteringCriteria> = [];

        listuse?.forEach((u: any) => {
          _offerCriteriaList.push({
            critcode: u.attcode,
            critvalue: u.usevalue ?? '',
          });
        });

        const listrv = await getAssetCatalogRvAmountList({
          prcode: form?.getFieldValue('flagmasterfacility')
            ? form?.getFieldValue('mfprcode')
            : form?.getFieldValue('prcode') ?? '',
          catalogid: assetCatalog.catalogid,
          assetamount: assetCatalog.assetnetamount * nbasset,
          filters: getFilterList(Array(assetCatalog), _offerCriteriaList),
        })
          .then((res: any) => res.list)
          .catch((er) => []);

        let lassetComponents = assetCatalog.assetCatalogComponents;
        if (selectedOption?.length! > 0 && !fromCatalogMulticomponents) {
          lassetComponents.push({
            assetid: 0,
            compcategory: 'ASSET',
            compcategorylabel: assetCatalog.assetlabel,
            compdescription: assetCatalog.assetlabel,
            compdiscountamount: 0,
            compdiscountrate: 0,
            compfree1: '',
            compgrossamount: assetCatalog.assetgrossamountorigine,
            compid: assetCatalog.catalogid,
            compnetamount: assetCatalog.assetnetamountorigine,
            comporiginalnetamount: assetCatalog.assetnetamountorigine,
            comptaxamount:
              assetCatalog.assetgrossamountorigine -
              assetCatalog.assetnetamountorigine,
            comptype: 'ASSET',
            comptypelabel: 'Asset',
            flagholdback: false,
            holdbackamount: 0,
            holdbackbeleasedate: '',
            holdbackbeleasenbdays: 0,
            holdbackpercentage: 0,
            suppliername: assetCatalog.suppliername,
            supplierreference: assetCatalog.supplierreference,
            taxcode: assetCatalog.taxcode,
            taxrate: 0,
            tpidsupplier: assetCatalog.tpidsupplier,
          });
        }

        selectedOption?.forEach((opt) => {
          lassetComponents.push({
            assetid: 0,
            compcategory: opt.optcode,
            compcategorylabel: opt.optcodelabel,
            compdescription: opt.optcodelabel + ' : ' + opt.optvaluelabel,
            compdiscountamount: 0,
            compdiscountrate: 0,
            compfree1: '',
            compgrossamount: opt.optgrossamount,
            compid: opt.optid,
            compnetamount: opt.optnetamount,
            comporiginalnetamount: opt.optnetamount,
            comptaxamount: opt.opttaxamount,
            comptype: 'OPT',
            comptypelabel: 'Option',
            flagholdback: false,
            holdbackamount: 0,
            holdbackbeleasedate: '',
            holdbackbeleasenbdays: 0,
            holdbackpercentage: 0,
            suppliername: assetCatalog.suppliername,
            supplierreference: assetCatalog.supplierreference,
            taxcode: opt.opttaxcode,
            taxrate: 0,
            tpidsupplier: assetCatalog.tpidsupplier,
          });
        });

        assetCatalog.assetCatalogComponents = lassetComponents;

        assetCatalog.assetCatalogServices = selectedServices ?? [];
        assetCatalog.assetCatalogOptions = selectedOption ?? [];

        if (form.getFieldValue('prcode') === 'LEASEBACK') {
          let client = form.getFieldValue('client');
          if (client && typeof client == 'object') {
            assetCatalog.suppliername = client?.tpname;
            assetCatalog.supplierreference = client?.reference;
            assetCatalog.tpidsupplier = client?.tpid;
          }
        }

        const asset = assetCatalogToAsset(
          assetCatalog,
          listrv,
          nbasset,
          cteid,
          'catalog',
          listuse,
          form.getFieldValue('flaguseassetgrossamount')
        );

        form.setFieldsValue({
          supplier: {
            tpid: assetCatalog.tpidsupplier,
            tpname: assetCatalog.suppliername,
            tpreference: assetCatalog.supplierreference,
          },
          ctpower: assetCatalog.kwhpower,
          ctproduction: assetCatalog.kwhproduction,
          ctdegradation: assetCatalog.kwhdegradation,
        });

        let client = form.getFieldValue('client');
        if (
          form.getFieldValue('prcode') === 'LEASEBACK' &&
          (client == null || client !== undefined)
        ) {
          form.setFieldsValue({
            client: {
              tpid: assetCatalog.tpidsupplier,
              tpname: assetCatalog.suppliername,
              tpreference: assetCatalog.supplierreference,
            },
          });
        }

        if (
          assetCatalog.tpidsupplier != null &&
          assetCatalog.tpidsupplier !== 0
        ) {
          loadTPDetail(
            assetCatalog.tpidsupplier,
            assetCatalog.suppliername,
            assetCatalog.supplierreference,
            'SUPPLIER'
          );
        }

        if (
          assetCatalog.tpidmanufacturer != null &&
          assetCatalog.tpidmanufacturer !== 0
        ) {
          loadTPDetail(
            assetCatalog.tpidmanufacturer,
            assetCatalog.manufacturername,
            assetCatalog.manufacturerreference,
            'OEM'
          );
        }

        // set element.assets :
        if (form.getFieldValue('ctfclevel') === 'PROPOSAL') {
          form.setFieldsValue({
            assets: [
              ...(form.getFieldValue('assets')?.map((asset: any) => {
                return { ...asset, assetrvamount: 0 };
              }) || []),
              asset,
            ],
          });
        } else {
          form.setFieldsValue({
            assets: [...form.getFieldValue('assets'), asset],
          });
        }

        if (form.getFieldValue('flaguseassetgrossamount')) {
          form.setFieldsValue({
            ctfinancedamount: sumBy(
              form.getFieldValue('assets'),
              'assetgrossamount'
            ),
            mfrequestedamount: sumBy(
              form.getFieldValue('assets'),
              'assetgrossamount'
            ),
          });
        } else {
          form.setFieldsValue({
            ctfinancedamount: sumBy(
              form.getFieldValue('assets'),
              'assetnetamount'
            ),
            mfrequestedamount: sumBy(
              form.getFieldValue('assets'),
              'assetnetamount'
            ),
          });
        }

        let elements = form.getFieldValue('elements');

        if (form.getFieldValue('ctfclevel') === 'MULTI') {
          let finelements = form.getFieldValue(['elements', 'FIN']);
          finelements.forEach((ele: any) => {
            if (ele?.cteid === cteid) {
              ele.cteinvestamount = ele.cteinvestamount + asset.assetfinamount;
              ele.ctevatdeferralamount =
                ele.ctevatdeferralamount + asset.assettaxamount;
            }
          });

          elements = { ...elements, FIN: finelements };

          form.setFieldsValue({ elements: elements });

          let fin = form
            .getFieldValue(['elements', 'FIN'])
            .find((e: any) => e.cteid === cteid);

          if (fin.ofrid != null && fin.ofrid !== 0) {
            handlePricingChange(
              {
                ofrid: fin.ofrid,
                ofrtype: fin.ofrtype,
                ofrlabel: fin.ofrlabel,
              },
              '',
              0
            );
          } else {
            handleOfferChange(form.getFieldValue('offerid'));
          }
        } else {
          // (form.getFieldValue('ctfclevel') === 'PROPOSAL') {

          form.setFieldsValue({
            offerid: null,
            pricing: null,
            elements: [],
            syndication: [],
            ctsyndinvoicingtype: null,
            ctsyndsuppliermanagementtype: null,
            ctsyndpaymentmanagementtype: null,
            ctsyndmgcoef: 0,
            ctsyndmgpartamount: 0,
          });
        }
      }
      catalogModal.close();
    };

  const handleConvertServToFinServ = (record: any) => {
    const servs = form.getFieldValue(['elements', 'SERV']);
    const updateserv = servs.map((element: any) =>
      record.cteid === element.cteid
        ? {
            ...element,
            ctetype: 'FINSERV',
          }
        : element
    );

    let elements = form.getFieldValue('elements');

    var newfinserv = { ...record, ctetype: 'FINSERV' };

    const servss = form.getFieldValue(['elements', 'FINSERV']);

    servss.push(newfinserv);

    elements = { ...elements, SERV: updateserv, FINSERV: servss };

    form.setFieldsValue({ elements: elements });

    const inCteid = record.cteidparent;

    const indexElement = form
      .getFieldValue(['elements', 'FIN'])
      .findIndex((e: any) => e.cteid === inCteid);

    calculateFinServiceNew(
      newfinserv,
      form.getFieldValue(['elements', 'FIN'])[indexElement],
      form.getFieldValue(['elements', 'FIN'])[indexElement].ctestartdate,
      form.getFieldValue(['elements', 'FIN'])[indexElement].ctebilligdate,
      form.getFieldValue(getName('ctefinancedamount', inCteid)),
      inCteid
    );

    let deleteserv = { ...record, ctetype: 'SERV' };
    handleDeleteElement(deleteserv);
    // let newfinserv=record;
    // newfinserv.ctetype="FINSERV";

    //
    // const servs = form.getFieldValue(['elements', 'FINSERV']);
    // servs.push(newfinserv);
    // let elements = form.getFieldValue('elements');
    // elements = { ...elements, FINSERV: servs };

    // form.setFieldsValue({ elements: elements });

    // set ctetype='FINSERV'
    // push elements
    // calculateNew
  };

  const handleDeleteFinChildElements = (cteid: number) => {
    const elementsByType = form.getFieldValue('elements') ?? {};

    const oldElements = unGroup(elementsByType).filter(
      (item: any) => item.cteidparent !== cteid
    );

    const {
      FIN = [],
      SERV = [],
      FEES = [],
      COMM = [],
      FINSERV = [],
    } = groupBy(oldElements, 'ctetype');

    form.setFieldsValue({
      elements: {
        COMM,
        FEES,
        FIN,
        FINSERV,
        SERV,
      },
    });
  };

  const handleDeleteElement = (record: any) => {
    // form?.getFieldValue('elements');

    const obj = form
      ?.getFieldValue(['elements', String(record?.ctetype)])
      ?.filter((element: any) => element.cteid !== record.cteid);

    let elements = form.getFieldValue('elements');

    switch (String(record?.ctetype)) {
      case 'COMM':
        elements = { ...elements, COMM: obj };
        break;
      case 'FEES':
        elements = { ...elements, FEES: obj };
        break;
      case 'FIN':
        elements = { ...elements, FIN: obj };
        break;
      case 'FINSERV':
        elements = { ...elements, FINSERV: obj };
        break;
      case 'SERV':
        elements = { ...elements, SERV: obj };
        break;
    }

    form.setFieldsValue({ elements: elements });
    if (record?.ctetype === 'FIN' || record?.ctetype === 'SPV') {
      handleDeleteFinChildElements(record.cteid);
      //deleting linked assets
      const newAssets = form
        .getFieldValue('assets')
        .filter((asset: any) => asset.cteid !== record.cteid);
      form.setFieldsValue({
        assets: newAssets,
        ctfinancedamount: sumBy(newAssets, 'assetfinamount'),
      });
    }
  };
  ////////////////////////

  const loadOfferDetail = (offerid: number) => {
    return getprOfferDetailByOfferId({
      offerid: offerid,
      filtersList: getFilterList(),
    });
  };

  const loadPricingDetail = (pricing: any) => {
    let finamount = form.getFieldValue(getName('cteinvestamount', elementID));
    if (
      form.getFieldValue('flagasset') !== true &&
      form.getFieldValue('ctfclevel') === 'PROPOSAL'
    )
      finamount = form.getFieldValue('ctfinancedamount');

    if (pricing.ofrtype === 'PACK') {
      return getPricingPackDetail({
        filtersList: getFilterList(),
        packid: pricing.ofrid,
      });
    } else {
      return getPricingDetail({
        filtersList: getFilterList(),
        priid: pricing.ofrid,
      });
    }
  };

  const addOptionsToAsset = (option: any, cteid: number, assetid: number) => {
    console.log(option, cteid, assetid);

    let assets = form.getFieldValue('assets');

    assets?.forEach((asset: any) => {
      if (asset.assetid === assetid) {
        if (asset.assetmulticomponents === true) {
          asset.assetComponents.push({
            assetid: 0,
            compcategory: option.optcode,
            compcategorylabel: option.optcodelabel,
            compdescription: option.optcodelabel + ' : ' + option.optvaluelabel,
            compdiscountamount: 0,
            compdiscountrate: 0,
            compfree1: '',
            compgrossamount: option.optgrossamount,
            compid: option.optid,
            compnetamount: option.optnetamount,
            comporiginalnetamount: option.optnetamount,
            comptaxamount: option.opttaxamount,
            comptype: 'OPT',
            comptypelabel: 'Option',
            flagholdback: false,
            holdbackamount: 0,
            holdbackbeleasedate: '',
            holdbackbeleasenbdays: 0,
            holdbackpercentage: 0,
            suppliername: option.suppliername,
            supplierreference: option.supplierreference,
            taxcode: option.opttaxcode,
            taxrate: 0,
            tpidsupplier: option.tpidsupplier,
          });

          asset.finasset = asset.finasset + option.optnetamount;
          asset.assetnetamount = asset.assetnetamount + option.optnetamount;
          asset.assetunitnetamount =
            asset.assetunitnetamount + option.optnetamount;
        } else {
          asset.assetComponents.push({
            assetid: 0,
            compcategory: 'ASSET',
            compcategorylabel: asset.assetlabel,
            compdescription: asset.assetlabel,
            compdiscountamount: 0,
            compdiscountrate: 0,
            compfree1: '',
            compgrossamount: asset.assetgrossamount,
            compid: asset.catalogid,
            compnetamount: asset.assetnetamount,
            comporiginalnetamount: asset.assetnetamount,
            comptaxamount: asset.assettaxamount,
            comptype: 'ASSET',
            comptypelabel: 'Asset',
            flagholdback: false,
            holdbackamount: 0,
            holdbackbeleasedate: '',
            holdbackbeleasenbdays: 0,
            holdbackpercentage: 0,
            suppliername: asset.suppliername,
            supplierreference: asset.supplierreference,
            taxcode: asset.taxcode,
            taxrate: 0,
            tpidsupplier: asset.tpidsupplier,
          });

          asset.assetComponents.push({
            assetid: 0,
            compcategory: option.optcode,
            compcategorylabel: option.optcodelabel,
            compdescription: option.optcodelabel + ' : ' + option.optvaluelabel,
            compdiscountamount: 0,
            compdiscountrate: 0,
            compfree1: '',
            compgrossamount: option.optgrossamount,
            compid: option.optid,
            compnetamount: option.optnetamount,
            comporiginalnetamount: option.optnetamount,
            comptaxamount: option.opttaxamount,
            comptype: 'OPT',
            comptypelabel: 'Option',
            flagholdback: false,
            holdbackamount: 0,
            holdbackbeleasedate: '',
            holdbackbeleasenbdays: 0,
            holdbackpercentage: 0,
            suppliername: option.suppliername,
            supplierreference: option.supplierreference,
            taxcode: option.opttaxcode,
            taxrate: 0,
            tpidsupplier: option.tpidsupplier,
          });
          asset.assetmulticomponents = true;
        }
      }
    });

    let finElements = form.getFieldValue(['elements', 'FIN']) || {};

    finElements[0].ctefinancedamount =
      finElements[0].ctefinancedamount + option.optnetamount;

    finElements[0].cteinvestamount = finElements[0].ctefinancedamount;
    console.log(
      'finElement.ctefinancedamount22',
      finElements[0].ctefinancedamount
    );

    let elements = form.getFieldValue('elements') || {};

    elements = { ...elements, FIN: finElements };

    console.log('addOptionsToAsset', assets);

    form.setFieldsValue({
      elements: elements,
      assets: assets,
      selectedElement: cteid,
    });

    form.setFieldValue('assets', assets);

    debouncedCalculateNew('', '', cteid);
  };

  const deleteOptionsAsset = (option: any, cteid: number, assetid: number) => {
    console.log(option, cteid, assetid);

    let assets = form.getFieldValue('assets');

    let newlistAssets = [...assets];

    newlistAssets?.forEach((asset: any) => {
      if (asset.assetid === assetid) {
        asset.assetComponents = asset.assetComponents.filter(
          (comp: any) => comp.compid !== option.optid
        );
        asset.finasset = asset.finasset - option.optnetamount;
        asset.assetnetamount = asset.assetnetamount - option.optnetamount;
        asset.assetunitnetamount =
          asset.assetunitnetamount - option.optnetamount;
      }
    });

    let finElements = form.getFieldValue(['elements', 'FIN']) || {};

    // console.log('finElement.ctefinancedamount11',finElement.ctefinancedamount)

    finElements[0].ctefinancedamount =
      finElements[0].ctefinancedamount - option.optnetamount;

    finElements[0].cteinvestamount = finElements[0].ctefinancedamount;

    let elements = form.getFieldValue('elements') || {};

    elements = { ...elements, FIN: finElements };

    form.setFieldsValue({
      elements: elements,
      assets: assets,
      selectedElement: cteid,
    });

    console.log('deleteOptionsAsset', newlistAssets);
    form.setFieldValue('assets', newlistAssets);

    setElementID(cteid);

    debouncedCalculateNew('', '', cteid);
  };

  const addAssetService = async (
    serviceAsset: any,
    cteid: number,
    assetid: number
  ) => {
    console.log(
      'addAssetService',
      serviceAsset,
      '--cteid:::',
      cteid,
      '--asset::',
      assetid
    );
    setLoading(true);

    const elements = form.getFieldValue('elements');
    console.log('element1111::', elements);

    const { SERV } = elements;

    let indexService = SERV.findIndex(
      (elem: any) =>
        elem?.ctecategory === serviceAsset?.servcode &&
        cteid === elem?.cteidparent
    );
    if (indexService > -1) {
      SERV[indexService].servfixedamount = serviceAsset.servfixedamount;

      SERV[indexService].servpercentage = serviceAsset.servpercentage;
      SERV[indexService].assetid = assetid;
      SERV[indexService].cteinstallmentamount = 0;

      const _elements = { ...elements, SERV: SERV };

      form.setFieldValue('elements', _elements);

      let assets = form.getFieldValue('assets');

      assets?.forEach((asset: any) => {
        if (asset.assetid === assetid) {
          asset.assetServiceList.push(serviceAsset);
        }
      });

      form.setFieldValue('assets', assets);
      await debouncedCalculateNew('', '', cteid);
      setLoading(false);
    } else {
      let service = await getServiceByServcode({
        servcode: serviceAsset?.servcode,
      });
      // let pricings = await getPricingListFiltered({
      //   entity: '',
      //   entityid: 0,
      //   offerid: form.getFieldValue('offerid'),
      //   ctetype: 'SERV',
      //   prcode: form.getFieldValue('prcode'),
      //   tpid: 0,
      // });
      // let service = pricings?.list.filter((res) => res.ctecategory = serviceAsset.servcode);
      console.log('service::', service);
      if (service.data != null) {
        let serv = ServiceResponceToElement(service.data);
        console.log('serv::', serv);
        let pricing = {
          ofrid: 0,
          ofrtype: 'OFFER',
          ofrlabel: '',
          ofrdescription: '',
        };

        const res = ServiceToElement(
          pricing,
          {
            ...serv,
            servfixedamount:
              serviceAsset?.servfixedamount ?? serv.servfixedamount,
          },
          form.getFieldValue('cteinvestamount'),
          [],
          0,
          cteid,
          0
        );

        let assets = form.getFieldValue('assets');

        assets?.forEach((asset: any) => {
          if (asset.assetid === assetid) {
            asset.assetServiceList.push(serviceAsset);
          }
        });

        form.setFieldValue('assets', assets);

        res.pritype = 'PRICING';

        onSaveService(res, 'create');
        await debouncedCalculateNew('', '', cteid);
        setLoading(false);
      }
    }
  };

  const onDeleteService = async (
    serviceAsset: any,
    cteid: number,
    assetid: number
  ) => {
    console.log('serviceAsset', serviceAsset);
    let elements = form.getFieldValue('elements');
    // debugger;

    const { SERV } = elements;

    const newServList = form
      ?.getFieldValue(['elements', 'SERV'])
      ?.filter((element: any) => serviceAsset.servcode !== element.ctecategory);

    let assets = form.getFieldValue('assets');

    let newAssetList = assets.map((asset: any) => {
      if (asset.assetid === assetid) {
        let newAssetServiceList = asset.assetServiceList.filter(
          (service: any) => service.servcode !== serviceAsset.servcode
        );

        asset.assetServiceList = newAssetServiceList;
        return { ...asset, assetServiceList: newAssetServiceList };
      } else {
        return asset;
      }
    });

    elements = { ...elements, SERV: newServList };

    form.setFieldsValue({
      assets: newAssetList,
      elements: elements,
    });

    form.setFieldValue('elements', elements);
    form.setFieldValue('assets', newAssetList);

    let offerid = form.getFieldValue('offerid');

    let ctepartamount = form.getFieldValue(getName('ctepartamount', cteid));
    let ctepartmethod = form.getFieldValue(getName('ctepartmethod', cteid));

    await handleOfferChange(offerid, false, true);

    form.setFieldValue(getName('ctepartamount', cteid), ctepartamount);
    form.setFieldValue(getName('ctepartmethod', cteid), ctepartmethod);

    await debouncedCalculateNew('', '', cteid);

    setLoading(false);
  };

  const handleAssetuseByOfferidORPricing = async (
    offerid: number,
    ofrid?: number,
    ofrtype?: string
  ) => {
    const listassets = form.getFieldValue('assets');
    const cteid = form.getFieldValue('selectedElement');

    const listAssetElement = listassets.filter((e: any) => e.cteid === cteid);

    const requestParams = listAssetElement.map(
      (asset: any): ParAssetUseRequest => ({
        assetid: asset.assetid,
        catalogid: asset.catalogid,
        assetfamily: asset.assetfamily,
        assettype: asset.assettype,
        assetcategory: asset.assetcategory,
        prcode: form.getFieldValue('prcode'),
        offerid: offerid,
        ofrtype: ofrtype ?? ('' as any),
        ofrid: ofrid ?? ('' as any),
      })
    );

    await getParAssetUseByFilters({
      parAssetRequest: requestParams,
    }).then((res) => {
      if (!isNil(res.list) && !isEmpty(res.list)) {
        form.setFieldsValue({
          assets: listassets.map((asset: any) => {
            if (asset.cteid === cteid) {
              let linkedListOfUse = res.list
                .filter((use: any) => use.assetid === asset.assetid)
                .map((use: any) => ({ ...use, usevalue: use.defaultvalue }));
              return {
                ...asset,
                assetusereqList: _.values(
                  _.merge(
                    _.keyBy(linkedListOfUse, 'useid'),
                    _.keyBy(asset.assetusereqList, 'useid')
                  )
                ),
              };
            } else return asset;
          }),
        });
      }
    });
  };

  const loadOfferWithnewDuration = async (newDuration: number) => {
    let FLAG_LOAD_OFFER_WITH_NEW_DURATION = true;
    try {
      FLAG_LOAD_OFFER_WITH_NEW_DURATION = getEnvValue(
        'FLAG_LOAD_OFFER_WITH_NEW_DURATION'
      );
    } catch (error) {}
    if (FLAG_LOAD_OFFER_WITH_NEW_DURATION) {
      setIsLoading(true);

      const cteid = form.getFieldValue('selectedElement');
      await getprOfferDetailByOfferId({
        offerid: form?.getFieldValue('offerParams')?.offerid,
        filtersList: getFilterList(),
        duration: newDuration,
      }).then(async (res) => {
        if (res.data !== null) {
          let indexElement = -1;
          let elements = form.getFieldValue('elements');
          let finElements = form.getFieldValue(['elements', 'FIN']) || [];
          let invest = form.getFieldValue('ctfinancedamount');

          const listassets = form.getFieldValue('assets');
          const listAssetElement = listassets.filter(
            (e: any) => e.cteid === cteid
          );

          indexElement =
            finElements.findIndex((item: any) => item.cteid === cteid) ?? 0;
          // adjust rate :

          finElements[indexElement].ctenominalrate =
            res.data.ratespreaddefault + res.data.ratevaluedefault;

          //adjust RV
          if (res.data.rvevaluationmode === 'PERC') {
            finElements[indexElement].ctervamount =
              (res.data.rvdefault * invest) / 100;
            finElements[indexElement].helpers.rvmax = res.data.rvmax;
            finElements[indexElement].helpers.rvmin = res.data.rvmin;
            finElements[indexElement].helpers.rvcontextmax =
              res.data.rvcontextmax;
            finElements[indexElement].helpers.rvcontextmin =
              res.data.rvcontextmin;
          } else {
            finElements[indexElement].ctervamount = res.data.rvdefaultamount;
            finElements[indexElement].helpers.rvmax =
              (res.data.rvmax / invest) * 100;
            finElements[indexElement].helpers.rvmin =
              (res.data.rvmin / invest) * 100;
            finElements[indexElement].helpers.rvcontextmax =
              (res.data.rvdefaultamount / invest) * 100;
            finElements[indexElement].helpers.rvcontextmin =
              (res.data.rvdefaultamount / invest) * 100;
          }

          elements = { ...elements, FIN: finElements };

          form.setFieldsValue({ elements: elements });
          ///
          /////
          let commList: Array<PropElementRequest> = [];

          let pricing = {
            ofrid: res.data.offerid,
            ofrtype: 'OFFER',
            ofrlabel: res.data.offerlabel,
            ofrdescription: '',
          };

          let newElements: any[] = res.data.servicesList?.map((item) => {
            if (item.ctetype === 'COMM') {
              commList.push(
                commissionToElement(
                  pricing,
                  item,
                  item.commissionResponse,
                  cteid,
                  invest
                )
              );
            } else {
              if (item.commissionList?.length !== 0) {
                item.commissionList?.forEach((c) =>
                  commList.push(
                    commissionToElement(pricing, item, c, cteid, invest)
                  )
                );
              }
              return pricingToElement(
                pricing,
                item,
                invest,
                0,
                0,
                0,
                item.ctetype === 'FIN' || item.ctetype === 'SPV' ? cteid : 0,
                cteid
              );
            }
          });

          if (commList.length == 0) {
            let COMM = form?.getFieldValue(['elements', 'COMM']);
            newElements = COMM;
          }
          commList.forEach((e) => {
            newElements.push(e);
          });

          const elementsByType = form.getFieldValue('elements') ?? {};

          const oldElements = unGroup(elementsByType).filter(
            (item: any) => item.cteidparent !== cteid
          );

          await Promise.all(
            listAssetElement.map((asset: any) => {
              if (asset.assetServiceList != null) {
                Promise.all(
                  asset.assetServiceList.map(async (assetService: any) => {
                    let indexService = newElements.findIndex(
                      (elem: any) =>
                        elem?.ctecategory === assetService?.servcode
                    );
                    if (indexService > -1) {
                      newElements[indexService].servfixedamount =
                        assetService.servfixedamount;
                      newElements[indexService].servpercentage =
                        assetService.servpercentage;
                      newElements[indexService].assetid = asset.assetid;
                      newElements[indexService].cteinstallmentamount =
                        asset.servfixedamount;
                    } else {
                      let service = await getServiceByServcode({
                        servcode: assetService?.servcode,
                      });
                      if (service.data != null) {
                        let serv = ServiceResponceToElement(service.data);

                        const res = ServiceToElement(
                          pricing,
                          serv,
                          form.getFieldValue('cteinvestamount'),
                          [],
                          0,
                          cteid,
                          0
                        );

                        res.pritype = 'PRICING';

                        onSaveService(res, 'create');
                      }
                    }
                    return assetService;
                  })
                );
              }
              return asset;
            })
          );

          const finalElemList = oldElements.concat(newElements);

          const {
            FIN = [],
            FINOUT = [],
            SPV = [],
            SERV = [],
            FEES = [],
            COMM = [],
            FINSERV = [],
            SERVOUT = [],
          } = groupBy(finalElemList, 'ctetype');

          let _newElements: any = {
            COMM,
            FEES,
            FIN,
            FINOUT,
            SPV,
            FINSERV,
            SERV,
            SERVOUT,
          };

          form.setFieldsValue({
            elements: _newElements,
          });

          ////
          debouncedCalculateNew('', '');
        } else {
          debouncedCalculateNew('', '');
        }
      });

      setIsLoading(false);
    } else {
      debouncedCalculateNew('', '');
    }
  };
  const handleOfferChange = async (
    offerid: number,
    calculate: boolean = true,
    getNewService: boolean = true
  ) => {
    const listassets = form.getFieldValue('assets');
    const cteid = form.getFieldValue('selectedElement');

    let listAssetElement = listassets.filter((e: any) => e.cteid === cteid);

    let _assetid = 0;

    if (
      form.getFieldValue('ctfclevel') === 'MOASSMUEL' &&
      listassets.length > 0
    ) {
      _assetid = listassets[0]?.assetid;
    }

    const listAssetOtherElement = listassets.filter(
      (e: any) => e.cteid !== cteid
    );

    let indexElement = -1;
    let elements = form.getFieldValue('elements');
    let finElements = form.getFieldValue(['elements', 'FIN']) || [];

    if (
      form.getFieldValue('ctfclevel') === 'MULTI' ||
      form.getFieldValue('ctfclevel') === 'MOASSMUEL' ||
      (form.getFieldValue('ctfclevel') === 'PROPOSAL' && finElements.length > 0)
    ) {
      indexElement =
        finElements.findIndex((item: any) => item.cteid === cteid) ?? 0;

      finElements[indexElement].ofrid = null;

      elements = { ...elements, FIN: finElements };

      form.setFieldsValue({ elements: elements });
      handleDeleteFinChildElements(cteid);
    }

    let investamount = 0; //sumBy(form.getFieldValue('assets'),'assetfinamount' );
    let taxamount = 0;
    //

    if (form.getFieldValue('ctfclevel') === 'MOASSMUEL') {
      if (finElements.length > 0) {
        investamount = finElements[indexElement].cteinvestamount;
      } else {
        investamount = sumBy(listAssetElement, 'assetfinamount');
      }
    } else if (form.getFieldValue('ctfclevel') !== 'PROPOSAL') {
      if (form.getFieldValue('flagasset')) {
        // get list of associated assets

        if (form.getFieldValue('flaguseassetgrossamount')) {
          investamount = sumBy(listAssetElement, 'assetgrossamount');
        } else {
          investamount = sumBy(listAssetElement, 'assetfinamount');
        }
      } else {
        if (indexElement >= 0) {
          investamount = finElements[indexElement].cteinvestamount;
          taxamount = finElements[indexElement].ctevatdeferralamount;
        }
      }
    } else {
      if (form.getFieldValue('flagasset')) {
        if (form.getFieldValue('flaguseassetgrossamount')) {
          investamount = sumBy(listAssetElement, 'assetgrossamount');
        } else {
          investamount = sumBy(listAssetElement, 'assetfinamount');
        }
        taxamount = sumBy(listAssetElement, 'assettaxamount');
      } else if (form.getFieldValue('flagfleet')) {
        investamount = sumBy(listAssetElement, 'assetunitnetamount');
      } else {
        investamount = form.getFieldValue('ctfinancedamount');
      }
    }

    form.setFieldsValue({
      pricing: null,
      syndication: [],
      ctsyndinvoicingtype: null,
      ctsyndsuppliermanagementtype: null,
      ctsyndpaymentmanagementtype: null,
      ctsyndmgcoef: 0,
      ctsyndmgpartamount: 0,
    });
    setIsLoading(true);
    return loadOfferDetail(offerid)
      .then(async (res) => {
        //create a fin element with params :

        form.setFieldsValue({
          ctexeedfeesformula: res.data?.priidexeed,
          ceilingrate: res.data.ceilingrate,
          ceilingdefaultrate: res.data.ceilingdefaultrate,
          floorrate: res.data.floorrate,
          floordefaultrate: res.data.floordefaultrate,
          calid: form.getFieldValue('calid') ?? res.data.calid,
        });
        const offerParams = res.data;
        const data = res.data;

        let rvcoef = 0;
        let rvamount = 0;

        if (data?.rvcalculationmode === 'ASSET') {
          let totalAssetRV = 0;
          let assetrvamount = 0;
          let newRvAmount = 0;
          const defaultduration = data.durationdefault;

          listAssetElement.forEach((asset: any) => {
            const lineRV = asset.listrv.filter(
              (lrv: any) =>
                defaultduration >= lrv.monthsmin &&
                defaultduration <= lrv.monthsmax &&
                //lrv.rvevaluationmode === offerParams.rvevaluationmode &&
                lrv.rvtype === 'FIN'
            )[0];
            assetrvamount = lineRV?.rvamount;
            if (lineRV?.rvevaluationmode !== 'FIXED')
              newRvAmount = isNaN(assetrvamount) ? 0 : assetrvamount;
            else
              newRvAmount = isNaN(assetrvamount)
                ? 0
                : assetrvamount * asset.assetqty;
            asset.assetrvamount = newRvAmount;
            totalAssetRV = totalAssetRV + newRvAmount;
          });

          rvcoef =
            (totalAssetRV / form.getFieldValue('ctfinancedamount')) * 100;
          rvamount = totalAssetRV;
        } else {
          // use FIN ELEMENT rv :
          if (data?.rvevaluationmode === 'FIXED') {
            rvamount = data?.rvdefaultamount;
            rvcoef = (rvamount / form.getFieldValue('ctfinancedamount')) * 100;
          } else {
            // eslint-disable-next-line no-unused-vars
            rvcoef = data?.rvdefault;
            rvamount =
              (data?.rvdefault * form.getFieldValue('ctfinancedamount')) / 100;
          }
        }
        // determine participation at asset level :
        let assetParticipation = false;
        let partamount = 0;
        let partmethod = '';

        listAssetElement.forEach((asset: any) => {
          if (!isNil(asset.partmethod) && asset.partmethod !== 'NONE') {
            assetParticipation = true;
            partmethod = asset.partmethod;
            partamount = partamount + asset.partamount;
          }
        });

        // const calculateDate = (
        //   prefinStepList: any[],
        //   _lctesstartdate: string
        // ) => {
        //   let lctesstartdate = _lctesstartdate ?? moment().format('YYYY-MM-DD');
        //   let lctesenddate = moment().format('YYYY-MM-DD');
        //   let newData = _.orderBy(prefinStepList ?? [], 'ctesorder').map(
        //     (step, index) => {
        //       if (index > 0) {
        //         lctesstartdate = moment(lctesenddate)
        //           .add(1, 'day')
        //           .format('YYYY-MM-DD');
        //         lctesenddate = moment(lctesstartdate)
        //           .add(step.ctesduration, 'days')
        //           .format('YYYY-MM-DD');
        //       } else {
        //         lctesenddate = moment(lctesstartdate)
        //           .add(step.ctesduration, 'days')
        //           .format('YYYY-MM-DD');
        //       }
        //       return {
        //         ...step,
        //         ctesstartdate: lctesstartdate,
        //         ctesenddate: lctesenddate,
        //       };
        //     }
        //   );

        //   return newData;
        // };

        let Element2 = offerToElement(
          data,
          investamount,
          taxamount,
          rvamount,
          assetParticipation,
          partmethod,
          partamount,
          cteid,
          form.getFieldValue('ctfclevel'),
          _assetid,
          finElements[indexElement]?.ctecategory,
          finElements[indexElement]?.ctecategorylabel,
          finElements[indexElement]?.ctedirection,
          finElements[indexElement]?.ctemileage,
          finElements[indexElement]?.ctepriidexceed
        );
        console.log('Element2::', Element2);

        if (
          (form.getFieldValue('ctfclevel') === 'MULTI' ||
            form.getFieldValue('ctfclevel') === 'MOASSMUEL') &&
          finElements[indexElement]?.ctedescription !== '' &&
          !isNil(finElements[indexElement]?.ctedescription)
        ) {
          Element2.ctedescription = finElements[indexElement]?.ctedescription;
          Element2.calid =
            form.getFieldValue('calid') ?? finElements[indexElement]?.calid;
        }
        /////
        let commList: Array<PropElementRequest> = [];

        let pricing = {
          ofrid: data.offerid,
          ofrtype: 'OFFER',
          ofrlabel: data.offerlabel,
          ofrdescription: '',
        };

        let newElements: any[] = [];

        data.servicesList?.forEach((item) => {

          if (item.ctetype === 'COMM') {
            commList.push(
              commissionToElement(
                pricing,
                item,
                item.commissionResponse,
                cteid,
                investamount,
                0,
                data,
                assetParticipation,
                partmethod,
                partamount
              )
            );
          } else {
            if (item.commissionList?.length !== 0) {
              item.commissionList?.forEach((c) =>
                commList.push(
                  commissionToElement(pricing, item, c, cteid, investamount)
                )
              );
            }
            newElements.push(
              pricingToElement(
                pricing,
                item,
                investamount,
                0,
                rvamount,
                rvcoef,
                item.ctetype === 'FIN' || item.ctetype === 'SPV' ? cteid : 0,
                cteid
              )
            );
          }
        });

        commList.forEach((e) => {
          newElements.push(e);
        });

        const elementsByType = form.getFieldValue('elements') ?? {};

        if (
          (form.getFieldValue('ctfclevel') === 'MULTI' ||
            form.getFieldValue('ctfclevel') === 'MOASSMUEL') &&
          finElements[indexElement]?.ctedescription !== '' &&
          !isNil(finElements[indexElement]?.ctedescription)
        ) {
          newElements = newElements.map((ele: any) => {
            if (ele?.cteid === finElements[indexElement]?.cteid)
              return {
                ...ele,
                ctedescription: finElements[indexElement]?.ctedescription,
              };
            else
              return {
                ...ele,
              };
          });
        }

        const oldElements = unGroup(elementsByType).filter(
          (item: any) => item.cteid !== cteid
        );

        // const finalElemList = { ...oldElements, ...newElements };
        oldElements.push(Element2);
        // eslint-disable-next-line no-debugger
        // debugger;

        await Promise.all(
          listAssetElement.map((asset: any) => {
            console.log('asset::::::::::::::::::::', asset);
            if (asset.assetServiceList != null) {
              Promise.all(
                asset.assetServiceList.map(async (assetService: any) => {
                  let indexService = newElements.findIndex(
                    (elem) => elem?.ctecategory === assetService?.servcode
                  );
                  if (indexService > -1) {
                    newElements[indexService].servfixedamount =
                      assetService.servfixedamount;
                    newElements[indexService].servpercentage =
                      assetService.servpercentage;
                    newElements[indexService].assetid = asset.assetid;
                    newElements[indexService].cteinstallmentamount =
                      asset.servfixedamount;
                  } else if (getNewService) {
                    let service = await getServiceByServcode({
                      servcode: assetService?.servcode,
                    });
                    if (service.data != null) {
                      let serv = ServiceResponceToElement(service.data);
                      let services = form.getFieldValue('flagfleet')
                        ? {
                            ...serv,
                            servfixedamount:
                              assetService?.servfixedamount ??
                              serv.servfixedamount,
                          }
                        : serv;
                      const res = ServiceToElement(
                        pricing,
                        services,
                        form.getFieldValue('cteinvestamount'),
                        [],
                        0,
                        cteid,
                        0,
                        finElements[indexElement]?.ctepriidexceed,
                        finElements[indexElement]?.ctemileage
                      );

                      res.pritype = 'PRICING';

                      onSaveService(res, 'create');
                    }
                  }
                  return assetService;
                })
              );
            }
            return asset;
          })
        );

        const finalElemList = oldElements.concat(newElements);

        const {
          FIN = [],
          FINOUT = [],
          SPV = [],
          SERV = [],
          FEES = [],
          COMM = [],
          FINSERV = [],
          SERVOUT = [],
        } = groupBy(finalElemList, 'ctetype');

        const elements = {
          COMM,
          FEES,
          FIN,
          FINOUT,
          SPV,
          FINSERV,
          SERV,
          SERVOUT,
        };

        if (data != null) {
          form.setFieldValue('elements', elements);
          form.setFieldsValue({
            selectedElement: cteid,
            offerParams: offerParams,
            assets: [...listAssetOtherElement, ...listAssetElement],
          });

          if (calculate) {
            debouncedCalculateNew('', '');
          }
          setIsLoading(false);
          if (
            offerParams.pricingChecklist !== null &&
            offerParams.pricingChecklist?.length > 0
          ) {
            showPricingHelper(offerParams.pricingChecklist);
          }
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  const showPricingHelper = (
    checklist: Array<MUserJobAuthorizationCheckResponse>
  ) => {
    confirm({
      width: 1000,
      style: { width: 800, top: 200, fontSize: 20 },

      title: <div style={{ fontSize: 20, color: 'black' }}>Pricing Helper</div>,
      icon: <ExclamationCircleOutlined />,
      content: (
        <div style={{ fontSize: 20, color: 'black' }}>
          <br></br>
          Several Financial combinations are available.
          <br></br>
          <br></br>
          Please refine your entry to benefit from our best rates
          <br></br>
          <br></br>
          <ul>
            {checklist.map((check, index) => (
              <li key={index}>
                {check.attribute +
                  ' : ' +
                  check.attributevalue +
                  ' : ' +
                  check.applicationRules[0]?.applicationRules[0]?.rulelabel +
                  ' ....'}
              </li>
            ))}
          </ul>
          <br></br>
          <br></br>
        </div>
      ),

      onOk() {
        return false;
      },
      okText: 'Yes',
      cancelText: 'No',
      okType: 'primary',
      onCancel() {
        return false;
      },
    });
    return false;
  };

  const handlePricingChange = async (
    pricing: any,
    inPartmethod: any,
    inPartamount: any,
    noCalcul?: boolean
  ) => {
    if (pricing !== undefined) {
      if (form.getFieldValue('flagasset') === true) {
        await handleAssetuseByOfferidORPricing(
          form.getFieldValue('offerid'),
          pricing.ofrid,
          pricing.ofrtype
        );
      }
      setIsLoading(true);
      loadPricingDetail(pricing)
        .then((res) => {
          const pricings = res.list;

          const data = pricings.find(
            ({ ctetype }) => ctetype === 'FIN' || ctetype === 'SPV'
          );

          if (inPartmethod === 'REDUCEFIN') {
            if (data) {
              data.partmethod = 'REDUCEFIN';
              data.partamount = inPartamount ?? 0;
            }
          }
          const cteid = form.getFieldValue('selectedElement');

          handleDeleteFinChildElements(cteid);

          const listassets = form.getFieldValue('assets');
          const listAssetElement = listassets.filter(
            (e: any) => e.cteid === cteid
          );
          const listAssetOtherElement = listassets.filter(
            (e: any) => e.cteid !== cteid
          );
          let indexElement = -1;

          const finElements = form.getFieldValue(['elements', 'FIN']) || [];

          if (finElements.length !== 0) {
            indexElement =
              finElements.findIndex((item: any) => item.cteid === cteid) ?? 0;
          }

          let investamount = form.getFieldValue('ctfinancedamount');
          let taxamount = 0;

          if (form.getFieldValue('ctfclevel') !== 'PROPOSAL') {
            if (form.getFieldValue('flagasset')) {
              // get list of associated assets
              investamount = sumBy(listAssetElement, 'assetfinamount');
              taxamount = sumBy(listAssetElement, 'assettaxamount');
            } else {
              if (indexElement >= 0) {
                investamount = finElements[indexElement].cteinvestamount;
                taxamount = finElements[indexElement].ctevatdeferralamount;
              }
            }
          }

          let commList: Array<PropElementRequest> = [];

          let rvcoef = 0;
          let rvamount = 0;

          //form.setFieldsValue({rvcalculationmode:data!.rvcalculationmode,rvevaluationmode:data!.rvevaluationmode})
          if (data && data!.rvcalculationmode === 'ASSET') {
            let totalAssetRV = 0;
            let assetrvamount = 0;
            let newRvAmount = 0;
            const defaultduration = data.durationdefault;

            listAssetElement.forEach((asset: any) => {
              const lineRV = (assetrvamount = asset.listrv.filter(
                (lrv: any) =>
                  defaultduration >= lrv.monthsmin &&
                  defaultduration <= lrv.monthsmax &&
                  //lrv.rvevaluationmode === finElements.rvevaluationmode &&
                  lrv.rvtype === 'FIN'
              )[0]);
              assetrvamount = lineRV?.rvamount;
              if (lineRV?.rvevaluationmode !== 'FIXED')
                newRvAmount = isNaN(assetrvamount) ? 0 : assetrvamount;
              else
                newRvAmount = isNaN(assetrvamount)
                  ? 0
                  : assetrvamount * asset.assetqty;
              asset.assetrvamount = newRvAmount;
              totalAssetRV = totalAssetRV + newRvAmount;
            });

            rvcoef = (totalAssetRV / investamount) * 100;
            rvamount = totalAssetRV;
          } else {
            // use FIN ELEMENT rv :
            if (data!.rvevaluationmode === 'FIXED') {
              rvamount = data!.rvdefaultamount;
              rvcoef = (rvamount / investamount) * 100;
            } else {
              rvcoef = data!.rvdefault;
              rvamount = (data!.rvdefault * investamount) / 100;
            }
          }

          form.setFieldsValue({
            assets: [...listAssetOtherElement, ...listAssetElement],
          });

          // eslint-disable-next-line array-callback-return
          let newElements = pricings.map((item) => {
            if (item.ctetype === 'COMM') {
              commList.push(
                commissionToElement(
                  pricing,
                  item,
                  item.commissionResponse,
                  cteid,
                  investamount
                )
              );
            } else {
              if (item.commissionList?.length !== 0) {
                item.commissionList?.map((c) =>
                  commList.push(
                    commissionToElement(pricing, item, c, cteid, investamount)
                  )
                );
              }
              return pricingToElement(
                pricing,
                item,
                investamount,
                taxamount,
                rvamount,
                rvcoef,
                item.ctetype === 'FIN' || item.ctetype === 'SPV' ? cteid : 0,
                cteid
              );
            }
          });
          commList.forEach((e) => {
            newElements.push(e);
          });

          const elementsByType = form.getFieldValue('elements') ?? {};

          if (
            form.getFieldValue('ctfclevel') === 'MULTI' &&
            finElements[indexElement]?.ctedescription !== '' &&
            !isNil(finElements[indexElement]?.ctedescription)
          ) {
            newElements = newElements.map((ele: any) => {
              if (ele?.cteid === finElements[indexElement]?.cteid)
                return {
                  ...ele,
                  ctedescription: finElements[indexElement]?.ctedescription,
                };
              else
                return {
                  ...ele,
                };
            });
          }
          const oldElements = unGroup(elementsByType).filter(
            (item: any) => item.cteid !== cteid
          );

          // const finalElemList = { ...oldElements, ...newElements };
          const finalElemList = oldElements.concat(newElements);

          const {
            FIN = [],
            FINOUT = [],
            SPV = [],
            SERV = [],
            FEES = [],
            COMM = [],
            FINSERV = [],
            SERVOUT = [],
          } = groupBy(finalElemList, 'ctetype');
          if (data != null) {
            let newElements: any = {
              COMM,
              FEES,
              FIN,
              FINOUT,
              SPV,
              FINSERV,
              SERV,
              SERVOUT,
            };
            form.setFieldsValue({
              elements: newElements,
            });
            debouncedCalculateNew('', '');
          } else {
            let ofr = form.getFieldValue('offerid');
            handleOfferChange(ofr);
            notification.error({
              message: 'No Pricing Financing Element associated to this Pack',
              description: '',
              duration: 10,
            });
          }
          setIsLoading(false);
        })
        .catch(() => {
          setIsLoading(false);
        });
    }
  };

  /////////////////////////

  const calculateSPVAmounts = debounce((param: string) => {
    const cteid = form.getFieldValue('selectedElement');
    let invest = form.getFieldValue('ctfinancedamount');
    let power = form.getFieldValue('ctpower');
    // let production = form.getFieldValue('ctproduction');
    // let degradation = form.getFieldValue('ctdegradation');
    // let unitprice = form.getFieldValue('ctunitprice');

    let discount = form.getFieldValue(getNameSpv('spvassetdiscount', cteid));
    let risk = form.getFieldValue(getNameSpv('spvriskrate', cteid));
    let fees = form.getFieldValue(getNameSpv('spvadditionalfees', cteid));
    let loan = form.getFieldValue(getNameSpv('spvloancoef', cteid));
    // let discountsale = form.getFieldValue(getNameSpv('spvdiscountsale', cteid));
    // let inflation = form.getFieldValue(getNameSpv('spvinflation', cteid));

    let discountamount = (invest * discount) / 100;
    let riskamount = (invest * risk) / 100;
    let feesamount = (fees * power * 1000) / 100;

    let finamount = feesamount + invest * (1 - discount / 100 + risk / 100);
    let loanamount = (loan * finamount) / 100;

    let elements = form.getFieldValue('elements');
    let spvElement = form.getFieldValue(['elements', 'SPV']);
    const indexElement = form
      .getFieldValue(['elements', 'SPV'])
      ?.findIndex((item: any) => item.cteid === cteid);

    spvElement[indexElement].spvassetdiscountamount = discountamount;
    spvElement[indexElement].spvriskamount = riskamount;
    spvElement[indexElement].spvfeesamount = feesamount;
    spvElement[indexElement].ctefinancedamount = finamount;
    spvElement[indexElement].spvloanamount = loanamount;

    const indexFin = form
      .getFieldValue(['elements', 'FINOUT'])
      ?.findIndex((item: any) => item.ctetype === 'FINOUT');
    let finElement = form.getFieldValue(['elements', 'FINOUT']);
    finElement[indexFin].ctefinancedamount = loanamount;

    elements = { ...elements, SPV: spvElement, FINOUT: finElement };

    form.setFieldsValue({ elements: elements });
  }, 1);

  const debouncedCalculateNew = debounce(
    async (param: string, calcMethod: string, _cteid?: number) => {
      console.log(
        'param',
        param,
        '--_cteid::',
        _cteid,
        '--calcMethod::',
        calcMethod
      );
      const cteid = _cteid ?? form?.getFieldValue('selectedElement');

      if (phase === 'PROPOSAL') {
        if (
          form
            ?.getFieldValue('assets')
            ?.find((asset: any) => asset.cteid === cteid) ||
          form?.getFieldValue('flagasset') === false
        )
          setIsLoading(true);

        await calculateNew(cteid, param, calcMethod)
          .then((e) => {
            // update element with fees and commission and then recalculate to get APR :

            // calculate FEES ELEMENT:
            const feesElement = form.getFieldValue(['elements', 'FEES']);

            const feesElements: any[] = feesElement?.filter(
              (item: any) => item.cteidparent === cteid
            );

            let ind = 0;
            let feesAmount = 0;
            if (Array.isArray(feesElements)) {
              for (var fees of feesElements) {
                feesAmount = feesAmount + fees.cteinstallmentamount;
              }
            }

            const commElements = form
              ?.getFieldValue(['elements', 'COMM'])
              ?.filter((item: any) => item.cteidparent === cteid);

            let commAmount = 0;

            if (Array.isArray(commElements)) {
              for (var comm of commElements) {
                commAmount = commAmount + comm.cteinstallmentamount;
              }
            }

            if (feesAmount > 0 || commAmount > 0) {
              let elements = form.getFieldValue('elements');

              let finelements = form.getFieldValue(['elements', 'FIN']);

              finelements.forEach((ele: any) => {
                if (ele?.cteid === cteid) {
                  ele.ctefeesamount = feesAmount;
                  ele.ctecommissionamount = commAmount;
                }
              });

              elements = { ...elements, FIN: finelements };

              form.setFieldsValue({ elements: elements });
              setIsLoading(false);

              // calculateNew(cteid, param, calcMethod);
            }
          })
          .catch((err) => {
            setIsLoading(false);
          });

        // check if exists options to propose :
        //

        const assets = form.getFieldValue('assets');

        let listAsset = assets?.filter((asset: any) => asset.cteid === cteid);

        let assetCatalogOptionsToPropose: any[] = [];
        let assetComponents: any[] = [];

        listAsset.forEach((asset: any) => {
          if (asset) {
            assetCatalogOptionsToPropose = [
              ...assetCatalogOptionsToPropose,
              ...(asset.assetCatalogOptionsToPropose || []),
            ];
            assetComponents = [
              ...assetComponents,
              ...(asset.assetComponents || []),
            ];
          }
        });

        const existOptionToPropose: any[] = [];

        assetCatalogOptionsToPropose?.forEach((opt: any) => {
          const CatalogAvailableOptions: any = assetComponents.find(
            (e) => e.optid === opt?.optid
          );
          if (opt.proposed !== true && isNil(CatalogAvailableOptions)) {
            existOptionToPropose.push(opt);
          }
        });

        let Simulate = false;
        if (
          Simulate &&
          existOptionToPropose.length > 0 &&
          alreadyanswered === false
        ) {
          alreadyanswered = true;
          const indexElement = form
            .getFieldValue(['elements', 'FIN'])
            ?.findIndex((item: any) => item.cteid === cteid);

          let newFinElement = form.getFieldValue([
            'elements',
            'FIN',
            indexElement,
          ]) as PropElementResponse;

          const finElement = { ...newFinElement };

          let finAmount = 0;

          assets
            ?.filter((a: any) => a?.cteid === cteid)
            ?.forEach((asset: any) => {
              finAmount += asset?.assetfinamount;

              asset?.assetCatalogOptionsToPropose?.forEach(
                (opt: ParAssetCatalogOptionResponse) => {
                  if (opt.proposed !== true) {
                    finAmount += opt?.optnetamount;
                  }
                }
              );
            });

          finElement.cteinvestamount = finAmount;
          finElement.ctefinancedamount =
            finAmount - finElement.cteupfrontamount ??
            0 - finElement.ctepartamount ??
            0;
          let newInstallement = await simulateWithOptions(
            cteid,
            finElement,
            finAmount
          ).then((res) => {
            return res?.installmentamount;
          });

          if (
            newInstallement - finElement?.cteinstallmentamount > 0 ||
            finElement?.cteinstallmentamount == null
          ) {
            confirm({
              content: (
                <Card title="Upgrade offer">
                  <span style={{ marginBottom: 7 }}>
                    Would you like to upgrade the asset with following options,
                    for &nbsp;
                    <span style={{ color: 'red' }}>
                      {toCurrency(
                        Number(
                          newInstallement -
                            form.getFieldValue(
                              getName('cteinstallmentamount', cteid)
                            )
                        ).toFixed(3),
                        localStorage.getItem('currcode') ?? ''
                      )}{' '}
                    </span>
                    per month ?
                  </span>
                  <List
                    size="small"
                    style={{ width: '100%' }}
                    dataSource={
                      assets.find((a: any) => a.cteid === cteid)
                        ?.assetCatalogOptionsToPropose
                    }
                    renderItem={(e: any) => (
                      <List.Item>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                          }}
                        >
                          <Col style={{ textDecoration: 'underline' }}>
                            {`${e.optcodelabel} 
                              : 
                              ${e.optvaluelabel ? e.optvaluelabel : ''} 
                              : 
                              ${toCurrency(
                                e.optnetamount,
                                localStorage.getItem('currcode') ?? ''
                              )}`}
                          </Col>
                        </div>
                      </List.Item>
                    )}
                  />
                </Card>
              ),
              width: 700,
              onOk() {
                const cteid = form.getFieldValue('selectedElement');

                const newAssets: any[] = [];
                assets?.forEach((asset: any) => {
                  if (asset.cteid === cteid) {
                    const lassetComponents: any[] = [];

                    let finA = 0;

                    if (asset.assetCatalogOptionsToPropose?.length! > 0) {
                      asset.assetCatalogOptionsToPropose?.forEach(
                        (opt: any) => {
                          if (opt.proposed !== true) {
                            lassetComponents.push({
                              assetid: 0,
                              compcategory: opt.optcode,
                              compcategorylabel: opt.optcodelabel,
                              compdescription:
                                opt.optcodelabel + ' : ' + opt.optvaluelabel,
                              compdiscountamount: 0,
                              compdiscountrate: 0,
                              compfree1: '',
                              compgrossamount: opt.optgrossamount,
                              compid: opt.optid,
                              compnetamount: opt.optnetamount,
                              comporiginalnetamount: opt.optnetamount,
                              comptaxamount: opt.opttaxamount,
                              comptype: 'OPT',
                              comptypelabel: 'Option',
                              flagholdback: false,
                              holdbackamount: 0,
                              holdbackbeleasedate: '',
                              holdbackbeleasenbdays: 0,
                              holdbackpercentage: 0,
                              suppliername: asset?.suppliername,
                              supplierreference: asset?.supplierreference,
                              taxcode: opt.opttaxcode,
                              taxrate: 0,
                              tpidsupplier: asset?.tpidsupplier,
                            });
                            opt.proposed = true;
                            finA += opt?.optnetamount;
                          }
                        }
                      );
                      if (
                        !asset?.assetmulticomponents &&
                        lassetComponents.length > 0
                      ) {
                        lassetComponents.push({
                          assetid: 0,
                          compcategory: 'ASSET',
                          compcategorylabel: asset.assetlabel,
                          compdescription: asset.assetlabel,
                          compdiscountamount: 0,
                          compdiscountrate: 0,
                          compfree1: '',
                          compgrossamount: asset.assetgrossamount,
                          compid: asset.catalogid,
                          compnetamount: asset.assetnetamount,
                          comporiginalnetamount: asset.assetnetamount,
                          comptaxamount: asset.assettaxamount,
                          comptype: 'ASSET',
                          comptypelabel: 'Asset',
                          flagholdback: false,
                          holdbackamount: 0,
                          holdbackbeleasedate: '',
                          holdbackbeleasenbdays: 0,
                          holdbackpercentage: 0,
                          suppliername: asset.suppliername,
                          supplierreference: asset.supplierreference,
                          taxcode: asset.taxcode,
                          taxrate: 0,
                          tpidsupplier: asset.tpidsupplier,
                        });
                      }
                      if (asset) {
                        asset.assetComponents = [
                          ...(asset.assetComponents || []),
                          ...lassetComponents,
                        ];
                      }

                      asset.assetnetamount = finA + asset.assetnetamount;
                      asset.assetfinamount = finA + asset.assetfinamount;
                      asset.assetmulticomponents = true;
                    }

                    newAssets.push(asset);
                  }
                });

                form.setFieldValue('assets', newAssets);

                let ctfinancedamount = sumBy(newAssets, 'assetnetamount');

                let mfrequestedamount = sumBy(newAssets, 'assetnetamount');

                form.setFieldsValue({
                  ctfinancedamount: ctfinancedamount,
                  mfrequestedamount: mfrequestedamount,
                });

                const fin = form
                  .getFieldValue(['elements', 'FIN'])
                  .find((e: any) => e?.cteid === cteid);

                if (fin.ofrid != null && fin.ofrid !== 0) {
                  handlePricingChange(
                    {
                      ofrid: fin.ofrid,
                      ofrtype: fin.ofrtype,
                      ofrlabel: fin.ofrlabel,
                    },
                    '',
                    0
                  );
                } else {
                  //                handleOfferChange(form.getFieldValue('offerid'));
                }

                let elements = form.getFieldValue('elements');

                if (form.getFieldValue('ctfclevel') === 'MULTI') {
                  const finelements = form.getFieldValue(['elements', 'FIN']);
                  finelements.forEach((ele: any) => {
                    if (ele?.cteid === cteid) {
                      const totalInvest = sumBy(
                        form
                          .getFieldValue('assets')
                          .filter((a: any) => (a.cteid = cteid)),
                        'assetnetamount'
                      );
                      ele.cteinvestamount = totalInvest;
                    }
                  });

                  elements = { ...elements, FIN: finelements };

                  form.setFieldsValue({ elements: elements });

                  const fin = form
                    .getFieldValue(['elements', 'FIN'])
                    .find((e: any) => e.cteid === cteid);

                  if (fin.ofrid != null && fin.ofrid !== 0) {
                    handlePricingChange(
                      {
                        ofrid: fin.ofrid,
                        ofrtype: fin.ofrtype,
                        ofrlabel: fin.ofrlabel,
                      },
                      '',
                      0
                    );
                  } else {
                    //                handleOfferChange(form.getFieldValue('offerid'));
                  }
                }

                debouncedCalculateNew('', '');
                setAlreadyanswered(true);
              },
              onCancel() {
                setAlreadyanswered(true);
                const assets = form.getFieldValue('assets');
              },
              okText: 'Yes',
              cancelText: 'No',
              okButtonProps: { style: { padding: '7px' } },
              centered: true,
            });
          }
        } else {
          assets?.forEach((asset: any) => {
            if (asset.cteid === cteid) {
              if (asset.assetCatalogOptionsToPropose?.length! > 0) {
                asset.assetCatalogOptionsToPropose?.forEach((opt: any) => {
                  if (opt.proposed !== true) {
                    opt.proposed = true;
                  }
                });
              }
            }
          });

          form.setFieldValue('assets', assets);
        }
      } // end if phase==='PROPOSAL'
    },
    1000
  );
  const handleOfferOrPricingChange = debounce((offer: any, pricing: any) => {
    if (pricing) handlePricingChange(pricing, '', 0);
    else if (offer) handleOfferChange(offer);
  }, 2000);
  const calculateREC = (
    stepStartamount: any,
    stepStartdate: any,
    i: number,
    currentStep: any,
    finElement: any,
    installmentamount: any,
    finElementconElemStep: any
  ) => {
    if (i === finElement.conElemSteps.length) {
      calculatePaymentSheduleWeightedStep('STEPWEIGH', finElementconElemStep);
      return finElementconElemStep;
    } else {
      setLoading(true);

      finEngine
        .calculate({
          finReq: {
            inBillingDate: finElement?.ctebilligdate,
            inCalculationMethod:
              finElement.conElemSteps.length - 1 === i ? 'INST' : 'OUTSTAND',
            inCalculationType: finElement?.ctecalculationtype,
            inCountingbasis: finElement?.cteratebasis,
            inDeferredMethod: finElement?.ctedeferredinterestmethod,
            inDeferredRate: finElement?.ctedeferredinterestnominalrate,
            inDepositAmount:
              finElement?.ctedepositamount == null
                ? 0
                : finElement?.ctedepositamount,
            inDepositMethod: finElement?.ctedepositinterestmethod,
            inDepositRate:
              finElement?.ctedepositnominalrate == null
                ? 0
                : finElement?.ctedepositnominalrate,
            inDuration: currentStep.ctesduration,
            inFinancedAmount: stepStartamount ?? 0,
            inFirstInstallmentDate: '', //dateToString(finElement?.ctestartdate),
            inFirstPayment: 0,
            inGracePeriodDuration: 0,
            inGracePeriodMethod: 'NONE',
            inInstallmentAmount:
              finElement.conElemSteps.length - 1 === i
                ? 0
                : (currentStep.ctesrentalcoef * installmentamount) / 100,
            inInterestMethod: i === 0 ? finElement?.cteinterestmethod : 'BOP',
            inPartAmount:
              finElement?.ctepartamount == null ? 0 : finElement?.ctepartamount,
            inPartMethod: finElement?.ctepartmethod
              ? finElement?.ctepartmethod
              : 'NONE',
            inPartNbDays:
              finElement?.ctepartdays == null ? 0 : finElement?.ctepartdays,
            inPartRate:
              finElement?.ctepartrate == null ? 0 : finElement?.ctepartrate,
            inPeriodicity: currentStep.ctesperiodicity,
            inPeriodicityUnit: currentStep.ctesperiodicityunit ?? 'M',
            inRatePeriodicity: Number(finElement?.cterateperiodicity),
            inRateType: finElement?.cteratetype,
            inRateValue:
              finElement?.ctenominalrate == null
                ? 0
                : finElement?.ctenominalrate,
            inResidualValue:
              finElement.conElemSteps.length - 1 === i
                ? finElement.ctervamount
                : 0, //e.ctesoutstandingamount,
            inRoundingAmount: getRounding(finElement.currcode),
            inRoundingRate: 9,
            inStartDate: stepStartdate, //dateToString(finElement.ctestartdate),
            inTaxcode: finElement?.taxcode,
            inTaxrate: finElement?.taxrate,
            inTaxtype: finElement?.taxtype,
            inTerm: finElement?.ctepaymentterm,
            inUpFrontAmount:
              finElement?.cteupfrontamount == null
                ? 0
                : finElement?.cteupfrontamount,
          },
        })
        .then((resStep) => {
          setLoading(false);

          if (resStep.success) {
            // update Step :

            finElementconElemStep.push({
              cteid: finElement.cteid,
              ctesamortizedcoef: (
                (resStep.residualvalue / finElement.cteinvestamount) *
                100
              ).toFixed(3),
              ctesduration: currentStep.ctesduration,
              ctesid: currentStep.ctesid,
              ctesorder: currentStep.ctesorder,
              ctesoutstandingamount: resStep.residualvalue,
              ctesperiodicity: currentStep.ctesperiodicity,
              ctesperiodicityunit: currentStep.ctesperiodicityunit ?? 'M',
              ctesperiodicityunitlabel: '',
              ctesrentalamount: resStep.installmentamount, //*e.ctesrentalcoef/100,
              ctesrentalcoef: (
                (resStep.installmentamount / installmentamount) *
                100
              ).toFixed(3),
              ctrid: finElement.ctrid,
              status: 'VALID',
            });

            stepStartamount = resStep.residualvalue;
            stepStartdate = resStep.paymentSchedule.find(
              (e) => e.ctstype === 'RV'
            )?.ctsenddate;

            calculateREC(
              stepStartamount,
              stepStartdate,
              i + 1,
              finElement.conElemSteps[i + 1],
              finElement,
              installmentamount,
              finElementconElemStep
            );
          } // end success calculation
        })
        .catch((err) => {
          setLoading(false);
        });

      //return finElementconElemStep;
    }
  };
  const calculateServAndComm = async (
    res: any,
    finElement: PropElementResponse,
    finamount: number,
    inCteid: number
  ) => {
    // calculate FinServices ELEMENTs:
    // calculate Services ELEMENT:

    const promises: Promise<any>[] = [];

    const finServElements = form
      .getFieldValue(['elements', 'FINSERV'])
      .filter((item: any) => item.cteidparent === inCteid);

    let ind = 0;
    for (var finserv of finServElements) {
      promises.push(
        calculateFinServiceNew(
          finserv,
          finElement,
          finElement.ctestartdate,
          finElement.ctebilligdate,
          finamount,
          inCteid
        )
      );
      ind = ind + 1;
    }

    // calculate Services ELEMENT:
    const servElements = form
      .getFieldValue(['elements', 'SERV'])
      .filter((item: any) => item.cteidparent === inCteid);

    ind = 0;
    for (var serv of servElements) {
      if (serv.ctecategory !== 'AFTERDELIV') {
        promises.push(
          calculateServiceNew(
            serv,
            res.inGracePeriodDuration,
            res.inFinancedamount,
            finElement.cteinvestamount,
            finElement.cteinvestamount,
            res.inStartDate,
            res.inDuration,
            res.paymentSchedule,
            inCteid,
            'IN',
            finElement.ctebilligdate
          )
        );
        ind = ind + 1;
      }
    }
    // calculate Services OUT ELEMENT:
    const servOutElements = form
      .getFieldValue(['elements', 'SERVOUT'])
      ?.filter((item: any) => item.cteidparent === inCteid);
    ind = 0;
    if (!isNil(servOutElements)) {
      for (var servout of servOutElements) {
        promises.push(
          calculateServiceNew(
            servout,
            res.inGracePeriodDuration,
            finElement.ctefinancedamount,
            finElement.cteinvestamount,
            finElement.cteinvestamount,
            res.inStartDate,
            res.inDuration,
            res.paymentSchedule,
            inCteid,
            'OUT',
            finElement.ctebilligdate
          )
        );
        ind = ind + 1;
      }
    }

    // calculate FEES ELEMENT:
    const feesElements = form
      .getFieldValue(['elements', 'FEES'])
      .filter((item: any) => item.cteidparent === inCteid);
    ind = 0;

    for (var fees of feesElements) {
      promises.push(
        calculateFeesNew(
          fees,
          res.inGracePeriodDuration,
          finElement.ctefinancedamount,
          finElement.cteinvestamount,
          finElement.cteinvestamount,
          res.inStartDate,
          res.inDuration,
          res.paymentSchedule,
          inCteid
        )
      );
      ind = ind + 1;
    }
    // calculate Commissions elements :
    // calculate Services ELEMENT:
    const commElements = form
      .getFieldValue(['elements', 'COMM'])
      .filter((item: any) => item.cteidparent === inCteid);

    ind = 0;

    for (var comm of commElements) {
      promises.push(
        calculateCommissionNew(
          comm,
          res.inGracePeriodDuration,
          finElement.ctefinancedamount,
          finElement.cteinvestamount,
          finElement.cteinvestamount,
          res.inStartDate,
          res.inDuration,
          res.paymentSchedule,
          inCteid
        )
      );
      ind = ind + 1;
    }
    await Promise.all(promises);
  };

  const calculateNew = async (
    inCteid: number,
    param: string,
    calcMethod: string
  ) => {
    setIsLoading(true);

    const indexElement = form
      .getFieldValue(['elements', 'FIN'])
      ?.findIndex((item: any) => item.cteid === inCteid);

    const finElement = form.getFieldValue([
      'elements',
      'FIN',
      indexElement,
    ]) as PropElementResponse;

    if (form.getFieldValue('flagspv') === false) {
      if (!finElement || finElement?.ctecalculationtype === null) {
        return;
      }
    }

    var finamount = 0;
    let investamount = finElement.cteinvestamount;
    let firstPayment = 0; //finElement.ctefirstpayment

    var rvcoef = 0;
    var rvamount = 0;

    const lcalcMethod = calcMethod === '' ? 'INST' : calcMethod;

    const listassets = form.getFieldValue('assets');
    const invest =
      form.getFieldValue('cttype') === 'LEAD'
        ? form.getFieldValue(getName('cteinvestamount', inCteid))
        : form.getFieldValue('cttype') === 'PART'
        ? form.getFieldValue('ctsyndmgpartamount')
        : form.getFieldValue(getName('cteinvestamount', inCteid));

    if (param === 'FP') {
      firstPayment = finElement.ctefirstpayment;
    } else {
      firstPayment = !isNaN(finElement.ctefirstpaymentcoef)
        ? (finElement.ctefirstpaymentcoef * invest) / 100
        : finElement.ctefirstpaymentcoef;
    }
    if (param === 'RV') {
      rvamount = finElement.ctervamount;
    } else {
      if (finElement.rvcalculationmode === 'ASSET') {
        let totalAssetRV = 0;
        let assetrvamount = 0;
        let newRvAmount = 0;
        const defaultduration = finElement.cteduration;
        listassets.forEach((asset: any) => {
          if (asset.cteid === inCteid) {
            const lineRV = asset.listrv.filter(
              (lrv: any) =>
                defaultduration >= lrv.monthsmin &&
                defaultduration <= lrv.monthsmax &&
                //lrv.rvevaluationmode === finElement.rvevaluationmode &&
                lrv.rvtype === 'FIN'
            )[0];
            assetrvamount = lineRV?.rvamount;
            if (lineRV?.rvevaluationmode !== 'FIXED')
              newRvAmount = isNaN(assetrvamount) ? 0 : assetrvamount;
            else
              newRvAmount = isNaN(assetrvamount)
                ? 0
                : assetrvamount * asset.assetqty;
            asset.assetrvamount = newRvAmount;
            totalAssetRV = totalAssetRV + newRvAmount;
          }
        });

        rvcoef = (totalAssetRV / invest) * 100;
        rvamount = totalAssetRV;
      } else {
        if (finElement.rvevaluationmode === 'FIXED') {
          rvamount = finElement.ctervamount;
          rvcoef = (rvamount / invest) * 100;
        } else {
          rvcoef = finElement.ctervcoef;
          rvamount = !isNaN(rvcoef)
            ? (rvcoef * invest) / 100
            : finElement.ctervamount;
        }
      }
    }
    // set rvamount for each asset :
    if (finElement.rvcalculationmode !== 'ASSET')
      listassets.forEach((asset: any) => {
        if (asset.cteid === inCteid) {
          asset.assetrvamount = (
            rvamount *
            (asset.assetfinamount / investamount)
          ).toFixed(getRounding(finElement.currcode));
        }
      });

    form.setFieldsValue({ assets: listassets });

    const rvAmount = rvamount;

    const upfront =
      finElement.cteupfrontamount == null ? 0 : finElement.cteupfrontamount;
    const extracost =
      finElement.cteextracosttofinance == null
        ? 0
        : finElement.cteextracosttofinance;

    investamount = getInvestAmount(
      form.getFieldValue('ctfclevel') === 'MULTI' ||
        form.getFieldValue('ctfclevel') === 'MOASSMUEL'
        ? finElement.cteinvestamount
        : form.getFieldValue('ctfinancedamount')
    );
    console.log('prcode:::', form.getFieldValue('prcode'));

    let ctepartamount = await getParticipationAmount(
      inCteid,
      investamount
    ).then((res) => {
      return res;
    });
    console.log('investamount::', investamount, '--finElement::', finElement);
    console.log(
      'ctepartamount::',
      ctepartamount,
      '--inCteid::',
      inCteid,
      '--param::',
      param
    );
    let ctepartrate = finElement.ctepartrate;
    finamount =
      investamount +
      extracost -
      upfront -
      (ctepartamount == null ? 0 : ctepartamount);

    // form.setFieldValue(getName('ctefinancedamount', inCteid), finamount);

    if (param === 'PARTRATE' || param === 'PARTAMOUNT') {
      if (param === 'PARTRATE') {
        ctepartamount = (finElement.ctepartrate * invest) / 100;
        ctepartrate = finElement.ctepartrate;
      }
      if (param === 'PARTAMOUNT') {
        ctepartrate = (finElement.ctepartamount / invest) * 100;
        ctepartamount = finElement.ctepartamount;
      }
    } else {
      if (finElement.ctepartmethod === 'FIXED') {
        ctepartrate = (finElement.ctepartamount / invest) * 100;
        ctepartamount = finElement.ctepartamount;
      }
      if (finElement.ctepartmethod === 'POURC') {
        ctepartamount = (finElement.ctepartrate * invest) / 100;
        ctepartrate = finElement.ctepartrate;
      }
      if (finElement.ctepartmethod === 'WSPART') {
        ctepartamount = (finElement.ctepartrate * invest) / 100;
        ctepartrate = finElement.ctepartrate;
      }
    }
    //updating ctefinancedamount
    let elements = form.getFieldValue('elements');
    let finelements = form.getFieldValue(['elements', 'FIN']);

    // form.setFieldValue('ctfinancedamount', sumBy(finelements,'ctefinancedamount'));

    //set rvamount for seasonalcalculation
    finelements[indexElement].ctervamount = rvAmount;
    finelements[indexElement].ctepartamount = ctepartamount;
    finelements[indexElement].ctepartrate = ctepartrate;
    finelements[indexElement].ctefinancedamount = finamount;
    finelements[indexElement].cteextracosttofinance = extracost;

    finelements[indexElement].ctedeferredinterestnominalrate =
      finelements[indexElement].deferredinterestratetype === 'CONTRACT'
        ? finelements[indexElement].ctenominalrate
        : finelements[indexElement].ctedeferredinterestnominalrate;

    finelements[indexElement].ctedepositnominalrate =
      finelements[indexElement].depositratetype === 'CONTRACT'
        ? finelements[indexElement].ctenominalrate
        : finelements[indexElement].ctedepositnominalrate;

    if (
      finElement.rvcalculationmode === 'ASSET' &&
      finElement.rvevaluationmode === 'FIXED'
    ) {
      finelements[indexElement].helpers.rvmax = rvcoef;
      finelements[indexElement].helpers.rvmin = rvcoef;
    }

    elements = { ...elements, FIN: finelements };
    let ctfinancedamount = sumBy(finelements, 'ctefinancedamount');

    form.setFieldsValue({
      elements: elements,
      ctfinancedamount: ctfinancedamount,
    });
    setIsLoading(false);
    console.log('finelement::',finelements[indexElement])

    //end updating
    switch (finElement?.ctecalculationtype) {
      case 'SEASON':
        await calculateSeasonal(inCteid);
        //OK
        break;
      case 'LINEAR':
      case 'LOYFIX':
        await calculateLinearAndWeighted(
          inCteid,
          finelements[indexElement],
          finamount,
          investamount,
          firstPayment,
          rvAmount,
          'IN',
          lcalcMethod
        );
        //OK
        break;
      case 'LINAMORT':
        await calculateLinearAndWeighted(
          inCteid,
          finelements[indexElement],
          finamount,
          investamount,
          firstPayment,
          rvAmount,
          'IN',
          lcalcMethod
        );
        //OK
        break;

      case 'STEP':
        await calculatePaymentSheduleStep(inCteid);
        break;
      case 'STEPWEIGH':
        await calculateLinearAndWeighted(
          inCteid,
          finelements[indexElement],
          finamount,
          investamount,
          0, //firstPayment
          rvAmount,
          'IN',
          lcalcMethod
        );
        //OK
        break;
    } // end switch calctype
  };

  // const calculateNewSPV = (inCteid: number, param: string) => {
  //   const indexSPV = form
  //     .getFieldValue(['elements', 'SPV'])
  //     ?.findIndex((item: any) => item.cteid === inCteid);

  //   const spvElement = form.getFieldValue([
  //     'elements',
  //     'SPV',
  //     indexSPV,
  //   ]) as PropElementResponse;

  //   if (!spvElement) {
  //     return;
  //   }
  //   var finamount = spvElement.ctefinancedamount;
  //   let investamount = spvElement.cteinvestamount;
  //   let firstPayment = 0; //finElement.ctefirstpayment

  //   var rvcoef = 0;
  //   var rvamount = 0;

  //   if (param === 'FP') {
  //     firstPayment = spvElement.ctefirstpayment;
  //   } else {
  //     firstPayment = !isNaN(spvElement.ctefirstpaymentcoef)
  //       ? (spvElement.ctefirstpaymentcoef * finamount) / 100
  //       : spvElement.ctefirstpaymentcoef;
  //   }
  //   if (param === 'RV') {
  //     rvamount = spvElement.ctervamount;
  //   } else {
  //     if (spvElement.rvevaluationmode === 'FIXED') {
  //       rvamount = spvElement.ctervamount;
  //       rvcoef = (rvamount / finamount) * 100;
  //     } else {
  //       rvcoef = spvElement.ctervcoef;
  //       rvamount = !isNaN(rvcoef)
  //         ? (rvcoef * finamount) / 100
  //         : spvElement.ctervamount;
  //     }
  //   }

  //   let elements = form.getFieldValue('elements');
  //   let spvelements = form.getFieldValue(['elements', 'SPV']);
  //   spvelements[indexSPV].ctervamount = rvamount;
  //   spvelements[indexSPV].ctefinancedamount = finamount;

  //   elements = { ...elements, SPV: spvelements };

  //   form.setFieldsValue({ elements: elements });
  //   //end updating
  //   calculateSPVAmounts('discount');

  //   // calculate SPV:
  //   //TODO :
  //   calculateSpvSchedule(
  //     elementID,
  //     spvelements[indexSPV],
  //     finamount,
  //     finamount,
  //     firstPayment,
  //     rvamount,
  //     'IN'
  //   );

  //   // recalculate FinOut:
  //   let finElement = form.getFieldValue(['elements', 'FINOUT', 0]);

  //   finamount = finElement.ctefinancedamount;
  //   inCteid = finElement.cteid;

  //   switch (finElement?.ctecalculationtype) {
  //     case 'SEASON':
  //       calculateSeasonal(inCteid);
  //       //OK
  //       break;
  //     case 'LINEAR':
  //       calculateLinearAndWeighted(
  //         inCteid,
  //         finElement,
  //         finamount,
  //         finamount,
  //         firstPayment,
  //         rvamount,
  //         'OUT',
  //         'INST'
  //       );
  //       //OK
  //       break;
  //     case 'STEP':
  //       calculatePaymentSheduleStep(inCteid);
  //       break;
  //     case 'STEPWEIGH':
  //       calculateLinearAndWeighted(
  //         inCteid,
  //         finElement,
  //         finamount,
  //         investamount,
  //         0, //firstPayment
  //         rvamount,
  //         'OUT',
  //         'INST'
  //       );
  //       //OK
  //       break;
  //   } // end switch calctype
  // };

  const calculateSpvSchedule = (
    inCteid: number,
    finElement: PropElementResponse,
    finamount: number,
    investamount: number,
    firstPayment: number,
    rvAmount: number,
    direction: string
  ) => {
    setLoading(true);

    finEngine
      .calculateSpvSchedule({
        finReq: {
          inBillingDate: finElement?.ctebilligdate,
          inDurationYears: finElement?.cteduration,
          inFirstInstallmentDate: '', //dateToString(finElement?.ctestartdate),
          inFirstPayment: firstPayment == null ? 0 : firstPayment,
          inPeriodicity: Number(finElement?.cteperiodicity),
          inPeriodicityUnit: finElement?.cteunit,
          inResidualValue: rvAmount == null ? 0 : rvAmount,
          inRoundingAmount: getRounding(finElement.currcode),
          inRoundingRate: 9,
          inStartDate: dateToString(finElement?.ctestartdate),
          inTaxcode: finElement?.taxcode,
          inTaxrate: finElement?.taxrate,
          inTaxtype: finElement?.taxtype,
          inPower: form.getFieldValue('ctpower'),
          inDegradation: form.getFieldValue('ctdegradation'),
          inDiscountsale: finElement?.spvdiscountsale,
          inInflation: finElement?.spvinflation,
          inProduction: form.getFieldValue('ctproduction'),
          inUnitPrice: form.getFieldValue('ctunitprice') ?? 0.868686,
        },
      })
      .then((res) => {
        setLoading(false);

        if (res.success) {
          message.success(t(`finEngine.${res.message}`));

          const FinElements = form.getFieldValue(['elements', 'SPV']) || [];

          form.setFieldsValue({
            elements: {
              SPV: FinElements.map((element: any, index: number) =>
                element.cteid === inCteid
                  ? {
                      ...element,
                      conElemSchedules: res.paymentSchedule,
                      conElemSteps: res.elementStep,
                      //cteduration: res.duration,
                      ctefirstpaymentcoef:
                        element.ctecalculationtype === 'STEPWEIGH'
                          ? 0
                          : (res.inFirstPayment / investamount) * 100,
                      ctervcoef: (res.residualvalue / investamount) * 100,
                    }
                  : element
              ),
            },
          });

          // calculateServAndComm(res, finElement, finamount, inCteid);
        }
      })
      .catch((err) => {
        setLoading(false);
      }); // end then
  };
  const simulateWithOptions = (
    inCteid: number,
    finElement: PropElementResponse,
    finamount: number
  ) => {
    return finEngine.calculate({
      finReq: {
        inBillingDate: finElement?.ctebilligdate,
        inCalculationMethod: 'INST',
        inCalculationType: finElement?.ctecalculationtype,
        inCountingbasis: finElement?.cteratebasis,
        inDeferredMethod: finElement?.ctedeferredinterestmethod,
        inDeferredRate: finElement?.ctedeferredinterestnominalrate,
        inDepositAmount:
          finElement?.ctedepositamount == null
            ? 0
            : finElement?.ctedepositamount,
        inDepositMethod: finElement?.ctedepositinterestmethod,
        inDepositRate:
          finElement?.ctedepositinterestmethod === 'NONE'
            ? 0
            : finElement?.ctedepositnominalrate == null
            ? 0
            : finElement?.ctedepositnominalrate,
        inDuration: finElement?.cteduration,
        inFinancedAmount: finamount,
        inFirstInstallmentDate: '', //dateToString(finElement?.ctestartdate),
        inFirstPayment: finElement?.ctefirstpayment,
        inGracePeriodDuration:
          finElement?.ctegraceperiodduration == null
            ? 0
            : finElement?.ctegraceperiodduration,
        inGracePeriodMethod: finElement?.ctegraceperiodmethod,
        inInstallmentAmount: finElement?.cteinstallmentamount,
        inInterestMethod: finElement?.cteinterestmethod,
        inPartAmount:
          finElement?.ctepartamount == null ? 0 : finElement?.ctepartamount,
        inPartMethod: finElement?.ctepartmethod
          ? finElement?.ctepartmethod
          : 'NONE',
        inPartNbDays:
          finElement?.ctepartdays == null ? 0 : finElement?.ctepartdays,
        inPartRate:
          finElement?.ctepartrate == null ? 0 : finElement?.ctepartrate,
        inPeriodicity: finElement?.cteperiodicity,
        inPeriodicityUnit: finElement?.cteunit,
        inRatePeriodicity: Number(finElement?.cterateperiodicity),
        inRateType: finElement?.cteratetype,
        inRateValue:
          finElement?.ctenominalrate == null ? 0 : finElement?.ctenominalrate,
        inResidualValue: finElement?.ctervamount,
        inRoundingAmount: getRounding(finElement?.currcode),
        inRoundingRate: 9,
        inStartDate: dateToString(finElement?.ctestartdate),
        inTaxcode: finElement?.taxcode,
        inTaxrate: finElement?.taxrate,
        inTaxtype: finElement?.taxtype,
        inTerm: finElement?.ctepaymentterm,
        inUpFrontAmount:
          finElement?.cteupfrontamount == null
            ? 0
            : finElement?.cteupfrontamount,
      },
    });
  };

  const calculateLinearAndWeighted = (
    inCteid: number,
    finElement: PropElementResponse,
    finamount: number,
    investamount: number,
    firstPayment: number,
    rvAmount: number,
    direction: string,
    calcMethod: string
  ) => {
    setLoading(true);

    finEngine
      .calculate({
        finReq: {
          inBillingDate: finElement?.ctebilligdate,
          inCalculationMethod: calcMethod, // INST
          inCalculationType: finElement?.ctecalculationtype,
          inCountingbasis: finElement?.cteratebasis,
          inDeferredMethod: finElement?.ctedeferredinterestmethod,
          inDeferredRate: finElement?.ctedeferredinterestnominalrate,
          inDepositAmount:
            finElement?.ctedepositamount == null
              ? 0
              : finElement?.ctedepositamount,
          inDepositMethod: finElement?.ctedepositinterestmethod,
          inDepositRate:
            finElement?.ctedepositinterestmethod === 'NONE'
              ? 0
              : finElement?.ctedepositnominalrate == null
              ? 0
              : finElement?.ctedepositnominalrate,
          inDuration: finElement.cteduration,
          inFinancedAmount: finamount ?? 0,
          inFirstInstallmentDate: '', //dateToString(finElement?.ctestartdate),
          inFirstPayment: firstPayment == null ? 0 : firstPayment,
          inGracePeriodDuration:
            finElement?.ctegraceperiodduration == null
              ? 0
              : finElement?.ctegraceperiodduration,
          inGracePeriodMethod: finElement?.ctegraceperiodmethod,
          inInstallmentAmount: finElement?.cteinstallmentamount,
          inInterestMethod: finElement?.cteinterestmethod,
          inPartAmount:
            finElement?.ctepartamount == null ? 0 : finElement?.ctepartamount,
          inPartMethod: finElement?.ctepartmethod
            ? finElement?.ctepartmethod
            : 'NONE',
          inPartNbDays:
            finElement?.ctepartdays == null ? 0 : finElement?.ctepartdays,
          inPartRate:
            finElement?.ctepartrate == null ? 0 : finElement?.ctepartrate,
          inPeriodicity: finElement?.cteperiodicity,
          inPeriodicityUnit: finElement?.cteunit,
          inRatePeriodicity: Number(finElement?.cterateperiodicity),
          inRateType: finElement?.cteratetype,
          inRateValue:
            finElement?.ctenominalrate == null ? 0 : finElement?.ctenominalrate,
          inResidualValue: rvAmount == null ? 0 : rvAmount,
          inRoundingAmount: getRounding(finElement.currcode),
          inRoundingRate: 9,
          inStartDate: dateToString(finElement?.ctestartdate),
          inTaxcode: finElement?.taxcode,
          inTaxrate: finElement?.taxrate,
          inTaxtype: finElement?.taxtype,
          inTerm: finElement?.ctepaymentterm,
          inUpFrontAmount: finElement?.cteupfrontamount,
          inFeesAmount: finElement?.ctefeesamount,
          inDealerPartAmount: finElement?.ctepartamount,
          inManufacturerPartAmount: 0,
          inCommissionAmount: finElement?.ctecommissionamount ?? 0,
          inProfitabilityRate: finElement?.cteprofitabilityrate ?? 0,
          inFundingRate: finElement?.ctefundingrate,
          inFundingPeriodicity: Number(finElement?.cteperiodicity),
          inVatAmount: finElement?.ctevatdeferralamount,
          inVatDuration: finElement?.ctevatdeferralduration,
          inVatDaysBasis: finElement?.ctevatdeferraldaysbasis,
          inVatMethod: finElement?.ctevatdeferralmethod,
        },
      })
      .then((res) => {
        setLoading(false);

        if (res.success) {
          // calculate RVI :

          let _paymentSchedule = res.paymentSchedule.filter(
            (res) => res.ctstype !== 'RV'
          );

          let maxCteEnddate = _.maxBy(
            _paymentSchedule,
            'ctsenddate'
          )?.ctsenddate;

          // calculate Weighted Steps :
          if (finElement?.ctecalculationtype === 'STEPWEIGH') {
            // add Steps based on Config :
            //finElement.conElemSteps = [];

            //finElement.conElemSteps = calculateREC(
            // eslint-disable-next-line no-unused-vars
            let steps = calculateREC(
              finamount,
              dateToString(finElement?.ctestartdate),
              0,
              finElement.conElemSteps[0],
              finElement,
              res.installmentamount,
              []
            );

            // end .then

            // end loop on steps
          } // end if STEPWEIGH
          // end if STEPWEIGH

          message.success(t(`finEngine.${res.message}`));

          setCalculatorStatusColor('#52c41a');

          const FinElements =
            form.getFieldValue([
              'elements',
              direction === 'OUT' ? 'FINOUT' : 'FIN',
            ]) || [];

          if (direction === 'IN') {
            let elements = {
              FIN: FinElements.map((element: any, index: number) =>
                element.cteid === inCteid
                  ? {
                      ...element,
                      conElemSchedules: res.paymentSchedule,
                      fundingSchedule: res.fundingSchedule,
                      ctepartamount: res.partAmount,
                      ctecommissionamount: res.commissionAmount,
                      ctenominalrate: res.nominalrate,
                      cteaprrate: res.aprRate,
                      cteflatrate: res.flatRate,
                      ctecoefrate: res.rate000,
                      cteprofitabilityrate: res.profitabilityRate,
                      ctemarginrate:
                        res.profitabilityRate - finElement.ctefundingrate,
                      ctemarginamount:
                        (finElement.ctepartamount ?? 0) +
                        (finElement.ctefeesamount ?? 0) +
                        res.totalInterest -
                        (sumBy(res.fundingSchedule, 'ctsinterestamount') ?? 0) -
                        (finElement.ctecommissionamount ?? 0),
                      calStatusColor: '#52c41a',
                      totalInterest: res.totalInterest,
                      totalRental: res.totalRental,
                      totalAmortization: res.totalAmortization,
                      totaldiscountedInterest: res.totaldiscountedInterest,
                      totalVatDeffered: res.totalVatDeffered,
                      totaldiscountedOutstanding:
                        res.totaldiscountedOutstanding,
                      totaldiscountedAgiosdeb: res.totaldiscountedAgiosdeb,
                      totalAgiosdeb: res.totalAgiosdeb,
                      marginImpactCredit: res.marginImpactCredit,
                      marginImpactDebit: res.marginImpactDebit,
                      dgo: res.dgo,
                      profitabilityAmount:
                        res.totalInterest +
                        res.inFeesAmount +
                        res.partAmount -
                        res.commissionAmount,
                      fundingInstallment: res.fundingInstallment ?? 0,
                      totalFundingInterest:
                        sumBy(res.fundingSchedule, 'ctsinterestamount') ?? 0,
                      cteactuarialrate: res.effectiverate,
                      ctedeferredinterest: res.deferredInterest,
                      ctedeferredinterestnominalrate: res.inDeferredRate,
                      ctedepositinterest: res.depositInterest,
                      ctedepositnominalrate: res.inDepositRate,
                      conElemSteps: finElement.conElemSteps,
                      cteduration: res.duration,
                      ctefinancedamount: res.financedamount,
                      cteupfrontamount:
                        finElement.cteinvestamount +
                        (finElement.cteextracosttofinance == null
                          ? 0
                          : finElement.cteextracosttofinance) -
                        res.financedamount -
                        res.partAmount,
                      ctefirstpayment:
                        element.ctecalculationtype === 'STEPWEIGH'
                          ? 0
                          : res.inFirstPayment,
                      ctefirstpaymentcoef:
                        element.ctecalculationtype === 'STEPWEIGH'
                          ? 0
                          : (res.inFirstPayment / investamount) * 100,
                      cteinstallmentamount: res.installmentamount,
                      cterentalamount:
                        res.installmentamount - res.depositInterest,
                      // ctervamount: res.residualvalue,
                      ctervcoef: (res.residualvalue / investamount) * 100,
                      ctervamount: res.residualvalue,
                      cteenddate:
                        maxCteEnddate !== ''
                          ? toDatePickerDate(maxCteEnddate)
                          : '',
                    }
                  : element
              ),
            };
            form.setFieldsValue({
              elements: elements,
            });

            calculateIRV(
              inCteid,
              investamount,
              finamount,
              finElement.ctestartdate,
              finElement.ctebilligdate,
              finElement.ctepaymentterm,
              res.paymentSchedule
            );

            calculateServAndComm(res, finElement, finamount, inCteid).then(
              () => {
                if (finElement?.ctecalculationtype === 'LOYFIX') {
                  const servElements =
                    form.getFieldValue(['elements', 'SERV']) || [];
                  const feesElements =
                    form.getFieldValue(['elements', 'FEES']) || [];

                  const combinedSchedules = [
                    ...servElements,
                    ...feesElements,
                  ].flatMap((element) => element.conElemSchedules || []);

                  finEngine
                    .calculatePSFixedInstallment({
                      finReq: {
                        inRatetype: finElement?.cteratetype,
                        calculationmethod: 'LOYFIX',
                        inFinancedamount: finElement?.ctefinancedamount,
                        inTerm: finElement?.ctepaymentterm,
                        inInterestmethod: finElement?.cteinterestmethod,
                        inNominalrate: finElement?.ctenominalrate,
                        inEffectiverate: res?.effectiverate,
                        inRatePeriodicity: Number(
                          finElement?.cterateperiodicity
                        ),
                        inRateterm: 'NOMINAL',
                        inPeriodicity: Number(finElement?.cteperiodicity),
                        inPeriodicityUnit: finElement?.cteunit,
                        inCountingbasis: finElement?.cteratebasis,
                        inDuration: finElement?.cteduration,
                        inResidualvalue: res?.inResidualValue,
                        inInstallmentamount: res?.installmentamount,
                        inRoudingAmount: getRounding(finElement?.currcode),
                        inRoudingRate: 9,
                        inTaxtype: finElement?.taxtype,
                        inTaxcode: finElement?.taxcode,
                        inTaxrate: finElement?.taxrate,
                        inFirstPayment: finElement?.ctefirstpayment,
                        inGracePeriodDuration:
                          finElement?.ctegraceperiodduration == null
                            ? 0
                            : finElement?.ctegraceperiodduration,
                        inGracePeriodMethod: finElement?.ctegraceperiodmethod,
                        inDeferredMethod: finElement?.ctedeferredinterestmethod,
                        inDeferredRate:
                          finElement?.ctedeferredinterestnominalrate,
                        inBillingDate: finElement?.ctebilligdate,
                        inDepositAmount:
                          finElement?.ctedepositamount == null
                            ? 0
                            : finElement?.ctedepositamount,
                        inDepositMethod: finElement?.ctedepositinterestmethod,
                        inDepositRate: res.inDepositRate,
                        inStartDate: dateToString(finElement?.ctestartdate),
                        inFirstInstallmentDate: '',
                        inUpFront: 0.0,
                        addRVLine: true,
                        inPsOrder: 1, // à discuter
                        inGracePeriodPeriodicity: 1,
                        inGracePeriodRate: res.inPeriodicity, //à discuter
                        inFundingRate: finElement?.ctefundingrate,
                        inInitialStartDate: dateToString(
                          finElement?.ctestartdate
                        ),
                        inVatAmount: finElement?.ctevatdeferralamount,
                        inVatDuration: finElement?.ctevatdeferralduration,
                        inVatDaysBasis: finElement?.ctevatdeferraldaysbasis,
                        inVatMethod: finElement?.ctevatdeferralmethod,
                        rentalType: null, // à discuter
                        addCapitalReimline: false,
                        capitalReimAmount: 0.0,
                        tpid: finElement?.tpid,
                        tpname: finElement?.tpname,
                        invoicingMode: null,
                        scheduleEndDate: null,
                        paymentSchedules: combinedSchedules || [],
                      },
                    })
                    .then((res: any) => {
                      const servFin =
                        form.getFieldValue(['elements', 'FIN']) || [];
                      const updatedFinElements = servFin.map(
                        (element: any) => ({
                          ...element,
                          conElemSchedules: res,
                        })
                      );
                      form.setFieldsValue({
                        elements: {
                          FIN: updatedFinElements,
                        },
                      });
                    });
                }
              }
            );
          } else {
            let elements = {
              FINOUT: FinElements.map((element: any, index: number) =>
                element.cteid === inCteid
                  ? {
                      ...element,
                      conElemSchedules: res.paymentSchedule,
                      cteactuarialrate: res.effectiverate,
                      ctenominalrate: res.nominalrate,
                      ctedeferredinterest: res.deferredInterest,
                      ctedeferredinterestnominalrate: res.inDeferredRate,
                      ctedepositinterest: res.depositInterest,
                      ctedepositnominalrate: res.inDepositRate,
                      conElemSteps: finElement.conElemSteps,
                      cteduration: res.duration,
                      ctefinancedamount: res.financedamount,
                      /// TO FIX WITH JEMIL
                      cteupfrontamount:
                        finElement.cteinvestamount +
                        (finElement.cteextracosttofinance == null
                          ? 0
                          : finElement.cteextracosttofinance) -
                        res.financedamount -
                        res.partAmount,
                      ctefirstpayment:
                        element.ctecalculationtype === 'STEPWEIGH'
                          ? 0
                          : res.inFirstPayment,
                      ctefirstpaymentcoef:
                        element.ctecalculationtype === 'STEPWEIGH'
                          ? 0
                          : (res.inFirstPayment / investamount) * 100,
                      cteinstallmentamount: res.installmentamount,
                      cterentalamount:
                        res.installmentamount - res.depositInterest,
                      // ctervamount: res.residualvalue,
                      ctervcoef: (res.residualvalue / investamount) * 100,
                      cteenddate:
                        maxCteEnddate !== ''
                          ? toDatePickerDate(maxCteEnddate)
                          : '',
                    }
                  : element
              ),
            };
            form.setFieldsValue({
              elements: elements,
            });
          }
        }
      })
      .catch((err) => {
        setLoading(false);
      }); // end then
  };

  const calculateInterest = async (
    finElement: PropElementResponse,
    finAmount: number,
    inRate: number,
    inDuration: number
  ) => {
    return finEngine.calculate({
      finReq: {
        inBillingDate: finElement?.ctebilligdate,
        inCalculationMethod: 'INST',
        inCalculationType: finElement?.ctecalculationtype,
        inCountingbasis: finElement?.cteratebasis,
        inDeferredMethod: 'NONE', //finElement?.ctedeferredinterestmethod,
        inDeferredRate: 0, //finElement?.ctedeferredinterestnominalrate,
        inDepositAmount:
          finElement?.ctedepositamount == null
            ? 0
            : finElement?.ctedepositamount,
        inDepositMethod: finElement?.ctedepositinterestmethod,
        inDepositRate:
          finElement?.ctedepositinterestmethod === 'NONE'
            ? 0
            : finElement?.ctedepositnominalrate == null
            ? 0
            : finElement?.ctedepositnominalrate,
        inDuration: inDuration,
        inFinancedAmount: finAmount,
        inFirstInstallmentDate: '', //dateToString(finElement?.ctestartdate),
        inFirstPayment: finElement?.ctefirstpayment,
        inGracePeriodDuration:
          finElement?.ctegraceperiodduration == null
            ? 0
            : finElement?.ctegraceperiodduration,
        inGracePeriodMethod: finElement?.ctegraceperiodmethod,
        inInstallmentAmount: finElement?.cteinstallmentamount,
        inInterestMethod: finElement?.cteinterestmethod,
        inPartAmount: 0,
        inPartMethod: 'NONE',
        inPartNbDays: 0,
        inPartRate: 0,
        inPeriodicity: finElement?.cteperiodicity,
        inPeriodicityUnit: finElement?.cteunit,
        inRatePeriodicity: Number(finElement?.cterateperiodicity),
        inRateType: finElement?.cteratetype,
        inRateValue: inRate,
        inResidualValue: finElement?.ctervamount,
        inRoundingAmount: getRounding(finElement.currcode),
        inRoundingRate: 9,
        inStartDate: dateToString(finElement?.ctestartdate),
        inTaxcode: finElement?.taxcode,
        inTaxrate: finElement?.taxrate,
        inTaxtype: finElement?.taxtype,
        inTerm: finElement?.ctepaymentterm,
        inUpFrontAmount:
          finElement?.cteupfrontamount == null
            ? 0
            : finElement?.cteupfrontamount,
      },
    });
  };

  const calculateIRV = async (
    inCteid: number,
    investAmount: any,
    finAmount: any,
    startDate: any,
    inBillingDate: string,
    inTerm: string,
    finSchedule: any
  ) => {
    const listassets = form.getFieldValue('assets');

    listassets.forEach(async (asset: any) => {
      if (
        asset.cteid === inCteid // && asset.listrv?.find((e: any) => e.rvtype === 'IRV')
      ) {
        setLoading(true);

        await finEngine
          .calculateIRVSchedule({
            irvReq: {
              finSchedule: finSchedule,
              inInvestAmount: investAmount,
              inFinAmount: finAmount,
              inAssetAmount: asset.assetfinamount,
              inStartDate: startDate,
              inBillingDate: inBillingDate,
              inTerm: inTerm,
              inRoundingAmount: 2,
              assetRvCalcParams: asset?.listrv?.filter(
                (e: any) => e.rvtype === 'IRV'
              ),
            },
          })
          .then((res2: any) => {
            setLoading(false);

            if (res2.success) {
              message.success('IRV - ' + t(`finEngine.${res2.message}`));
              form.setFieldsValue({
                assets: form.getFieldValue('assets').map((ele: any) => {
                  if (
                    asset.cteid === ele.cteid &&
                    asset.assetid === ele.assetid
                  ) {
                    return {
                      ...ele,
                      irvSchedule: res2.irvSchedule,
                    };
                  } else return ele;
                }),
              });
            }
          })
          .catch((err) => {
            setLoading(false);
          });
      }
    });
  };

  const calculateFinServiceNew = async (
    finserv: any,
    firstFinElement: any,
    ctinitstartdate: any,
    ctbillingdate: any,
    finamount: any,
    inCteid: number
  ) => {
    let finServamount = 0;
    if (finserv.serviceResponse?.servcalculationmethod === 'FIXED') {
      finServamount = finserv.serviceResponse.servfixedamount;
    } else {
      if (finserv.serviceResponse?.servcalculationmethod === 'PERCENT') {
        switch (finserv.serviceResponse.servbasis) {
          case 'FINANCING':
            finServamount =
              (finamount * finserv.serviceResponse.servpercentage) / 100;
            break;
          case 'ASSETNET':
            finServamount =
              (finserv.cteinvestamount *
                finserv.serviceResponse.servpercentage) /
              100;
            break;

          case 'INVEST':
            finServamount =
              (finserv.cteinvestamount *
                finserv.serviceResponse.servpercentage) /
              100;
            break;
        }
      } else {
        //default : instamount :
        finServamount = finserv.cteinvestamount;
      }
    }

    //set finserv=firstFinElement :
    let newfinServ = {
      assetid: firstFinElement.assetid,
      conElemAssets: [],
      conElemSchedules: [] as any,
      conElemSteps: [],
      cteactuarialrate: 0,
      serviceResponse: finserv.serviceResponse,
      pricing: finserv.pricing,
      ctecalculationbasis: finserv?.serviceResponse?.servbasis,
      ctecalculationtype: 'LINEAR',
      ctecategory: finserv.ctecategory,
      ctedeferredinterest: 0,
      ctedeferredinterestmethod: firstFinElement.ctedeferredinterestmethod,
      ctedeferredinterestnominalrate:
        firstFinElement.ctedeferredinterestnominalrate,
      ctedepositamount: 0,
      ctedepositcoef: 0,
      ctedepositinterest: 0,
      ctedepositinterestmethod: 'NONE',
      ctedepositnominalrate: 0,
      ctedescription: finserv.ctedescription,
      ctedirection: 'IN',
      cteduration: firstFinElement.cteduration,
      cteendamount: 0,
      cteenddate: '',
      ctefinancedamount: finServamount,
      ctefirstpayment: 0,
      ctefirstpaymentcoef: 0,
      ctefirstpaymentdate: '',
      ctefree1: '',
      ctegraceperiodduration: firstFinElement.ctegraceperiodduration,
      ctegraceperiodmethod: firstFinElement.ctegraceperiodmethod,
      cteid: Math.floor(_.random(100000) * 10000),
      cteidparent: inCteid,
      cteinitialamount: finServamount,
      cteinstallmentamount: 0,
      cteinterestmethod: firstFinElement.cteinterestmethod,
      cteinvestamount: finServamount,
      ctenominalrate: firstFinElement.ctenominalrate,
      cteorder: finserv.cteorder,
      ctepartamount: 0,
      ctepartdays: 0,
      ctepartmethod: 'NONE',
      ctepartrate: 0,
      ctepaymentterm: firstFinElement.ctepaymentterm,
      cteperiodicity: firstFinElement.cteperiodicity,
      cteratebasis: firstFinElement.cteratebasis,
      cterateformula: firstFinElement.cterateformula,
      cterateperiodicity: firstFinElement.cterateperiodicity,
      cteratespread: firstFinElement.cteratespread,
      cterateterm: firstFinElement.cterateterm,
      cteratetype: firstFinElement.cteratetype,
      cterentalamount: 0,
      ctervamount: 0,
      ctervcoef: 0,
      ctestartamount: finServamount,
      ctestartdate: firstFinElement.ctestartdate,
      ctestatus: 'INIT',
      ctetype: 'FINSERV',
      cteunit: firstFinElement.cteunit,
      cteupfrontamount: 0,
      ctrid: 0,
      currcode: firstFinElement.currcode,
      last_action: '',
      prefinbasis: '0',
      prefinmethod: '',
      prefinnominalrate: 0,
      prefinperiodicity: '',
      prefinrateformula: '',
      prefinratetype: '',
      priid: finserv.priid,
      taxcode: firstFinElement.taxcode,
      tpid: firstFinElement.tpid,
      tpidparticipation: '',
      ctebilligdate: firstFinElement.ctebilligdate,
    };
    setLoading(true);

    finEngine
      .calculate({
        finReq: {
          inBillingDate: firstFinElement.ctebilligdate,
          inCalculationMethod: 'INST',
          inCalculationType: firstFinElement?.ctecalculationtype,
          inCountingbasis: firstFinElement?.cteratebasis,
          inDeferredMethod: firstFinElement?.ctedeferredinterestmethod,
          inDeferredRate: firstFinElement?.ctedeferredinterestnominalrate,
          inDepositAmount: 0,

          inDepositMethod: 'NONE',
          inDepositRate: 0,
          inDuration:
            firstFinElement?.cteduration == null
              ? 1
              : firstFinElement?.cteduration,
          inFinancedAmount: finServamount,
          inFirstInstallmentDate: '', //dateTimeToDate(firstFinElement?.ctestartdate),
          inFirstPayment: 0,
          inGracePeriodDuration:
            firstFinElement?.ctegraceperiodduration == null
              ? 0
              : firstFinElement?.ctegraceperiodduration,
          inGracePeriodMethod: firstFinElement?.ctegraceperiodmethod,
          inInstallmentAmount: 0,
          inInterestMethod: firstFinElement?.cteinterestmethod,
          inPartAmount: 0,
          inPartMethod: 'NONE',
          inPartNbDays: 0,
          inPartRate: 0,
          inPeriodicity: firstFinElement?.cteperiodicity,
          inPeriodicityUnit: firstFinElement?.cteunit,
          inRatePeriodicity: firstFinElement?.cterateperiodicity,
          inRateType: firstFinElement?.cteratetype,
          inRateValue:
            firstFinElement?.ctenominalrate == null
              ? 0
              : firstFinElement?.ctenominalrate,
          inResidualValue: 0,
          inRoundingAmount: getRounding(firstFinElement.currcode),
          inRoundingRate: 9,
          inStartDate: dateToString(firstFinElement.ctestartdate),
          inTaxcode: firstFinElement?.taxcode,
          inTaxrate: firstFinElement?.taxrate,
          inTaxtype: firstFinElement?.taxtype,
          inTerm: firstFinElement?.ctepaymentterm,
          inUpFrontAmount: 0,
        },
      })
      .then((res) => {
        setLoading(false);

        if (res.success) {
          message.success('FinService ' + t(`finEngine.${res.message}`));

          newfinServ.conElemSchedules = res.paymentSchedule;
          newfinServ.cteactuarialrate = res.effectiverate;
          newfinServ.ctedeferredinterest = res.deferredInterest;
          newfinServ.ctedepositinterest = res.depositInterest;
          newfinServ.cteduration = res.duration;
          newfinServ.ctefinancedamount = res.financedamount;
          newfinServ.cteinstallmentamount = res.installmentamount;
          newfinServ.cterentalamount = res.installmentamount;
          const finServElements =
            form.getFieldValue(['elements', 'FINSERV']) || [];

          form.setFieldsValue({
            elements: {
              FINSERV: finServElements.map((element: any, index: any) => {
                return element.cteid === finserv.cteid ? newfinServ : element;
              }),
            },
          });
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const calculateServiceNew = async (
    servElement: PropElementRequest,
    gpduration: any,
    finamount: any,
    investAmount: any,
    assetAmount: any,
    startDate: any,
    duration: number,
    finSchedule: any,
    inCteid: number,
    direction: string,
    inBillingdate: string
  ) => {
    setLoading(true);

    return finEngine
      .calculateServiceWithStep({
        servReq: {
          finSchedule: finSchedule,
          inDownPayment: 0,
          inFinAmount: finamount,
          inFollowGP: true,
          inGPDuration: gpduration,
          inPstype: servElement.ctecategory,
          inRoudingAmount: getRounding(servElement.currcode),
          inServcalculationmethod:
            servElement.serviceResponse.servcalculationmethod,
          inServfixedamount: servElement.servfixedamount,
          inServiceduration: servElement.serviceResponse.servduration,
          inServpercentage: servElement.servpercentage,
          inTaxcode: servElement?.taxcode,
          inTaxrate: servElement?.taxrate,
          inDuration: duration,
          inInvestAmount: investAmount,
          inAssetAmount: assetAmount,
          inServperiodicity: servElement.serviceResponse.servperiodicity,
          inServDurationFree:
            servElement.cteduration > duration
              ? duration
              : servElement.cteduration,
          inStartDate: startDate,
          inServbasis: servElement.serviceResponse.servbasis,

          inCalculatedamountbasis:
            servElement.serviceResponse.calculatedamountbasis,

          inMarginoncalcultedamount:
            servElement.serviceResponse.marginoncalulatedamount,
          inAdditionalcostaftermargin:
            servElement.serviceResponse.additionalcostaftermargin,

          servStep: servElement.serviceStepList,
        },
      })
      .then((res) => {
        setLoading(false);

        if (res.success) {
          message.success('Service - ' + t(`finEngine.${res.message}`));

          const servElements =
            form.getFieldValue([
              'elements',
              direction === 'OUT' ? 'SERVOUT' : 'SERV',
            ]) || [];

          if (direction === 'IN') {
            form.setFieldsValue({
              elements: {
                SERV: servElements.map((element: any, index: any) =>
                  element.cteid === servElement.cteid
                    ? {
                        ...element,
                        conElemSchedules: res.paymentSchedule,
                        ctefinancedamount: finamount,
                        cteinvestamount: investAmount,
                        cteduration: res.duration,
                        cteperiodicity:
                          servElement.serviceResponse.servperiodicity,
                        ctebilligdate: inBillingdate,
                        cteinstallmentamount: res.installmentamount,
                        cterentalamount: res.installmentamount,
                      }
                    : element
                ),
              },
            });
          } else {
            form.setFieldsValue({
              elements: {
                SERVOUT: servElements.map((element: any, index: any) =>
                  element.cteid === servElement.cteid
                    ? {
                        ...element,
                        conElemSchedules: res.paymentSchedule,

                        cteduration: res.duration,

                        cteinstallmentamount: res.installmentamount,
                        cterentalamount: res.installmentamount,
                      }
                    : element
                ),
              },
            });
          }
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const calculateFeesNew = async (
    servElement: PropElementRequest,
    gpduration: any,
    finamount: any,
    investAmount: any,
    assetAmount: any,
    startDate: any,
    duration: number,
    finSchedule: any,
    inCteid: number
  ) => {
    setLoading(true);

    return finEngine
      .calculateServiceWithStep({
        servReq: {
          finSchedule: finSchedule,
          inDownPayment: 0,
          inFinAmount: finamount,
          inFollowGP: true,
          inGPDuration: gpduration,
          inPstype: servElement.ctecategory,
          inRoudingAmount: getRounding(servElement.currcode),
          inServcalculationmethod:
            servElement.serviceResponse.servcalculationmethod,
          inServfixedamount: servElement.servfixedamount,
          inServiceduration: servElement.serviceResponse.servduration,
          inServpercentage: servElement.servpercentage,
          inTaxcode: servElement?.taxcode,
          inTaxrate: servElement?.taxrate,
          inDuration: duration,
          inInvestAmount: investAmount,
          inAssetAmount: assetAmount,
          inServperiodicity: servElement.serviceResponse.servperiodicity,
          inServDurationFree:
            servElement.cteduration === 0
              ? servElement?.serviceResponse?.servdurationdefault
              : servElement.cteduration,

          inStartDate: startDate,
          inServbasis: servElement.serviceResponse.servbasis,

          inCalculatedamountbasis:
            servElement.serviceResponse.calculatedamountbasis,

          inMarginoncalcultedamount:
            servElement.serviceResponse.marginoncalulatedamount,
          inAdditionalcostaftermargin:
            servElement.serviceResponse.additionalcostaftermargin,

          servStep: servElement.serviceStepList,
        },
      })
      .then((res) => {
        setLoading(false);

        if (res.success) {
          message.success('Fees - ' + t(`finEngine.${res.message}`));

          const feesElements = form.getFieldValue(['elements', 'FEES']) || [];

          form.setFieldsValue({
            elements: {
              FEES: feesElements.map((element: any, index: any) =>
                element.cteid === servElement.cteid
                  ? {
                      ...element,
                      conElemSchedules: res.paymentSchedule,

                      cteduration: res.duration,

                      cteinstallmentamount: res.installmentamount,
                      cterentalamount: res.installmentamount,
                    }
                  : element
              ),
            },
          });
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const calculateCommissionNew = async (
    commElement: PropElementRequest,
    gpduration: any,
    finamount: any,
    investAmount: any,
    assetAmount: any,
    startDate: any,
    duration: number,
    finSchedule: any,
    inCteid: number
  ) => {
    console.log('commElement', commElement);

    let finServamount = 0;

    if (commElement.commissionResponse?.commcalculationmethod === 'FIXED') {
      finServamount = commElement.commissionResponse.commfixedamount;
    } else {
      if (commElement.commissionResponse?.commcalculationmethod === 'PERCENT') {
        switch (commElement.commissionResponse.commbasis) {
          case 'FINANCING':
            finServamount =
              (finamount * commElement.commissionResponse.commpercentage) / 100;
            break;
          case 'ASSETNET':
            finServamount =
              (commElement.cteinvestamount *
                commElement.commissionResponse.commpercentage) /
              100;
            break;
          case 'ELEMBASIS':
            finServamount =
              (finamount * commElement.commissionResponse.commpercentage) / 100;
            break;

          case 'INVEST':
            finServamount =
              (commElement.cteinvestamount *
                commElement.commissionResponse.commpercentage) /
              100;
            break;
        }
      } else {
        //default : instamount :
        finServamount = commElement.cteinstallmentamount;
      }
    }
    setLoading(true);

    const cteupfrontamount = form.getFieldValue(
      getName('cteupfrontamount', elementID)
    );

    return finEngine
      .calculateServiceWithStep({
        servReq: {
          finSchedule: finSchedule,
          inDownPayment: cteupfrontamount,
          inFinAmount: finamount,
          inFollowGP: true,
          inGPDuration: gpduration,
          inPstype: commElement.ctecategory,
          inRoudingAmount: getRounding(commElement.currcode),
          inServcalculationmethod:
            commElement.commissionResponse.commcalculationmethod,
          inServfixedamount:
            commElement.commissionResponse.commfixedamount === null
              ? 0
              : commElement.commissionResponse.commfixedamount,
          inServiceduration: commElement.commissionResponse.commduration,
          inServpercentage:
            commElement?.ctenominalrate ??
            commElement.commissionResponse.commpercentage,
          inTaxcode: commElement?.taxcode,
          inTaxrate: commElement?.taxrate,
          inDuration: duration,
          inInvestAmount: investAmount,
          inAssetAmount: assetAmount,
          inServperiodicity: commElement.commissionResponse.commperiodicity,
          inServDurationFree:
            commElement.commissionResponse.commdurationdefault,

          inStartDate: startDate,
          inServbasis: commElement.commissionResponse.commbasis,

          inCalculatedamountbasis: 'ANNUAL',

          inMarginoncalcultedamount: 0,
          inAdditionalcostaftermargin: 0,

          servStep: [],
        },
      })
      .then((res) => {
        setLoading(false);

        if (res.success) {
          message.success('Commission - ' + t(`finEngine.${res.message}`));
          const commElements = form.getFieldValue(['elements', 'COMM']) || [];

          form.setFieldsValue({
            elements: {
              COMM: commElements.map((element: any, index: any) =>
                element.cteid === commElement.cteid
                  ? {
                      ...element,
                      conElemSchedules: res.paymentSchedule,
                      cteduration: res.duration,
                      cteinstallmentamount: res.installmentamount,
                      cterentalamount: res.installmentamount,
                    }
                  : element
              ),
            },
          });
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const handleSelectAssetFromCatalogAndCreateElements: AssetCatalogModalProps['onSelect'] =
    async (
      _assetCatalog,
      nbasset,
      selectedServices,
      selectedOption,
      fromCatalogMulticomponents,
      assetCatalogServices,
      assetCatalogOptions
    ) => {
      const cteid = form.getFieldValue('selectedElement');

      let assetCatalog = _assetCatalog;

      if (form) {
        let finElements = form.getFieldValue(['elements', 'FIN']) || {};
        setAlreadyanswered(false);

        const listuse = await getParAssetUseByFilters({
          parAssetRequest: [
            {
              assetcategory: assetCatalog.assetcategory ?? '',
              assetfamily: assetCatalog.assetfamily,
              assetid: '' as any,
              assettype: assetCatalog.assettype,
              catalogid: assetCatalog.catalogid ?? '',
              offerid: '' as any,
              ofrid: '' as any,
              ofrtype: '',
              prcode: form?.getFieldValue('flagmasterfacility')
                ? form?.getFieldValue('mfprcode')
                : form?.getFieldValue('prcode') ?? '',
            },
          ],
        })
          .then((res: any) => res.list)
          .catch((er) => []);

        console.log(' ---- listuse', listuse);

        let _offerCriteriaList: Array<FilteringCriteria> = [];

        listuse?.forEach((u: any) => {
          _offerCriteriaList.push({
            critcode: u.attcode,
            critvalue: u.usevalue ?? '',
          });
        });

        const listrv = await getAssetCatalogRvAmountList({
          prcode: form?.getFieldValue('flagmasterfacility')
            ? form?.getFieldValue('mfprcode')
            : form?.getFieldValue('prcode') ?? '',
          catalogid: assetCatalog.catalogid,
          assetamount: assetCatalog.assetnetamount * nbasset,
          filters: getFilterList(Array(assetCatalog), _offerCriteriaList),
        })
          .then((res: any) => res.list)
          .catch((er) => []);

        let lassetComponents = [];
        if (selectedOption?.length! > 0 && !fromCatalogMulticomponents) {
          lassetComponents.push({
            assetid: 0,
            compcategory: 'ASSET',
            compcategorylabel: assetCatalog.assetlabel,
            compdescription: assetCatalog.assetlabel,
            compdiscountamount: 0,
            compdiscountrate: 0,
            compfree1: '',
            compgrossamount: assetCatalog.assetgrossamountorigine,
            compid: assetCatalog.catalogid,
            compnetamount: assetCatalog.assetnetamountorigine,
            comporiginalnetamount: assetCatalog.assetnetamountorigine,
            comptaxamount:
              assetCatalog.assetgrossamountorigine -
              assetCatalog.assetnetamountorigine,
            comptype: 'ASSET',
            comptypelabel: 'Asset',
            flagholdback: false,
            holdbackamount: 0,
            holdbackbeleasedate: '',
            holdbackbeleasenbdays: 0,
            holdbackpercentage: 0,
            suppliername: assetCatalog.suppliername,
            supplierreference: assetCatalog.supplierreference,
            taxcode: assetCatalog.taxcode,
            taxrate: 0,
            tpidsupplier: assetCatalog.tpidsupplier,
          });
        }

        selectedOption?.forEach((opt) => {
          lassetComponents.push({
            assetid: 0,
            compcategory: opt.optcode,
            compcategorylabel: opt.optcodelabel,
            compdescription: opt.optcodelabel + ' : ' + opt.optvaluelabel,
            compdiscountamount: 0,
            compdiscountrate: 0,
            compfree1: '',
            compgrossamount: opt.optgrossamount,
            compid: opt.optid,
            compnetamount: opt.optnetamount,
            comporiginalnetamount: opt.optnetamount,
            comptaxamount: opt.opttaxamount,
            comptype: 'OPT',
            comptypelabel: 'Option',
            flagholdback: false,
            holdbackamount: 0,
            holdbackbeleasedate: '',
            holdbackbeleasenbdays: 0,
            holdbackpercentage: 0,
            suppliername: assetCatalog.suppliername,
            supplierreference: assetCatalog.supplierreference,
            taxcode: opt.opttaxcode,
            taxrate: 0,
            tpidsupplier: assetCatalog.tpidsupplier,
          });
        });

        console.log('lassetComponents', lassetComponents);

        assetCatalog.assetCatalogComponents = lassetComponents;

        assetCatalog.assetmulticomponents =
          lassetComponents.length > 0 ? true : false;

        assetCatalog.assetCatalogServices = selectedServices ?? [];
        assetCatalog.assetCatalogOptions = selectedOption ?? [];

        if (form.getFieldValue('prcode') === 'LEASEBACK') {
          let client = form.getFieldValue('client');
          if (client && typeof client == 'object') {
            assetCatalog.suppliername = client?.tpname;
            assetCatalog.supplierreference = client?.reference;
            assetCatalog.tpidsupplier = client?.tpid;
          }
        }

        let assets = form.getFieldValue('assets');

        if (assets.length === 0) {
          finElements[0].conElemSchedules = [];

          let elements = form.getFieldValue('elements') || {};

          let servElements = form.getFieldValue(['elements', 'SERV']) || {};

          let _assetCatalogServices = assetCatalogServices?.map(
            (assetCatalogService) => {
              let flagSelected = false;
              if (
                !isNil(selectedServices) &&
                selectedServices?.findIndex(
                  (serv: any) => serv.servcode === assetCatalogService.servcode
                ) > -1
              ) {
                flagSelected = true;
              }
              return {
                ...assetCatalogService,
                flagSelected: flagSelected,
              };
            }
          );

          assetCatalog.assetCatalogComponents = lassetComponents;

          assetCatalog.assetmulticomponents =
            lassetComponents.length > 0 ? true : false;

          assetCatalog.assetCatalogServices = selectedServices ?? [];
          assetCatalog.assetCatalogOptions = selectedOption ?? [];

          const asset: any = assetCatalogToAsset(
            assetCatalog,
            listrv,
            nbasset,
            finElements[0].cteid,
            'catalog',
            listuse,
            false,
            {
              ..._assetCatalog,
              assetCatalogOptions: assetCatalogOptions,
              assetCatalogServices: _assetCatalogServices,
            }
          );

          let marks: any = asset?.listMarksMillageByDuration?.find(
            (e: any) => e.duration === asset.rvDuration
          );
          if (!isNil(asset.tpidsupplier)) {
            form.setFieldsValue({
              supplier: {
                tpid: asset.tpidsupplier,
                tpname: asset.suppliername,
                tpreference: asset.supplierreference,
              },
            });
            loadTPDetail(
              asset.tpidsupplier,
              asset.suppliername,
              asset.supplierreference,
              'SUPPLIER'
            );
          }

          asset.ctemileage = marks?.minMillage;
          console.log('asset', asset);

          finElements[0].ctemileage = asset.ctemileage;
          finElements[0].ctedescription = asset.assetlabel + ' 1 ';

          finElements[0].cteinitialamount = asset.assetnetamount;

          finElements[0].cteinvestamount = asset.assetnetamount;

          finElements[0].cteduration = asset.rvDuration;
          finElements[0].ctervamount = asset.rvamountByDuration;

          finElements[0].ctestartamount = asset.assetnetamount;
          finElements[0].ctefinancedamount = asset.assetnetamount;

          finElements[0].totalAmortization = asset.assetnetamount;
          finElements[0].ctefinancedamount = asset.assetnetamount;
          finElements[0].supplier = {
            tpid: asset.tpidsupplier,
            tpreference: asset.supplierreference,
            tpname: asset.suppliername,
          };

          let formula = asset?.listrv?.find(
            (e: any) =>
              e.monthsmax === asset.rvDuration &&
              e.mileagemax === asset.ctemileage
          )?.exceedformula;

          console.log('formula', formula);

          finElements[0].ctepriidexceed = formula;

          console.log('---- finElements[0]', finElements[0]);

          console.log(' ---- asset', asset);

          assets.push(asset);
          elements = { ...elements, FIN: finElements };

          form.setFieldsValue({
            elements: elements,
            assets: assets,
            selectedElement: finElements[0].cteid,
          });
          console.log('elements::::', elements);

          setElementID(finElements[0].cteid);

          await handleOfferChange(form.getFieldValue('offerid'));

          let pricing = {
            ofrid: 0,
            ofrtype: 'OFFER',
            ofrlabel: '',
            ofrdescription: '',
          };

          let serviceElements: any[] = [];

          servElements = form.getFieldValue('elements') || {};

          console.log('_______servElements', servElements);

          // if (asset.assetServiceList != null) {
          //   Promise.all(
          //     asset.assetServiceList.map(async (assetService: any) => {
          //       let indexService = servElements.findIndex(
          //         (elem: any) => elem?.ctecategory === assetService?.servcode
          //       );
          //       if (indexService > -1) {
          //         servElements[indexService].servfixedamount =
          //           assetService.servfixedamount;

          //         servElements[indexService].servpercentage =
          //           assetService.servpercentage;
          //         servElements[indexService].assetid = asset.assetid;
          //         servElements[indexService].cteinstallmentamount = 0;
          //       } else {
          //         let service = await getServiceByServcode({
          //           servcode: assetService?.servcode,
          //         });
          //         if (service.data != null) {
          //           let serv = ServiceResponceToElement(service.data);

          //           const res = ServiceToElement(
          //             pricing,
          //             serv,
          //             form.getFieldValue('cteinvestamount'),
          //             [],
          //             0,
          //             cteid,
          //             0
          //           );

          //           res.pritype = 'PRICING';

          //           serviceElements.push(res);

          //           onSaveService(res, 'create');
          //         }
          //       }
          //       return assetService;
          //     })
          //   );
          // }
        } else {
          let finElements = form.getFieldValue(['elements', 'FIN']) || {};

          let finElement = { ...finElements[0] };

          finElement.conElemSchedules = [];
          finElement.cteid = Math.round(_.random(10000000));

          let elements = form.getFieldValue('elements') || {};

          let _assetCatalogServices = assetCatalogServices?.map(
            (assetCatalogService) => {
              let flagSelected = false;
              if (
                !isNil(selectedServices) &&
                selectedServices?.findIndex(
                  (serv: any) => serv.servcode === assetCatalogService.servcode
                ) > -1
              ) {
                flagSelected = true;
              }
              return {
                ...assetCatalogService,
                flagSelected: flagSelected,
              };
            }
          );

          console.log('assetCatalogOptions', assetCatalogOptions);

          assetCatalog.assetCatalogComponents = lassetComponents;

          assetCatalog.assetmulticomponents =
            lassetComponents.length > 0 ? true : false;

          assetCatalog.assetCatalogServices = selectedServices ?? [];
          assetCatalog.assetCatalogOptions = selectedOption ?? [];

          const asset: any = assetCatalogToAsset(
            assetCatalog,
            listrv,
            nbasset,
            finElement.cteid,
            'catalog',
            listuse,
            false,
            {
              ..._assetCatalog,
              assetCatalogOptions: assetCatalogOptions,
              assetCatalogServices: _assetCatalogServices,
            }
          );

          let marks: any = asset?.listMarksMillageByDuration?.find(
            (e: any) => e.duration === asset.rvDuration
          );

          asset.ctemileage = marks.minMillage;
          finElement.ctemileage = asset.ctemileage;
          finElement.ctedescription =
            asset.assetlabel + ' ' + String(assets.length + 1);

          finElement.cteinitialamount = asset.assetnetamount;

          finElement.cteinvestamount = asset.assetnetamount;

          finElement.ctervamount = asset.rvamountByDuration;

          finElement.ctestartamount = asset.assetnetamount;
          finElement.ctefinancedamount = asset.assetnetamount;

          finElement.totalAmortization = asset.assetnetamount;
          finElement.ctefinancedamount = asset.assetnetamount;

          finElement.cteduration = asset.rvDuration;

          let formula = asset?.listrv?.find(
            (e: any) =>
              e.monthsmax === asset.rvDuration &&
              e.mileagemax === asset.ctemileage
          ).exceedformula;

          finElement.cteexceedformula = formula;

          finElements.push(finElement);

          form.setFieldsValue({
            assets: [...form.getFieldValue('assets'), asset],
          });

          assets.push(asset);

          elements = { ...elements, FIN: finElements };

          form.setFieldsValue({
            elements: elements,
            assets: [...form.getFieldValue('assets'), asset],
            selectedElement: finElement.cteid,
          });

          setElementID(finElement.cteid);
          let serviceElements: any[] = [];

          await handleOfferChange(form.getFieldValue('offerid'));
          let servElements = form.getFieldValue(['elements', 'SERV']) || {};

          let pricing = {
            ofrid: 0,
            ofrtype: 'OFFER',
            ofrlabel: '',
            ofrdescription: '',
          };

          if (asset.assetServiceList != null) {
            Promise.all(
              asset.assetServiceList.map(async (assetService: any) => {
                let indexService = servElements.findIndex(
                  (elem: any) =>
                    elem?.ctecategory === assetService?.servcode &&
                    finElement?.cteid === elem?.cteidparent
                );
                if (indexService > -1) {
                  servElements[indexService].servfixedamount =
                    assetService.servfixedamount;

                  servElements[indexService].servpercentage =
                    assetService.servpercentage;
                  servElements[indexService].assetid = asset.assetid;
                  servElements[indexService].cteinstallmentamount = 0;
                } else {
                  let service = await getServiceByServcode({
                    servcode: assetService?.servcode,
                  });
                  if (service.data != null) {
                    let serv = ServiceResponceToElement(service.data);

                    const res = ServiceToElement(
                      pricing,
                      {
                        ...serv,
                        servfixedamount:
                          assetService?.servfixedamount ?? serv.servfixedamount,
                      },
                      form.getFieldValue('cteinvestamount'),
                      [],
                      0,
                      cteid,
                      0
                    );

                    res.pritype = 'PRICING';

                    serviceElements.push(res);

                    onSaveService(res, 'create');
                  }
                }
                return assetService;
              })
            );
          }
        }

        form.setFieldsValue({
          ctfinancedamount: sumBy(
            form.getFieldValue('assets'),
            'assetfinamount'
          ),
          mfrequestedamount: sumBy(
            form.getFieldValue('assets'),
            'assetfinamount'
          ),
        });

        debouncedCalculateNew('RV', '');
      }
      catalogModal.close();
    };

  const onSaveFinElement = (finElement: any, pricing: any, action: string) => {
    let indexElement = 0;
    let elements = form.getFieldValue('elements') || {};
    let finElements = form.getFieldValue(['elements', 'FIN']) || {};

    if (action === 'update') {
      indexElement = form
        .getFieldValue(['elements', 'FIN'])
        .findIndex((item: any) => item.cteid === finElement.cteid);
    } else {
      // add :
      finElements.push(finElement);

      indexElement = finElements.findIndex(
        (item: any) => item.cteid === finElement.cteid
      );
    }

    finElements[indexElement].cteinvestamount = finElement.cteinvestamount;
    finElements[indexElement].ctefinancedamount = finElement.ctefinancedamount;
    finElements[indexElement].ctedescription = finElement.ctedescription;
    finElements[indexElement].ofrid = finElement.ofrid;
    finElements[indexElement].ofrlabel = finElement.ofrlabel;
    finElements[indexElement].ofrtype = finElement.ofrtype;
    finElements[indexElement].pricing = pricing;

    finElements[indexElement].ctecategory = finElement?.ctecategory ?? '';
    finElements[indexElement].ctecategorylabel =
      finElement?.ctecategorylabel ?? '';
    finElements[indexElement].calid = finElement?.calid;
    finElements[indexElement].ctedirection = finElement?.ctedirection ?? 'IN';
    finElements[indexElement].ctemileage = finElement?.ctemileage;
    finElements[indexElement].ctepriidexceed = finElement?.ctepriidexceed;

    elements = { ...elements, FIN: finElements };

    form.setFieldsValue({
      elements: elements,
      selectedElement: finElement.cteid,
    });

    if (form.getFieldValue('ctfclevel') === 'MOASSMUEL') {
      let listFinElemLikedToElem: any[] = form
        .getFieldValue(['elements', 'FIN'])
        .filter((elem: any) => elem.ctecategory === 'ELEMLINK');
      const investamount = sumBy(listFinElemLikedToElem, 'cteinvestamount');

      let assets = form.getFieldValue('assets') || [];

      const totalAssetAmount = sumBy(assets, 'assetfinamount');

      form.setFieldsValue({
        ctfinancedamount: totalAssetAmount + investamount,
      });
    } else {
      const investamount = sumBy(
        form.getFieldValue(['elements', 'FIN']),
        'cteinvestamount'
      );

      form.setFieldsValue({ ctfinancedamount: investamount });
    }

    if (isNil(pricing)) {
      handleOfferChange(form.getFieldValue('offerid'));
    } else {
      handlePricingChange(
        pricing,
        finElement.ctepartmethod,
        finElement.ctepartamount
      );
    }
  };

  const onSavePreFinElement = (offerPrefinStep: any, action: string) => {
    if (action === 'create') {
      const listElements = form.getFieldValue('elements') || {};

      let cteid = form.getFieldValue('selectedElement');

      const indexElement = form
        .getFieldValue(['elements', 'FIN'])
        ?.findIndex((item: any) => item.cteid === cteid);

      const finElement = form.getFieldValue([
        'elements',
        'FIN',
        indexElement,
      ]) as any;

      // finElement
      const ConElemPrefinStepsList = finElement.conElemPrefinSteps ?? [];

      let investamount = isNaN(
        form.getFieldValue(getName('ctefinancedamount', elementID))
      )
        ? 0
        : form.getFieldValue(getName('ctefinancedamount', elementID));

      ConElemPrefinStepsList.push({
        ...offerPrefinStep,
        calcmethod: offerPrefinStep.calcmethod,
        calmethod: offerPrefinStep.calcmethod,
        /*ctesoutstandingamount:
          (investamount * offerPrefinStep.ctesoutstandingcoef) / 100,*/
      });

      finElement.conElemPrefinSteps = ConElemPrefinStepsList;

      const elements = { ...listElements, FIN: [finElement] };

      form.setFieldValue('elements', elements);
    }
    if (action === 'update') {
      const listElements = form.getFieldValue('elements') || {};

      let cteid = form.getFieldValue('selectedElement');

      const indexElement = form
        .getFieldValue(['elements', 'FIN'])
        ?.findIndex((item: any) => item.cteid === cteid);

      const finElement = form.getFieldValue([
        'elements',
        'FIN',
        indexElement,
      ]) as any;

      // finElement
      const ConElemPrefinStepsList = finElement.conElemPrefinSteps;
      const newConelemprefinstepList: any[] = [];

      let investamount = isNaN(
        form.getFieldValue(getName('ctefinancedamount', elementID))
      )
        ? 0
        : form.getFieldValue(getName('ctefinancedamount', elementID));

      ConElemPrefinStepsList.forEach((e: any) => {
        if (e.ctesid === offerPrefinStep.ctesid) {
          newConelemprefinstepList.push({
            ...offerPrefinStep,
            calcmethod: offerPrefinStep.calcmethod,
            calmethod: offerPrefinStep.calcmethod,
            /*ctesoutstandingamount:
              (investamount * offerPrefinStep.ctesoutstandingcoef) / 100,*/
          });
        } else {
          newConelemprefinstepList.push(e);
        }
      });

      const newfinElement = {
        ...finElement,
        conElemPrefinSteps: newConelemprefinstepList,
      };

      const elements = { ...listElements, FIN: [newfinElement] };

      form.setFieldValue('elements', elements);
    }
  };

  const onSaveService = async (service: any, action: string) => {
    let cteid = form.getFieldValue('selectedElement');

    let finElement = form
      .getFieldValue(['elements', 'FIN'])
      .filter((e: any) => e.cteid === cteid);

    if (action === 'create') {
      let elements = form.getFieldValue('elements');

      if (service.ctetype === 'SERV') {
        const servs = [...(form.getFieldValue(['elements', 'SERV']) || [])];
        servs.push(service);
        elements = { ...elements, SERV: servs };
      } else {
        const fees = [...(form.getFieldValue(['elements', 'FEES']) || [])];
        fees.push(service);
        elements = { ...elements, FEES: fees };
      }
      form.setFieldsValue({ elements: elements });
    }
    if (action === 'update') {
      //const servs = getFieldValue(['elements', 'SERV']);

      let elements = form.getFieldValue('elements');

      if (service.ctetype === 'SERV') {
        const servs = [...(form.getFieldValue(['elements', 'SERV']) || [])];

        const updateserv = servs.map((element: any, index: number) =>
          element.cteid === service.cteid
            ? {
                ...element,
                ...service,
              }
            : element
        );

        elements = { ...elements, SERV: updateserv };
        form.setFieldValue('elements', elements);
      } else {
        const fees = [...(form.getFieldValue(['elements', 'FEES']) || [])];

        const updatefees = fees.map((element: any, index: number) =>
          element.cteid === service.cteid
            ? {
                ...element,
                ...service,
              }
            : element
        );

        elements = { ...elements, FEES: updatefees };
        form.setFieldValue('elements', elements);
      }

      let commList: Array<PropElementRequest> = [];

      let filtersList = getFilterList();
      filtersList.offerCriteria.push({
        critcode: 'SERVAMOUNT',
        critvalue: service.cterentalamount,
      });

      elements = { ...elements, COMM: [] };

      await getApplicablePricingCommissionList({
        priid: service.priid,
        filtersList: filtersList,
      }).then((res: any) => {
        if (res.code === '200' && res.list != null && res.list.length > 0) {
          let pricing = {
            ofrdescription: '',
            ofrid: 1,
            ofrlabel: '',
            ofrtype: 'PRICING',
          };
          let newCommElements = res.list?.forEach(
            (item: ParCommissionResponse) => {
              if (item.commcalculationmethod === 'PERCENT') {
                if (item.commbasis === 'ELEMBASIS') {
                  item.commfixedamount =
                    (item.commpercentage * service.cteinstallmentamount) / 100;
                } else {
                  item.commfixedamount =
                    (item.commpercentage * finElement.cteinvestamount) / 100;
                }
              }
              commList.push(
                commissionToElement(
                  pricing,
                  item,
                  item,
                  cteid,
                  item.commfixedamount
                )
              );
            }
          );
          elements = { ...elements, COMM: commList };
          form.setFieldValue('elements', elements);
        }

        form.setFieldsValue({ elements: elements });
        debouncedCalculateNew('', '');
      });
    }
  };
  const onSaveComm = (service: any, action: string) => {
    if (action === 'create') {
      const servs: any[] = form.getFieldValue(['elements', 'COMM']) ?? [];
      servs?.push(service);
      let elements = form.getFieldValue('elements');
      elements = { ...elements, COMM: servs };

      form.setFieldsValue({ elements: elements });
    }
    if (action === 'update') {
      const servs = form.getFieldValue(['elements', 'COMM']);
      const updateserv = servs.map((element: any, index: number) =>
        index === service.index
          ? {
              ...element,
              ...service,
            }
          : element
      );

      let elements = form.getFieldValue('elements');
      elements = { ...elements, COMM: updateserv };
      form.setFieldsValue({ elements: elements });
    }
  };

  const handelSaveAttribute = (attribute: any, action: string) => {
    let finelements = form.getFieldValue(['elements', 'FIN']);
    let elements = form.getFieldValue('elements');

    let cteid = form.getFieldValue('selectedElement');

    finelements.forEach((ele: any) => {
      if (ele?.cteid === cteid) {
        if (action === 'create') {
          ele?.conElemAttributes.push({
            ...attribute,
            cteid: cteid,
          });
        } else {
          ele?.conElemAttributes?.forEach((att: any) => {
            if (att?.attid === attribute.attid) {
              att.attamount = attribute.attamount;
              att.attamountrequested = attribute.attamountrequested;
              att.attcomment = attribute.attcomment;
              att.nbmonthsrequested = attribute.nbmonthsrequested;
              att.nbmonthsmax = attribute.nbmonthsmax;
              att.nbmonthsagreed = attribute.nbmonthsagreed;
              att.attstatus = attribute.attstatus;
              att.attstatuslabel = attribute.attstatuslabel;
              att.cteid = cteid;

              //att=attribute;
            }
          });
        }
      }
    });

    elements = { ...elements, FIN: finelements };

    form.setFieldsValue({ elements: elements });

    debouncedCalculateNew('', '');
  };

  const handelDeleteAttribute = (attribute: any) => {
    let finelements = form.getFieldValue(['elements', 'FIN']);
    let elements = form.getFieldValue('elements');

    let cteid = form.getFieldValue('selectedElement');
    let conElemAttributes = finelements.find(
      (ele: any) => ele?.cteid === cteid
    )?.conElemAttributes;

    const newconElemAttributes = conElemAttributes.filter(
      (att: any) => att?.attid !== attribute?.attid
    );
    let newfinelements = finelements.map((ele: any) => {
      if (ele?.cteid === cteid) {
        ele.conElemAttributes = newconElemAttributes;
      }
      return ele;
    });

    elements = { ...elements, FIN: newfinelements };

    form.setFieldsValue({ elements: elements });

    debouncedCalculateNew('', '');
  };

  return (
    <Spin spinning={isLoading} delay={700}>
      <Collapse
        bordered={false}
        defaultActiveKey={['1', '3']}
        expandIcon={({ isActive }) => <PlusOutlined style={{ fontSize: 17 }} />}
        expandIconPosition="left"
        //style={{ marginBottom: 24,overflow:'hidden',backgroundColor:'#f7f7f7',border:0,borderRadius:2  }}
      >
        <UtinaPanel
          comcode="generaldataTitle"
          key="1"
          extra={
            <Form.Item shouldUpdate noStyle>
              {({ getFieldValue }) => {
                return (
                  <FinancialScheduleModal
                    finElement={getFieldValue(['elements', 'FIN'])?.find(
                      (ele: any) =>
                        ele?.cteid === getFieldValue('selectedElement')
                    )}
                    global
                    currcode={getFieldValue('currcode')}
                    data={getFieldValue('elements')}
                    comcode="globalSchedule"
                    loading={loading}
                    flagretailer={getFieldValue('flagretailer') ?? false}
                    controller={
                      <ScheduleButton
                        size="large"
                        comcode="globalSchedule"
                        twoToneColor={
                          isNil(getFieldValue('offerid')) ? 'gray' : 'green'
                        }
                        disabled={isNil(getFieldValue('offerid'))}
                      ></ScheduleButton>
                    }
                  />
                );
              }}
            </Form.Item>
          }
        >
          <Card size="small">
            <Row gutter={8}>
              <Form.Item shouldUpdate noStyle>
                {({ getFieldValue }) => {
                  return (
                    <UtinaCard
                      level={5}
                      lg={form.getFieldValue('flagasset') ? 12 : 18}
                      comcode="product"
                      additionalAttribute
                    >
                      <Form.Item shouldUpdate noStyle>
                        {phase === 'PROPOSAL' && (
                          <FormInput col xs={24} md={6} name="propreference">
                            <Value></Value>
                          </FormInput>
                        )}
                      </Form.Item>
                      <Form.Item shouldUpdate noStyle>
                        {phase === 'PROD' && (
                          <FormInput col xs={24} md={6} name="ctreference">
                            <Value></Value>
                          </FormInput>
                        )}
                      </Form.Item>
                      <Form.Item shouldUpdate noStyle>
                        {({ setFieldsValue, setFieldValue }) => (
                          <FormInput
                            col
                            xs={24}
                            md={8}
                            name="prcode"
                            // rules={[{ required: true }]}
                          >
                            <ProductInput
                              onSelected={(value, option) => {
                                let ctfclevel = 'PROPOSAL';
                                // if (option.flagfleet) {
                                //   ctfclevel = 'MULTI';
                                // }
                                setFieldsValue({
                                  assets: option.flagasset ? [] : null,
                                  flagasset: option.flagasset ?? false,
                                  flagmasterfacility:
                                    option.flagmasterfacility ?? false,
                                  flagrealestate:
                                    option.flagrealestate ?? false,
                                  flagspv: option.flagspv ?? false,
                                  flaguseassetgrossamount:
                                    option.flaguseassetgrossamount ?? false,
                                  flagredemption:
                                    option.flagredemption ?? false,
                                  flagretailer: option.flagretailer ?? false,
                                  flagfleet: option.flagfleet ?? false,
                                  mfprcode: option.mfprcode ?? '',
                                  ctfclevel: ctfclevel, //option.flagspv===true??'PROPOSAL',
                                  selectedElement: 1,
                                  mfrequestedamount: 0,
                                  ctfinancedamount: 0,
                                  thirdparties: [],
                                });
                              }}
                            />
                          </FormInput>
                        )}
                      </Form.Item>
                      <Form.Item shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                          const prcode = getFieldValue('prcode');
                          return (
                            (getFieldValue('flagspv') === false ||
                              isNil(getFieldValue('flagspv'))) && (
                              <FormInput
                                col
                                xs={24}
                                md={8}
                                name="ctfclevel"
                                comcode="ctfclevel"
                              >
                                <ParListSelect
                                  parcode="CTFCLEVEL"
                                  prcode={prcode}
                                  onSelected={(e) =>
                                    form.setFieldsValue({
                                      ctfinancedamount: null,
                                      elements: [],
                                      assets: [],
                                      selectedElement: 1,
                                      offerid: null,
                                      pricing: null,
                                      syndication: [],
                                      ctsyndinvoicingtype: null,
                                      ctsyndsuppliermanagementtype: null,
                                      ctsyndpaymentmanagementtype: null,
                                      ctsyndmgcoef: 0,
                                      ctsyndmgpartamount: 0,
                                    })
                                  }
                                />
                              </FormInput>
                            )
                          );
                        }}
                      </Form.Item>
                      <FormInput name="currcode" col md={6}>
                        <ParListSelect
                          parcode="CURRENCY"
                          onSelected={() =>
                            form.setFieldsValue({
                              assets: [],
                              offerid: null,
                              pricing: null,
                              elements: [],
                              syndication: [],
                              ctsyndinvoicingtype: null,
                              ctsyndsuppliermanagementtype: null,
                              ctsyndpaymentmanagementtype: null,
                              ctsyndmgcoef: 0,
                              ctsyndmgpartamount: 0,
                              ctfinancedamount: null,
                              selectedElement: 1,
                            })
                          }
                        />
                      </FormInput>
                      <Form.Item
                        shouldUpdate={shouldUpdateCompare([
                          'prcode',
                          'currcode',
                          'ctfclevel',
                          'offerid',
                          'pricing',
                        ])}
                        noStyle
                      >
                        {({ getFieldValue, setFieldsValue }) =>
                          getFieldValue('currcode') !== undefined &&
                          (getFieldValue('flagasset') !== true ||
                            getFieldValue('flagfleet') === true) ? (
                            getFieldValue('ctfclevel') === 'PROPOSAL' ? (
                              <InputCurrency
                                currcode={getFieldValue('currcode')}
                                fieldname="ctfinancedamount"
                                rules={[
                                  {
                                    required: true,
                                    message: `${getComponentLabel(
                                      'ctfinancedamount'
                                    )} is mandatory`,
                                  },
                                ]}
                                col
                                md={8}
                                onChange={(e: any) => {
                                  setFieldsValue({
                                    mfrequestedamount: e,
                                  });
                                  handleOfferOrPricingChange(
                                    getFieldValue('offerid'),
                                    getFieldValue('pricing')
                                  );
                                }}
                              />
                            ) : (
                              <InputCurrency
                                col
                                value={sumBy(
                                  getFieldValue('assets'),
                                  'assetfinamount'
                                )}
                                disabled
                                currcode={getFieldValue('currcode')}
                                fieldname="ctfinancedamount"
                                comcode="ctfinancedamount"
                                md={8}
                              ></InputCurrency>
                            )
                          ) : (
                            <InputCurrency
                              col
                              value={sumBy(
                                getFieldValue('assets'),
                                'assetfinamount'
                              )}
                              disabled
                              currcode={getFieldValue('currcode')}
                              fieldname="ctfinancedamount"
                              comcode="ctfinancedamount"
                              md={8}
                            ></InputCurrency>
                          )
                        }
                      </Form.Item>

                      <Form.Item shouldUpdate noStyle>
                        {({ getFieldValue }) =>
                          getFieldValue('ctfclevel') === 'MULTI' ||
                          (getFieldValue('ctfclevel') === 'PROPOSAL' &&
                            (getFieldValue('flagasset') === false ||
                              getFieldValue('flagfleet') === true)) ? (
                            <>
                              <FormInput
                                col
                                xs={24}
                                md={8}
                                rules={[
                                  {
                                    required: true,
                                    message: `${getComponentLabel(
                                      'offerid'
                                    )} is mandatory`,
                                  },
                                ]}
                                name="offerid"
                              >
                                <OfferInput
                                  disabled={
                                    !getFieldValue('prcode') ||
                                    (!getFieldValue('flagfleet') &&
                                      (getFieldValue('ctfinancedamount') ===
                                        0 ||
                                        getFieldValue('ctfinancedamount') ===
                                          null))
                                  }
                                  params={{
                                    prcode: getFieldValue('flagmasterfacility')
                                      ? getFieldValue('mfprcode')
                                      : getFieldValue('prcode')
                                      ? getFieldValue('prcode')
                                      : '',
                                    filtersList: getFilterList(),
                                    filters: '',
                                    finamount:
                                      getFieldValue('ctfinancedamount'),
                                    duration: getFieldValue('cteduration'),
                                    searchMode: 'PRCODE',
                                  }}
                                  onChange={(e) => {
                                    form.setFieldsValue({
                                      elements: [],
                                      assets: [],
                                      selectedElement: 1,
                                      pricing: null,
                                    });
                                    handleOfferChange(
                                      e,
                                      !getFieldValue('flagfleet')
                                    );
                                  }}
                                />
                              </FormInput>

                              {getFieldValue('ctfclevel') === 'PROPOSAL' && (
                                <FormInput col xs={24} md={8} name="pricing">
                                  <PricingInput
                                    disabled={!getFieldValue('offerid')}
                                    params={{
                                      catalogid: 0,
                                      duration: 0,
                                      filters: '',
                                      filtersList: getFilterList(),
                                      finamount: form.getFieldValue(
                                        getName('cteinvestamount', elementID)
                                      ),
                                      mgid:
                                        Number(localStorage.getItem('mgid')) ??
                                        0,
                                      offerid: getFieldValue('offerid'),
                                      prcode: getFieldValue(
                                        'flagmasterfacility'
                                      )
                                        ? getFieldValue('mfprcode')
                                        : getFieldValue('prcode')
                                        ? getFieldValue('prcode')
                                        : '',
                                    }}
                                    allowClear
                                    onClear={() => {
                                      handleDeleteFinChildElements(
                                        getFieldValue('selectedElement')
                                      );
                                      handleOfferChange(
                                        getFieldValue('offerid')
                                      );
                                    }}
                                    onChange={(e) => {
                                      handlePricingChange(e, '', 0);
                                    }}
                                  />
                                </FormInput>
                              )}
                            </>
                          ) : null
                        }
                      </Form.Item>
                      <Form.Item shouldUpdate noStyle>
                        {({ getFieldValue }) =>
                          (getFieldValue('flagspv') === false ||
                            isNil(getFieldValue('flagspv'))) && (
                            <FormInput col xs={24} md={8} name="cttype">
                              <ParListSelect
                                parcode="CTTYPE"
                                prcode={getFieldValue('prcode')}
                                onChange={() => {
                                  form.setFieldsValue({
                                    syndication: [],
                                    ctsyndinvoicingtype: null,
                                    ctsyndsuppliermanagementtype: null,
                                    ctsyndpaymentmanagementtype: null,
                                    ctsyndmgcoef: 0,
                                    ctsyndmgpartamount: 0,
                                  });
                                }}
                              />
                            </FormInput>
                          )
                        }
                      </Form.Item>
                      <Form.Item shouldUpdate noStyle>
                        {({ getFieldValue, setFieldsValue }) => {
                          return (
                            <FormInput
                              col
                              xs={24}
                              md={8}
                              name="client"
                              rules={[{ required: true }]}
                              comcode={
                                getFieldValue('prcode') === 'REFIN'
                                  ? 'préteur'
                                  : 'client'
                              }
                            >
                              <ThirdPartyInput
                                role="CLIENT"
                                display={
                                  !isProposalCreate && ctrid !== undefined
                                }
                                isCreate={isProposalCreate}
                                onChange={(e) => {
                                  setLoadingBtn(true);
                                  if (getFieldValue('prcode') === 'LEASEBACK') {
                                    setFieldsValue({
                                      supplier: {
                                        tpid: e.tpid,
                                        tpname: e.tpname,
                                        tpreference: e.tpreference,
                                      },
                                    });
                                    let cteid =
                                      getFieldValue('selectedElement') ?? 0;
                                    let assets = getFieldValue('assets')
                                      ?.filter((a: any) => a.cteid === cteid)
                                      ?.map((asset: any) =>
                                        !isEmpty(asset?.irvSchedule)
                                          ? {
                                              ...asset,
                                              suppliername: e.tpname,
                                              supplierreference: e.tpreference,
                                              tpidsupplier: e.tpid,
                                              rentalpart:
                                                asset?.irvSchedule?.filter(
                                                  (e: any) =>
                                                    e.ctstype === 'RENTAL'
                                                )[0]?.rentalpart,
                                            }
                                          : {
                                              ...asset,
                                              suppliername: e.tpname,
                                              supplierreference: e.tpreference,
                                              tpidsupplier: e.tpid,
                                            }
                                      );

                                    form.setFieldsValue({
                                      assets: assets,
                                    });

                                    let alltp =
                                      form.getFieldValue('thirdparties');

                                    alltp = alltp?.filter((tp: any) => {
                                      const clientTpid = alltp?.find(
                                        (tp: any) => tp.tprolecode === 'CLIENT'
                                      )?.tpid?.tpid;
                                      const supplierTpid = alltp?.find(
                                        (tp: any) =>
                                          tp.tprolecode === 'SUPPLIER'
                                      )?.tpid?.tpid;

                                      // Vérifier si le tpid est différent du tpid d'un élément ayant tprolecode égal à 'CLIENT' ou 'SUPPLIER'
                                      return (
                                        tp.tpid.tpid !== clientTpid &&
                                        tp.tpid.tpid !== supplierTpid
                                      );
                                    });
                                  }
                                  setLoadingBtn(false);
                                }}
                              />
                            </FormInput>
                          );
                        }}
                      </Form.Item>
                      <Form.Item shouldUpdate={() => true} noStyle>
                        {({ getFieldValue }) => {
                          return (
                            <FormInput col xs={24} md={8} name="ctnetworkcode">
                              <ParListSelect
                                parcode="NETWORK"
                                disabled={
                                  localStorage?.getItem('userrole') !== 'BROKER'
                                }
                              />
                            </FormInput>
                          );
                        }}
                      </Form.Item>
                      <Form.Item shouldUpdate={() => true} noStyle>
                        {({ getFieldValue }) => {
                          return (
                            <FormInput col xs={24} md={8} name="ctchannelcode">
                              <ParListSelect
                                parcode="CHANNEL"
                                offerid={getFieldValue('offerid')}
                              />
                            </FormInput>
                          );
                        }}
                      </Form.Item>

                      <Form.Item shouldUpdate={() => true} noStyle>
                        {({ getFieldValue }) =>
                          getFieldValue('ctfclevel') === 'PROPOSAL' && (
                            <FormInput col xs={24} md={8} name="calid">
                              <ParCalendarSelect
                                calid={form.getFieldValue('calid')}
                              />
                            </FormInput>
                          )
                        }
                      </Form.Item>

                      <Form.Item shouldUpdate={() => true} noStyle>
                        {({ getFieldValue }) => {
                          return (
                            <FormInput col xs={24} md={8} name="ctproporigin">
                              <ParListSelect parcode="PROPORIGIN" />
                            </FormInput>
                          );
                        }}
                      </Form.Item>
                      <Form.Item shouldUpdate={() => true} noStyle>
                        {({ getFieldValue }) => {
                          return (
                            <FormInput col xs={24} md={8} name="ctdealerrating">
                              <ParListSelect parcode="DEALRATING" />
                            </FormInput>
                          );
                        }}
                      </Form.Item>

                      <Form.Item shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                          return getFieldValue('flagmasterfacility') ? (
                            <FormInput
                              col
                              xs={24}
                              md={4}
                              name="mfflagrevolving"
                              valuePropName="checked"
                            >
                              <Switch
                                checkedChildren={<CheckOutlined />}
                                unCheckedChildren={<CloseOutlined />}
                              />
                            </FormInput>
                          ) : null;
                        }}
                      </Form.Item>

                      <Form.Item shouldUpdate noStyle>
                        {({ getFieldValue }) =>
                          !getFieldValue('flagmasterfacility') &&
                          getFieldValue('ctidautorization') ? (
                            <FormInput
                              col
                              xs={24}
                              md={6}
                              name="ctidautorization"
                            >
                              <ModalControllerNV
                                content={({ setVisible, visible }) => (
                                  <a
                                    onClick={() => {
                                      setVisible(true);
                                    }}
                                  >
                                    {getFieldValue('ctidautorization')}
                                  </a>
                                )}
                                modal={({ setVisible, visible }) => (
                                  <ProposalModal
                                    ctrid={Number(
                                      getFieldValue('ctidautorization') ?? null
                                    )}
                                    phase="PROPOSAL"
                                    visible={visible}
                                    onCancel={() => setVisible(false)}
                                    onSuccess={() => setVisible(false)}
                                    title="Master Facility"
                                  />
                                )}
                              />
                            </FormInput>
                          ) : null
                        }
                      </Form.Item>

                      <Form.Item shouldUpdate noStyle>
                        {({ getFieldValue }) =>
                          getFieldValue('flagmasterfacility') ? (
                            <InputCurrency
                              col
                              md={6}
                              currcode={getFieldValue('currcode')}
                              comcode="mfrequestedamount"
                              fieldname="mfrequestedamount"
                              disabled={getFieldValue('prcode') === 'CLINE'}
                            />
                          ) : null
                        }
                      </Form.Item>
                      <Form.Item shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                          return getFieldValue('flagmasterfacility') ? (
                            <FormInput
                              col
                              xs={24}
                              md={6}
                              style={{ color: 'red' }}
                              name="mfagreedamount"
                              comcode="mfagreedamount"
                            >
                              <Value
                                formatter={(value) =>
                                  toCurrency(value, getFieldValue('currcode'))
                                }
                              />
                            </FormInput>
                          ) : null;
                        }}
                      </Form.Item>

                      <Form.Item shouldUpdate noStyle>
                        {({ getFieldValue }) =>
                          getFieldValue('flagmasterfacility') ? (
                            <FormInput
                              col
                              xs={24}
                              md={6}
                              style={{ color: 'red' }}
                              name="mfbookedamount"
                              comcode="mfbookedamount"
                            >
                              <Value
                                formatter={(value) =>
                                  toCurrency(value, getFieldValue('currcode'))
                                }
                              />
                            </FormInput>
                          ) : null
                        }
                      </Form.Item>
                      <Form.Item shouldUpdate noStyle>
                        {({ getFieldValue }) =>
                          getFieldValue('flagmasterfacility') ? (
                            <FormInput
                              col
                              xs={24}
                              md={6}
                              style={{ color: 'red' }}
                              name="mfusedamount"
                              comcode="mfusedamount"
                            >
                              <Value
                                formatter={(value) =>
                                  toCurrency(value, getFieldValue('currcode'))
                                }
                              />
                            </FormInput>
                          ) : null
                        }
                      </Form.Item>
                      <Form.Item shouldUpdate noStyle>
                        {({ getFieldValue }) =>
                          getFieldValue('flagmasterfacility') ? (
                            <FormInput
                              col
                              xs={24}
                              md={6}
                              style={{ color: 'red' }}
                              name="mfavailableamount"
                              comcode="mfavailableamount"
                            >
                              <Value
                                formatter={(value) =>
                                  toCurrency(value, getFieldValue('currcode'))
                                }
                              />
                            </FormInput>
                          ) : null
                        }
                      </Form.Item>
                    </UtinaCard>
                  );
                }}
              </Form.Item>

              <UtinaCard level={5} lg={5} comcode="status" additionalAttribute>
                <FormInput col xs={20} name="ctstatuslabel">
                  <Value />
                </FormInput>
                <FormInput col xs={4} name="history" noStyle>
                  <StatusHistoryPopover
                    objectid={ctrid ? ctrid : (null as any)}
                    entity={phase}
                  >
                    <CalendarTwoTone twoToneColor="red" />
                  </StatusHistoryPopover>
                </FormInput>
                <FormInput
                  col
                  xs={24}
                  name="ctrequestdate"
                  initialValue={moment(new Date(), 'YYYY-MM-DD')}
                >
                  <DatePicker defaultValue={moment(new Date(), 'YYYY-MM-DD')} />
                </FormInput>
                <Form.Item shouldUpdate noStyle>
                  {phase === 'PROPOSAL' && (
                    <FormInput
                      col
                      xs={24}
                      name="ctinitstartdate"
                      initialValue={moment(new Date(), 'YYYY-MM-DD')}
                    >
                      <DatePicker
                        onChange={(e: any) => {
                          var init = moment(dateToString(e), 'YYYY-MM-DD');
                          var target = init
                            .add(
                              form.getFieldValue('ctdurationmonths') ?? 0,
                              'M'
                            )
                            .subtract(1, 'd');
                          form.setFieldsValue({
                            ctinitenddate: dateToString(target),
                          });
                        }}
                        defaultValue={moment(new Date(), 'YYYY-MM-DD')}
                      />
                    </FormInput>
                  )}
                </Form.Item>
                <Form.Item shouldUpdate noStyle>
                  {phase === 'PROPOSAL' && (
                    <FormInput col xs={24} name="ctdurationmonths">
                      <InputNumber
                        disabled={!form.getFieldValue('offerid')}
                        onChange={(e: any) => {
                          let ctinitstartdate =
                            form.getFieldValue('ctinitstartdate') ?? moment();
                          var init = moment(dateToString(ctinitstartdate));
                          var target = init.add(e, 'M').subtract(1, 'd');

                          form.setFieldValue(
                            getName('cteenddate', elementID),
                            target
                          );
                          form.setFieldValue(
                            getName('cteduration', elementID),
                            e
                          );
                          form.setFieldsValue({
                            ctinitenddate: dateToString(target),
                          });
                        }}
                      />
                    </FormInput>
                  )}
                </Form.Item>
                <Form.Item shouldUpdate noStyle>
                  {phase === 'PROPOSAL' && (
                    <FormInput col xs={24} name="ctinitenddate">
                      <Value />
                    </FormInput>
                  )}
                </Form.Item>
                <Form.Item shouldUpdate noStyle>
                  {({ getFieldValue }) => {
                    return phase === 'PROPOSAL' &&
                      !getFieldValue('flagmasterfacility') ? (
                      <FormInput col xs={24} name="ctvaliditydate">
                        <Value />
                      </FormInput>
                    ) : null;
                  }}
                </Form.Item>
                <FormInput col xs={24} name="ctenddate">
                  <Value />
                </FormInput>
                <FormInput col xs={24} name="ctacceptancedate">
                  <Value />
                </FormInput>
                <FormInput col xs={24} name="ctsignaturedate">
                  <Value />
                </FormInput>

                <FormInput col xs={24} name="ctactivationdate">
                  <Value />
                </FormInput>
                <Form.Item shouldUpdate noStyle>
                  {({ getFieldValue }) => {
                    return getFieldValue('flagmasterfacility') ? (
                      <FormInput
                        col
                        xs={24}
                        style={{ color: 'red' }}
                        name="mfvaliditydate"
                        comcode="mfvaliditydate"
                      >
                        <Value />
                      </FormInput>
                    ) : null;
                  }}
                </Form.Item>
                {/* <Form.Item shouldUpdate noStyle>
                  {phase === 'PROD' && (
                    <FormInput col xs={24} name="ctactivationdate">
                      <Value />
                    </FormInput>
                  )}
                </Form.Item> */}
              </UtinaCard>

              <Form.Item shouldUpdate noStyle>
                {({ getFieldValue }) => {
                  return (
                    form.getFieldValue('flagasset') &&
                    form.getFieldValue('imageBase64') && (
                      <UtinaCard
                        level={5}
                        lg={5}
                        comcode="assetPicture"
                        additionalAttribute
                      >
                        <Image
                          preview={{ visible: false }}
                          src={
                            'data:image/jpeg;charset=utf-8;base64, ' +
                            form.getFieldValue('imageBase64')
                          }
                        />
                      </UtinaCard>
                    )
                  );
                }}
              </Form.Item>
            </Row>
            <Row gutter={32}>
              <FormInput col xs={24} name="ctcomment">
                <TextArea rows={4} style={{ width: '100%' }} />
              </FormInput>
            </Row>
          </Card>
        </UtinaPanel>
      </Collapse>
      <FormItem shouldUpdate noStyle>
        {({ getFieldValue }) => {
          return (
            getFieldValue('flagredemption') && (
              <Collapse
                bordered={false}
                expandIcon={({ isActive }) => (
                  <PlusOutlined style={{ fontSize: 17 }} />
                )}
                expandIconPosition="left"
                style={{ background: 'none !important' }}
              >
                <UtinaPanel comcode="Redemption" key={5}>
                  <Card>
                    <Row>
                      <Col span={22}></Col>
                      <LoanRedemption form={form} ctstatus={ctstatus} />
                    </Row>
                  </Card>
                </UtinaPanel>
              </Collapse>
            )
          );
        }}
      </FormItem>
      <FormItem shouldUpdate noStyle>
        {({ getFieldValue }) => {
          return (
            getFieldValue('flagmasterfacility') && (
              <Collapse
                bordered={false}
                defaultActiveKey={['1']}
                expandIcon={({ isActive }) => (
                  <PlusOutlined style={{ fontSize: 17 }} />
                )}
                expandIconPosition="left"
                style={{ background: 'none !important' }}
              >
                <UtinaPanel comcode="beneficiary" key={2}>
                  <Card>
                    <Row>
                      <Col span={22}></Col>
                      <Col span={2}>
                        <NewButton onClick={addRowBen} comcode="add" />
                      </Col>

                      <DataGrid
                        rowKey={(record: any) =>
                          typeof record.tpid === 'object'
                            ? record?.tpid!.tpid
                            : record.tpid
                        }
                        dataSource={
                          getFieldValue('thirdparties').filter(
                            (elem: any) => elem.tprolecode === 'MFBENEF'
                          ) ?? []
                        }
                        titleComcode="beneficaryList"
                        columns={columnsbeneficary}
                      />
                    </Row>
                  </Card>
                </UtinaPanel>
                {!isProposalCreate && phase === 'PROPOSAL' && (
                  <UtinaPanel comcode="ListOfUse" key={3}>
                    <Card>
                      <PropList
                        hideExtraAction
                        hideFilters
                        prcode=""
                        mfid={ctrid}
                        search
                        phase="PROPOSAL"
                        refetch={getFieldValue('refetch')}
                      />
                    </Card>
                  </UtinaPanel>
                )}
              </Collapse>
            )
          );
        }}
      </FormItem>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div
          style={{
            order: form.getFieldValue('ctfclevel') === 'MOASSMUEL' ? 2 : 1,
          }}
        >
          <FormItem shouldUpdate noStyle>
            {({ getFieldValue }) => {
              const elements = getFieldValue(['elements', 'FIN']) || [];
              const assets = getFieldValue('assets') || [];

              let totalFinAmountElemLinkedToAsset = 0;

              elements?.forEach((elem: any) => {
                totalFinAmountElemLinkedToAsset += elem?.ctefinancedamount;
              });

              return (
                (getFieldValue('ctfclevel') === 'MULTI' ||
                  getFieldValue('ctfclevel') === 'MOASSMUEL') &&
                getFieldValue('flagfleet') === false && (
                  <Collapse
                    bordered={false}
                    defaultActiveKey={['1']}
                    expandIcon={({ isActive }) => (
                      <PlusOutlined style={{ fontSize: 17 }} />
                    )}
                    expandIconPosition="left"
                    style={{ background: 'none !important' }}
                  >
                    <UtinaPanel
                      comcode="financingElements"
                      key={4}
                      extra={
                        <ModalControllerNV
                          content={({ setVisible, visible }) => (
                            <Button
                              icon={<IAdd height="15px" width="15px" />}
                              onClick={(ev) => {
                                ev.stopPropagation();
                                //form.setFieldsValue({selectedElement:0});
                                setVisible(true);
                              }}
                              disabled={isNil(getFieldValue('offerid'))}
                            >
                              Add Element
                            </Button>
                          )}
                          modal={({ setVisible, visible }) => (
                            <SimpleFinElementModal
                              offerParams={form?.getFieldValue('offerParams')}
                              visible={visible}
                              onClose={() => setVisible(false)}
                              onSave={onSaveFinElement}
                              form={form!}
                              display
                              ctfclevel={getFieldValue('ctfclevel')}
                              assetAmount={assets[0]?.assetfinamount ?? 0}
                              totalFinAmountElemLinkedToAsset={
                                totalFinAmountElemLinkedToAsset
                              }
                              elements={elements}
                            />
                          )}
                        />
                      }
                    >
                      <Form.Item shouldUpdate>
                        {({ getFieldValue }) => {
                          const elements =
                            getFieldValue(['elements', 'FIN']) || [];
                          const assets = getFieldValue('assets') || [];

                          let totalFinAmountElemLinkedToAsset = 0;

                          elements?.forEach((elem: any) => {
                            totalFinAmountElemLinkedToAsset +=
                              elem.ctefinancedamount;
                          });

                          return (
                            <ElementsFinTable
                              form={form}
                              elements={[...elements]}
                              onDeleteElement={handleDeleteElement}
                              onSelect={handleSelectedElement}
                              onSave={onSaveFinElement}
                              offerid={form.getFieldValue('offerid')}
                              prcode={
                                getFieldValue('flagmasterfacility')
                                  ? getFieldValue('mfprcode')
                                  : getFieldValue('prcode')
                                  ? getFieldValue('prcode')
                                  : ''
                              }
                              ctfclevel={getFieldValue('ctfclevel')}
                              preFin={
                                elements[0]?.ctecalculationtype === 'PREFIN'
                              }
                              assetAmount={assets[0]?.assetfinamount ?? 0}
                              totalFinAmountElemLinkedToAsset={
                                totalFinAmountElemLinkedToAsset
                              }
                              flagretailer={getFieldValue('flagretailer')}
                            />
                          );
                        }}
                      </Form.Item>
                    </UtinaPanel>
                  </Collapse>
                )
              );
            }}
          </FormItem>
        </div>

        <div
          style={{
            order: form.getFieldValue('ctfclevel') === 'MOASSMUEL' ? 1 : 2,
          }}
        >
          <FormItem
            shouldUpdate={shouldUpdateCompare([
              'flagasset',
              'flagspv',
              'assets',
              'flagfleet',
            ])}
            noStyle
          >
            {({ getFieldValue }) => {
              return (
                getFieldValue('flagfleet') === true &&
                !isNil(getFieldValue('offerid')) &&
                getFieldValue('offerid') !== 0 && (
                  <Collapse
                    bordered={false}
                    defaultActiveKey={['1']}
                    expandIcon={({ isActive }) => (
                      <PlusOutlined style={{ fontSize: 17 }} />
                    )}
                    expandIconPosition="left"
                    style={{ background: 'none !important' }}
                  >
                    <UtinaPanel comcode="assetList" key={5}>
                      <Card>
                        <Form.Item shouldUpdate noStyle>
                          {({ getFieldValue }) => {
                            const cteid = getFieldValue('selectedElement') ?? 0;

                            // let assets = getFieldValue('assets') ?? [];

                            let assets = getFieldValue('assets');

                            let elements = getFieldValue('elements');

                            console.log('assets', assets);

                            /* if (getFieldValue('ctfclevel') !== 'MOASSMUEL') {
                              assets = getFieldValue('assets')
                                ?.filter((a: any) => a.cteid === cteid)
                                ?.map((asset: any) =>
                                  !isEmpty(asset?.irvSchedule)
                                    ? {
                                        ...asset,
                                        rentalpart: asset?.irvSchedule?.filter(
                                          (e: any) => e.ctstype === 'RENTAL'
                                        )[0]?.rentalpart,
                                      }
                                    : asset
                                );
                            }*/

                            return (
                              <AssetsCardTable
                                elementID={elementID}
                                reftechProp={reftechProp}
                                ctrid={ctrid}
                                currcode={getFieldValue('currcode')}
                                assets={[...assets]}
                                onAddFromCatalog={handleAddFromCatalog}
                                onAddFromCatalogPack={handleAddFromCatalogPack}
                                onCreateNewAsset={handleCreateNewAsset}
                                onCreateNewMultiCompAsset={
                                  handleCreateNewMultiCompAsset
                                }
                                onAddFromStock={handleAddFromStock}
                                onAddInitAsset={handleAddInitAsset}
                                onSaveAsset={handleSaveAssetCard}
                                onDelete={(asset) =>
                                  handleDeleteAsset(asset.assetid)
                                }
                                onMoveToNewelement={(asset) =>
                                  handleMoveAsset(asset)
                                }
                                ctfclevel={getFieldValue('ctfclevel')}
                                phase={phase}
                                flagreal={Boolean(
                                  getFieldValue('flagrealestate')
                                )}
                                fromproposal
                                proposalData={{
                                  pricing: getFieldValue('pricing'),
                                  prcode: getFieldValue('prcode'),
                                  duration: getFieldValue(
                                    getName('cteduration', elementID)
                                  ),
                                  offerid: getFieldValue('offerid'),
                                }}
                                mfuse={
                                  getFieldValue('ctidautorization') === null ||
                                  getFieldValue('ctidautorization') ===
                                    undefined
                                    ? false
                                    : true
                                }
                                ctstatus={ctstatus}
                                nbreAsset={nbreAsset}
                                form={form}
                                debouncedCalculateNew={(
                                  param: string,
                                  calcMethod: string,
                                  _cteid: number
                                ) => {
                                  setElementID(_cteid);
                                  form.setFieldValue('selectedElement', _cteid);
                                  debouncedCalculateNew(
                                    param,
                                    calcMethod,
                                    _cteid
                                  );
                                }}
                                handleConvertServToFinServ={
                                  handleConvertServToFinServ
                                }
                                handleDeleteElement={handleDeleteElement}
                                onSaveService={onSaveService}
                                onSelect={handleSelectAssetFromCatalog}
                                onSelectOptions={(
                                  option: any,
                                  cteid: number,
                                  assetid: number,
                                  operation: string
                                ) => {
                                  if (operation === 'ADD') {
                                    addOptionsToAsset(option, cteid, assetid);
                                  } else {
                                    deleteOptionsAsset(option, cteid, assetid);
                                  }
                                }} // recalculate={(w
                                onSelectServices={(
                                  service: any,
                                  cteid: number,
                                  assetid: number,
                                  operation: string
                                ) => {
                                  setLoading(true);
                                  if (operation === 'ADD') {
                                    addAssetService(service, cteid, assetid);
                                  } else {
                                    onDeleteService(service, cteid, assetid);
                                  }
                                }} //   duration: any,
                                //   rvamount: any,
                                //   cteid: number
                                // ) => {
                                //   form.setFieldValue(
                                //     getName('cteduration', elementID),
                                //     duration
                                //   );
                                //   form.setFieldValue(
                                //     getName('ctervamount', elementID),
                                //     rvamount
                                //   );
                                //   debouncedCalculateNew('RV', '');
                                //   // debouncedCalculateNew('', '')
                                // }}
                              />
                            );
                          }}
                        </Form.Item>
                      </Card>
                    </UtinaPanel>
                  </Collapse>
                )
              );
            }}
          </FormItem>
        </div>
        <div
          style={{
            order: form.getFieldValue('ctfclevel') === 'MOASSMUEL' ? 1 : 2,
          }}
        >
          <FormItem
            shouldUpdate={shouldUpdateCompare([
              'flagasset',
              'flagspv',
              'assets',
            ])}
            noStyle
          >
            {({ getFieldValue }) => {
              return (
                //getFieldValue('flagspv') === false &&
                getFieldValue('flagasset') === true && (
                  <Collapse
                    bordered={false}
                    defaultActiveKey={['5']}
                    expandIcon={({ isActive }) => (
                      <PlusOutlined style={{ fontSize: 17 }} />
                    )}
                    expandIconPosition="left"
                    style={{ background: 'none !important' }}
                  >
                    <UtinaPanel comcode="assetList" key={5}>
                      <Card>
                        <Form.Item shouldUpdate noStyle>
                          {({ getFieldValue }) => {
                            const cteid = getFieldValue('selectedElement') ?? 0;

                            let assets = getFieldValue('assets');
                            if (getFieldValue('ctfclevel') !== 'MOASSMUEL') {
                              assets = getFieldValue('assets')
                                ?.filter((a: any) => a.cteid === cteid)
                                ?.map((asset: any) =>
                                  !isEmpty(asset?.irvSchedule)
                                    ? {
                                        ...asset,
                                        rentalpart: asset?.irvSchedule?.filter(
                                          (e: any) => e.ctstype === 'RENTAL'
                                        )[0]?.rentalpart,
                                      }
                                    : asset
                                );
                            }

                            return (
                              <AssetsTable
                                reftechProp={reftechProp}
                                ctrid={ctrid}
                                currcode={getFieldValue('currcode')}
                                assets={[...assets]}
                                onAddFromCatalog={handleAddFromCatalog}
                                onAddFromCatalogPack={handleAddFromCatalogPack}
                                onCreateNewAsset={handleCreateNewAsset}
                                onCreateNewMultiCompAsset={
                                  handleCreateNewMultiCompAsset
                                }
                                hideSaveBtnAsset={phase === 'PROD'}
                                onAddFromStock={handleAddFromStock}
                                onAddInitAsset={handleAddInitAsset}
                                onSaveAsset={handleSaveAsset}
                                onDelete={(asset) =>
                                  handleDeleteAsset(asset.assetid)
                                }
                                onMoveToNewelement={(asset) =>
                                  handleMoveAsset(asset)
                                }
                                ctfclevel={getFieldValue('ctfclevel')}
                                phase={phase}
                                flagreal={Boolean(
                                  getFieldValue('flagrealestate')
                                )}
                                fromproposal
                                proposalData={{
                                  pricing: getFieldValue('pricing'),
                                  prcode: getFieldValue('prcode'),
                                  duration: getFieldValue(
                                    getName('cteduration', elementID)
                                  ),
                                  offerid: getFieldValue('offerid'),
                                }}
                                mfuse={
                                  getFieldValue('ctidautorization') === null ||
                                  getFieldValue('ctidautorization') ===
                                    undefined
                                    ? false
                                    : true
                                }
                                ctstatus={ctstatus}
                                nbreAsset={nbreAsset}
                              />
                            );
                          }}
                        </Form.Item>
                        <Divider></Divider>
                        <Row gutter={[8, 8]}>
                          <Form.Item shouldUpdate noStyle>
                            {({ getFieldValue }) =>
                              getFieldValue('ctfclevel') === 'PROPOSAL' ||
                              getFieldValue('ctfclevel') === 'MOASSMUEL' ? (
                                <FormInput
                                  col
                                  xs={24}
                                  md={10}
                                  name="offerid"
                                  rules={[{ required: true }]}
                                >
                                  <OfferInput
                                    disabled={
                                      !getFieldValue('prcode') ||
                                      (getFieldValue('flagasset') === true &&
                                        getFieldValue('assets')?.length === 0)
                                    }
                                    params={{
                                      prcode: form?.getFieldValue(
                                        'flagmasterfacility'
                                      )
                                        ? form?.getFieldValue('mfprcode')
                                        : form?.getFieldValue('prcode')
                                        ? form?.getFieldValue('prcode')
                                        : '',
                                      filtersList: getFilterList(),
                                      /*                                  filters:
                                    getFieldValue('assets').length === 1
                                      ? `ASSETFAM=${
                                          getFieldValue('assets')[0].assetfamily
                                        },ASSETTYPE=${
                                          getFieldValue('assets')[0].assettype
                                        },ASSETCAT=${
                                          getFieldValue('assets')[0]
                                            .assetcategory
                                        },`
                                      : '',*/
                                      finamount:
                                        getFieldValue('ctfinancedamount'),
                                      duration: getFieldValue('cteduration'),
                                      searchMode: 'PRCODE',
                                    }}
                                    onChange={(e) => {
                                      handleDeleteFinChildElements(
                                        getFieldValue('selectedElement')
                                      );
                                      handleOfferChange(e);
                                    }}
                                  />
                                </FormInput>
                              ) : null
                            }
                          </Form.Item>
                          <Form.Item shouldUpdate noStyle>
                            {({ getFieldValue, setFieldsValue }) =>
                              getFieldValue('ctfclevel') === 'PROPOSAL' ? (
                                <FormInput col xs={24} md={10} name="pricing">
                                  <PricingInput
                                    disabled={!getFieldValue('offerid')}
                                    params={{
                                      catalogid: 0,
                                      duration: 0,
                                      filters: '',
                                      filtersList: getFilterList(),
                                      finamount: form.getFieldValue(
                                        getName('cteinvestamount', elementID)
                                      ),
                                      mgid:
                                        Number(localStorage.getItem('mgid')) ??
                                        0,
                                      offerid: getFieldValue('offerid'),
                                      prcode: getFieldValue(
                                        'flagmasterfacility'
                                      )
                                        ? getFieldValue('mfprcode')
                                        : getFieldValue('prcode')
                                        ? getFieldValue('prcode')
                                        : '',
                                    }}
                                    onChange={(e) => {
                                      handlePricingChange(e, '', 0);
                                    }}
                                    allowclear
                                    onClear={() => {
                                      handleDeleteFinChildElements(
                                        getFieldValue('selectedElement')
                                      );
                                      handleOfferChange(
                                        getFieldValue('offerid')
                                      );
                                    }}
                                  />
                                </FormInput>
                              ) : null
                            }
                          </Form.Item>
                        </Row>
                      </Card>
                    </UtinaPanel>
                  </Collapse>
                )
              );
            }}
          </FormItem>
        </div>
      </div>

      <FormItem shouldUpdate={shouldUpdateCompare(['cttype'])} noStyle>
        {({ getFieldValue }) => {
          return getFieldValue('cttype') !== 'ALONE' &&
            getFieldValue('cttype') !== 'BUYBACK' &&
            getFieldValue('cttype') !== undefined ? (
            <Collapse
              bordered={false}
              defaultActiveKey={['1']}
              expandIcon={({ isActive }) => (
                <PlusOutlined style={{ fontSize: 17 }} />
              )}
              expandIconPosition="left"
              style={{ background: 'none !important' }}
            >
              <UtinaPanel comcode="syndication" key={6}>
                <Card>
                  <Row gutter={16}>
                    <FormInput col xs={24} md={5} name="ctsyndinvoicingtype">
                      <ParListSelect
                        parcode="SYNDINV"
                        onSelected={() => {
                          debouncedCalculateNew('', '');
                        }}
                      />
                    </FormInput>
                    <FormInput
                      col
                      xs={24}
                      md={5}
                      name="ctsyndsuppliermanagementtype"
                    >
                      <ParListSelect parcode="SYNDSUPP" />
                    </FormInput>
                    <FormInput
                      col
                      xs={24}
                      md={5}
                      name="ctsyndpaymentmanagementtype"
                    >
                      <ParListSelect parcode="SYNDPAY" />
                    </FormInput>
                  </Row>
                  <Row gutter={16}>
                    <FormInput col xs={4} name="ctsyndmgcoef">
                      <InputRate
                        defaultValue={0}
                        onChange={(e) => {
                          handlesyncoef(e);
                          debouncedCalculateNew('', '');
                        }}
                      />
                    </FormInput>
                    <FormInput col xs={6} name="ctsyndmgpartamount">
                      <InputCurrency
                        currcode={getFieldValue('currcode')}
                        onChange={() => debouncedCalculateNew('', '')}
                      />
                    </FormInput>
                  </Row>
                  <Divider></Divider>
                  <FormItem shouldUpdate={shouldUpdateCompare('syndication')}>
                    {({ getFieldValue }) => {
                      return (
                        <Row>
                          <Col span={22} />
                          <Col span={2}>
                            <NewButton onClick={addRowsyn} comcode="add" />
                          </Col>
                          <DataGrid
                            rowKey="syndid"
                            dataSource={getFieldValue('syndication')}
                            titleComcode="syndication"
                            columns={columnssyndication}
                          />
                        </Row>
                      );
                    }}
                  </FormItem>
                </Card>
              </UtinaPanel>
            </Collapse>
          ) : null;
        }}
      </FormItem>
      <FormItem shouldUpdate={shouldUpdateCompare(['flagfleet'])} noStyle>
        {({ getFieldValue }) => {
          const elements = getFieldValue(['elements', 'FIN']) || [];

          const cteid = getFieldValue('selectedElement') ?? 0;
          const ctedescription = getFieldValue('ctedescription') ?? '';

          return (
            getFieldValue('flagfleet') === false && (
              <Collapse
                bordered={false}
                expandIcon={({ isActive }) => (
                  <PlusOutlined style={{ fontSize: 17 }} />
                )}
                expandIconPosition="left"
                style={{ background: 'none !important' }}
              >
                <UtinaPanel
                  comcode="proposalConditions"
                  labelAdditional={ctedescription}
                  extra={
                    <Row style={{ fontWeight: 'bold', fontSize: 12 }}>
                      <Col style={{ textAlign: 'left' }}>
                        <Form.Item shouldUpdate noStyle>
                          {({ getFieldValue }) => (
                            <FinancialScheduleModal
                              currcode={form.getFieldValue('currcode')}
                              finElement={getFieldValue([
                                'elements',
                                'FIN',
                              ])?.find(
                                (ele: any) =>
                                  ele.cteid === getFieldValue('selectedElement')
                              )}
                              phase={phase}
                              comcode="finSchedule"
                              loading={loading}
                              flagretailer={getFieldValue('flagretailer')}
                              controller={
                                <ScheduleButton
                                  size="large"
                                  comcode="finSchedule"
                                  onClickCapture={() => {
                                    debouncedCalculateNew('', '');
                                  }}
                                  twoToneColor={
                                    isNil(getFieldValue('offerid'))
                                      ? 'gray'
                                      : 'blue'
                                  }
                                  disabled={isNil(getFieldValue('offerid'))}
                                ></ScheduleButton>
                              }
                            />
                          )}
                        </Form.Item>
                      </Col>
                    </Row>
                  }
                  key={7}
                >
                  <Form.Item shouldUpdate>
                    {({ getFieldValue }) => {
                      return (
                        <Tabs animated type="card" defaultActiveKey="1">
                          {getFieldValue('elements') !== undefined ? (
                            (getFieldValue(
                              getName('ctecalculationtype', elementID)
                            ) === undefined ||
                              getFieldValue(
                                getName('ctecalculationtype', elementID)
                              ) === 'LINEAR' ||
                              getFieldValue(
                                getName('ctecalculationtype', elementID)
                              ) === 'LINAMORT' ||
                              getFieldValue(
                                getName('ctecalculationtype', elementID)
                              ) === 'LOYFIX' ||
                              getFieldValue(
                                getName('ctecalculationtype', elementID)
                              ) === 'STEP' ||
                              getFieldValue(
                                getName('ctecalculationtype', elementID)
                              ) === 'PREFIN' ||
                              getFieldValue(
                                getName('ctecalculationtype', elementID)
                              ) === 'SEASON') &&
                            getFieldValue(['elements', 'FIN'])?.find(
                              (ele: any) =>
                                ele.cteid === getFieldValue('selectedElement')
                            ) ? (
                              <TabPane
                                key={1}
                                tab={<GetLabel label="Simplemode" />}
                              >
                                <Row>
                                  <Col xs={24} md={12}>
                                    <Card
                                      bordered
                                      type="inner"
                                      style={{ height: '100%' }}
                                    >
                                      <Row gutter={[8, 0]}>
                                        <Form.Item shouldUpdate noStyle>
                                          {({ getFieldValue }) => (
                                            <>
                                              {unlockCalculator && (
                                                <FormInput
                                                  col
                                                  md={1}
                                                  comcode="calculate"
                                                >
                                                  <Button
                                                    type="default"
                                                    icon={
                                                      <ICalculator
                                                        color={
                                                          calculatorStatusColor
                                                        }
                                                      />
                                                    }
                                                    size="middle"
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      debouncedCalculateNew(
                                                        '',
                                                        'FINANCING'
                                                      );
                                                    }}
                                                  />
                                                </FormInput>
                                              )}
                                              <FormInput
                                                col
                                                md={unlockCalculator ? 23 : 24}
                                                comcode="cteupfrontamount"
                                                name={getName(
                                                  'cteupfrontamount',
                                                  elementID
                                                )}
                                              >
                                                <SliderWithInputAndPercentage
                                                  currcode={getFieldValue(
                                                    'currcode'
                                                  )}
                                                  max={getFieldValue(
                                                    getHelper(
                                                      'upmax',
                                                      elementID
                                                    )
                                                  )}
                                                  min={getFieldValue(
                                                    getHelper(
                                                      'upmin',
                                                      elementID
                                                    )
                                                  )}
                                                  //defaultValue={100} //getFieldValue(['helpers', 'frdefault'])*getFieldValue('cteinvestamount')/100}
                                                  //value={100} //{getFieldValue(['helpers', 'frdefault'])*getFieldValue('cteinvestamount')/100}
                                                  basis={
                                                    getFieldValue('cttype') ===
                                                    'LEAD'
                                                      ? getFieldValue(
                                                          getName(
                                                            'cteinvestamount',
                                                            elementID
                                                          )
                                                        )
                                                      : getFieldValue(
                                                          'cttype'
                                                        ) === 'PART'
                                                      ? getFieldValue(
                                                          'ctsyndmgpartamount'
                                                        )
                                                      : getFieldValue(
                                                          getName(
                                                            'cteinvestamount',
                                                            elementID
                                                          )
                                                        )
                                                  }
                                                  step={1}
                                                  precisionAmount={2}
                                                  precisionCoef={5}
                                                  onChange={() =>
                                                    debouncedCalculateNew(
                                                      'UP',
                                                      'INST'
                                                    )
                                                  }
                                                />
                                              </FormInput>
                                            </>
                                          )}
                                        </Form.Item>
                                        <FormInput
                                          col
                                          xs={24}
                                          md={6}
                                          comcode="cteextracosttofinance"
                                          name={getName(
                                            'cteextracosttofinance',
                                            elementID
                                          )}
                                        >
                                          <InputCurrency
                                            currcode={getFieldValue('currcode')}
                                            onChange={() =>
                                              debouncedCalculateNew('', '')
                                            }
                                          />
                                        </FormInput>
                                        <FormInput
                                          col
                                          xs={24}
                                          md={18}
                                          comcode="cteextracostcomment"
                                          name={getName(
                                            'cteextracostcomment',
                                            elementID
                                          )}
                                        >
                                          <Input />
                                        </FormInput>
                                        {/*finamount*/}
                                        <Form.Item shouldUpdate noStyle>
                                          {({ getFieldValue }) => {
                                            const investamount = isNaN(
                                              getFieldValue(
                                                getName(
                                                  'cteinvestamount',
                                                  elementID
                                                )
                                              )
                                            )
                                              ? 0
                                              : getFieldValue(
                                                  getName(
                                                    'cteinvestamount',
                                                    elementID
                                                  )
                                                );

                                            const cteextracosttofinance = isNaN(
                                              getFieldValue(
                                                getName(
                                                  'cteextracosttofinance',
                                                  elementID
                                                )
                                              )
                                            )
                                              ? 0
                                              : getFieldValue(
                                                  getName(
                                                    'cteextracosttofinance',
                                                    elementID
                                                  )
                                                );

                                            const cteupfrontamount = isNaN(
                                              getFieldValue(
                                                getName(
                                                  'cteupfrontamount',
                                                  elementID
                                                )
                                              )
                                            )
                                              ? 0
                                              : getFieldValue(
                                                  getName(
                                                    'cteupfrontamount',
                                                    elementID
                                                  )
                                                );

                                            const ctepartmethod = getFieldValue(
                                              getName(
                                                'ctepartmethod',
                                                elementID
                                              )
                                            );

                                            var ctepartamount = 0;
                                            if (
                                              ctepartmethod === 'PROMO' ||
                                              ctepartmethod === 'REDUCEFIN' ||
                                              ctepartmethod === 'MULTI'
                                            ) {
                                              ctepartamount = isNaN(
                                                getFieldValue(
                                                  getName(
                                                    'ctepartamount',
                                                    elementID
                                                  )
                                                )
                                              )
                                                ? 0
                                                : getFieldValue(
                                                    getName(
                                                      'ctepartamount',
                                                      elementID
                                                    )
                                                  );
                                            }

                                            const finamount =
                                              investamount +
                                              cteextracosttofinance -
                                              cteupfrontamount -
                                              ctepartamount;

                                            return (
                                              <FormInput
                                                col
                                                //colStyle={{textAlign:'right', color: 'red' }}
                                                //labelstyle={{textAlign:'right', color: 'red' }}
                                                style={{
                                                  textAlign: 'right',
                                                  color: 'red',
                                                }}
                                                md={24}
                                                name={getName(
                                                  'ctefinancedamount',
                                                  elementID
                                                )}
                                                comcode="ctefinancedamount"
                                              >
                                                <Text
                                                  style={{
                                                    textAlign: 'right',
                                                    color: 'red',
                                                  }}
                                                >
                                                  {toCurrency(
                                                    finamount,
                                                    getFieldValue('currcode')
                                                  )}
                                                </Text>
                                              </FormInput>
                                            );
                                          }}
                                        </Form.Item>

                                        <Form.Item shouldUpdate noStyle>
                                          {({ getFieldValue }) => {
                                            return (
                                              <FormInput
                                                col
                                                md={6}
                                                comcode="ctevatdeferralmethod"
                                                name={getName(
                                                  'ctevatdeferralmethod',
                                                  elementID
                                                )}
                                              >
                                                <ParListSelect
                                                  parcode="VATDEFMETH"
                                                  offerid={getFieldValue(
                                                    'offerid'
                                                  )}
                                                  onSelected={(e) => {
                                                    if (e.value !== 'NONE') {
                                                      setVatDefferal(true);
                                                    } else {
                                                      setVatDefferal(false);
                                                    }
                                                    debouncedCalculateNew(
                                                      '',
                                                      ''
                                                    );
                                                  }}
                                                />
                                              </FormInput>
                                            );
                                          }}
                                        </Form.Item>

                                        <Form.Item shouldUpdate noStyle>
                                          {({ getFieldValue }) => {
                                            if (
                                              getFieldValue(
                                                getName(
                                                  'ctevatdeferralmethod',
                                                  elementID
                                                )
                                              ) !== 'NONE'
                                            ) {
                                              return (
                                                <>
                                                  <FormInput
                                                    col
                                                    xs={24}
                                                    md={8}
                                                    comcode="ctevatdeferralamount"
                                                    name={getName(
                                                      'ctevatdeferralamount',
                                                      elementID
                                                    )}
                                                  >
                                                    <InputCurrency
                                                      currcode={
                                                        localStorage.getItem(
                                                          'currcode'
                                                        ) ?? ''
                                                      }
                                                      onChange={() =>
                                                        debouncedCalculateNew(
                                                          '',
                                                          ''
                                                        )
                                                      }
                                                    />
                                                  </FormInput>
                                                  <FormInput
                                                    col
                                                    xs={24}
                                                    md={8}
                                                    comcode="ctevatdeferralduration"
                                                    name={getName(
                                                      'ctevatdeferralduration',
                                                      elementID
                                                    )}
                                                  >
                                                    <InputNumber
                                                      onChange={() =>
                                                        debouncedCalculateNew(
                                                          '',
                                                          ''
                                                        )
                                                      }
                                                    />
                                                  </FormInput>
                                                  <FormInput
                                                    col
                                                    xs={24}
                                                    md={8}
                                                    comcode="ctevatdeferraldaysbasis"
                                                    name={getName(
                                                      'ctevatdeferraldaysbasis',
                                                      elementID
                                                    )}
                                                  >
                                                    <ParListSelect
                                                      parcode="CALBASIS"
                                                      onChange={() =>
                                                        debouncedCalculateNew(
                                                          '',
                                                          ''
                                                        )
                                                      }
                                                    />
                                                  </FormInput>
                                                </>
                                              );
                                            } else {
                                              return null;
                                            }
                                          }}
                                        </Form.Item>

                                        <Form.Item shouldUpdate noStyle>
                                          {({ getFieldValue }) => {
                                            return (
                                              <FormInput
                                                col
                                                xs={24}
                                                md={12}
                                                name={getName(
                                                  'ctebilligdate',
                                                  elementID
                                                )}
                                              >
                                                <ParListSelect
                                                  parcode="BILLDATE"
                                                  offerid={getFieldValue(
                                                    'offerid'
                                                  )}
                                                  onSelected={() =>
                                                    debouncedCalculateNew(
                                                      '',
                                                      ''
                                                    )
                                                  }
                                                />
                                              </FormInput>
                                            );
                                          }}
                                        </Form.Item>

                                        <FormInput
                                          col
                                          xs={24}
                                          md={12}
                                          comcode="ctinitstartdate"
                                          name={getName(
                                            'ctestartdate',
                                            elementID
                                          )}
                                          //name="ctrequestdate"
                                        >
                                          <DatePicker
                                            style={{ width: '100%' }}
                                            onChange={() =>
                                              debouncedCalculateNew('', '')
                                            }
                                          />
                                          {/*<Input onChange={() => debouncedCalculateNew('','')} />*/}
                                        </FormInput>
                                        <Form.Item shouldUpdate noStyle>
                                          {({ getFieldValue }) => {
                                            return (
                                              <FormInput
                                                col
                                                xs={24}
                                                md={12}
                                                comcode="ctedeferredinterestmethod"
                                                name={getName(
                                                  'ctedeferredinterestmethod',
                                                  elementID
                                                )}
                                              >
                                                <ParListSelect
                                                  parcode="CTEDEFINT"
                                                  offerid={getFieldValue(
                                                    'offerid'
                                                  )}
                                                  onSelected={() =>
                                                    debouncedCalculateNew(
                                                      '',
                                                      ''
                                                    )
                                                  }
                                                />
                                              </FormInput>
                                            );
                                          }}
                                        </Form.Item>

                                        <FormInput
                                          col
                                          xs={24}
                                          md={6}
                                          comcode="ctedeferredinterestnominalrate"
                                          name={getName(
                                            'ctedeferredinterestnominalrate',
                                            elementID
                                          )}
                                        >
                                          <InputRate
                                            style={{ width: '100%' }}
                                            onChange={() =>
                                              debouncedCalculateNew('', '')
                                            }
                                            disabled={
                                              getFieldValue(
                                                getName(
                                                  'deferredinterestratetype',
                                                  elementID
                                                )
                                              ) !== 'FREE'
                                            }
                                          />
                                        </FormInput>
                                        <Form.Item
                                          shouldUpdate={shouldUpdateCompare(
                                            'currcode'
                                          )}
                                          noStyle
                                        >
                                          {({ getFieldValue }) => {
                                            return (
                                              <FormInput
                                                col
                                                xs={24}
                                                md={6}
                                                style={{ color: 'red' }}
                                                name={getName(
                                                  'ctedeferredinterest',
                                                  elementID
                                                )}
                                                comcode="ctedeferredinterest"
                                              >
                                                <Value
                                                  formatter={(value) =>
                                                    toCurrency(
                                                      value,
                                                      getFieldValue('currcode')
                                                    )
                                                  }
                                                />
                                              </FormInput>
                                            );
                                          }}
                                        </Form.Item>
                                        <Form.Item shouldUpdate noStyle>
                                          {({ getFieldValue }) => {
                                            return (
                                              <FormInput
                                                col
                                                xs={24}
                                                md={12}
                                                name={getName(
                                                  'ctedepositinterestmethod',
                                                  elementID
                                                )}
                                                comcode="ctedepositinterestmethod"
                                              >
                                                <ParListSelect
                                                  parcode="CTEDEPOINT"
                                                  offerid={getFieldValue(
                                                    'offerid'
                                                  )}
                                                  onSelected={() =>
                                                    debouncedCalculateNew(
                                                      '',
                                                      ''
                                                    )
                                                  }
                                                />
                                              </FormInput>
                                            );
                                          }}
                                        </Form.Item>

                                        <FormInput
                                          col
                                          xs={24}
                                          md={6}
                                          comcode="ctedepositnominalrate"
                                          name={getName(
                                            'ctedepositnominalrate',
                                            elementID
                                          )}
                                        >
                                          <InputRate
                                            style={{ width: '100%' }}
                                            disabled={
                                              getFieldValue(
                                                getName(
                                                  'depositratetype',
                                                  elementID
                                                )
                                              ) !== 'FREE'
                                            }
                                            onChange={() =>
                                              debouncedCalculateNew('', '')
                                            }
                                          />
                                        </FormInput>
                                        <Form.Item
                                          shouldUpdate={shouldUpdateCompare(
                                            'currcode'
                                          )}
                                          noStyle
                                        >
                                          {({ getFieldValue }) => {
                                            return (
                                              <FormInput
                                                style={{ color: 'red' }}
                                                col
                                                xs={24}
                                                md={6}
                                                name={getName(
                                                  'ctedepositinterest',
                                                  elementID
                                                )}
                                                //name='ctedepositinterest'
                                                comcode="ctedepositinterest"
                                              >
                                                <Value
                                                  formatter={(value) =>
                                                    toCurrency(
                                                      value,
                                                      getFieldValue('currcode')
                                                    )
                                                  }
                                                ></Value>
                                              </FormInput>
                                            );
                                          }}
                                        </Form.Item>
                                        <Form.Item shouldUpdate noStyle>
                                          {({ getFieldValue }) => (
                                            <FormInput
                                              col
                                              xs={24}
                                              md={24}
                                              comcode="ctedepositamount"
                                              name={getName(
                                                'ctedepositamount',
                                                elementID
                                              )}
                                            >
                                              <SliderWithInputAndPercentage
                                                currcode={getFieldValue(
                                                  'currcode'
                                                )}
                                                max={getFieldValue(
                                                  getName(
                                                    'ctedepositcoef',
                                                    elementID
                                                  )
                                                )}
                                                min={0}
                                                basis={getFieldValue(
                                                  getName(
                                                    'cteinvestamount',
                                                    elementID
                                                  )
                                                )}
                                                step={1}
                                                precisionAmount={2}
                                                precisionCoef={5}
                                                onChange={() =>
                                                  debouncedCalculateNew('', '')
                                                }
                                              />
                                            </FormInput>
                                          )}
                                        </Form.Item>

                                        <Form.Item shouldUpdate noStyle>
                                          {({ getFieldValue }) => {
                                            return (
                                              <FormInput
                                                col
                                                xs={24}
                                                md={12}
                                                name={getName(
                                                  'ctepartmethod',
                                                  elementID
                                                )}
                                                comcode="ctepartmethod"
                                              >
                                                <ParListSelect
                                                  parcode="CTEPARTMET"
                                                  offerid={getFieldValue(
                                                    'offerid'
                                                  )}
                                                  onSelected={() =>
                                                    debouncedCalculateNew(
                                                      '',
                                                      ''
                                                    )
                                                  }
                                                />
                                              </FormInput>
                                            );
                                          }}
                                        </Form.Item>
                                        <Form.Item
                                          shouldUpdate={shouldUpdateCompare(
                                            'currcode'
                                          )}
                                          noStyle
                                        >
                                          {({ getFieldValue }) => {
                                            return (
                                              <>
                                                {unlockCalculator && (
                                                  <FormInput
                                                    col
                                                    md={1}
                                                    comcode="calculate"
                                                  >
                                                    <Button
                                                      type="default"
                                                      icon={
                                                        <ICalculator
                                                          color={
                                                            calculatorStatusColor
                                                          }
                                                        />
                                                      }
                                                      size="middle"
                                                      onClick={(e) => {
                                                        e.stopPropagation();
                                                        debouncedCalculateNew(
                                                          '',
                                                          'PART'
                                                        );
                                                      }}
                                                    />
                                                  </FormInput>
                                                )}

                                                <InputCurrency
                                                  col
                                                  md={unlockCalculator ? 5 : 6}
                                                  comcode="ctepartamount"
                                                  currcode={getFieldValue(
                                                    'currcode'
                                                  )}
                                                  disabled={
                                                    getFieldValue(
                                                      getName(
                                                        'ctepartmethod',
                                                        elementID
                                                      )
                                                    ) === 'POURC'
                                                  }
                                                  onChange={() =>
                                                    debouncedCalculateNew(
                                                      'PARTAMOUNT',
                                                      'INST'
                                                    )
                                                  }
                                                  fieldname={getName(
                                                    'ctepartamount',
                                                    elementID
                                                  )}
                                                />
                                              </>
                                            );
                                          }}
                                        </Form.Item>
                                        <FormInput
                                          col
                                          xs={24}
                                          md={6}
                                          comcode="ctepartrate"
                                          name={getName(
                                            'ctepartrate',
                                            elementID
                                          )}
                                        >
                                          <InputRate
                                            style={{ width: '100%' }}
                                            onChange={() =>
                                              debouncedCalculateNew(
                                                'PARTRATE',
                                                'INST'
                                              )
                                            }
                                            disabled={
                                              getFieldValue(
                                                getName(
                                                  'ctepartmethod',
                                                  elementID
                                                )
                                              ) === 'FIXED'
                                            }
                                          />
                                        </FormInput>
                                        <InputCurrency
                                          col
                                          md={12}
                                          comcode="ctefeesamount"
                                          currcode={getFieldValue('currcode')}
                                          onChange={() =>
                                            debouncedCalculateNew('', 'INST')
                                          }
                                          fieldname={getName(
                                            'ctefeesamount',
                                            elementID
                                          )}
                                        />
                                        {unlockCalculator && (
                                          <FormInput
                                            col
                                            md={1}
                                            comcode="calculate"
                                          >
                                            <Button
                                              type="default"
                                              icon={
                                                <ICalculator
                                                  color={calculatorStatusColor}
                                                />
                                              }
                                              size="middle"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                debouncedCalculateNew(
                                                  '',
                                                  'COMM'
                                                );
                                              }}
                                            />
                                          </FormInput>
                                        )}

                                        <InputCurrency
                                          col
                                          md={unlockCalculator ? 11 : 12}
                                          comcode="ctecommissionamount"
                                          currcode={getFieldValue('currcode')}
                                          onChange={() =>
                                            debouncedCalculateNew('', 'INST')
                                          }
                                          fieldname={getName(
                                            'ctecommissionamount',
                                            elementID
                                          )}
                                        />
                                      </Row>
                                    </Card>
                                  </Col>

                                  <Col xs={24} md={12}>
                                    <Card
                                      bordered
                                      type="inner"
                                      style={{ height: '100%' }}
                                    >
                                      <Row gutter={[8, 0]}>
                                        <Form.Item shouldUpdate noStyle>
                                          {({ getFieldValue }) => (
                                            <>
                                              {unlockCalculator && (
                                                <FormInput
                                                  col
                                                  md={1}
                                                  comcode="calculate"
                                                >
                                                  <Button
                                                    type="default"
                                                    icon={
                                                      <ICalculator
                                                        color={
                                                          calculatorStatusColor
                                                        }
                                                      />
                                                    }
                                                    size="middle"
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      debouncedCalculateNew(
                                                        '',
                                                        'DURATION'
                                                      );
                                                    }}
                                                  />
                                                </FormInput>
                                              )}

                                              <FormInput
                                                col
                                                md={unlockCalculator ? 19 : 20}
                                                comcode="cteduration"
                                                name={getName(
                                                  'cteduration',
                                                  elementID
                                                )}
                                              >
                                                <SliderWithInput
                                                  max={getFieldValue(
                                                    getHelper(
                                                      'durationmax',
                                                      elementID
                                                    )
                                                  )}
                                                  min={getFieldValue(
                                                    getHelper(
                                                      'durationmin',
                                                      elementID
                                                    )
                                                  )}
                                                  contextmin={getFieldValue(
                                                    getHelper(
                                                      'durationcontextmin',
                                                      elementID
                                                    )
                                                  )}
                                                  contextmax={getFieldValue(
                                                    getHelper(
                                                      'durationcontextmax',
                                                      elementID
                                                    )
                                                  )}
                                                  precision={0}
                                                  onChange={
                                                    (e) =>
                                                      loadOfferWithnewDuration(
                                                        Number(e) ?? 0
                                                      )
                                                    //debouncedCalculateNew('', '')
                                                  }
                                                />
                                              </FormInput>
                                            </>
                                          )}
                                        </Form.Item>
                                        <FormInput xl={4} comcode="more">
                                          <MoreButton
                                            comcode="more"
                                            onClick={(e) =>
                                              setDisplayTerm(!displayTerm)
                                            }
                                          ></MoreButton>
                                        </FormInput>
                                        {displayTerm && (
                                          <>
                                            <Form.Item shouldUpdate noStyle>
                                              {({ getFieldValue }) => {
                                                return (
                                                  <FormInput
                                                    col
                                                    xs={8}
                                                    name={getName(
                                                      'cteperiodicity',
                                                      elementID
                                                    )}
                                                  >
                                                    <ParListSelect
                                                      parcode="PERIOD"
                                                      onSelected={() =>
                                                        debouncedCalculateNew(
                                                          '',
                                                          'INST'
                                                        )
                                                      }
                                                    />
                                                  </FormInput>
                                                );
                                              }}
                                            </Form.Item>
                                            <Form.Item shouldUpdate noStyle>
                                              <FormInput
                                                col
                                                xs={8}
                                                name={getName(
                                                  'cteunit',
                                                  elementID
                                                )}
                                              >
                                                <ParListSelect
                                                  parcode="UNIT"
                                                  onSelected={() =>
                                                    debouncedCalculateNew(
                                                      '',
                                                      ''
                                                    )
                                                  }
                                                />
                                              </FormInput>
                                            </Form.Item>
                                            <Form.Item shouldUpdate noStyle>
                                              <FormInput
                                                col
                                                xs={8}
                                                name={getName(
                                                  'ctepaymentterm',
                                                  elementID
                                                )}
                                              >
                                                <ParListSelect
                                                  parcode="TERM"
                                                  onChange={() =>
                                                    debouncedCalculateNew(
                                                      '',
                                                      ''
                                                    )
                                                  }
                                                />
                                              </FormInput>
                                            </Form.Item>
                                          </>
                                        )}
                                        <Form.Item shouldUpdate noStyle>
                                          {({ getFieldValue }) => (
                                            <FormInput
                                              col
                                              xs={24}
                                              md={24}
                                              comcode="ctegraceperiodduration"
                                              name={getName(
                                                'ctegraceperiodduration',
                                                elementID
                                              )}
                                            >
                                              <SliderWithInput
                                                max={getFieldValue(
                                                  getHelper('gpmax', elementID)
                                                )}
                                                min={getFieldValue(
                                                  getHelper('gpmin', elementID)
                                                )}
                                                precision={0}
                                                onChange={() =>
                                                  debouncedCalculateNew('', '')
                                                }
                                              />
                                            </FormInput>
                                          )}
                                        </Form.Item>

                                        <Form.Item shouldUpdate noStyle>
                                          {({ getFieldValue }) => (
                                            <FormInput
                                              col
                                              xs={24}
                                              md={24}
                                              comcode="ctefirstpayment"
                                              name={getName(
                                                'ctefirstpayment',
                                                elementID
                                              )}
                                            >
                                              <SliderWithInputAndPercentage
                                                currcode={getFieldValue(
                                                  'currcode'
                                                )}
                                                max={getFieldValue(
                                                  getHelper('frmax', elementID)
                                                )}
                                                min={getFieldValue(
                                                  getHelper('frmin', elementID)
                                                )}
                                                contextmin={getFieldValue(
                                                  getHelper(
                                                    'frcontextmin',
                                                    elementID
                                                  )
                                                )}
                                                contextmax={getFieldValue(
                                                  getHelper(
                                                    'frcontextmax',
                                                    elementID
                                                  )
                                                )}
                                                //defaultValue={100} //getFieldValue(['helpers', 'frdefault'])*getFieldValue('cteinvestamount')/100}
                                                //value={100} //{getFieldValue(['helpers', 'frdefault'])*getFieldValue('cteinvestamount')/100}
                                                basis={
                                                  getFieldValue('cttype') ===
                                                  'LEAD'
                                                    ? getFieldValue(
                                                        getName(
                                                          'cteinvestamount',
                                                          elementID
                                                        )
                                                      )
                                                    : getFieldValue(
                                                        'cttype'
                                                      ) === 'PART'
                                                    ? getFieldValue(
                                                        'ctsyndmgpartamount'
                                                      )
                                                    : getFieldValue(
                                                        getName(
                                                          'cteinvestamount',
                                                          elementID
                                                        )
                                                      )
                                                }
                                                step={1}
                                                precisionAmount={2}
                                                precisionCoef={5}
                                                onChange={() =>
                                                  debouncedCalculateNew(
                                                    'FP',
                                                    'INST'
                                                  )
                                                }
                                              />
                                            </FormInput>
                                          )}
                                        </Form.Item>
                                        <Form.Item shouldUpdate noStyle>
                                          {({ getFieldValue }) => (
                                            <>
                                              {unlockCalculator && (
                                                <FormInput
                                                  col
                                                  md={1}
                                                  comcode="calculate"
                                                >
                                                  <Button
                                                    type="default"
                                                    icon={
                                                      <ICalculator
                                                        color={
                                                          calculatorStatusColor
                                                        }
                                                      />
                                                    }
                                                    size="middle"
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      debouncedCalculateNew(
                                                        '',
                                                        'OUTSTAND'
                                                      );
                                                    }}
                                                  />
                                                </FormInput>
                                              )}

                                              <FormInput
                                                col
                                                md={unlockCalculator ? 23 : 24}
                                                comcode="ctervamount"
                                                name={getName(
                                                  'ctervamount',
                                                  elementID
                                                )}
                                              >
                                                <SliderWithInputAndPercentage
                                                  currcode={getFieldValue(
                                                    'currcode'
                                                  )}
                                                  max={getFieldValue(
                                                    getHelper(
                                                      'rvmax',
                                                      elementID
                                                    )
                                                  )}
                                                  min={getFieldValue(
                                                    getHelper(
                                                      'rvmin',
                                                      elementID
                                                    )
                                                  )}
                                                  contextmin={getFieldValue(
                                                    getHelper(
                                                      'rvcontextmin',
                                                      elementID
                                                    )
                                                  )}
                                                  contextmax={getFieldValue(
                                                    getHelper(
                                                      'rvcontextmax',
                                                      elementID
                                                    )
                                                  )}
                                                  basis={
                                                    getFieldValue('cttype') ===
                                                    'LEAD'
                                                      ? getFieldValue(
                                                          getName(
                                                            'cteinvestamount',
                                                            elementID
                                                          )
                                                        )
                                                      : getFieldValue(
                                                          'cttype'
                                                        ) === 'PART'
                                                      ? getFieldValue(
                                                          'ctsyndmgpartamount'
                                                        )
                                                      : getFieldValue(
                                                          getName(
                                                            'cteinvestamount',
                                                            elementID
                                                          )
                                                        )
                                                  }
                                                  step={1}
                                                  precisionAmount={2}
                                                  precisionCoef={5}
                                                  onChange={() =>
                                                    debouncedCalculateNew(
                                                      'RV',
                                                      'INST'
                                                    )
                                                  }
                                                />
                                              </FormInput>
                                            </>
                                          )}
                                        </Form.Item>
                                        <Form.Item
                                          shouldUpdate={shouldUpdateCompare(
                                            'currcode'
                                          )}
                                          noStyle
                                        >
                                          {({ getFieldValue }) => {
                                            return (
                                              <FormInput
                                                style={{ color: 'red' }}
                                                col
                                                xs={24}
                                                md={10}
                                                comcode="cteinstallmentamount"
                                                name={getName(
                                                  'cteinstallmentamount',
                                                  elementID
                                                )}
                                              >
                                                {unlockCalculator ? (
                                                  <InputCurrency
                                                    col
                                                    md={10}
                                                    currcode={getFieldValue(
                                                      'currcode'
                                                    )}
                                                  />
                                                ) : (
                                                  <Value
                                                    formatter={(value) =>
                                                      toCurrency(
                                                        value,
                                                        getFieldValue(
                                                          'currcode'
                                                        )
                                                      )
                                                    }
                                                  ></Value>
                                                )}
                                              </FormInput>
                                            );
                                          }}
                                        </Form.Item>
                                        <FormInput col md={4} comcode="unlock">
                                          <ButtonAction
                                            icon={
                                              unlockCalculator === true ? (
                                                <UnlockTwoTone twoToneColor="#52c41a" />
                                              ) : (
                                                <LockTwoTone twoToneColor="red" />
                                              )
                                            }
                                            onlyIcon
                                            onClick={() =>
                                              setunlockCalculator(
                                                !unlockCalculator
                                              )
                                            }
                                          />
                                        </FormInput>
                                        <Form.Item
                                          shouldUpdate={shouldUpdateCompare(
                                            'currcode'
                                          )}
                                          noStyle
                                        >
                                          {({ getFieldValue }) => {
                                            return (
                                              <FormInput
                                                style={{ color: 'blue' }}
                                                col
                                                xs={24}
                                                md={10}
                                                name={getName(
                                                  'cterentalamount',
                                                  elementID
                                                )}
                                                comcode="cterentalamount"
                                              >
                                                <Value
                                                  formatter={(value) =>
                                                    toCurrency(
                                                      value,
                                                      getFieldValue('currcode')
                                                    )
                                                  }
                                                ></Value>
                                              </FormInput>
                                            );
                                          }}
                                        </Form.Item>

                                        <Form.Item shouldUpdate noStyle>
                                          {({ getFieldValue }) => (
                                            <>
                                              {unlockCalculator && (
                                                <FormInput
                                                  col
                                                  md={1}
                                                  comcode="calculate"
                                                >
                                                  <Button
                                                    type="default"
                                                    icon={
                                                      <ICalculator
                                                        color={
                                                          calculatorStatusColor
                                                        }
                                                      />
                                                    }
                                                    size="middle"
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      debouncedCalculateNew(
                                                        '',
                                                        'RATE'
                                                      );
                                                    }}
                                                  />
                                                </FormInput>
                                              )}

                                              <FormInput
                                                col
                                                md={unlockCalculator ? 19 : 20}
                                                comcode="ctenominalrate"
                                                name={getName(
                                                  'ctenominalrate',
                                                  elementID
                                                )}
                                              >
                                                <SliderWithInput
                                                  max={getFieldValue(
                                                    getHelper(
                                                      'ratemax',
                                                      elementID
                                                    )
                                                  )}
                                                  min={getFieldValue(
                                                    getHelper(
                                                      'ratemin',
                                                      elementID
                                                    )
                                                  )}
                                                  contextmin={getFieldValue(
                                                    getHelper(
                                                      'ratecontextmin',
                                                      elementID
                                                    )
                                                  )}
                                                  contextmax={getFieldValue(
                                                    getHelper(
                                                      'ratecontextmax',
                                                      elementID
                                                    )
                                                  )}
                                                  step={0.001}
                                                  precision={5}
                                                  widthInput={5}
                                                  onChange={() => {
                                                    setIsLoading(true);
                                                    debouncedCalculateNew(
                                                      '',
                                                      ''
                                                    );
                                                  }}
                                                />
                                              </FormInput>
                                            </>
                                          )}
                                        </Form.Item>

                                        <FormInput
                                          col
                                          xs={24}
                                          md={4}
                                          name={getName(
                                            'cteactuarialrate',
                                            elementID
                                          )}
                                          comcode="cteactuarialrate"
                                        >
                                          <InputRate
                                            style={{ width: '100%' }}
                                            disabled
                                          />
                                        </FormInput>
                                        <Divider />
                                        {getFieldValue('prcode') !==
                                          'REFIN' && (
                                          <>
                                            <FormInput
                                              col
                                              md={12}
                                              name={getName(
                                                'ctridrefin',
                                                elementID
                                              )}
                                              comcode="ctridrefin"
                                            >
                                              <ProposalSelect
                                                onlyctrid
                                                prcode="REFIN"
                                                ctstatus="VALID"
                                                onSelected={(e: any) => {                                                        
                                                  const financedAmount = form.getFieldValue('ctfinancedamount');
                                                  const availablemaount= e.values?.mfavailableamount;
                                                  console.log('e',e,'--',financedAmount , '--',availablemaount)
                                                  if ( availablemaount && (financedAmount > availablemaount)) {
                                                    notification.error({
                                                      message: 'The available amount is less than the financed amount',
                                                    });
                                                    return;
                                                  }else{
                                                    
                                                    form.setFieldValue(
                                                      getName(
                                                        'ctefundingrate',
                                                        elementID
                                                      ),
                                                      e.values
                                                        .ctenominalrate
                                                    );
                                                    form.setFieldValue(
                                                      getName(
                                                        'cteidrefin',
                                                        elementID
                                                      ),
                                                      e.values.cteid
                                                    );
                                                    form.setFieldValue(
                                                      getName(
                                                        'ctridrefin',
                                                        elementID
                                                      ),
                                                      e
                                                    );
                                                    setIsLoading(true);
                                                    debouncedCalculateNew(
                                                      '',
                                                      ''
                                                    );
                                                  }
                                                }}
                                              />
                                            </FormInput>
                                            <Col span={12} />
                                          </>
                                        )}

                                        <FormInput
                                          col
                                          xs={24}
                                          md={6}
                                          name={getName(
                                            'ctefundingrate',
                                            elementID
                                          )}
                                          comcode="ctefundingrate"
                                        >
                                          <InputRate
                                            onChange={() => {
                                              setIsLoading(true);
                                              debouncedCalculateNew('', '');
                                            }}
                                          />
                                        </FormInput>
                                        <FormInput
                                          col
                                          xs={24}
                                          md={4}
                                          name={getName(
                                            'cteprofitabilityrate',
                                            elementID
                                          )}
                                          comcode="cteprofitabilityrate"
                                        >
                                          <InputRate />
                                        </FormInput>
                                        <Col span={4} />
                                        <FormInput
                                          col
                                          xs={24}
                                          md={4}
                                          name={getName(
                                            'cteflatrate',
                                            elementID
                                          )}
                                          comcode="cteflatrate"
                                        >
                                          <Value formatter={toRate} />
                                        </FormInput>
                                        <FormInput
                                          col
                                          xs={24}
                                          md={4}
                                          name={getName(
                                            'ctecoefrate',
                                            elementID
                                          )}
                                          comcode="ctecoefrate"
                                        >
                                          <Value formatter={toRate} />
                                        </FormInput>
                                        <FormInput
                                          col
                                          xs={24}
                                          md={4}
                                          name={getName(
                                            'cteaprrate',
                                            elementID
                                          )}
                                          comcode="cteaprrate"
                                        >
                                          <Value formatter={toRate} />
                                        </FormInput>
                                        <FormInput
                                          col
                                          xs={24}
                                          md={8}
                                          name={getName(
                                            'totalFundingInterest',
                                            elementID
                                          )}
                                          comcode="totalFundingInterest"
                                        >
                                          <Value
                                            formatter={(value) =>
                                              toCurrency(
                                                value,
                                                form.getFieldValue('currcode')
                                              )
                                            }
                                          />
                                        </FormInput>

                                        <FormInput
                                          col
                                          xs={24}
                                          md={8}
                                          name={getName(
                                            'totalInterest',
                                            elementID
                                          )}
                                          comcode="totalInterest"
                                        >
                                          <Value
                                            formatter={(value) =>
                                              toCurrency(
                                                value,
                                                form.getFieldValue('currcode')
                                              )
                                            }
                                          />
                                        </FormInput>

                                        <FormInput
                                          col
                                          xs={24}
                                          md={8}
                                          name={getName(
                                            'totalRental',
                                            elementID
                                          )}
                                          comcode="totalRental"
                                        >
                                          <Value
                                            formatter={(value) =>
                                              toCurrency(
                                                value,
                                                form.getFieldValue('currcode')
                                              )
                                            }
                                          />
                                        </FormInput>
                                        <Divider />
                                        <FormInput
                                          col
                                          xs={24}
                                          md={4}
                                          name={getName(
                                            'ctemarginrate',
                                            elementID
                                          )}
                                          comcode="ctemarginrate"
                                        >
                                          <Value formatter={toRate} />
                                        </FormInput>
                                        <FormInput
                                          col
                                          xs={24}
                                          md={6}
                                          name={getName('marginmin', elementID)}
                                          comcode="marginmin"
                                        >
                                          <Text>
                                            {toRate(
                                              getFieldValue(
                                                getHelper(
                                                  'margincontextmin',
                                                  elementID
                                                )
                                              )
                                            )}
                                          </Text>
                                        </FormInput>
                                        <FormInput
                                          col
                                          xs={24}
                                          md={12}
                                          name={getName(
                                            'ctemarginamount',
                                            elementID
                                          )}
                                          comcode="ctemarginamount"
                                        >
                                          <Value
                                            formatter={(value) =>
                                              toCurrency(
                                                value,
                                                form.getFieldValue('currcode')
                                              )
                                            }
                                          />
                                        </FormInput>

                                        <FormInput
                                          col
                                          xs={24}
                                          md={4}
                                          name={getName('dgo', elementID)}
                                          comcode="dgo"
                                        >
                                          <Value
                                            formatter={(value) =>
                                              toCurrency(
                                                value,
                                                form.getFieldValue('currcode')
                                              )
                                            }
                                          />
                                        </FormInput>
                                      </Row>
                                    </Card>
                                  </Col>
                                </Row>
                              </TabPane>
                            ) : null
                          ) : null}

                          {getFieldValue('elements') !== undefined ? (
                            getFieldValue(['elements', 'FIN'])?.find(
                              (ele: any) =>
                                ele.cteid === getFieldValue('selectedElement')
                            ) ? (
                              <TabPane
                                key={2}
                                tab={<GetLabel label="Advancedmode" />}
                              >
                                <Tabs
                                  animated
                                  tabPosition="top"
                                  defaultActiveKey="21"
                                >
                                  <TabPane
                                    tab={<GetLabel label="tabGeneralData" />}
                                    key={21}
                                  >
                                    <div style={{ padding: 5 }}>
                                      <Card
                                        bordered
                                        title={
                                          <Title
                                            level={4}
                                            comcode="CalculationMethod"
                                          ></Title>
                                        }
                                      >
                                        <Row>
                                          <Form.Item shouldUpdate noStyle>
                                            <FormInput
                                              col
                                              lg={6}
                                              comcode="ctecategory"
                                              name={getName(
                                                'ctecategory',
                                                elementID
                                              )}
                                            >
                                              <ParListSelect parcode="CTEFIN" />
                                            </FormInput>
                                          </Form.Item>

                                          <Form.Item shouldUpdate noStyle>
                                            <FormInput
                                              col
                                              xs={6}
                                              comcode="ctecalculationtype"
                                              name={getName(
                                                'ctecalculationtype',
                                                elementID
                                              )}
                                            >
                                              <ParListSelect
                                                parcode="CALMETHOD"
                                                onSelect={() =>
                                                  clearElementsstep(
                                                    getFieldValue(
                                                      'selectedElement'
                                                    )
                                                  )
                                                }
                                              />
                                            </FormInput>
                                          </Form.Item>

                                          <FormInput
                                            col
                                            xs={6}
                                            comcode="ctedescription"
                                            name={getName(
                                              'ctedescription',
                                              elementID
                                            )}
                                          >
                                            <Input />
                                          </FormInput>

                                          <FormInput
                                            col
                                            xs={6}
                                            name={getName(
                                              'ctecalculationbasis',
                                              elementID
                                            )}
                                            comcode="ctecalculationbasis"
                                          >
                                            <ParListSelect parcode="CALBASIS" />
                                          </FormInput>
                                        </Row>
                                        <Row gutter={[8, 8]}>
                                          <FormInput
                                            col
                                            xs={6}
                                            comcode="ctestartdate"
                                            name={getName(
                                              'ctestartdate',
                                              elementID
                                            )}
                                          >
                                            <DatePicker
                                              onChange={() =>
                                                debouncedCalculateNew('', '')
                                              }
                                            />
                                          </FormInput>
                                          <FormInput
                                            col
                                            xs={6}
                                            comcode="cteenddate"
                                            name={getName(
                                              'cteenddate',
                                              elementID
                                            )}
                                          >
                                            <DatePicker />
                                          </FormInput>

                                          <Form.Item shouldUpdate noStyle>
                                            {({ getFieldValue }) => (
                                              <FormInput
                                                col
                                                xs={6}
                                                comcode="taxcode"
                                                name={getName(
                                                  'taxcode',
                                                  elementID
                                                )}
                                              >
                                                <TaxSelect taxflow="INOUT" />
                                              </FormInput>
                                            )}
                                          </Form.Item>

                                          <Form.Item shouldUpdate noStyle>
                                            {({ getFieldValue }) => (
                                              <FormInput
                                                col
                                                xs={6}
                                                comcode="currcode"
                                                name={getName(
                                                  'currcode',
                                                  elementID
                                                )}
                                              >
                                                <ParListSelect parcode="CURRENCY" />
                                              </FormInput>
                                            )}
                                          </Form.Item>
                                        </Row>

                                        <Row gutter={[8, 8]}>
                                          <FormInput
                                            col
                                            xs={6}
                                            name={getName(
                                              'ctefinancedamount',
                                              elementID
                                            )}
                                            comcode="ctefinancedamount"
                                          >
                                            <InputCurrency
                                              currcode={form.getFieldValue(
                                                'currcode'
                                              )}
                                            />
                                          </FormInput>

                                          <FormInput
                                            col
                                            xs={6}
                                            name={getName(
                                              'ctervamount',
                                              elementID
                                            )}
                                            comcode="ctervamount"
                                          >
                                            <InputCurrency
                                              currcode={form.getFieldValue(
                                                'currcode'
                                              )}
                                            />
                                          </FormInput>

                                          <FormInput
                                            col
                                            xs={6}
                                            name={getName(
                                              'ctestatuslabel',
                                              elementID
                                            )}
                                            comcode="ctestatuslabel"
                                          >
                                            <Value
                                              style={{ fontWeight: 'bold' }}
                                            />
                                          </FormInput>

                                          <FormInput
                                            col
                                            xs={6}
                                            name={getName(
                                              'cteduration',
                                              elementID
                                            )}
                                            comcode="cteduration"
                                          >
                                            <Value
                                              style={{ fontWeight: 'bold' }}
                                            />
                                          </FormInput>
                                        </Row>
                                      </Card>
                                    </div>

                                    <div style={{ padding: 5 }}>
                                      <Tabs
                                        animated
                                        tabPosition="top"
                                        defaultActiveKey="33"
                                      >
                                        <TabPane
                                          tab={<GetLabel label="tabPrefin" />}
                                          key={33}
                                        >
                                          <Card>
                                            <Row gutter={[8, 8]}>
                                              <Col span={6}>
                                                <Form.Item shouldUpdate noStyle>
                                                  {({ getFieldValue }) => (
                                                    <FormInput
                                                      col
                                                      xs={24}
                                                      name={getName(
                                                        'prefinmethod',
                                                        elementID
                                                      )}
                                                      comcode="prefinmethod"
                                                    >
                                                      <ParListSelect
                                                        parcode="PREFINMET"
                                                        // parvalueparent={getFieldValue('prefinmethod')}
                                                      />
                                                    </FormInput>
                                                  )}
                                                </Form.Item>
                                              </Col>

                                              <Col span={6}>
                                                <Form.Item shouldUpdate noStyle>
                                                  {({ getFieldValue }) => (
                                                    <FormInput
                                                      col
                                                      xs={24}
                                                      name={getName(
                                                        'prefinbasis',
                                                        elementID
                                                      )}
                                                      comcode="prefinbasis"
                                                    >
                                                      <ParListSelect parcode="PREFINBAS" />
                                                    </FormInput>
                                                  )}
                                                </Form.Item>
                                              </Col>
                                              <Col span={6}>
                                                <Form.Item shouldUpdate noStyle>
                                                  {({ getFieldValue }) => (
                                                    <FormInput
                                                      col
                                                      xs={24}
                                                      name={getName(
                                                        'prefinperiodicity',
                                                        elementID
                                                      )}
                                                      comcode="prefinperiodicity"
                                                    >
                                                      <ParListSelect
                                                        parcode="PREFINPER"
                                                        // parvalueparent={getFieldValue('prefinperiodicity')}
                                                      />
                                                    </FormInput>
                                                  )}
                                                </Form.Item>
                                              </Col>
                                            </Row>

                                            <Row gutter={[8, 8]}>
                                              <Col span={6}>
                                                <Form.Item shouldUpdate noStyle>
                                                  {({ getFieldValue }) => (
                                                    <FormInput
                                                      col
                                                      xs={24}
                                                      name={getName(
                                                        'prefinratetype',
                                                        elementID
                                                      )}
                                                      comcode="prefinratetype"
                                                    >
                                                      <ParListSelect parcode="RATETYPE" />
                                                    </FormInput>
                                                  )}
                                                </Form.Item>
                                              </Col>
                                              <Col span={6}>
                                                <Form.Item shouldUpdate noStyle>
                                                  {({ getFieldValue }) => {
                                                    return (
                                                      <FormInput
                                                        col
                                                        xs={24}
                                                        name={getName(
                                                          'prefinrateformula',
                                                          elementID
                                                        )}
                                                        comcode="prefinrateformula"
                                                      >
                                                        <RateFormulaSelect
                                                          params={{
                                                            formulatype:
                                                              getFieldValue(
                                                                getName(
                                                                  'prefinratetype',
                                                                  elementID
                                                                )
                                                              ),
                                                          }}
                                                          onSelected={(val) => {
                                                            handleselectformula(
                                                              val?.ratevalue +
                                                                val?.rateriskcost +
                                                                val?.ratespread,
                                                              'prefin',
                                                              val
                                                            );
                                                            debouncedCalculateNew(
                                                              '',
                                                              ''
                                                            );
                                                          }}
                                                        />
                                                      </FormInput>
                                                    );
                                                  }}
                                                </Form.Item>
                                              </Col>
                                              <Col span={3}>
                                                <FormItem shouldUpdate>
                                                  {({ getFieldValue }) => {
                                                    return (
                                                      <FormInput
                                                        col
                                                        xs={24}
                                                        name={getName(
                                                          'prefinrateref',
                                                          elementID
                                                        )}
                                                        comcode="prefinrateref"
                                                      >
                                                        <Value
                                                          formatter={() =>
                                                            toRate(
                                                              getFieldValue(
                                                                getName(
                                                                  'prefinrateref',
                                                                  elementID
                                                                )
                                                              ) as any
                                                            )
                                                          }
                                                        />
                                                      </FormInput>
                                                    );
                                                  }}
                                                </FormItem>
                                              </Col>
                                              <Col span={3}>
                                                <FormInput
                                                  col
                                                  xs={24}
                                                  name={getName(
                                                    'prefinratespread',
                                                    elementID
                                                  )}
                                                  comcode="prefinratespread"
                                                >
                                                  <InputRate
                                                    onChange={(val) => {
                                                      handleratespread(
                                                        val,
                                                        'prefin'
                                                      );
                                                      debouncedCalculateNew(
                                                        '',
                                                        ''
                                                      );
                                                    }}
                                                  />
                                                </FormInput>
                                              </Col>

                                              <Col span={3}>
                                                <FormItem shouldUpdate>
                                                  {({ getFieldValue }) => {
                                                    return (
                                                      <FormInput
                                                        col
                                                        xs={24}
                                                        name={getName(
                                                          'prefinnominalrate',
                                                          elementID
                                                        )}
                                                        comcode="prefinnominalrate"
                                                      >
                                                        <InputRate
                                                          value={getFieldValue(
                                                            getName(
                                                              'prefinnominalrate',
                                                              elementID
                                                            )
                                                          )}
                                                        />
                                                      </FormInput>
                                                    );
                                                  }}
                                                </FormItem>
                                              </Col>
                                            </Row>

                                            <Row gutter={[8, 8]}>
                                              <FormInput
                                                col
                                                xs={6}
                                                name={getName(
                                                  'payrefrence',
                                                  elementID
                                                )}
                                                comcode="payrefrence"
                                              >
                                                <ModalControllerNV
                                                  content={({
                                                    setVisible,
                                                    visible,
                                                  }) => (
                                                    <a
                                                      onClick={() =>
                                                        setVisible(true)
                                                      }
                                                    >
                                                      {form.getFieldValue(
                                                        getName(
                                                          'payrefrence',
                                                          elementID
                                                        )
                                                      )}
                                                    </a>
                                                  )}
                                                  modal={({
                                                    setVisible,
                                                    visible,
                                                  }) => (
                                                    <PayementModal
                                                      payid={form.getFieldValue(
                                                        getName(
                                                          'payid',
                                                          elementID
                                                        )
                                                      )}
                                                      showAsModal
                                                      hideButtons
                                                      visible={visible}
                                                      onCancel={() =>
                                                        setVisible(false)
                                                      }
                                                      onSuccess={() =>
                                                        setVisible(false)
                                                      }
                                                    />
                                                  )}
                                                />
                                              </FormInput>

                                              <FormInput
                                                col
                                                xs={6}
                                                name={getName(
                                                  'payreimbreference',
                                                  elementID
                                                )}
                                                comcode="payreimbreference"
                                              >
                                                <ModalControllerNV
                                                  content={({
                                                    setVisible,
                                                    visible,
                                                  }) => (
                                                    <a
                                                      onClick={() =>
                                                        setVisible(true)
                                                      }
                                                    >
                                                      {form.getFieldValue(
                                                        getName(
                                                          'payreimbreference',
                                                          elementID
                                                        )
                                                      )}
                                                    </a>
                                                  )}
                                                  modal={({
                                                    setVisible,
                                                    visible,
                                                  }) => (
                                                    <PayementModal
                                                      payid={form.getFieldValue(
                                                        getName(
                                                          'payidreimbursment',
                                                          elementID
                                                        )
                                                      )}
                                                      showAsModal
                                                      hideButtons
                                                      visible={visible}
                                                      onCancel={() =>
                                                        setVisible(false)
                                                      }
                                                      onSuccess={() =>
                                                        setVisible(false)
                                                      }
                                                    />
                                                  )}
                                                />
                                              </FormInput>

                                              <Row gutter={10}>
                                                <Form.Item shouldUpdate noStyle>
                                                  {({ getFieldValue }) => {
                                                    return (
                                                      <FormInput
                                                        col
                                                        xs={24}
                                                        md={6}
                                                        name={getName(
                                                          'ctepartmethod',
                                                          elementID
                                                        )}
                                                        comcode="ctepartmethod"
                                                      >
                                                        <ParListSelect
                                                          parcode="CTEPARTMET"
                                                          offerid={getFieldValue(
                                                            'offerid'
                                                          )}
                                                          onSelected={() =>
                                                            debouncedCalculateNew(
                                                              '',
                                                              ''
                                                            )
                                                          }
                                                        />
                                                      </FormInput>
                                                    );
                                                  }}
                                                </Form.Item>
                                                <Form.Item
                                                  shouldUpdate={shouldUpdateCompare(
                                                    'currcode'
                                                  )}
                                                  noStyle
                                                >
                                                  {({ getFieldValue }) => {
                                                    return (
                                                      <InputCurrency
                                                        col
                                                        md={6}
                                                        disabled={
                                                          getFieldValue(
                                                            getName(
                                                              'ctepartmethod',
                                                              elementID
                                                            )
                                                          ) === 'POURC'
                                                        }
                                                        currcode={getFieldValue(
                                                          'currcode'
                                                        )}
                                                        comcode="ctepartamount"
                                                        onChange={() =>
                                                          debouncedCalculateNew(
                                                            'PARTAMOUNT',
                                                            'INST'
                                                          )
                                                        }
                                                        fieldname={getName(
                                                          'ctepartamount',
                                                          elementID
                                                        )}
                                                      />
                                                    );
                                                  }}
                                                </Form.Item>

                                                <FormInput
                                                  col
                                                  xs={24}
                                                  md={6}
                                                  comcode="ctepartdays"
                                                  name={getName(
                                                    'ctepartdays',
                                                    elementID
                                                  )}
                                                  tooltip={
                                                    'Max : ' +
                                                    getFieldValue(
                                                      getHelper(
                                                        'partnbdaysmax',
                                                        elementID
                                                      )
                                                    )
                                                  }
                                                >
                                                  <InputNumber
                                                    style={{ width: '100%' }}
                                                    max={getFieldValue(
                                                      getHelper(
                                                        'partnbdaysmax',
                                                        elementID
                                                      )
                                                    )}
                                                  />
                                                </FormInput>

                                                <FormInput
                                                  col
                                                  xs={24}
                                                  md={6}
                                                  comcode="tpidparticipation"
                                                  name={getName(
                                                    'tpidparticipation',
                                                    elementID
                                                  )}
                                                >
                                                  <ThirdPartyInput />
                                                </FormInput>

                                                <Form.Item shouldUpdate noStyle>
                                                  {({
                                                    getFieldValue,
                                                    setFieldsValue,
                                                  }) => (
                                                    <FormInput
                                                      col
                                                      md={5}
                                                      name={getName(
                                                        'ctepartratetype',
                                                        elementID
                                                      )}
                                                      comcode="ctepartratetype"
                                                    >
                                                      <ParListSelect
                                                        parcode="RATETYPE"
                                                        onChange={(e) => {
                                                          setFieldsValue({
                                                            rateformula: '',
                                                          });
                                                        }}
                                                      />
                                                    </FormInput>
                                                  )}
                                                </Form.Item>
                                                <Form.Item shouldUpdate noStyle>
                                                  {({
                                                    getFieldValue,
                                                    setFieldValue,
                                                  }) => {
                                                    return (
                                                      <FormInput
                                                        col
                                                        md={5}
                                                        name={getName(
                                                          'ctepartrateformula',
                                                          elementID
                                                        )}
                                                        comcode="ctepartrateformula"
                                                      >
                                                        <RateFormulaSelect
                                                          params={{
                                                            formulatype:
                                                              getFieldValue(
                                                                getName(
                                                                  'ctepartratetype',
                                                                  elementID
                                                                )
                                                              ),
                                                          }}
                                                          onSelected={(e) => {
                                                            let ctepartratespread =
                                                              getFieldValue(
                                                                getName(
                                                                  'ctepartratespread',
                                                                  elementID
                                                                )
                                                              ) ?? 0;
                                                            setFieldValue(
                                                              getName(
                                                                'ctepartrate',
                                                                elementID
                                                              ),
                                                              e?.ratevalue +
                                                                e?.rateriskcost +
                                                                e?.ratespread +
                                                                ctepartratespread
                                                            );

                                                            setFieldValue(
                                                              getName(
                                                                'ctepartratedefault',
                                                                elementID
                                                              ),
                                                              e?.ratevalue +
                                                                e?.rateriskcost +
                                                                e?.ratespread
                                                            );
                                                          }}
                                                        />
                                                      </FormInput>
                                                    );
                                                  }}
                                                </Form.Item>

                                                <Form.Item shouldUpdate noStyle>
                                                  {({
                                                    getFieldValue,
                                                    setFieldsValue,
                                                  }) => (
                                                    <FormInput
                                                      col
                                                      md={5}
                                                      name={getName(
                                                        'ctepartratedefault',
                                                        elementID
                                                      )}
                                                      comcode="ctepartratedefault"
                                                      hidden={
                                                        getFieldValue(
                                                          'partmethod'
                                                        ) === 'NONE'
                                                      }
                                                    >
                                                      <InputNumber
                                                        onKeyPress={(event) => {
                                                          if (
                                                            !/[0-9]/.test(
                                                              event.key
                                                            )
                                                          ) {
                                                            event.preventDefault();
                                                          }
                                                        }}
                                                        formatter={toRate}
                                                        max={100}
                                                        min={0}
                                                        disabled
                                                        step={1}
                                                      />
                                                    </FormInput>
                                                  )}
                                                </Form.Item>

                                                <Form.Item shouldUpdate noStyle>
                                                  {({
                                                    getFieldValue,
                                                    setFieldValue,
                                                  }) => (
                                                    <FormInput
                                                      col
                                                      md={5}
                                                      name={getName(
                                                        'ctepartratespread',
                                                        elementID
                                                      )}
                                                      comcode="ctepartratespread"
                                                      hidden={
                                                        getFieldValue(
                                                          'partmethod'
                                                        ) === 'NONE'
                                                      }
                                                    >
                                                      <InputNumber
                                                        onKeyPress={(event) => {
                                                          if (
                                                            !/[0-9]/.test(
                                                              event.key
                                                            )
                                                          ) {
                                                            event.preventDefault();
                                                          }
                                                        }}
                                                        formatter={toRate}
                                                        max={100}
                                                        min={0}
                                                        step={1}
                                                        onChange={(e) => {
                                                          let newpartrate =
                                                            getFieldValue(
                                                              getName(
                                                                'ctepartratedefault',
                                                                elementID
                                                              )
                                                            ) + Number(e);

                                                          setFieldValue(
                                                            getName(
                                                              'ctepartrate',
                                                              elementID
                                                            ),
                                                            newpartrate
                                                          );
                                                        }}
                                                      />
                                                    </FormInput>
                                                  )}
                                                </Form.Item>

                                                <Form.Item shouldUpdate noStyle>
                                                  {({
                                                    getFieldValue,
                                                    setFieldValue,
                                                  }) => (
                                                    <FormInput
                                                      col
                                                      xs={24}
                                                      md={6}
                                                      comcode="ctepartrate"
                                                      name={getName(
                                                        'ctepartrate',
                                                        elementID
                                                      )}
                                                    >
                                                      <InputRate
                                                        style={{
                                                          width: '100%',
                                                        }}
                                                        onChange={() =>
                                                          debouncedCalculateNew(
                                                            'PARTRATE',
                                                            'INST'
                                                          )
                                                        }
                                                        disabled={
                                                          getFieldValue(
                                                            getName(
                                                              'ctepartmethod',
                                                              elementID
                                                            )
                                                          ) === 'FIXED'
                                                        }
                                                      />
                                                    </FormInput>
                                                  )}
                                                </Form.Item>

                                                <FormInput
                                                  col
                                                  xs={24}
                                                  md={6}
                                                  comcode="ctepartinvoicingmode"
                                                  name={getName(
                                                    'ctepartinvoicingmode',
                                                    elementID
                                                  )}
                                                >
                                                  <ParListSelect parcode="PARTINVMET" />
                                                </FormInput>
                                              </Row>
                                            </Row>
                                          </Card>
                                        </TabPane>

                                        {form.getFieldValue(
                                          getName('prefinmethod', elementID)
                                        ) === 'PREFINSTEP' && (
                                          <TabPane
                                            tab={
                                              <GetLabel label="tabprefinsteps" />
                                            }
                                            key={34}
                                          >
                                            <Card>
                                              <Form.Item shouldUpdate noStyle>
                                                {({ getFieldValue }) => {
                                                  const _element: any =
                                                    getFieldValue([
                                                      'elements',
                                                      'FIN',
                                                      0,
                                                    ]) as any;

                                                  let conElemPrefinStepsList =
                                                    _element &&
                                                    !isNil(
                                                      _element.conElemPrefinSteps
                                                    )
                                                      ? [
                                                          ..._element.conElemPrefinSteps,
                                                        ]
                                                      : [];
                                                  let ctesorderMax: any =
                                                    _.maxBy(
                                                      _element?.conElemPrefinSteps,
                                                      'ctesorder'
                                                    );

                                                  const ctesorder =
                                                    ctesorderMax?.ctesorder ??
                                                    0;

                                                  return (
                                                    <>
                                                      <Row justify="end">
                                                        <ModalControllerNV
                                                          content={({
                                                            setVisible,
                                                            visible,
                                                          }) => (
                                                            <>
                                                              <ButtonOperation
                                                                onClick={() => {
                                                                  setVisible(
                                                                    true
                                                                  );
                                                                }}
                                                                type="primary"
                                                                comcode="add"
                                                              />
                                                              <ButtonOperation
                                                                onClick={() => {
                                                                  calculatePaymentShedulePrefinSteps(
                                                                    elementID
                                                                  );
                                                                }}
                                                                htmlType="button"
                                                                comcode="calculate"
                                                              />
                                                            </>
                                                          )}
                                                          modal={({
                                                            setVisible,
                                                            visible,
                                                          }) => (
                                                            <ConElemPrefinStepModal
                                                              visible={visible}
                                                              onClose={() => {
                                                                setVisible(
                                                                  false
                                                                );
                                                              }}
                                                              ctesorder={
                                                                1 + ctesorder ??
                                                                0
                                                              }
                                                              onSave={(
                                                                values,
                                                                action
                                                              ) => {
                                                                onSavePreFinElement(
                                                                  values,
                                                                  'create'
                                                                );
                                                              }}
                                                              record={undefined}
                                                            />
                                                          )}
                                                        ></ModalControllerNV>
                                                      </Row>

                                                      <DataGrid
                                                        dataSource={
                                                          conElemPrefinStepsList ??
                                                          []
                                                        }
                                                        pagination={false}
                                                        columns={
                                                          columnsPrefinSteps
                                                        }
                                                        titleComcode="conElemPrefinSteps"
                                                        rowKey={(e) => e.ctesid}
                                                      />
                                                    </>
                                                  );
                                                }}
                                              </Form.Item>
                                            </Card>
                                          </TabPane>
                                        )}
                                      </Tabs>
                                    </div>
                                  </TabPane>

                                  {elements.length > 0 &&
                                    elements[0].ctecalculationtype !==
                                      'PREFIN' && (
                                      <>
                                        {' '}
                                        <TabPane
                                          tab={
                                            <GetLabel label="tabFinCondition" />
                                          }
                                          key={24}
                                        >
                                          <Card
                                            bordered
                                            type="inner"
                                            style={{ height: '100%' }}
                                          >
                                            <Row gutter={[8, 0]}>
                                              <Form.Item shouldUpdate noStyle>
                                                {({ getFieldValue }) => (
                                                  <FormInput
                                                    col
                                                    md={12}
                                                    comcode="cteupfrontamount"
                                                    name={getName(
                                                      'cteupfrontamount',
                                                      elementID
                                                    )}
                                                  >
                                                    <SliderWithInputAndPercentage
                                                      currcode={getFieldValue(
                                                        'currcode'
                                                      )}
                                                      max={getFieldValue(
                                                        getHelper(
                                                          'upmax',
                                                          elementID
                                                        )
                                                      )}
                                                      min={getFieldValue(
                                                        getHelper(
                                                          'upmin',
                                                          elementID
                                                        )
                                                      )}
                                                      //defaultValue={100} //getFieldValue(['helpers', 'frdefault'])*getFieldValue('cteinvestamount')/100}
                                                      //value={100} //{getFieldValue(['helpers', 'frdefault'])*getFieldValue('cteinvestamount')/100}
                                                      basis={
                                                        getFieldValue(
                                                          'cttype'
                                                        ) === 'LEAD'
                                                          ? getFieldValue(
                                                              getName(
                                                                'cteinvestamount',
                                                                elementID
                                                              )
                                                            )
                                                          : getFieldValue(
                                                              'cttype'
                                                            ) === 'PART'
                                                          ? getFieldValue(
                                                              'ctsyndmgpartamount'
                                                            )
                                                          : getFieldValue(
                                                              getName(
                                                                'cteinvestamount',
                                                                elementID
                                                              )
                                                            )
                                                      }
                                                      step={1}
                                                      precisionAmount={2}
                                                      precisionCoef={5}
                                                      onChange={() =>
                                                        debouncedCalculateNew(
                                                          'UP',
                                                          'INST'
                                                        )
                                                      }
                                                    />
                                                  </FormInput>
                                                )}
                                              </Form.Item>
                                              <Form.Item shouldUpdate noStyle>
                                                {({ getFieldValue }) => {
                                                  const investamount = isNaN(
                                                    getFieldValue(
                                                      getName(
                                                        'cteinvestamount',
                                                        elementID
                                                      )
                                                    )
                                                  )
                                                    ? 0
                                                    : getFieldValue(
                                                        getName(
                                                          'cteinvestamount',
                                                          elementID
                                                        )
                                                      );
                                                  const cteextracosttofinance =
                                                    isNaN(
                                                      getFieldValue(
                                                        getName(
                                                          'cteextracosttofinance',
                                                          elementID
                                                        )
                                                      )
                                                    )
                                                      ? 0
                                                      : getFieldValue(
                                                          getName(
                                                            'cteextracosttofinance',
                                                            elementID
                                                          )
                                                        );

                                                  const cteupfrontamount =
                                                    isNaN(
                                                      getFieldValue(
                                                        getName(
                                                          'cteupfrontamount',
                                                          elementID
                                                        )
                                                      )
                                                    )
                                                      ? 0
                                                      : getFieldValue(
                                                          getName(
                                                            'cteupfrontamount',
                                                            elementID
                                                          )
                                                        );

                                                  const ctepartmethod =
                                                    getFieldValue(
                                                      getName(
                                                        'ctepartmethod',
                                                        elementID
                                                      )
                                                    );

                                                  var ctepartamount = 0;
                                                  if (
                                                    ctepartmethod === 'PROMO' ||
                                                    ctepartmethod ===
                                                      'REDUCEFIN' ||
                                                    ctepartmethod === 'MULTI'
                                                  ) {
                                                    ctepartamount = isNaN(
                                                      getFieldValue(
                                                        getName(
                                                          'ctepartamount',
                                                          elementID
                                                        )
                                                      )
                                                    )
                                                      ? 0
                                                      : getFieldValue(
                                                          getName(
                                                            'ctepartamount',
                                                            elementID
                                                          )
                                                        );
                                                  }

                                                  const finamount =
                                                    investamount +
                                                    cteextracosttofinance -
                                                    cteupfrontamount -
                                                    ctepartamount;

                                                  return (
                                                    <FormInput
                                                      style={{ color: 'red' }}
                                                      col
                                                      xs={24}
                                                      md={6}
                                                      name={getName(
                                                        'ctefinancedamount',
                                                        elementID
                                                      )}
                                                      comcode="ctefinancedamount"
                                                    >
                                                      <Text>
                                                        {toCurrency(
                                                          finamount,
                                                          getFieldValue(
                                                            'currcode'
                                                          )
                                                        )}
                                                      </Text>
                                                    </FormInput>
                                                  );
                                                }}
                                              </Form.Item>
                                              <FormInput
                                                style={{ color: 'red' }}
                                                col
                                                xs={24}
                                                md={6}
                                                name={getName(
                                                  'ctegraceperiodmethod',
                                                  elementID
                                                )}
                                                comcode="ctegraceperiodmethod"
                                              >
                                                <ParListSelect parcode="GPMETHOD" />
                                              </FormInput>

                                              <Form.Item shouldUpdate noStyle>
                                                {({ getFieldValue }) => {
                                                  return (
                                                    <FormInput
                                                      col
                                                      xs={24}
                                                      md={12}
                                                      name={getName(
                                                        'ctebilligdate',
                                                        elementID
                                                      )}
                                                    >
                                                      <ParListSelect
                                                        parcode="BILLDATE"
                                                        offerid={getFieldValue(
                                                          'offerid'
                                                        )}
                                                        onSelected={() =>
                                                          debouncedCalculateNew(
                                                            '',
                                                            ''
                                                          )
                                                        }
                                                      />
                                                    </FormInput>
                                                  );
                                                }}
                                              </Form.Item>

                                              <FormInput
                                                col
                                                xs={24}
                                                md={12}
                                                comcode="ctinitstartdate"
                                                name={getName(
                                                  'ctestartdate',
                                                  elementID
                                                )}
                                                //name="ctrequestdate"
                                              >
                                                <DatePicker
                                                  style={{ width: '100%' }}
                                                  onChange={() =>
                                                    debouncedCalculateNew(
                                                      '',
                                                      ''
                                                    )
                                                  }
                                                />
                                                {/*<Input onChange={() => debouncedCalculateNew('','')} />*/}
                                              </FormInput>
                                              <Form.Item shouldUpdate noStyle>
                                                {({ getFieldValue }) => {
                                                  return (
                                                    <FormInput
                                                      col
                                                      xs={24}
                                                      md={12}
                                                      comcode="ctedeferredinterestmethod"
                                                      name={getName(
                                                        'ctedeferredinterestmethod',
                                                        elementID
                                                      )}
                                                    >
                                                      <ParListSelect
                                                        parcode="CTEDEFINT"
                                                        offerid={getFieldValue(
                                                          'offerid'
                                                        )}
                                                        onSelected={() =>
                                                          debouncedCalculateNew(
                                                            '',
                                                            ''
                                                          )
                                                        }
                                                      />
                                                    </FormInput>
                                                  );
                                                }}
                                              </Form.Item>

                                              <FormInput
                                                col
                                                xs={24}
                                                md={6}
                                                comcode="ctedeferredinterestnominalrate"
                                                name={getName(
                                                  'ctedeferredinterestnominalrate',
                                                  elementID
                                                )}
                                              >
                                                <InputRate
                                                  style={{ width: '100%' }}
                                                  onChange={() =>
                                                    debouncedCalculateNew(
                                                      '',
                                                      ''
                                                    )
                                                  }
                                                  disabled={
                                                    getFieldValue(
                                                      getName(
                                                        'deferredinterestratetype',
                                                        elementID
                                                      )
                                                    ) !== 'FREE'
                                                  }
                                                />
                                              </FormInput>
                                              <Form.Item
                                                shouldUpdate={shouldUpdateCompare(
                                                  'currcode'
                                                )}
                                                noStyle
                                              >
                                                {({ getFieldValue }) => {
                                                  return (
                                                    <FormInput
                                                      col
                                                      xs={24}
                                                      md={6}
                                                      style={{ color: 'red' }}
                                                      name={getName(
                                                        'ctedeferredinterest',
                                                        elementID
                                                      )}
                                                      comcode="ctedeferredinterest"
                                                    >
                                                      <Value
                                                        formatter={(value) =>
                                                          toCurrency(
                                                            value,
                                                            getFieldValue(
                                                              'currcode'
                                                            )
                                                          )
                                                        }
                                                      ></Value>
                                                    </FormInput>
                                                  );
                                                }}
                                              </Form.Item>

                                              <Form.Item shouldUpdate noStyle>
                                                {({ getFieldValue }) => {
                                                  return (
                                                    <FormInput
                                                      col
                                                      xs={24}
                                                      md={6}
                                                      name={getName(
                                                        'ctedepositinterestmethod',
                                                        elementID
                                                      )}
                                                      comcode="ctedepositinterestmethod"
                                                    >
                                                      <ParListSelect
                                                        parcode="CTEDEPOINT"
                                                        offerid={getFieldValue(
                                                          'offerid'
                                                        )}
                                                        onSelected={() =>
                                                          debouncedCalculateNew(
                                                            '',
                                                            ''
                                                          )
                                                        }
                                                      />
                                                    </FormInput>
                                                  );
                                                }}
                                              </Form.Item>

                                              <FormInput
                                                col
                                                xs={24}
                                                md={3}
                                                comcode="ctedepositnominalrate"
                                                name={getName(
                                                  'ctedepositnominalrate',
                                                  elementID
                                                )}
                                              >
                                                <InputRate
                                                  style={{ width: '100%' }}
                                                  onChange={() =>
                                                    debouncedCalculateNew(
                                                      '',
                                                      ''
                                                    )
                                                  }
                                                  disabled={
                                                    getFieldValue(
                                                      getName(
                                                        'depositratetype',
                                                        elementID
                                                      )
                                                    ) !== 'FREE'
                                                  }
                                                />
                                              </FormInput>
                                              <Form.Item
                                                shouldUpdate={shouldUpdateCompare(
                                                  'currcode'
                                                )}
                                                noStyle
                                              >
                                                {({ getFieldValue }) => {
                                                  return (
                                                    <FormInput
                                                      style={{ color: 'red' }}
                                                      col
                                                      xs={24}
                                                      md={3}
                                                      name={getName(
                                                        'ctedepositinterest',
                                                        elementID
                                                      )}
                                                      //name='ctedepositinterest'
                                                      comcode="ctedepositinterest"
                                                    >
                                                      <Value
                                                        formatter={(value) =>
                                                          toCurrency(
                                                            value,
                                                            getFieldValue(
                                                              'currcode'
                                                            )
                                                          )
                                                        }
                                                      ></Value>
                                                    </FormInput>
                                                  );
                                                }}
                                              </Form.Item>
                                              <Form.Item shouldUpdate noStyle>
                                                {({ getFieldValue }) => (
                                                  <FormInput
                                                    col
                                                    xs={24}
                                                    md={12}
                                                    comcode="ctedepositamount"
                                                    name={getName(
                                                      'ctedepositamount',
                                                      elementID
                                                    )}
                                                  >
                                                    <SliderWithInputAndPercentage
                                                      currcode={getFieldValue(
                                                        'currcode'
                                                      )}
                                                      max={getFieldValue(
                                                        getName(
                                                          'ctedepositcoef',
                                                          elementID
                                                        )
                                                      )}
                                                      min={0}
                                                      basis={getFieldValue(
                                                        getName(
                                                          'cteinvestamount',
                                                          elementID
                                                        )
                                                      )}
                                                      step={1}
                                                      precisionAmount={2}
                                                      precisionCoef={5}
                                                      onChange={() =>
                                                        debouncedCalculateNew(
                                                          '',
                                                          ''
                                                        )
                                                      }
                                                    />
                                                  </FormInput>
                                                )}
                                              </Form.Item>

                                              <Form.Item shouldUpdate noStyle>
                                                {({ getFieldValue }) => {
                                                  return (
                                                    <FormInput
                                                      col
                                                      xs={24}
                                                      md={6}
                                                      name={getName(
                                                        'ctepartmethod',
                                                        elementID
                                                      )}
                                                      comcode="ctepartmethod"
                                                    >
                                                      <ParListSelect
                                                        parcode="CTEPARTMET"
                                                        offerid={getFieldValue(
                                                          'offerid'
                                                        )}
                                                        onSelected={() =>
                                                          debouncedCalculateNew(
                                                            '',
                                                            ''
                                                          )
                                                        }
                                                      />
                                                    </FormInput>
                                                  );
                                                }}
                                              </Form.Item>
                                              <Form.Item
                                                shouldUpdate={shouldUpdateCompare(
                                                  'currcode'
                                                )}
                                                noStyle
                                              >
                                                {({ getFieldValue }) => {
                                                  return (
                                                    <InputCurrency
                                                      col
                                                      md={3}
                                                      disabled={
                                                        getFieldValue(
                                                          getName(
                                                            'ctepartmethod',
                                                            elementID
                                                          )
                                                        ) === 'POURC'
                                                      }
                                                      currcode={getFieldValue(
                                                        'currcode'
                                                      )}
                                                      comcode="ctepartamount"
                                                      onChange={() =>
                                                        debouncedCalculateNew(
                                                          'PARTAMOUNT',
                                                          'INST'
                                                        )
                                                      }
                                                      fieldname={getName(
                                                        'ctepartamount',
                                                        elementID
                                                      )}
                                                    />
                                                  );
                                                }}
                                              </Form.Item>
                                              <FormInput
                                                col
                                                xs={24}
                                                md={3}
                                                comcode="ctepartrate"
                                                name={getName(
                                                  'ctepartrate',
                                                  elementID
                                                )}
                                              >
                                                <InputRate
                                                  style={{ width: '100%' }}
                                                  onChange={() =>
                                                    debouncedCalculateNew(
                                                      'PARTRATE',
                                                      'INST'
                                                    )
                                                  }
                                                  disabled={
                                                    getFieldValue(
                                                      getName(
                                                        'ctepartmethod',
                                                        elementID
                                                      )
                                                    ) === 'FIXED'
                                                  }
                                                />
                                              </FormInput>

                                              <Form.Item shouldUpdate noStyle>
                                                {({ getFieldValue }) => {
                                                  return (
                                                    <FormInput
                                                      col
                                                      md={6}
                                                      comcode="ctevatdeferralmethod"
                                                      name={getName(
                                                        'ctevatdeferralmethod',
                                                        elementID
                                                      )}
                                                    >
                                                      <ParListSelect
                                                        parcode="VATDEFMETH"
                                                        offerid={getFieldValue(
                                                          'offerid'
                                                        )}
                                                        onSelected={(e) => {
                                                          if (
                                                            e.value !== 'NONE'
                                                          ) {
                                                            setVatDefferal(
                                                              true
                                                            );
                                                          } else {
                                                            setVatDefferal(
                                                              false
                                                            );
                                                          }
                                                          debouncedCalculateNew(
                                                            '',
                                                            ''
                                                          );
                                                        }}
                                                      />
                                                    </FormInput>
                                                  );
                                                }}
                                              </Form.Item>

                                              <Form.Item shouldUpdate noStyle>
                                                {({ getFieldValue }) => {
                                                  if (
                                                    getFieldValue(
                                                      getName(
                                                        'ctevatdeferralmethod',
                                                        elementID
                                                      )
                                                    ) !== 'NONE'
                                                  ) {
                                                    return (
                                                      <>
                                                        <FormInput
                                                          col
                                                          xs={24}
                                                          md={8}
                                                          comcode="ctevatdeferralamount"
                                                          name={getName(
                                                            'ctevatdeferralamount',
                                                            elementID
                                                          )}
                                                        >
                                                          <InputCurrency
                                                            currcode={
                                                              localStorage.getItem(
                                                                'currcode'
                                                              ) ?? ''
                                                            }
                                                            onChange={() =>
                                                              debouncedCalculateNew(
                                                                '',
                                                                ''
                                                              )
                                                            }
                                                          />
                                                        </FormInput>
                                                        <FormInput
                                                          col
                                                          xs={24}
                                                          md={8}
                                                          comcode="ctevatdeferralduration"
                                                          name={getName(
                                                            'ctevatdeferralduration',
                                                            elementID
                                                          )}
                                                        >
                                                          <InputNumber
                                                            onChange={() =>
                                                              debouncedCalculateNew(
                                                                '',
                                                                ''
                                                              )
                                                            }
                                                          />
                                                        </FormInput>
                                                        <FormInput
                                                          col
                                                          xs={24}
                                                          md={8}
                                                          comcode="ctevatdeferraldaysbasis"
                                                          name={getName(
                                                            'ctevatdeferraldaysbasis',
                                                            elementID
                                                          )}
                                                        >
                                                          <ParListSelect
                                                            parcode="CALBASIS"
                                                            onChange={() =>
                                                              debouncedCalculateNew(
                                                                '',
                                                                ''
                                                              )
                                                            }
                                                          />
                                                        </FormInput>
                                                      </>
                                                    );
                                                  } else {
                                                    return null;
                                                  }
                                                }}
                                              </Form.Item>
                                            </Row>
                                          </Card>
                                        </TabPane>
                                        <TabPane
                                          tab={<GetLabel label="tabPayment" />}
                                          key={25}
                                        >
                                          <Card
                                            bordered
                                            title={
                                              <Title
                                                level={4}
                                                comcode="Rate"
                                              ></Title>
                                            }
                                          >
                                            <Row gutter={[8, 8]}>
                                              <Form.Item shouldUpdate noStyle>
                                                <FormInput
                                                  col
                                                  xs={6}
                                                  name={getName(
                                                    'cteratetype',
                                                    elementID
                                                  )}
                                                  comcode="cteratetype"
                                                >
                                                  <ParListSelect parcode="RATETYPE" />
                                                </FormInput>
                                              </Form.Item>
                                              <Form.Item shouldUpdate noStyle>
                                                {({ getFieldValue }) => {
                                                  return (
                                                    <FormInput
                                                      col
                                                      xs={6}
                                                      name={getName(
                                                        'cterateformula',
                                                        elementID
                                                      )}
                                                      comcode="cterateformula"
                                                    >
                                                      <RateFormulaSelect
                                                        params={{
                                                          formulatype:
                                                            getFieldValue(
                                                              getName(
                                                                'cteratetype',
                                                                elementID
                                                              )
                                                            ),
                                                        }}
                                                        onSelected={(val) => {
                                                          handleselectformula(
                                                            val?.ratevalue +
                                                              val?.rateriskcost +
                                                              val?.ratespread,
                                                            'cte',
                                                            val
                                                          );
                                                          debouncedCalculateNew(
                                                            '',
                                                            ''
                                                          );
                                                        }}
                                                      />
                                                    </FormInput>
                                                  );
                                                }}
                                              </Form.Item>
                                              <Form.Item shouldUpdate noStyle>
                                                <FormInput
                                                  col
                                                  xs={6}
                                                  name={getName(
                                                    'cterateperiodicity',
                                                    elementID
                                                  )}
                                                  comcode="cterateperiodicity"
                                                >
                                                  <ParListSelect parcode="PERIOD" />
                                                </FormInput>
                                              </Form.Item>
                                              <FormInput
                                                col
                                                xs={3}
                                                comcode="cterateref"
                                                name={getName(
                                                  'cterateref',
                                                  elementID
                                                )}
                                              >
                                                <Value formatter={toRate} />
                                              </FormInput>

                                              <FormInput
                                                col
                                                xs={3}
                                                comcode="cteratespread"
                                                name={getName(
                                                  'cteratespread',
                                                  elementID
                                                )}
                                              >
                                                <Value formatter={toRate} />
                                              </FormInput>

                                              <Form.Item shouldUpdate noStyle>
                                                {({ getFieldValue }) => {
                                                  return (
                                                    <FormInput
                                                      col
                                                      xs={6}
                                                      comcode="cteinterestmethod"
                                                      name={getName(
                                                        'cteinterestmethod',
                                                        elementID
                                                      )}
                                                    >
                                                      <ParListSelect
                                                        parcode="INTCALC"
                                                        // parvalueparent={getFieldValue('"cteinterestmethod"')}
                                                      />
                                                    </FormInput>
                                                  );
                                                }}
                                              </Form.Item>

                                              <Form.Item shouldUpdate noStyle>
                                                {({ getFieldValue }) => {
                                                  return (
                                                    <FormInput
                                                      col
                                                      xs={6}
                                                      comcode="cteratebasis"
                                                      name={getName(
                                                        'cteratebasis',
                                                        elementID
                                                      )}
                                                    >
                                                      <ParListSelect
                                                        parcode="CALBASIS"
                                                        // parvalueparent={getFieldValue('"cteratebasis"')}
                                                      />
                                                    </FormInput>
                                                  );
                                                }}
                                              </Form.Item>

                                              <Form.Item shouldUpdate noStyle>
                                                {({ getFieldValue }) => (
                                                  <FormInput
                                                    col
                                                    xs={12}
                                                    comcode="ctenominalrate"
                                                    name={getName(
                                                      'ctenominalrate',
                                                      elementID
                                                    )}
                                                  >
                                                    <SliderWithInput
                                                      max={getFieldValue(
                                                        getHelper(
                                                          'ratemax',
                                                          elementID
                                                        )
                                                      )}
                                                      min={getFieldValue(
                                                        getHelper(
                                                          'ratemin',
                                                          elementID
                                                        )
                                                      )}
                                                      step={0.001}
                                                      precision={5}
                                                      widthInput={5}
                                                      onChange={() => {
                                                        setIsLoading(true);
                                                        debouncedCalculateNew(
                                                          '',
                                                          ''
                                                        );
                                                      }}
                                                    />
                                                  </FormInput>
                                                )}
                                              </Form.Item>

                                              <FormInput
                                                col
                                                xs={6}
                                                name={getName(
                                                  'cteactuarialrate',
                                                  elementID
                                                )}
                                                comcode="cteactuarialrate"
                                              >
                                                <InputRate
                                                  style={{ width: '100%' }}
                                                  disabled
                                                />
                                              </FormInput>

                                              <FormInput
                                                col
                                                xs={4}
                                                name={getName(
                                                  'ceilingdefaultrate',
                                                  cteid
                                                )}
                                                comcode="ceilingdefaultrate"
                                              >
                                                <InputRate
                                                  style={{ width: '100%' }}
                                                />
                                              </FormInput>

                                              <FormInput
                                                col
                                                xs={4}
                                                name={getName(
                                                  'ceilingrate',
                                                  cteid
                                                )}
                                                comcode="ceilingrate"
                                              >
                                                <InputRate
                                                  style={{ width: '100%' }}
                                                  disabled
                                                />
                                              </FormInput>

                                              <FormInput
                                                col
                                                xs={4}
                                                name={getName(
                                                  'floordefaultrate',
                                                  cteid
                                                )}
                                                comcode="floordefaultrate"
                                              >
                                                <InputRate
                                                  style={{ width: '100%' }}
                                                />
                                              </FormInput>

                                              <FormInput
                                                col
                                                xs={4}
                                                name={getName(
                                                  'floorrate',
                                                  cteid
                                                )}
                                                comcode="floorrate"
                                              >
                                                <InputRate
                                                  style={{ width: '100%' }}
                                                  disabled
                                                />
                                              </FormInput>
                                            </Row>
                                          </Card>
                                          <Form.Item shouldUpdate noStyle>
                                            {({ getFieldValue }) => {
                                              const calcmethod = getFieldValue(
                                                getName(
                                                  'ctecalculationtype',
                                                  elementID
                                                )
                                              );
                                              const steps =
                                                getFieldValue(
                                                  getName(
                                                    'conElemSteps',
                                                    elementID
                                                  )
                                                ) ?? [];

                                              if (
                                                calcmethod === 'LINEAR' ||
                                                calcmethod === 'LINAMORT'
                                              ) {
                                                return (
                                                  <Card
                                                    bordered
                                                    title={
                                                      <Title
                                                        level={4}
                                                        comcode="LinearPayment"
                                                      ></Title>
                                                    }
                                                  >
                                                    <Row gutter={[8, 8]}>
                                                      <Form.Item
                                                        shouldUpdate
                                                        noStyle
                                                      >
                                                        {({
                                                          getFieldValue,
                                                        }) => {
                                                          return (
                                                            <FormInput
                                                              col
                                                              xs={6}
                                                              name={getName(
                                                                'cteperiodicity',
                                                                elementID
                                                              )}
                                                            >
                                                              <ParListSelect
                                                                parcode="PERIOD"
                                                                onSelected={() =>
                                                                  debouncedCalculateNew(
                                                                    '',
                                                                    'INST'
                                                                  )
                                                                }
                                                              />
                                                            </FormInput>
                                                          );
                                                        }}
                                                      </Form.Item>
                                                      <Form.Item
                                                        shouldUpdate
                                                        noStyle
                                                      >
                                                        <FormInput
                                                          col
                                                          xs={6}
                                                          name={getName(
                                                            'cteunit',
                                                            elementID
                                                          )}
                                                        >
                                                          <ParListSelect
                                                            parcode="UNIT"
                                                            onSelected={() =>
                                                              debouncedCalculateNew(
                                                                '',
                                                                ''
                                                              )
                                                            }
                                                          />
                                                        </FormInput>
                                                      </Form.Item>
                                                      <Form.Item
                                                        shouldUpdate
                                                        noStyle
                                                      >
                                                        <FormInput
                                                          col
                                                          xs={6}
                                                          name={getName(
                                                            'ctepaymentterm',
                                                            elementID
                                                          )}
                                                        >
                                                          <ParListSelect
                                                            parcode="TERM"
                                                            onChange={() =>
                                                              debouncedCalculateNew(
                                                                '',
                                                                ''
                                                              )
                                                            }
                                                            offerid={getFieldValue(
                                                              'offerid'
                                                            )}
                                                          />
                                                        </FormInput>
                                                      </Form.Item>
                                                    </Row>
                                                    <Row gutter={[8, 0]}>
                                                      {(calcmethod ===
                                                        'LINEAR' ||
                                                        calcmethod ===
                                                          'LINAMORT') && (
                                                        <Form.Item
                                                          shouldUpdate
                                                          noStyle
                                                        >
                                                          {({
                                                            getFieldValue,
                                                          }) => (
                                                            <FormInput
                                                              col
                                                              xs={12}
                                                              comcode="cteduration"
                                                              name={getName(
                                                                'cteduration',
                                                                elementID
                                                              )}
                                                            >
                                                              <SliderWithInput
                                                                max={getFieldValue(
                                                                  getHelper(
                                                                    'durationmax',
                                                                    elementID
                                                                  )
                                                                )}
                                                                min={getFieldValue(
                                                                  getHelper(
                                                                    'durationmin',
                                                                    elementID
                                                                  )
                                                                )}
                                                                precision={0}
                                                                onChange={() =>
                                                                  debouncedCalculateNew(
                                                                    '',
                                                                    'INST'
                                                                  )
                                                                }
                                                              />
                                                            </FormInput>
                                                          )}
                                                        </Form.Item>
                                                      )}
                                                      <Form.Item
                                                        shouldUpdate
                                                        noStyle
                                                      >
                                                        {({
                                                          getFieldValue,
                                                        }) => (
                                                          <FormInput
                                                            col
                                                            xs={12}
                                                            comcode="ctegraceperiodduration"
                                                            name={getName(
                                                              'ctegraceperiodduration',
                                                              elementID
                                                            )}
                                                          >
                                                            <SliderWithInput
                                                              max={getFieldValue(
                                                                getHelper(
                                                                  'gpmax',
                                                                  elementID
                                                                )
                                                              )}
                                                              min={getFieldValue(
                                                                getHelper(
                                                                  'gpmin',
                                                                  elementID
                                                                )
                                                              )}
                                                              precision={0}
                                                              onChange={() =>
                                                                debouncedCalculateNew(
                                                                  '',
                                                                  'INST'
                                                                )
                                                              }
                                                            />
                                                          </FormInput>
                                                        )}
                                                      </Form.Item>
                                                    </Row>
                                                    <Row gutter={[8, 0]}>
                                                      <Form.Item
                                                        shouldUpdate
                                                        noStyle
                                                      >
                                                        {({
                                                          getFieldValue,
                                                        }) => (
                                                          <FormInput
                                                            col
                                                            xs={12}
                                                            comcode="ctefirstpayment"
                                                            name={getName(
                                                              'ctefirstpayment',
                                                              elementID
                                                            )}
                                                          >
                                                            <SliderWithInputAndPercentage
                                                              currcode={getFieldValue(
                                                                'currcode'
                                                              )}
                                                              max={getFieldValue(
                                                                getHelper(
                                                                  'frmax',
                                                                  elementID
                                                                )
                                                              )}
                                                              min={getFieldValue(
                                                                getHelper(
                                                                  'frmin',
                                                                  elementID
                                                                )
                                                              )}
                                                              defaultValue={100} //getFieldValue(['helpers', 'frdefault'])*getFieldValue('cteinvestamount')/100}
                                                              value={100} //{getFieldValue(['helpers', 'frdefault'])*getFieldValue('cteinvestamount')/100}
                                                              basis={getFieldValue(
                                                                getName(
                                                                  'cteinvestamount',
                                                                  elementID
                                                                )
                                                              )}
                                                              step={1}
                                                              precisionAmount={
                                                                2
                                                              }
                                                              precisionCoef={5}
                                                              onChange={() =>
                                                                debouncedCalculateNew(
                                                                  'FP',
                                                                  'INST'
                                                                )
                                                              }
                                                            />
                                                          </FormInput>
                                                        )}
                                                      </Form.Item>
                                                      <Form.Item
                                                        shouldUpdate
                                                        noStyle
                                                      >
                                                        {({
                                                          getFieldValue,
                                                        }) => {
                                                          const indexElement =
                                                            form
                                                              .getFieldValue([
                                                                'elements',
                                                                'FIN',
                                                              ])
                                                              ?.findIndex(
                                                                (item: any) =>
                                                                  item.cteid ===
                                                                  getFieldValue(
                                                                    'selectedElement'
                                                                  )
                                                              );

                                                          const finElement =
                                                            form.getFieldValue([
                                                              'elements',
                                                              'FIN',
                                                              indexElement,
                                                            ]);
                                                          return (
                                                            <FormInput
                                                              col
                                                              xs={12}
                                                              comcode="ctervamount"
                                                              name={getName(
                                                                'ctervamount',
                                                                elementID
                                                              )}
                                                            >
                                                              <SliderWithInputAndPercentage
                                                                currcode={getFieldValue(
                                                                  'currcode'
                                                                )}
                                                                disabled={
                                                                  finElement?.rvcalculationmode ===
                                                                  'ASSET'
                                                                }
                                                                max={getFieldValue(
                                                                  getHelper(
                                                                    'rvmax',
                                                                    elementID
                                                                  )
                                                                )}
                                                                min={getFieldValue(
                                                                  getHelper(
                                                                    'rvmin',
                                                                    elementID
                                                                  )
                                                                )}
                                                                contextmin={getFieldValue(
                                                                  getHelper(
                                                                    'rvcontextmin',
                                                                    elementID
                                                                  )
                                                                )}
                                                                contextmax={getFieldValue(
                                                                  getHelper(
                                                                    'rvcontextmax',
                                                                    elementID
                                                                  )
                                                                )}
                                                                basis={getFieldValue(
                                                                  getName(
                                                                    'cteinvestamount',
                                                                    elementID
                                                                  )
                                                                )}
                                                                step={1}
                                                                precisionAmount={
                                                                  2
                                                                }
                                                                precisionCoef={
                                                                  5
                                                                }
                                                                onChange={() =>
                                                                  debouncedCalculateNew(
                                                                    'RV',
                                                                    'INST'
                                                                  )
                                                                }
                                                              />
                                                            </FormInput>
                                                          );
                                                        }}
                                                      </Form.Item>
                                                    </Row>
                                                    <Row gutter={[8, 0]}>
                                                      <Form.Item
                                                        shouldUpdate={shouldUpdateCompare(
                                                          'currcode'
                                                        )}
                                                        noStyle
                                                      >
                                                        {({
                                                          getFieldValue,
                                                        }) => {
                                                          return (
                                                            <FormInput
                                                              style={{
                                                                color: 'red',
                                                              }}
                                                              col
                                                              xs={24}
                                                              md={10}
                                                              comcode="cteinstallmentamount"
                                                              name={getName(
                                                                'cteinstallmentamount',
                                                                elementID
                                                              )}
                                                            >
                                                              {unlockCalculator ? (
                                                                <InputCurrency
                                                                  col
                                                                  md={10}
                                                                  currcode={getFieldValue(
                                                                    'currcode'
                                                                  )}
                                                                />
                                                              ) : (
                                                                <Value
                                                                  formatter={(
                                                                    value
                                                                  ) =>
                                                                    toCurrency(
                                                                      value,
                                                                      getFieldValue(
                                                                        'currcode'
                                                                      )
                                                                    )
                                                                  }
                                                                ></Value>
                                                              )}
                                                            </FormInput>
                                                          );
                                                        }}
                                                      </Form.Item>
                                                      <FormInput
                                                        col
                                                        md={4}
                                                        comcode="unlock"
                                                      >
                                                        <ButtonAction
                                                          icon={
                                                            unlockCalculator ===
                                                            true ? (
                                                              <UnlockTwoTone twoToneColor="#52c41a" />
                                                            ) : (
                                                              <LockTwoTone twoToneColor="red" />
                                                            )
                                                          }
                                                          onlyIcon
                                                          onClick={() =>
                                                            setunlockCalculator(
                                                              !unlockCalculator
                                                            )
                                                          }
                                                        />
                                                      </FormInput>
                                                      <FormInput
                                                        style={{
                                                          color: 'green',
                                                        }}
                                                        col
                                                        xs={6}
                                                        comcode="ctedepositinterest"
                                                        name={getName(
                                                          'ctedepositinterest',
                                                          elementID
                                                        )}
                                                      >
                                                        <Value
                                                          formatter={(value) =>
                                                            toCurrency(
                                                              value,
                                                              getFieldValue(
                                                                'currcode'
                                                              )
                                                            )
                                                          }
                                                        ></Value>
                                                      </FormInput>
                                                      <FormInput
                                                        style={{ color: 'red' }}
                                                        col
                                                        xs={6}
                                                        name={getName(
                                                          'cterentalamount',
                                                          elementID
                                                        )}
                                                        comcode="cterentalamount"
                                                      >
                                                        <Value
                                                          formatter={(value) =>
                                                            toCurrency(
                                                              value,
                                                              getFieldValue(
                                                                'currcode'
                                                              )
                                                            )
                                                          }
                                                        ></Value>
                                                      </FormInput>
                                                    </Row>
                                                  </Card>
                                                );
                                              } else {
                                                if (calcmethod === 'STEP') {
                                                  return (
                                                    <Card
                                                      bordered
                                                      title={
                                                        <Title
                                                          level={4}
                                                          comcode="StepPayment"
                                                        ></Title>
                                                      }
                                                    >
                                                      <Row>
                                                        <Col span={20}>
                                                          <Row>
                                                            <Form.Item
                                                              shouldUpdate={() =>
                                                                true
                                                              }
                                                              noStyle
                                                            >
                                                              <FormInput
                                                                col
                                                                xs={4}
                                                                name={getName(
                                                                  'ctepaymentterm',
                                                                  elementID
                                                                )}
                                                              >
                                                                <ParListSelect
                                                                  parcode="TERM"
                                                                  // parvalueparent={getFieldValue('ctepaymentterm')}
                                                                />
                                                              </FormInput>
                                                            </Form.Item>
                                                            <FormInput
                                                              style={{
                                                                color: 'blue',
                                                              }}
                                                              col
                                                              xs={6}
                                                              comcode="cteinvestamount"
                                                              name={getName(
                                                                'cteinvestamount',
                                                                elementID
                                                              )}
                                                            >
                                                              <Value
                                                                formatter={(
                                                                  value
                                                                ) =>
                                                                  toCurrency(
                                                                    value,
                                                                    getFieldValue(
                                                                      'currcode'
                                                                    )
                                                                  )
                                                                }
                                                              ></Value>
                                                            </FormInput>
                                                            <Form.Item
                                                              shouldUpdate={() =>
                                                                true
                                                              }
                                                              noStyle
                                                            >
                                                              <FormInput
                                                                col
                                                                xs={4}
                                                                name={getName(
                                                                  'cteupfrontamount',
                                                                  elementID
                                                                )}
                                                                comcode="cteupfrontamount"
                                                              >
                                                                <Value
                                                                  formatter={(
                                                                    value
                                                                  ) =>
                                                                    toCurrency(
                                                                      value,
                                                                      getFieldValue(
                                                                        'currcode'
                                                                      )
                                                                    )
                                                                  }
                                                                ></Value>
                                                              </FormInput>
                                                            </Form.Item>
                                                            <FormInput
                                                              style={{
                                                                color: 'blue',
                                                              }}
                                                              col
                                                              xs={6}
                                                              comcode="ctefinancedamount"
                                                              name={getName(
                                                                'ctefinancedamount',
                                                                elementID
                                                              )}
                                                            >
                                                              <Value
                                                                formatter={(
                                                                  value
                                                                ) =>
                                                                  toCurrency(
                                                                    value,
                                                                    getFieldValue(
                                                                      'currcode'
                                                                    )
                                                                  )
                                                                }
                                                              ></Value>
                                                            </FormInput>

                                                            <Form.Item
                                                              shouldUpdate={shouldUpdateCompare(
                                                                'currcode'
                                                              )}
                                                              noStyle
                                                            >
                                                              {({
                                                                getFieldValue,
                                                              }) => {
                                                                return (
                                                                  <FormInput
                                                                    xs={4}
                                                                    style={{
                                                                      color:
                                                                        'red',
                                                                    }}
                                                                    name={getName(
                                                                      'ctedeferredinterest',
                                                                      elementID
                                                                    )}
                                                                    comcode="ctedeferredinterest"
                                                                  >
                                                                    <Value
                                                                      formatter={(
                                                                        value
                                                                      ) =>
                                                                        toCurrency(
                                                                          value,
                                                                          getFieldValue(
                                                                            'currcode'
                                                                          )
                                                                        )
                                                                      }
                                                                    />
                                                                  </FormInput>
                                                                );
                                                              }}
                                                            </Form.Item>
                                                          </Row>
                                                        </Col>
                                                        <Col span={4}>
                                                          <Space
                                                            size="middle"
                                                            direction="vertical"
                                                          >
                                                            <NewButtonSmall
                                                              type="primary"
                                                              onClick={addStep}
                                                              comcode="add"
                                                              disabled={
                                                                typeof getFieldValue(
                                                                  'pricing'
                                                                ) !== 'object'
                                                                  ? !isNil(
                                                                      getFieldValue(
                                                                        'pricing'
                                                                      )
                                                                    )
                                                                  : !isNil(
                                                                      getFieldValue(
                                                                        'pricing'
                                                                      )?.ofrid
                                                                    )
                                                              }
                                                            />

                                                            <Form.Item
                                                              shouldUpdate
                                                              noStyle
                                                            >
                                                              {({
                                                                getFieldValue,
                                                              }) => (
                                                                <FinancialScheduleModal
                                                                  currcode={getFieldValue(
                                                                    'currcode'
                                                                  )}
                                                                  finElement={getFieldValue(
                                                                    [
                                                                      'elements',
                                                                      'FIN',
                                                                    ]
                                                                  )?.find(
                                                                    (
                                                                      ele: any
                                                                    ) =>
                                                                      ele.cteid ===
                                                                      getFieldValue(
                                                                        'selectedElement'
                                                                      )
                                                                  )}
                                                                  comcode="finSchedule"
                                                                  loading={
                                                                    loading
                                                                  }
                                                                  flagretailer={getFieldValue(
                                                                    'flagretailer'
                                                                  )}
                                                                  controller={
                                                                    <ScheduleButton
                                                                      size="large"
                                                                      style={{
                                                                        width:
                                                                          '100%',
                                                                      }}
                                                                      onClickCapture={async (
                                                                        e
                                                                      ) => {
                                                                        // await debouncedCalculateNew(
                                                                        //   '',
                                                                        //   ''
                                                                        // );
                                                                        // calculatePaymentSheduleStep(
                                                                        //   elementID
                                                                        // );
                                                                      }}
                                                                      comcode="finSchedule"
                                                                      twoToneColor={
                                                                        form.getFieldValue(
                                                                          getName(
                                                                            'elementstatus',
                                                                            elementID
                                                                          )
                                                                        ) ===
                                                                        'ERROR'
                                                                          ? 'red'
                                                                          : 'blue'
                                                                      }
                                                                    ></ScheduleButton>
                                                                  }
                                                                />
                                                              )}
                                                            </Form.Item>
                                                          </Space>
                                                        </Col>
                                                      </Row>
                                                      <Row gutter={[8, 8]}>
                                                        <DataGrid
                                                          rowKey="ctesid"
                                                          dataSource={[
                                                            ...steps,
                                                          ]}
                                                          columns={columns}
                                                          pagination={false}
                                                          isLoading={
                                                            loadingCalculateStep
                                                          }
                                                        />
                                                      </Row>
                                                    </Card>
                                                  );
                                                } else {
                                                  if (
                                                    calcmethod === 'STEPWEIGH'
                                                  ) {
                                                    return (
                                                      <Card
                                                        bordered
                                                        title={
                                                          <Title
                                                            level={4}
                                                            comcode="WeightedStepPayment"
                                                          ></Title>
                                                        }
                                                      >
                                                        <Row>
                                                          <Col span={20}>
                                                            <Row gutter={20}>
                                                              <Form.Item
                                                                shouldUpdate
                                                                noStyle
                                                              >
                                                                <FormInput
                                                                  col
                                                                  xs={4}
                                                                  name={getName(
                                                                    'ctepaymentterm',
                                                                    elementID
                                                                  )}
                                                                >
                                                                  <ParListSelect
                                                                    parcode="TERM"
                                                                    // parvalueparent={getFieldValue('ctepaymentterm')}
                                                                  />
                                                                </FormInput>
                                                              </Form.Item>
                                                              <FormInput
                                                                style={{
                                                                  color: 'blue',
                                                                }}
                                                                col
                                                                xs={6}
                                                                comcode="cteinvestamount"
                                                                name={getName(
                                                                  'cteinvestamount',
                                                                  elementID
                                                                )}
                                                              >
                                                                <Value
                                                                  formatter={(
                                                                    value
                                                                  ) =>
                                                                    toCurrency(
                                                                      value,
                                                                      getFieldValue(
                                                                        'currcode'
                                                                      )
                                                                    )
                                                                  }
                                                                ></Value>
                                                              </FormInput>
                                                              <Form.Item
                                                                shouldUpdate={() =>
                                                                  true
                                                                }
                                                                noStyle
                                                              >
                                                                <FormInput
                                                                  col
                                                                  xs={4}
                                                                  name={getName(
                                                                    'cteupfrontamount',
                                                                    elementID
                                                                  )}
                                                                  comcode="cteupfrontamount"
                                                                >
                                                                  <Value
                                                                    formatter={(
                                                                      value
                                                                    ) =>
                                                                      toCurrency(
                                                                        value,
                                                                        getFieldValue(
                                                                          'currcode'
                                                                        )
                                                                      )
                                                                    }
                                                                  ></Value>
                                                                </FormInput>
                                                              </Form.Item>
                                                              <FormInput
                                                                style={{
                                                                  color: 'blue',
                                                                }}
                                                                col
                                                                xs={6}
                                                                comcode="ctefinancedamount"
                                                                name={getName(
                                                                  'ctefinancedamount',
                                                                  elementID
                                                                )}
                                                              >
                                                                <Value
                                                                  formatter={(
                                                                    value
                                                                  ) =>
                                                                    toCurrency(
                                                                      value,
                                                                      getFieldValue(
                                                                        'currcode'
                                                                      )
                                                                    )
                                                                  }
                                                                ></Value>
                                                              </FormInput>
                                                              <Form.Item
                                                                shouldUpdate={shouldUpdateCompare(
                                                                  'currcode'
                                                                )}
                                                                noStyle
                                                              >
                                                                {({
                                                                  getFieldValue,
                                                                }) => {
                                                                  return (
                                                                    <FormInput
                                                                      xs={4}
                                                                      style={{
                                                                        color:
                                                                          'red',
                                                                      }}
                                                                      name={getName(
                                                                        'ctedeferredinterest',
                                                                        elementID
                                                                      )}
                                                                      comcode="ctedeferredinterest"
                                                                    >
                                                                      <Value
                                                                        formatter={(
                                                                          value
                                                                        ) =>
                                                                          toCurrency(
                                                                            value,
                                                                            getFieldValue(
                                                                              'currcode'
                                                                            )
                                                                          )
                                                                        }
                                                                      />
                                                                    </FormInput>
                                                                  );
                                                                }}
                                                              </Form.Item>
                                                            </Row>

                                                            <Row
                                                              gutter={[8, 0]}
                                                            >
                                                              <Form.Item
                                                                shouldUpdate={shouldUpdateCompare(
                                                                  'currcode'
                                                                )}
                                                                noStyle
                                                              >
                                                                {({
                                                                  getFieldValue,
                                                                }) => {
                                                                  return (
                                                                    <FormInput
                                                                      style={{
                                                                        color:
                                                                          'red',
                                                                      }}
                                                                      col
                                                                      xs={24}
                                                                      md={4}
                                                                      comcode="ctelinearinstamount"
                                                                      name={getName(
                                                                        'cteinstallmentamount',
                                                                        elementID
                                                                      )}
                                                                    >
                                                                      {unlockCalculator ? (
                                                                        <InputCurrency
                                                                          col
                                                                          md={
                                                                            10
                                                                          }
                                                                          currcode={getFieldValue(
                                                                            'currcode'
                                                                          )}
                                                                          onChange={(
                                                                            e
                                                                          ) =>
                                                                            debouncedCalculateNew(
                                                                              '',
                                                                              'FINANCING'
                                                                            )
                                                                          }
                                                                        />
                                                                      ) : (
                                                                        <Value
                                                                          formatter={(
                                                                            value
                                                                          ) =>
                                                                            toCurrency(
                                                                              value,
                                                                              getFieldValue(
                                                                                'currcode'
                                                                              )
                                                                            )
                                                                          }
                                                                        ></Value>
                                                                      )}
                                                                    </FormInput>
                                                                  );
                                                                }}
                                                              </Form.Item>

                                                              <Form.Item
                                                                shouldUpdate
                                                                noStyle
                                                              >
                                                                {({
                                                                  getFieldValue,
                                                                }) => {
                                                                  return (
                                                                    <FormInput
                                                                      style={{
                                                                        color:
                                                                          'green',
                                                                      }}
                                                                      col
                                                                      xs={6}
                                                                      comcode="ctefirstglobalpayment"
                                                                      name={getName(
                                                                        'ctefirstglobalpayment',
                                                                        elementID
                                                                      )}
                                                                    >
                                                                      <Value
                                                                        formatter={(
                                                                          value
                                                                        ) =>
                                                                          toCurrency(
                                                                            getFirstGlobalPayment(),
                                                                            getFieldValue(
                                                                              'currcode'
                                                                            )
                                                                          )
                                                                        }
                                                                      ></Value>
                                                                    </FormInput>
                                                                  );
                                                                }}
                                                              </Form.Item>
                                                              <Form.Item
                                                                shouldUpdate={shouldUpdateCompare(
                                                                  'currcode'
                                                                )}
                                                                noStyle
                                                              >
                                                                {({
                                                                  getFieldValue,
                                                                }) => {
                                                                  return (
                                                                    <FormInput
                                                                      style={{
                                                                        color:
                                                                          'red',
                                                                      }}
                                                                      col
                                                                      xs={24}
                                                                      md={6}
                                                                      comcode="ctetargetinstallmentamount"
                                                                      name={getName(
                                                                        'ctetargetinstallmentamount',
                                                                        elementID
                                                                      )}
                                                                    >
                                                                      <InputCurrency
                                                                        col
                                                                        md={24}
                                                                        currcode={getFieldValue(
                                                                          'currcode'
                                                                        )}
                                                                        onChange={(
                                                                          e
                                                                        ) =>
                                                                          setTargetRentalAmount(
                                                                            e
                                                                          )
                                                                        }
                                                                      />
                                                                    </FormInput>
                                                                  );
                                                                }}
                                                              </Form.Item>
                                                            </Row>
                                                            <Divider />
                                                            <Row gutter={16}>
                                                              <Form.Item
                                                                shouldUpdate={() =>
                                                                  true
                                                                }
                                                                noStyle
                                                              >
                                                                {({
                                                                  getFieldValue,
                                                                }) => (
                                                                  <FormInput
                                                                    col
                                                                    xs={8}
                                                                    comcode="cteduration"
                                                                    name={getName(
                                                                      'cteduration',
                                                                      elementID
                                                                    )}
                                                                  >
                                                                    <SliderWithInput
                                                                      max={getFieldValue(
                                                                        getHelper(
                                                                          'durationmax',
                                                                          elementID
                                                                        )
                                                                      )}
                                                                      min={getFieldValue(
                                                                        getHelper(
                                                                          'durationmin',
                                                                          elementID
                                                                        )
                                                                      )}
                                                                      precision={
                                                                        0
                                                                      }
                                                                      onChange={() =>
                                                                        debouncedCalculateNew(
                                                                          '',
                                                                          'INST'
                                                                        )
                                                                      }
                                                                    />
                                                                  </FormInput>
                                                                )}
                                                              </Form.Item>
                                                              <Form.Item
                                                                shouldUpdate
                                                                noStyle
                                                              >
                                                                {({
                                                                  getFieldValue,
                                                                }) => (
                                                                  <FormInput
                                                                    col
                                                                    xs={16}
                                                                    comcode="ctefirstpayment"
                                                                    name={getName(
                                                                      'ctefirstpayment',
                                                                      elementID
                                                                    )}
                                                                  >
                                                                    <SliderWithInputAndPercentage
                                                                      currcode={getFieldValue(
                                                                        'currcode'
                                                                      )}
                                                                      max={getFieldValue(
                                                                        getHelper(
                                                                          'frmax',
                                                                          elementID
                                                                        )
                                                                      )}
                                                                      min={getFieldValue(
                                                                        getHelper(
                                                                          'frmin',
                                                                          elementID
                                                                        )
                                                                      )}
                                                                      defaultValue={
                                                                        100
                                                                      } //getFieldValue(['helpers', 'frdefault'])*getFieldValue('cteinvestamount')/100}
                                                                      value={
                                                                        100
                                                                      } //{getFieldValue(['helpers', 'frdefault'])*getFieldValue('cteinvestamount')/100}
                                                                      basis={getFieldValue(
                                                                        getName(
                                                                          'cteinvestamount',
                                                                          elementID
                                                                        )
                                                                      )}
                                                                      step={1}
                                                                      precisionAmount={
                                                                        2
                                                                      }
                                                                      precisionCoef={
                                                                        5
                                                                      }
                                                                      onChange={() =>
                                                                        debouncedCalculateNew(
                                                                          'FP',
                                                                          'INST'
                                                                        )
                                                                      }
                                                                    />
                                                                  </FormInput>
                                                                )}
                                                              </Form.Item>
                                                              <Form.Item
                                                                shouldUpdate
                                                                noStyle
                                                              >
                                                                {({
                                                                  getFieldValue,
                                                                }) => (
                                                                  <FormInput
                                                                    col
                                                                    xs={24}
                                                                    comcode="ctervamount"
                                                                    name={getName(
                                                                      'ctervamount',
                                                                      elementID
                                                                    )}
                                                                  >
                                                                    <SliderWithInputAndPercentage
                                                                      currcode={getFieldValue(
                                                                        'currcode'
                                                                      )}
                                                                      max={getFieldValue(
                                                                        getHelper(
                                                                          'rvmax',
                                                                          elementID
                                                                        )
                                                                      )}
                                                                      min={getFieldValue(
                                                                        getHelper(
                                                                          'rvmin',
                                                                          elementID
                                                                        )
                                                                      )}
                                                                      contextmin={getFieldValue(
                                                                        getHelper(
                                                                          'rvcontextmin',
                                                                          elementID
                                                                        )
                                                                      )}
                                                                      contextmax={getFieldValue(
                                                                        getHelper(
                                                                          'rvcontextmax',
                                                                          elementID
                                                                        )
                                                                      )}
                                                                      basis={getFieldValue(
                                                                        getName(
                                                                          'cteinvestamount',
                                                                          elementID
                                                                        )
                                                                      )}
                                                                      step={1}
                                                                      precisionAmount={
                                                                        2
                                                                      }
                                                                      precisionCoef={
                                                                        5
                                                                      }
                                                                      onChange={() =>
                                                                        debouncedCalculateNew(
                                                                          'RV',
                                                                          'INST'
                                                                        )
                                                                      }
                                                                    />
                                                                  </FormInput>
                                                                )}
                                                              </Form.Item>
                                                            </Row>
                                                          </Col>

                                                          <Col span={4}>
                                                            <Space
                                                              size="middle"
                                                              direction="vertical"
                                                            >
                                                              <NewButtonSmall
                                                                type="primary"
                                                                onClick={
                                                                  addWeightedStep
                                                                }
                                                                comcode="add"
                                                                disabled={
                                                                  typeof getFieldValue(
                                                                    'pricing'
                                                                  ) !== 'object'
                                                                    ? !isNil(
                                                                        getFieldValue(
                                                                          'pricing'
                                                                        )
                                                                      )
                                                                    : !isNil(
                                                                        getFieldValue(
                                                                          'pricing'
                                                                        )?.ofrid
                                                                      )
                                                                }
                                                              />

                                                              <Form.Item
                                                                shouldUpdate={() =>
                                                                  true
                                                                }
                                                                noStyle
                                                              >
                                                                {({
                                                                  getFieldValue,
                                                                }) => (
                                                                  <FinancialScheduleModal
                                                                    finElement={getFieldValue(
                                                                      [
                                                                        'elements',
                                                                        'FIN',
                                                                      ]
                                                                    )?.find(
                                                                      (
                                                                        ele: any
                                                                      ) =>
                                                                        ele.cteid ===
                                                                        getFieldValue(
                                                                          'selectedElement'
                                                                        )
                                                                    )}
                                                                    loading={
                                                                      loading
                                                                    }
                                                                    flagretailer={getFieldValue(
                                                                      'flagretailer'
                                                                    )}
                                                                    comcode="finSchedule"
                                                                    controller={
                                                                      <ScheduleButton
                                                                        onClickCapture={(
                                                                          e
                                                                        ) => {
                                                                          debouncedCalculateNew(
                                                                            '',
                                                                            ''
                                                                          );
                                                                          calculatePaymentSheduleWeightedStep(
                                                                            getFieldValue(
                                                                              getName(
                                                                                'ctecalculationtype',
                                                                                elementID
                                                                              )
                                                                            ),
                                                                            getFieldValue(
                                                                              getName(
                                                                                'conElemSteps',
                                                                                elementID
                                                                              )
                                                                            )
                                                                          );
                                                                        }}
                                                                        size="large"
                                                                        style={{
                                                                          width:
                                                                            '100%',
                                                                        }}
                                                                        comcode="finSchedule"
                                                                        twoToneColor="blue"
                                                                      ></ScheduleButton>
                                                                    }
                                                                  />
                                                                )}
                                                              </Form.Item>
                                                            </Space>
                                                          </Col>
                                                        </Row>

                                                        <Row gutter={[8, 8]}>
                                                          <DataGrid
                                                            rowKey="ctesid"
                                                            dataSource={[
                                                              ...steps,
                                                            ]}
                                                            columns={
                                                              columnsWeigthedStep
                                                            }
                                                          />
                                                        </Row>
                                                      </Card>
                                                    );
                                                  }
                                                  return (
                                                    <Card
                                                      bordered
                                                      title={
                                                        <Title
                                                          level={4}
                                                          comcode="SeasonalPayment"
                                                        ></Title>
                                                      }
                                                    >
                                                      <Row>
                                                        <Col span={20}>
                                                          <Row>
                                                            <Form.Item
                                                              shouldUpdate={() =>
                                                                true
                                                              }
                                                              noStyle
                                                            >
                                                              <FormInput
                                                                col
                                                                xs={4}
                                                                name={getName(
                                                                  'ctepaymentterm',
                                                                  elementID
                                                                )}
                                                              >
                                                                <ParListSelect
                                                                  parcode="TERM"
                                                                  // parvalueparent={getFieldValue('ctepaymentterm')}
                                                                />
                                                              </FormInput>
                                                            </Form.Item>
                                                            <FormInput
                                                              style={{
                                                                color: 'blue',
                                                              }}
                                                              col
                                                              xs={6}
                                                              comcode="cteinvestamount"
                                                              name={getName(
                                                                'cteinvestamount',
                                                                elementID
                                                              )}
                                                            >
                                                              <Value
                                                                formatter={(
                                                                  value
                                                                ) =>
                                                                  toCurrency(
                                                                    value,
                                                                    getFieldValue(
                                                                      'currcode'
                                                                    )
                                                                  )
                                                                }
                                                              ></Value>
                                                            </FormInput>
                                                            <Form.Item
                                                              shouldUpdate={() =>
                                                                true
                                                              }
                                                              noStyle
                                                            >
                                                              <FormInput
                                                                col
                                                                xs={4}
                                                                name={getName(
                                                                  'cteupfrontamount',
                                                                  elementID
                                                                )}
                                                                comcode="cteupfrontamount"
                                                              >
                                                                <Value
                                                                  formatter={(
                                                                    value
                                                                  ) =>
                                                                    toCurrency(
                                                                      value,
                                                                      getFieldValue(
                                                                        'currcode'
                                                                      )
                                                                    )
                                                                  }
                                                                ></Value>
                                                              </FormInput>
                                                            </Form.Item>
                                                            <FormInput
                                                              style={{
                                                                color: 'blue',
                                                              }}
                                                              col
                                                              xs={6}
                                                              comcode="ctefinancedamount"
                                                              name={getName(
                                                                'ctefinancedamount',
                                                                elementID
                                                              )}
                                                            >
                                                              <Value
                                                                formatter={(
                                                                  value
                                                                ) =>
                                                                  toCurrency(
                                                                    value,
                                                                    getFieldValue(
                                                                      'currcode'
                                                                    )
                                                                  )
                                                                }
                                                              ></Value>
                                                            </FormInput>

                                                            <Form.Item
                                                              shouldUpdate={shouldUpdateCompare(
                                                                'currcode'
                                                              )}
                                                              noStyle
                                                            >
                                                              {({
                                                                getFieldValue,
                                                              }) => {
                                                                return (
                                                                  <FormInput
                                                                    xs={4}
                                                                    style={{
                                                                      color:
                                                                        'red',
                                                                    }}
                                                                    name={getName(
                                                                      'ctedeferredinterest',
                                                                      elementID
                                                                    )}
                                                                    comcode="ctedeferredinterest"
                                                                  >
                                                                    <Value
                                                                      formatter={(
                                                                        value
                                                                      ) =>
                                                                        toCurrency(
                                                                          value,
                                                                          getFieldValue(
                                                                            'currcode'
                                                                          )
                                                                        )
                                                                      }
                                                                    />
                                                                  </FormInput>
                                                                );
                                                              }}
                                                            </Form.Item>
                                                          </Row>
                                                          <Row gutter={16}>
                                                            <Form.Item
                                                              shouldUpdate={() =>
                                                                true
                                                              }
                                                              noStyle
                                                            >
                                                              {({
                                                                getFieldValue,
                                                              }) => (
                                                                <FormInput
                                                                  col
                                                                  xs={8}
                                                                  comcode="cteduration"
                                                                  name={getName(
                                                                    'cteduration',
                                                                    elementID
                                                                  )}
                                                                >
                                                                  <SliderWithInput
                                                                    max={getFieldValue(
                                                                      getHelper(
                                                                        'durationmax',
                                                                        elementID
                                                                      )
                                                                    )}
                                                                    min={getFieldValue(
                                                                      getHelper(
                                                                        'durationmin',
                                                                        elementID
                                                                      )
                                                                    )}
                                                                    precision={
                                                                      0
                                                                    }
                                                                    onChange={() =>
                                                                      debouncedCalculateNew(
                                                                        '',
                                                                        'INST'
                                                                      )
                                                                    }
                                                                  />
                                                                </FormInput>
                                                              )}
                                                            </Form.Item>
                                                            <Form.Item
                                                              shouldUpdate={() =>
                                                                true
                                                              }
                                                              noStyle
                                                            >
                                                              {({
                                                                getFieldValue,
                                                              }) => (
                                                                <FormInput
                                                                  col
                                                                  xs={16}
                                                                  comcode="ctefirstpayment"
                                                                  name={getName(
                                                                    'ctefirstpayment',
                                                                    elementID
                                                                  )}
                                                                >
                                                                  <SliderWithInputAndPercentage
                                                                    currcode={getFieldValue(
                                                                      'currcode'
                                                                    )}
                                                                    max={getFieldValue(
                                                                      getHelper(
                                                                        'frmax',
                                                                        elementID
                                                                      )
                                                                    )}
                                                                    min={getFieldValue(
                                                                      getHelper(
                                                                        'frmin',
                                                                        elementID
                                                                      )
                                                                    )}
                                                                    defaultValue={
                                                                      100
                                                                    } //getFieldValue(['helpers', 'frdefault'])*getFieldValue('cteinvestamount')/100}
                                                                    value={100} //{getFieldValue(['helpers', 'frdefault'])*getFieldValue('cteinvestamount')/100}
                                                                    basis={getFieldValue(
                                                                      getName(
                                                                        'cteinvestamount',
                                                                        elementID
                                                                      )
                                                                    )}
                                                                    step={1}
                                                                    precisionAmount={
                                                                      2
                                                                    }
                                                                    precisionCoef={
                                                                      5
                                                                    }
                                                                    onChange={() =>
                                                                      debouncedCalculateNew(
                                                                        'FP',
                                                                        'INST'
                                                                      )
                                                                    }
                                                                  />
                                                                </FormInput>
                                                              )}
                                                            </Form.Item>
                                                            <Form.Item
                                                              shouldUpdate={() =>
                                                                true
                                                              }
                                                              noStyle
                                                            >
                                                              {({
                                                                getFieldValue,
                                                              }) => (
                                                                <FormInput
                                                                  col
                                                                  xs={24}
                                                                  comcode="ctervamount"
                                                                  name={getName(
                                                                    'ctervamount',
                                                                    elementID
                                                                  )}
                                                                >
                                                                  <SliderWithInputAndPercentage
                                                                    currcode={getFieldValue(
                                                                      'currcode'
                                                                    )}
                                                                    max={getFieldValue(
                                                                      getHelper(
                                                                        'rvmax',
                                                                        elementID
                                                                      )
                                                                    )}
                                                                    min={getFieldValue(
                                                                      getHelper(
                                                                        'rvmin',
                                                                        elementID
                                                                      )
                                                                    )}
                                                                    contextmin={getFieldValue(
                                                                      getHelper(
                                                                        'rvcontextmin',
                                                                        elementID
                                                                      )
                                                                    )}
                                                                    contextmax={getFieldValue(
                                                                      getHelper(
                                                                        'rvcontextmax',
                                                                        elementID
                                                                      )
                                                                    )}
                                                                    basis={getFieldValue(
                                                                      getName(
                                                                        'cteinvestamount',
                                                                        elementID
                                                                      )
                                                                    )}
                                                                    step={1}
                                                                    precisionAmount={
                                                                      2
                                                                    }
                                                                    precisionCoef={
                                                                      5
                                                                    }
                                                                    onChange={() =>
                                                                      debouncedCalculateNew(
                                                                        'RV',
                                                                        'INST'
                                                                      )
                                                                    }
                                                                  />
                                                                </FormInput>
                                                              )}
                                                            </Form.Item>
                                                          </Row>
                                                        </Col>
                                                        <Col span={4}>
                                                          <Space
                                                            size="middle"
                                                            direction="vertical"
                                                          >
                                                            <NewButtonSmall
                                                              type="primary"
                                                              onClick={addStep}
                                                              comcode="add"
                                                              /*disabled={
                                                            typeof getFieldValue(
                                                              'pricing'
                                                            ) !== 'object'
                                                              ? !isNil(
                                                                  getFieldValue(
                                                                    'pricing'
                                                                  )
                                                                )
                                                              : !isNil(
                                                                  getFieldValue(
                                                                    'pricing'
                                                                  )?.ofrid
                                                                )
                                                          }*/
                                                            />

                                                            <Form.Item
                                                              shouldUpdate={() =>
                                                                true
                                                              }
                                                              noStyle
                                                            >
                                                              {({
                                                                getFieldValue,
                                                              }) => (
                                                                <FinancialScheduleModal
                                                                  finElement={getFieldValue(
                                                                    [
                                                                      'elements',
                                                                      'FIN',
                                                                    ]
                                                                  )?.find(
                                                                    (
                                                                      ele: any
                                                                    ) =>
                                                                      ele.cteid ===
                                                                      getFieldValue(
                                                                        'selectedElement'
                                                                      )
                                                                  )}
                                                                  loading={
                                                                    loading
                                                                  }
                                                                  comcode="finSchedule"
                                                                  //visible={visibleSeasonal}
                                                                  flagretailer={getFieldValue(
                                                                    'flagretailer'
                                                                  )}
                                                                  controller={
                                                                    <ScheduleButton
                                                                      onClickCapture={(
                                                                        e
                                                                      ) => {
                                                                        e.stopPropagation();
                                                                        debouncedCalculateNew(
                                                                          '',
                                                                          ''
                                                                        );
                                                                        calculateSeasonal(
                                                                          form.getFieldValue(
                                                                            'selectedElement'
                                                                          )
                                                                        );
                                                                      }}
                                                                      size="large"
                                                                      style={{
                                                                        width:
                                                                          '100%',
                                                                      }}
                                                                      comcode="finSchedule"
                                                                      twoToneColor="blue"
                                                                    ></ScheduleButton>
                                                                  }
                                                                  onCancel={() =>
                                                                    setVisibleSeasonal(
                                                                      false
                                                                    )
                                                                  }
                                                                />
                                                              )}
                                                            </Form.Item>
                                                          </Space>
                                                        </Col>
                                                      </Row>
                                                      <Row gutter={[8, 8]}>
                                                        <DataGrid
                                                          rowKey="ctesid"
                                                          dataSource={[
                                                            ...steps,
                                                          ]}
                                                          columns={
                                                            columnsSeasonal
                                                          }
                                                          pagination={false}
                                                        />
                                                      </Row>
                                                    </Card>
                                                  );
                                                }
                                              }
                                            }}
                                          </Form.Item>
                                        </TabPane>
                                      </>
                                    )}
                                </Tabs>
                              </TabPane>
                            ) : (
                              <>
                                <TabPane
                                  key={1}
                                  tab={<GetLabel label="Simplemode" />}
                                  disabled
                                ></TabPane>
                                <TabPane
                                  key={2}
                                  tab={<GetLabel label="Advancedmode" />}
                                  disabled
                                ></TabPane>
                              </>
                            )
                          ) : null}
                        </Tabs>
                      );
                    }}
                  </Form.Item>
                </UtinaPanel>
              </Collapse>
            )
          );
        }}
      </FormItem>

      <FormItem shouldUpdate={shouldUpdateCompare(['elements'])} noStyle>
        {({ getFieldValue }) => {
          return (
            getFieldValue(getName('ctepartmethod', elementID)) === 'MULTI' && (
              <Collapse
                bordered={false}
                expandIcon={({ isActive }) => (
                  <PlusOutlined style={{ fontSize: 17 }} />
                )}
                expandIconPosition="left"
                style={{ background: 'none !important' }}
              >
                <UtinaPanel
                  comcode="additionalAttributes"
                  key={8}
                  extra={
                    <ModalControllerNV
                      content={({ setVisible, visible }) => (
                        <Button
                          icon={<IAdd height="15px" width="15px" />}
                          onClick={(ev) => {
                            ev.stopPropagation();
                            setVisible(true);
                          }}
                        >
                          <GetLabel label="AddAttribute" />
                        </Button>
                      )}
                      modal={({ setVisible, visible }) => (
                        <AttributeModal
                          visible={visible}
                          onClose={() => {
                            setVisible(false);
                          }}
                          onSave={handelSaveAttribute}
                          finElement={
                            form
                              .getFieldValue(['elements', 'FIN'])
                              ?.filter(
                                (e: any) =>
                                  e.cteid === getFieldValue('selectedElement')
                              )[0]
                          }
                          params={{
                            priid: getFieldValue('pricing'),
                            filtersList: getFilterList(),
                            offerid: getFieldValue('offerid'),
                          }}
                        />
                      )}
                    ></ModalControllerNV>
                  }
                >
                  <Form.Item shouldUpdate>
                    {({ getFieldValue }) => {
                      const element = getFieldValue([
                        'elements',
                        'FIN',
                      ])?.filter(
                        (e: any) => e.cteid === getFieldValue('selectedElement')
                      )[0];

                      const elementAttribute = element?.conElemAttributes;

                      return (
                        <ElementAttributesTable
                          form={form}
                          attributes={[...elementAttribute]}
                          onDeleteAttribute={handelDeleteAttribute}
                          currcode={getFieldValue('currcode')}
                          priid={getFieldValue('pricing')}
                          filtersList={getFilterList()}
                          offerid={getFieldValue('offerid')}
                          finElement={element}
                          onSaveAttribute={handelSaveAttribute}
                          //onConvertServToFinServ={handleConvertServToFinServ}
                        />
                      );
                    }}
                  </Form.Item>
                </UtinaPanel>
              </Collapse>
            )
          );
        }}
      </FormItem>

      <FormItem
        shouldUpdate={shouldUpdateCompare(['flagfleet', 'selectedElement'])}
        noStyle
      >
        {({ getFieldValue }) => {
          return (
            <Collapse
              bordered={false}
              expandIcon={({ isActive }) => (
                <PlusOutlined style={{ fontSize: 17 }} />
              )}
              expandIconPosition="left"
              style={{ background: 'none !important' }}
            >
              {getFieldValue('flagfleet') === false &&
                !isNil(getFieldValue('offerid')) &&
                getFieldValue('offerid') !== 0 && (
                  <UtinaPanel comcode="servicesToFinance" key={8}>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare([
                        'elements',
                        'currcode',
                      ])}
                    >
                      {({ getFieldValue }) => {
                        const elements = getFieldValue([
                          'elements',
                          'FINSERV',
                        ])?.filter(
                          (e: any) =>
                            e.cteidparent === getFieldValue('selectedElement')
                        );

                        return (
                          <ElementsTable
                            form={form}
                            elements={elements}
                            onDeleteElement={handleDeleteElement}
                            currcode={getFieldValue('currcode')}
                            //onConvertServToFinServ={handleConvertServToFinServ}
                          />
                        );
                      }}
                    </Form.Item>
                  </UtinaPanel>
                )}
              {!isNil(getFieldValue('offerid')) &&
                getFieldValue('offerid') !== 0 && (
                  <UtinaPanel
                    comcode="additionalServicesAndFees"
                    key={9}
                    extra={
                      !showAsModal &&
                      phase !== 'PROD' && (
                        <ModalControllerNV
                          content={({ setVisible, visible }) => (
                            <Button
                              icon={<IAdd height="15px" width="15px" />}
                              onClick={(ev) => {
                                setVisible(true);
                                ev.stopPropagation();
                              }}
                            >
                              <GetLabel label="AddService" />
                            </Button>
                          )}
                          modal={({ setVisible, visible }) => (
                            <SimpleServElementModal
                              offerid={form.getFieldValue('offerid')}
                              visible={visible}
                              onClose={() => setVisible(false)}
                              onSave={onSaveService}
                              // form={form}
                              assetid={elementID}
                              phase={phase}
                              cteidparent={form?.getFieldValue(
                                'selectedElement'
                              )}
                              finschedule={form.getFieldValue(
                                getName('conElemSchedules', elementID)
                              )}
                              ctegraceperiodduration={form.getFieldValue(
                                getName('ctegraceperiodduration', elementID)
                              )}
                              ctefinancedamount={form.getFieldValue(
                                getName('ctefinancedamount', elementID)
                              )}
                              cteinvestamount={form.getFieldValue(
                                getName('ctefinancedamount', elementID)
                              )}
                              assetamount={form.getFieldValue(
                                getName('ctefinancedamount', elementID)
                              )}
                              ctestartdate={form.getFieldValue(
                                getName('ctestartdate', elementID)
                              )}
                              cteduration={form.getFieldValue(
                                getName('cteduration', elementID)
                              )}
                              assets={form.getFieldValue('assets')}
                            />
                          )}
                        ></ModalControllerNV>
                      )
                    }
                  >
                    <Form.Item shouldUpdate>
                      {({ getFieldValue }) => {
                        const SERV: any[] = Array.isArray(
                          getFieldValue(['elements', 'SERV'])
                        )
                          ? getFieldValue(['elements', 'SERV'])
                          : [];

                        const FEES: any[] = Array.isArray(
                          getFieldValue(['elements', 'FEES'])
                        )
                          ? getFieldValue(['elements', 'FEES'])
                          : [];

                        console.log(
                          'selectedElement',
                          getFieldValue('selectedElement')
                        );
                        const elements = [...SERV, ...FEES].filter(
                          (e) =>
                            e.cteidparent ===
                              getFieldValue('selectedElement') &&
                            e.ctedirection === 'IN'
                        );

                        const obj = {
                          finschedule: form.getFieldValue(
                            getName('conElemSchedules', elementID)
                          ),
                          ctegraceperiodduration: form.getFieldValue(
                            getName('ctegraceperiodduration', elementID)
                          ),
                          ctefinancedamount: form.getFieldValue(
                            getName('ctefinancedamount', elementID)
                          ),
                          cteinvestamount: form.getFieldValue(
                            getName('ctefinancedamount', elementID)
                          ),
                          assetamount: form.getFieldValue(
                            getName('ctefinancedamount', elementID)
                          ),
                          ctestartdate: form.getFieldValue(
                            getName('ctestartdate', elementID)
                          ),
                          cteduration: form.getFieldValue(
                            getName('cteduration', elementID)
                          ),
                        };
                        return (
                          <ElementsTable
                            offerid={getFieldValue('offerid')}
                            onSave={onSaveService}
                            form={form}
                            elements={elements}
                            onDeleteElement={(elements) => {
                              handleDeleteElement(elements);
                            }}
                            phase={phase}
                            onConvertServToFinServ={handleConvertServToFinServ}
                            propsforcalculate={obj}
                            currcode={getFieldValue('currcode')}
                          />
                        );
                      }}
                    </Form.Item>
                  </UtinaPanel>
                )}

              {getFieldValue('flagfleet') === false && (
                <UtinaPanel
                  comcode="commissions"
                  key={10}
                  extra={
                    !showAsModal && (
                      <ModalControllerNV
                        content={({ setVisible, visible }) => (
                          <Button
                            icon={<IAdd height="15px" width="15px" />}
                            onClick={(ev) => {
                              setVisible(true);
                              ev.stopPropagation();
                            }}
                          >
                            <GetLabel label="AddCommission" />
                          </Button>
                        )}
                        modal={({ setVisible, visible }) => (
                          <SimpleCommissionModal
                            offerid={form.getFieldValue('offerid')}
                            visible={visible}
                            onClose={() => setVisible(false)}
                            onSave={onSaveComm}
                            form={form}
                            finschedule={form.getFieldValue(
                              getName('conElemSchedules', elementID)
                            )}
                            ctegraceperiodduration={form.getFieldValue(
                              getName('ctegraceperiodduration', elementID)
                            )}
                            ctefinancedamount={form.getFieldValue(
                              getName('ctefinancedamount', elementID)
                            )}
                            cteinvestamount={form.getFieldValue(
                              getName('ctefinancedamount', elementID)
                            )}
                            ctestartdate={form.getFieldValue(
                              getName('ctestartdate', elementID)
                            )}
                            cteduration={form.getFieldValue(
                              getName('cteduration', elementID)
                            )}
                            assetamount={form.getFieldValue(
                              getName('ctefinancedamount', elementID)
                            )}
                          />
                        )}
                      />
                    )
                  }
                >
                  <Form.Item shouldUpdate>
                    {({ getFieldValue }) => {
                      const elements = [
                        ...(getFieldValue(['elements', 'COMM']) || []),
                      ].filter(
                        (e) =>
                          e.cteidparent === getFieldValue('selectedElement')
                      );
                      const obj = {
                        finschedule: form.getFieldValue(
                          getName('conElemSchedules', elementID)
                        ),
                        ctegraceperiodduration: form.getFieldValue(
                          getName('ctegraceperiodduration', elementID)
                        ),
                        ctefinancedamount: form.getFieldValue(
                          getName('ctefinancedamount', elementID)
                        ),
                        cteinvestamount: form.getFieldValue(
                          getName('ctefinancedamount', elementID)
                        ),
                        ctestartdate: form.getFieldValue(
                          getName('ctestartdate', elementID)
                        ),
                        cteduration: form.getFieldValue(
                          getName('cteduration', elementID)
                        ),
                        assetamount: form.getFieldValue(
                          getName('ctefinancedamount', elementID)
                        ),
                      };
                      return (
                        <ElementsTable
                          offerid={getFieldValue('offerid')}
                          form={form}
                          elements={elements}
                          onDeleteElement={handleDeleteElement}
                          onSave={onSaveComm}
                          propsforcalculate={obj}
                          currcode={getFieldValue('currcode')}
                        />
                      );
                    }}
                  </Form.Item>
                </UtinaPanel>
              )}
              {getFieldValue('flagfleet') === false &&
                !isNil(getFieldValue('offerid')) &&
                getFieldValue('offerid') !== 0 && (
                  <UtinaPanel
                    comcode="ServiceOut"
                    key={11}
                    extra={
                      !showAsModal && (
                        <ModalControllerNV
                          content={({ setVisible, visible }) => (
                            <Button
                              icon={<IAdd height="15px" width="15px" />}
                              onClick={(ev) => {
                                setVisible(true);
                                ev.stopPropagation();
                              }}
                            >
                              <GetLabel label="AddServiceOut" />
                            </Button>
                          )}
                          modal={({ setVisible, visible }) => (
                            <SimpleCommissionModal
                              assetid={elementID}
                              offerid={form.getFieldValue('offerid')}
                              visible={visible}
                              onClose={() => setVisible(false)}
                              onSave={onSaveComm}
                              form={form}
                              finschedule={form.getFieldValue(
                                getName('conElemSchedules', elementID)
                              )}
                              ctegraceperiodduration={form.getFieldValue(
                                getName('ctegraceperiodduration', elementID)
                              )}
                              ctefinancedamount={form.getFieldValue(
                                getName('ctefinancedamount', elementID)
                              )}
                              cteinvestamount={form.getFieldValue(
                                getName('ctefinancedamount', elementID)
                              )}
                              ctestartdate={form.getFieldValue(
                                getName('ctestartdate', elementID)
                              )}
                              cteduration={form.getFieldValue(
                                getName('cteduration', elementID)
                              )}
                              assetamount={form.getFieldValue(
                                getName('ctefinancedamount', elementID)
                              )}
                            />
                          )}
                        />
                      )
                    }
                  >
                    <Form.Item shouldUpdate>
                      {({ getFieldValue }) => {
                        const elements = [
                          ...(getFieldValue(['elements', 'SERV']) || []),
                        ].filter(
                          (e) =>
                            e.cteidparent ===
                              getFieldValue('selectedElement') &&
                            e.ctedirection === 'OUT'
                        );
                        const obj = {
                          finschedule: form.getFieldValue(
                            getName('conElemSchedules', elementID)
                          ),
                          ctegraceperiodduration: form.getFieldValue(
                            getName('ctegraceperiodduration', elementID)
                          ),
                          ctefinancedamount: form.getFieldValue(
                            getName('ctefinancedamount', elementID)
                          ),
                          cteinvestamount: form.getFieldValue(
                            getName('ctefinancedamount', elementID)
                          ),
                          ctestartdate: form.getFieldValue(
                            getName('ctestartdate', elementID)
                          ),
                          cteduration: form.getFieldValue(
                            getName('cteduration', elementID)
                          ),
                          assetamount: form.getFieldValue(
                            getName('ctefinancedamount', elementID)
                          ),
                        };
                        return (
                          <ElementsTable
                            offerid={getFieldValue('offerid')}
                            form={form}
                            elements={elements}
                            onDeleteElement={handleDeleteElement}
                            phase={phase}
                            onSave={onSaveComm}
                            propsforcalculate={obj}
                            currcode={getFieldValue('currcode')}
                          />
                        );
                      }}
                    </Form.Item>
                  </UtinaPanel>
                )}
            </Collapse>
          );
        }}
      </FormItem>

      <AssetCatalogModal
        currcode={form.getFieldValue('currcode')}
        network={form.getFieldValue('ctnetworkcode')}
        onCancel={catalogModal.close}
        onSelect={
          form.getFieldValue('flagfleet')
            ? handleSelectAssetFromCatalogAndCreateElements
            : handleSelectAssetFromCatalog
        }
        visible={catalogModal.visible}
      />

      <AssetCatalogPackModal
        currcode={form.getFieldValue('currcode')}
        onCancel={catalogPackModal.close}
        onSelect={handleSelectAssetFromCatalogPack}
        visible={catalogPackModal.visible}
      />

      <AssetListModalV
        alreadySelected={getAssetListId()}
        visible={assetModalVisible}
        onCancel={() => {
          setAssetModalVisible(false);
        }}
        phase={assetphase === 'PROD' ? 'PROD' : 'PROPOSAL'}
        status={assetstatus}
        // rowSelection={{
        //   type: 'checkbox',
        //   onChange: (selectedRowKeys, selectedRows) => {
        //     setassetlist(selectedRows);
        //   },
        //   hideSelectAll: true,
        // }}
        validate={handleSelectAssetFromStockOrInit}
        nbreAsset={nbreAsset}
      />
      {/*assetMultiCompModal.visible === true ? (
        <AssetDetails
          asset={null}
          onCancel={() => assetMultiCompModal.close()}
          showAsModal
          visible={assetMultiCompModal.visible}
          onSave={(asset) => {
            handleSaveAsset && handleSaveAsset(asset);
          }}
          phaseprop={phase}
          fromproposal
          flagreal={Boolean(form.getFieldValue('flagrealestate'))}
        />
        ) : null*/}

      <Form.Item shouldUpdate>
        {({ getFieldValue }) => {
          return (
            <SimpleAssetModal
              flagreal={Boolean(form.getFieldValue('flagrealestate'))}
              supplier={
                form.getFieldValue('prcode') === 'LEASEBACK'
                  ? form.getFieldValue('client')
                  : null
              }
              onAdd={handleAddSimpleAsset}
              onCancel={simpleAssetModal.close}
              currcode={form.getFieldValue('currcode')}
              visible={simpleAssetModal.visible}
            />
          );
        }}
      </Form.Item>
    </Spin>
  );
};
const newsynd = (tprole: any, percent: any, partamount: any) => {
  const row: any = {
    ctrid: 0,
    partcoef: percent,
    partamount: partamount,
    partnername: '',
    partnerreference: '',
    payinmode: '',
    payoutmode: '',
    syndid: Math.floor(_.random(10000) * 100000),
    tpbkidin: '' as any,
    tpbkidout: '' as any,
    tpadrid: '' as any,
    tpid: 0,
    tprole: tprole,
    new: true,
  };
  return row;
};
const newBF = (mfrequestedamount: any) => {
  const rowtp: PropThirdPartyRequest = {
    isNew: true,
    tpname: '',
    ctrid: 0,
    enddate: '',
    mfagreedamount: 0,
    mfavailableamount: 0,
    mfbookedamount: 0,
    mfrequestedamount: mfrequestedamount,
    mfusedamount: 0,
    mfvaliditydate: '',
    startdate: toDatePickerDate(moment(Date.now()).format('YYYY-MM-DD')) as '',
    status: 'ACTIVE',
    statusdate: '',
    tpadrid: 0,
    tpbkidin: 0,
    tpbkidout: 0,
    tpblocklateinterestinvoicing: false,
    tpblockrejectionfeesinvoicing: false,
    tpblockreminderfeesinvoicing: false,
    tpid: 0,
    tplateinterestformula: '',
    tppaydelayin: '',
    tppaydelayout: '',
    tppaymodein: '',
    tppaymodeout: '',
    tprejectionfeesformula: '',
    tpreminderfeesformula: '',
    tprolecode: 'MFBENEF',
    tproleid: Math.floor(_.random(100000) * 10000000) * -1,
    tprolecodelabel: '',
  };
  return rowtp;
};
export default QuickSimulation;
